import { EditBookDeliveryComponent } from './../edit-book-delivery/edit-book-delivery.component';
import { DatePipe, formatDate } from '@angular/common';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { saveAs } from 'file-saver';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  ValidatorFn,
} from '@angular/forms';

import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { MatDialog } from '@angular/material/dialog';
import { EncdecriptService } from 'src/app/services/encdecrypt.service';
import { AddNewAdminDialogComponent } from 'src/app/pages/add-new-admin-dialog/add-new-admin-dialog.component';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { FileUploader } from 'ng2-file-upload';
import html2canvas from 'html2canvas';
import { forkJoin, from, of, timer } from 'rxjs';
import { EditBookStockComponent } from '../edit-book-stock/edit-book-stock.component';
import { EditBookComponent } from '../edit-book/edit-book.component';
import * as XLSX from 'xlsx';
import { ViewBookComponent } from '../view-book/view-book.component';
import { SubscriptionAccountsComponent } from '../subscription-accounts/subscription-accounts.component';
import { BookinvoiceComponent } from '../bookinvoice/bookinvoice.component';
import { CreditvoucherDialogComponent } from '../creditvoucher-dialog/creditvoucher-dialog.component';
import { Observable } from 'rxjs';
import { concatMap, finalize, map, startWith, take } from 'rxjs/operators';
import { BookstorereceiptComponent } from '../bookstorereceipt/bookstorereceipt.component';
import { BookstoresendmessageComponent } from '../bookstoresendmessage/bookstoresendmessage.component';
import { UpdateOfficeRepresentativeComponent } from '../update-office-representative/update-office-representative.component';
import { AddBookPerPriceComponent } from '../add-book-per-price/add-book-per-price.component';
import { UpdateBookPerPriceComponent } from '../update-book-per-price/update-book-per-price.component';
import { BookCrdtnoteRcptComponent } from '../book-crdtnote-rcpt/book-crdtnote-rcpt.component';
import { ShowBookInvoiceComponent } from '../show-book-invoice/show-book-invoice.component';
import { ShowBookCrdtNoteRcptComponent } from '../show-book-crdt-note-rcpt/show-book-crdt-note-rcpt.component';
import { AuthorAddressComponent } from '../author-address/author-address.component';
import { BookSellerAddressComponent } from '../book-seller-address/book-seller-address.component';
import { ShowBookSellerOutstandingDataComponent } from '../show-book-seller-outstanding-data/show-book-seller-outstanding-data.component';
import { BooktworeciptComponent } from 'src/app/booktworecipt/booktworecipt.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { BookSellerLedgerBriefReportComponentComponent } from 'src/app/book-seller-ledger-brief-report-component/book-seller-ledger-brief-report-component.component';
import { ShowBookOrderComponent } from 'src/app/show-book-order/show-book-order.component';
import { AddBookCreditPriceComponent } from 'src/app/add-book-credit-price/add-book-credit-price.component';
import { BookCreditNoteRegisterComponent } from 'src/app/book-credit-note-register/book-credit-note-register.component';
import { AddBookPerCommisionPriceComponent } from 'src/app/add-book-per-commision-price/add-book-per-commision-price.component';
import { BookCommRcptComponent } from 'src/app/book-comm-rcpt/book-comm-rcpt.component';
import { BookCommissionNoteRegisterComponent } from 'src/app/book-commission-note-register/book-commission-note-register.component';
// import { request } from 'http';
// import { request } from 'http';
import { DecimalPipe } from '@angular/common';
import { OutstandingReportComponent } from 'src/app/outstanding-report/outstanding-report.component';
import { E } from '@angular/cdk/keycodes';
import { GSTReportComponent } from 'src/app/gstreport/gstreport.component';
import { BookReceiptReportComponent } from 'src/app/book-receipt-report/book-receipt-report.component';
import { BookPymtMonthwiseReportComponent } from 'src/app/book-pymt-monthwise-report/book-pymt-monthwise-report.component';
import { BookReceiptIndetailOfficerComponent } from 'src/app/book-receipt-indetail-officer/book-receipt-indetail-officer.component';
import { BookReceiptVeryBrieflyOfficerComponent } from 'src/app/book-receipt-very-briefly-officer/book-receipt-very-briefly-officer.component';
import { BookReceiptBrieflyOfficerComponent } from 'src/app/book-receipt-briefly-officer/book-receipt-briefly-officer.component';
import { ShowOrderEntryBookSellerComponent } from 'src/app/show-order-entry-book-seller/show-order-entry-book-seller.component';
import { OpeninvoiceprintComponent } from 'src/app/openinvoiceprint/openinvoiceprint.component';
import { AddBookPerPriceComponent1Component } from 'src/app/add-book-per-price-component1/add-book-per-price-component1.component';
import { AddBookCreditPrice1Component } from 'src/app/add-book-credit-price1/add-book-credit-price1.component';
import { Bookstoresendmessage1Component } from 'src/app/bookstoresendmessage1/bookstoresendmessage1.component';
import { BooksellerbillingregisterreportComponent } from 'src/app/booksellerbillingregisterreport/booksellerbillingregisterreport.component';
import { RepUnpaidCommissionComponent } from 'src/app/rep-unpaid-commission/rep-unpaid-commission.component';
import { RepCommissionPaidComponent } from 'src/app/rep-commission-paid/rep-commission-paid.component';
// import { BookSellerAddressLabelsComponent } from 'src/app/book-seller-address-labels/book-seller-address-labels.component';
import { AllRepBookCommissionComponent } from 'src/app/all-rep-book-commission/all-rep-book-commission.component';
import { BookReceiptMonthwiseComponent } from 'src/app/book-receipt-monthwise/book-receipt-monthwise.component';
import { OfficeRepInDetailsComponent } from 'src/app/office-rep-in-details/office-rep-in-details.component';
import { BookReceiptAllBrieflyComponent } from 'src/app/book-receipt-all-briefly/book-receipt-all-briefly.component';
import { BookReceiptIndetailallComponent } from 'src/app/book-receipt-indetailall/book-receipt-indetailall.component';
import { OfficeRepBrieflyComponent } from 'src/app/office-rep-briefly/office-rep-briefly.component';
import { BusinessReportVeryBriefly1Component } from 'src/app/business-report-very-briefly1/business-report-very-briefly1.component';
import { BookCreditNoteReportBrieflyOfficerComponent } from 'src/app/book-credit-note-report-briefly-officer/book-credit-note-report-briefly-officer.component';
import { BookCreditNoteReportVeryBrieflyOfficerComponent } from 'src/app/book-credit-note-report-very-briefly-officer/book-credit-note-report-very-briefly-officer.component';
import { BookCreditNoteReportInDetailOfficerComponent } from 'src/app/book-credit-note-report-in-detail-officer/book-credit-note-report-in-detail-officer.component';
import { BookCreditNoteReportMonthwiseComponent } from 'src/app/book-credit-note-report-monthwise/book-credit-note-report-monthwise.component';
import { BookCreditNoteReportBrieflyComponent } from 'src/app/book-credit-note-report-briefly/book-credit-note-report-briefly.component';
import { BookCreditNoteReportComponent } from 'src/app/book-credit-note-report/book-credit-note-report.component';
import { BookRegistrationLedgerReportBrieflyOfficerComponent } from 'src/app/book-registration-ledger-report-briefly-officer/book-registration-ledger-report-briefly-officer.component';
import { BookRegistrationLedgerReportInDetailOfficerComponent } from 'src/app/book-registration-ledger-report-in-detail-officer/book-registration-ledger-report-in-detail-officer.component';
import { BookRegistrationLedgerReportVBrieflyComponent } from 'src/app/book-registration-ledger-report-vbriefly/book-registration-ledger-report-vbriefly.component';
import { BookRegistrationLedgerReportBrieflyComponent } from 'src/app/book-registration-ledger-report-briefly/book-registration-ledger-report-briefly.component';
import { BookRegistrationLedgerReportComponent } from 'src/app/book-registration-ledger-report/book-registration-ledger-report.component';
import { BookRegistrationLedgerReportVeryBrieflyOfficerComponent } from 'src/app/book-registration-ledger-report-very-briefly-officer/book-registration-ledger-report-very-briefly-officer.component';
import { ExpenseLedgerReportComponent } from 'src/app/expense-ledger-report/expense-ledger-report.component';
import { SendReminderLetterBookComponent } from 'src/app/send-reminder-letter-book/send-reminder-letter-book.component';
import { SendReminderLetterRepBookComponent } from 'src/app/send-reminder-letter-rep-book/send-reminder-letter-rep-book.component';
import { EditBookExpenseComponent } from 'src/app/edit-book-expense/edit-book-expense.component';
import * as FileSaver from 'file-saver';
import { BusinessReportIndetailComponentComponent } from 'src/app/business-report-indetail-component/business-report-indetail-component.component';
import { ReceiptpackagebookComponent } from 'src/app/receiptpackagebook/receiptpackagebook.component';
import { BookwiseReportComponent } from 'src/app/bookwise-report/bookwise-report.component';
import { BusinessReportComponent } from 'src/app/business-report/business-report.component';
import { MonthwiseReportComponent } from 'src/app/monthwise-report/monthwise-report.component';
import { OfficeRepMonthwiseReportComponent } from 'src/app/office-rep-monthwise-report/office-rep-monthwise-report.component';
import { GranthInvoiceComponent } from 'src/app/granth-invoice/granth-invoice.component';
import { ShowgranthorderComponent } from 'src/app/showgranthorder/showgranthorder.component';
import { ShowGranthInvoiceComponent } from 'src/app/show-granth-invoice/show-granth-invoice.component';
import { BookSellerAddressLabelsComponent } from '../book-seller-address-labels/book-seller-address-labels.component';
import { BookSellerPostingLabelBriefComponent } from 'src/app/book-seller-posting-label-brief/book-seller-posting-label-brief.component';
import { BooksellerwithpratiComponent } from 'src/app/booksellerwithprati/booksellerwithprati.component';
import { BooksellerwithoutpratiComponent } from 'src/app/booksellerwithoutprati/booksellerwithoutprati.component';
import { IssuesellerdispatchreportlistComponent } from 'src/app/issuesellerdispatchreportlist/issuesellerdispatchreportlist.component';
import { BooksellerdispatchreportlistComponent } from 'src/app/booksellerdispatchreportlist/booksellerdispatchreportlist.component';
import { BookSellerpostingOfficerepreportComponentComponent } from 'src/app/book-sellerposting-officerepreport-component/book-sellerposting-officerepreport-component.component';
import { BookSellerAddressLabelsComponentsComponent } from 'src/app/book-seller-address-labels-components/book-seller-address-labels-components.component';
import { BookSellerStatewisestatementComponent } from 'src/app/book-seller-statewisestatement/book-seller-statewisestatement.component';
import { BooksellerDistrictwiseStatementComponentComponent } from 'src/app/bookseller-districtwise-statement-component/bookseller-districtwise-statement-component.component';
import { GranthRegistaionLedgerIndetailReportComponent } from 'src/app/granth-registaion-ledger-indetail-report/granth-registaion-ledger-indetail-report.component';
import { GranthRegistrationLedgerReportBriflyComponent } from 'src/app/granth-registration-ledger-report-brifly/granth-registration-ledger-report-brifly.component';
import { BookSellerdispatchLabelsComponent } from 'src/app/book-sellerdispatch-labels/book-sellerdispatch-labels.component';
import { BookSellerpracelLabelsComponent } from 'src/app/book-sellerpracel-labels/book-sellerpracel-labels.component';
import { GranthRegistrationLedgerBriflyReportComponent } from 'src/app/granth-registration-ledger-brifly-report/granth-registration-ledger-brifly-report.component';
import { GranthRegistrationLedgerIndetailOfficerReportComponent } from 'src/app/granth-registration-ledger-indetail-officer-report/granth-registration-ledger-indetail-officer-report.component';
import { GranthRegistrationLedgerVeryBriflyOfficerReportComponent } from 'src/app/granth-registration-ledger-very-brifly-officer-report/granth-registration-ledger-very-brifly-officer-report.component';
import { GranthRegistrationLedgerBrieflyOfficerComponent } from 'src/app/granth-registration-ledger-briefly-officer/granth-registration-ledger-briefly-officer.component';
import { BusinessReportIndetailGranthComponent } from 'src/app/business-report-indetail-granth/business-report-indetail-granth.component';
import { BooksellerPrintJavakComponent } from 'src/app/bookseller-print-javak/bookseller-print-javak.component';
import { BookSellerHandDeliveryComponent } from 'src/app/book-seller-hand-delivery/book-seller-hand-delivery.component';
import { BookSellerPrintOrderStatementComponent } from 'src/app/book-seller-print-order-statement/book-seller-print-order-statement.component';
import { BussinessReportBriflyGranthComponent } from 'src/app/bussiness-report-brifly-granth/bussiness-report-brifly-granth.component';
import { BookSellerAddressLabelsComponent2Component } from 'src/app/book-seller-address-labels-component2/book-seller-address-labels-component2.component';
import { BooksellerViewPrintOrderComponentComponent } from 'src/app/bookseller-view-print-order-component/bookseller-view-print-order-component.component';
import { BookSellerUpdatePrintOrderComponent } from 'src/app/book-seller-update-print-order/book-seller-update-print-order.component';
import { RegistrationReportGranthVeryBrieflyComponent } from 'src/app/registration-report-granth-very-briefly/registration-report-granth-very-briefly.component';
import { GranthBussinessOfficeRepIndetailsComponent } from 'src/app/granth-bussiness-office-rep-indetails/granth-bussiness-office-rep-indetails.component';
import { GranthBussinessOfficeRepIndetailsofficerepwiseComponent } from 'src/app/granth-bussiness-office-rep-indetailsofficerepwise/granth-bussiness-office-rep-indetailsofficerepwise.component';
import { GranthSellerLedgerBriefReportIndetailComponent } from 'src/app/granth-seller-ledger-brief-report-indetail/granth-seller-ledger-brief-report-indetail.component';
import { GranthOutstandingBriefComponent } from 'src/app/granth-outstanding-brief/granth-outstanding-brief.component';
import { GranthOutstandingReportComponent } from 'src/app/granth-outstanding-report/granth-outstanding-report.component';
import { OfficeRepBrieflyGranthComponent } from 'src/app/office-rep-briefly-granth/office-rep-briefly-granth.component';
import { OfficeRepUnpaidBrieflyGranthComponent } from 'src/app/office-rep-unpaid-briefly-granth/office-rep-unpaid-briefly-granth.component';
import { UnpaidGranthOutstandingBriefComponent } from 'src/app/unpaid-granth-outstanding-brief/unpaid-granth-outstanding-brief.component';
import { UnpaidGranthOutstandingDetailComponent } from 'src/app/unpaid-granth-outstanding-detail/unpaid-granth-outstanding-detail.component';
import { GranthSellerAddressLabelsComponent } from 'src/app/granth-seller-address-labels/granth-seller-address-labels.component';
import { GrantSellerWithoutPratiComponent } from 'src/app/grant-seller-without-prati/grant-seller-without-prati.component';
import { GranthSellerWithPratiComponent } from 'src/app/granth-seller-with-prati/granth-seller-with-prati.component';
import { GranthSellerAddresscomponentgranthwithComponent } from 'src/app/granth-seller-addresscomponentgranthwith/granth-seller-addresscomponentgranthwith.component';
import { GranthSellerDispatchReportListComponent } from 'src/app/granth-seller-dispatch-report-list/granth-seller-dispatch-report-list.component';
import { GranthSellerPostingOffReportComponent } from 'src/app/granth-seller-posting-off-report/granth-seller-posting-off-report.component';
import { GranthSellerDispatchLabelsComponent } from 'src/app/granth-seller-dispatch-labels/granth-seller-dispatch-labels.component';
import { GranthSellerHandDeliveryComponent } from 'src/app/granth-seller-hand-delivery/granth-seller-hand-delivery.component';
import { BookSellerPrintOrderStatementgranthComponent } from 'src/app/book-seller-print-order-statementgranth/book-seller-print-order-statementgranth.component';
import { SellerGrantViewPrintOrderComponent } from 'src/app/seller-grant-view-print-order/seller-grant-view-print-order.component';
import { GranthSellerUpdatePrintOrderComponent } from 'src/app/granth-seller-update-print-order/granth-seller-update-print-order.component';
import { SendReminderLetterGranthComponent } from 'src/app/send-reminder-letter-granth/send-reminder-letter-granth.component';
import { ViewReceiptpackagebookComponent } from 'src/app/viewreceiptpackagebook/viewreceiptpackagebook.component';
// import { BooksellerAddressLabelsMobileNoComponent } from 'src/app/bookseller-address-labels-mobile-no/bookseller-address-labels-mobile-no.component';
// import { IssueSellerAddressLabelsComponent } from 'src/app/issue-seller-address-labels/issue-seller-address-labels.component';
// import { BookSellerAddressLabelsComponent } from 'src/app/book-seller-address-labels/book-seller-address-labels.component';
// import { SendReminderLetterBookComponent } from 'src/app/send-reminder-letter-book/send-reminder-letter-book.component';
// import { SendReminderLetterRepBookComponent } from 'src/app/send-reminder-letter-rep-book/send-reminder-letter-rep-book.component';
// import { ContractBriefBookReportComponent } from 'src/app/contract-brief-book-report/contract-brief-book-report.component';

export const _filter = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter1 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter2 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter7 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter3 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter4 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter5 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter6 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter8 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter9 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter10 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter11 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

export const _filter12 = (opt: string[], value: string): string[] => {
  const filterValue = value.toLowerCase();

  return opt.filter((item) => item.toLowerCase().includes(filterValue));
};

const uploadAPI = 'https://vivekweb.in/VivekApplication/portal_fileUpload.php';


export function financialYearValidator(): ValidatorFn {
  return (control: FormControl) => {
    const selectedDateStr = control.value;
    const selectedDate = new Date(selectedDateStr);

    // Read financial year boundaries from localStorage
    const startDateStr = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const endDateStr = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    if (!startDateStr || !endDateStr || isNaN(selectedDate.getTime())) {
      return { financialYear: true }; // invalid or missing data
    }

    const financialYearStart = new Date(startDateStr);
    const financialYearEnd = new Date(endDateStr);

    // Check if the selected date is within the stored financial year range
    if (selectedDate >= financialYearStart && selectedDate <= financialYearEnd) {
      return null; // Valid
    } else {
      return { financialYear: true }; // Invalid
    }
  };
}


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  BookForm: FormGroup;
  subform: FormGroup;
  packsubform: FormGroup;
  bookExpenseForm!: FormGroup;
  // removedBookIds: number[] = [];
  bsform: FormGroup;
  bookpymtrecptform: FormGroup;
  bookcommrecptform: FormGroup;
  bookrcptregisterform: FormGroup;
  bookcommrcptform: FormGroup;
  bookrepcommisionform: FormGroup;
  bookrepcommision1form: FormGroup;
  booksellercrdtnoteform: FormGroup;
  bookoutstandingform: FormGroup;
  bookoutstandingform1: FormGroup;
  bookName: FormGroup;
  addSellerType: FormGroup;
  addDeliveryModeType: FormGroup;
  addComplType: FormGroup;
  addAbhiyanType: FormGroup;
  bookcrdtnoteForm: FormGroup;
  bookselectedForm: FormGroup;
  expense: FormGroup;
  distributionForm: FormGroup;
  imgPath: string;
  bookData: any = [];
  bookStockData: any = [];
  bookdata: any = [];
  book_data = [];
  totalBookPrice = 0;
  totalPrintOrder = 0;
  totalAuthorHonorarium = 0;
  book_data1;
  bookDeliveryData = [];
  deliveredBooks = [];
  totalPaperBill = 0;
  totalPrintingBill = 0;
  totalProcessing = 0;
  totalCover = 0;
  totalOther = 0;
  totalShipping = 0;
  totalExpense = 0;
  totalBilling = 0;
  totalReceived = 0;
  totalOutstanding = 0;
  displayFilter = false;
  bookimgpath = 'https://vivekweb.in/VivekApplication/uploads/';
  total = 0;
  booksizeform: FormGroup;
  authorForm: FormGroup;
  bookselleraddressForm: FormGroup;
  bookselForm: FormGroup;
  bookselgranthForm: FormGroup;
  bookcommForm: FormGroup;
  officerepdata;
  officerepnames = [];
  selectedState = '';
  selectedCity = '';
  selectedTaluka = '';
  repNameSearch: string = '';
  bookNameSearch: string = '';
  bookNameSearch1: string = '';
  filteredSubDistributionModes: any;
  // cdr: any;
  curweekfirstday: any;
  preweekfirstday: any;
  labelsforDispatch: any;
  FilteredlabelsforDispatch: any;
  FilteredlabelsforPostStatement: any[];
  pindcodelist: any[];
  taluka_names: any;
  pincodes: any;
  yourForm: any;
  iscustomer: any;
  LabelsDispatchSubnames: any;
  LabelsDispatchRepNames: any;
  LabelsDispatchOffRepNames: any;
  LabelsDispatchDisRepNames: any;
  LabelsDispatchDeliveryModes: any;
  disrepnames: string;
  subdismode: string;
  dismode1: string;
  FilteredLabelsListForDispatch: any;
  mode_names: any;
  state_names: any;
  district_names: any;
  sub_mode: any;
  dist_rep_name: any;
  country_names: any;
  repnames: any;
  disRepData: any;
  sub_names: any;
  filteredIssueSellerList: any;
  dev_mode: any;
  id: any;
  delivery_update_data: any;
  compl_update_data: any;
  abhiyan_update_data: any;
  FilteredGSTdata = [];
  showGSTReceiptData: any[];
  exportGSTReceiptData = [];
  gstreporttotalamt = 0;
  resultData: any[];
  months = [
    'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
    'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'
  ];
  monthName: string = '';
  monthTotal: number = 0;
  complementryTotal: number;
  soldCopiesTotal: number;
  abhiyanTotal: number;
  totalSellTotal: number;
  availableTotal: number;
  printorderTotal: number;
  openingstockTotal: number;
  openingValueTotal: number;
  balanceStockTotal: number;
  valueOfBookTotal: number;
  totalBillingTotal: number;
  receivedAmtTotal: number;
  creditAmountTotal: number;
  outstandingAmtTotal: number;
  bookretrunCopiesTotal: number;
  availableStock: number;
  selectAll: any;
  selectedItems: any;
  bookingId: any;
  gstType: any;
  gstPercentage: number;
  gstAmount: number;
  withoutGstAmount: number;
  withGstAmount: number;
  totalAmount: any;
  filteredDistributorList: any;
  distributionModeList: any;
  distributionmodesData1: any;
  distributionmodesData: any;
  distributorList: any;
  selectedModes: any[];
  delivery_mode: any;
  FilteredsubDistributionModeData: any;
  filteredOptions28: any
  filteredOptionsdist: Observable<any>;
  Filteredbookdata2: unknown[];
  Filteredbookdatagranth: unknown[];
  authorList: unknown[];
  allSelected: any;
  selectedItems2: any;
  bookrcptForm: any;
  bname: any;
  filteredOptionspackage: Observable<any[]>;
  book_seller_datapack: any;
  financialYearMin: Date;
  financialYearMax: Date;
  financialYearSelected: boolean;
  startDate: Date;
  endDate: Date;
  office_rep_name: string;
  office_rep_name_registration: string;
  totalInvoice: number;
  totalReceipt: number;
  totalCredit: number;
  totalPending: number;
  delivery_mode1: any;
  filteredOptionsbook: any;
  filteredOptionsbookdm: any;
  distributorList1: any;
  distributorListDM: any;
  filteredData: any;
  names: any[] = [];           // Original data from API
  filteredNames: any[] = [];   // Filtered data for display
  searchText: string = '';
  matSelect: any;
  totalBillAmount = 0;
  totalRepCommission = 0;
  totalSelectEntry = 0;
  totalInvoiceAmount: number;
  totalInvoiceReceived: number;
  totalReceivedAmount: number;
  totalCommission: number;
  totalPaidCommission: number;
  totalUnpaidCommission: number;
  filteredBookNames: any[] = [];
  isExistingSeller: boolean;
  granthPriceTotal: number;
  granthCommissionTotal: number;
  granthRemainingTotal: number;
  repCommissionTotal: number;
  someSelected: boolean;
  booksByOrder: any;
  bookForm: any;
  startdate: any;
  enddate: any;
  books: any;
  Filter: any;
  businessReportList: any;
  granthunquiedata;
  granthdata1: Object;
  startDate_registrationReport: string = '';
  enddate_registrationReport: string = '';
  dispatchissueForm: FormGroup<{ DeliveryMode: FormControl<string | null>; DistributiveRep: FormControl<string | null>; DistributionMode: FormControl<string | null>; SubDistMode: FormControl<string | null>; }>;
  advtCategorylist: Object;
  filteredIssueDates: any[];
  selectedCategory: any;
  issueSellerPrice: number;
  allIssueDates: any[];
  adddeliverymode: FormGroup<{ deliverymode: FormControl<string | null>; }>;
  adddeliverymodeform: FormGroup<{ deliverymode: FormControl<string | null>; subdeliverymode: FormControl<string | null>; }>;
  subdistributionmodesData: any;
  subDeliveryModeData: any;
  addsubdeliverymodeform: FormGroup<{ deliverymode: FormControl<string | null>; subdeliverymode: FormControl<string | null>; }>;
  AssignDisRepForm: FormGroup<{ disrep1: FormControl<string | null>; dismode: FormControl<string | null>; dissubmode: FormControl<string | null>; }>;
  distributionmoderepData: any;
  deliveryModes: any;
  filteredDistributionModes: any[];
  filteredSubDistModes: any[];
  yourService: any;
  // filteredSubDistributionModes: any;
  cdr: any;
  DistributiveRep: any;
  selectedDeliveryModeName: any;
  show_prati: any;
  sub_type: any;
  dispatchdate: any;
  filterForm: any;
  bookregistrationdatapackage: any[];
  issuedate: any;
  disRepData1: any;
  labeldata: Object;
  person_name: any;
  handDeliveryData: any;
  subDistributionModeData: any;
  filteredOptions17: Observable<any>;
  originalPrintOrderData: any;
  form: any;
  isAllSelected6: any;
  granthoutstandingform: FormGroup<{ start: FormControl<string>; end: FormControl<string>; officerepwise: FormControl<string>; repwise: FormControl<string>; booksellerwise: FormControl<string>; bookwise: FormControl<string>; repname: FormControl<string>; mob: FormControl<string>; }>;
  isLoading: boolean;
  printOrderDatagranth: any;
  resultData1: any[];
  bookSellerId: null;
  sub_no: any[];

  // show_prati_hide: boolean;
  // filteredOptionspack: any;
  //   totalInvoice = 0;
  // totalReceipt = 0;
  // totalCredit = 0;
  // totalPending = 0;
  safeNum(val: any): number {
    return val != null && !isNaN(Number(val)) ? Number(val) : 0;
  }


  // options: string[] = ['सप्रेम भेट', 'देणगी', 'लेखक','इतर'];

  complementary(checked: boolean) {
    this.iscomplementary = checked;
  }

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  businessForm = this.fb.group({
    start: [''],
    end: [''],
    officerepwise: [[]],
    country: [''],
    state: [''],
    district: [''],
    taluka: ['']
  });


  Managerange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repname: new FormControl(),
    book_name: new FormControl(),
    custname: new FormControl(),


  });
  searchBillControl = new FormControl('');
  filteredBillNos: any[] = [];
  rangeRegistration = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    bookwise: new FormControl(),  // ✅ FIX
    officerepwise: new FormControl(),  // ✅ FIX
    repwise: new FormControl(),  // ✅ FIX
    cust_name: new FormControl()
  });

  BookrangeRegistration = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  Sendreminderform = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null),
    repwise: new FormControl([]),
    advtname: new FormControl(null),
    booksellername: new FormControl([]),
    reportType: new FormControl(null)
  });

    Sendreminderformgranth = new FormGroup({
    start: new FormControl(null),
    end: new FormControl(null),
    repwise: new FormControl([]),
    advtname: new FormControl(null),
    booksellername: new FormControl([]),
    reportType: new FormControl(null)
  });



  BookbillingRegister = this.fb.group({
    start: [''],
    end: [''],
    invoice_no: [''],
    cust_name: [''],
    repwise: [[]],
    officerepwise: [[]]
  });
  // BookLedgerform = new FormGroup({
  //   start_date: new FormControl(''),
  //   end_date: new FormControl(''),
  //   book_seller_name: new FormControl(''),
  // });

  BookStockform = new FormGroup({
    start_date: new FormControl(''),
    end_date: new FormControl(),
    book_name: new FormControl(''),
  });


   generateform = new FormGroup({

    bookwise: new FormControl([]),

    dispatchdate: new FormControl(''),
    sellertype: new FormControl(''),
    type: new FormControl(''),
    booksellerwise: new FormControl([]),

    DistributiveRep: new FormControl(''),

    start_date: new FormControl(''),
    end_date: new FormControl(''),

    adesh_from: new FormControl(''),
    adesh_to: new FormControl(''),

    // ✅ ADD THIS
    start_publish_date: new FormControl(''),
    end_publish_date: new FormControl(''),

    country: new FormControl(''),
    state: new FormControl(''),
    district: new FormControl([]),
    taluka: new FormControl([]),
    pincode: new FormControl([]),
    subdismode: new FormControl([]),

    repwise: new FormControl([]),
    officerepwise: new FormControl([]),

    DeliveryMode: new FormControl([]),
    DistributionMode: new FormControl([]),
    SubDistMode: new FormControl([]),

    DeliveryMode1: new FormControl([]),
    DistributionMode1: new FormControl([]),
    SubDistMode1: new FormControl([]),
    DistributiveRep1: new FormControl(''),

    issue_date: new FormControl(''),
    issueCatregoryId: new FormControl(''),

    showMobileNo: new FormControl('no')
  });
  generateform1 = new FormGroup({

    bookwise: new FormControl([]),

    dispatchdate: new FormControl(''),
    sellertype: new FormControl(''),
    type: new FormControl(''),
    booksellerwise: new FormControl([]),

    DistributiveRep: new FormControl(''),

    start_date: new FormControl(''),
    end_date: new FormControl(''),

    adesh_from: new FormControl(''),
    adesh_to: new FormControl(''),

    // ✅ ADD THIS
    start_publish_date: new FormControl(''),
    end_publish_date: new FormControl(''),

    country: new FormControl(''),
    state: new FormControl(''),
    district: new FormControl([]),
    taluka: new FormControl([]),
    pincode: new FormControl([]),
    subdismode: new FormControl([]),

    repwise: new FormControl([]),
    officerepwise: new FormControl([]),

    DeliveryMode: new FormControl([]),
    DistributionMode: new FormControl([]),
    SubDistMode: new FormControl([]),

    DeliveryMode1: new FormControl([]),
    DistributionMode1: new FormControl([]),
    SubDistMode1: new FormControl([]),
    DistributiveRep1: new FormControl(''),

    issue_date: new FormControl(''),
    issueCatregoryId: new FormControl(''),

    showMobileNo: new FormControl('no')
  });



  public uploader: FileUploader = new FileUploader({
    url: uploadAPI,
    itemAlias: 'file',
  });
  userprofile: any;
  userprofileStartDate: any;
  userprofileEndDate: any;
  userprofileForm: any;
  entryForm: any;
  bookselnamedata1: any;
  bookselnamedata: any;
  priceTotal: number = 0;
  bookCopiesTotal: number = 0;
  shippingCharges: number = 0;
  totalTotal: number = 0;
  recvTotal: number = 0;
  creditTotal: number = 0;
  remTotal: number = 0;
  commissionTotal: number = 0;
  commRemainingTotal: number = 0;
  remainingTotal: number = 0;
  commTotal: number = 0;
  commission_Total: number = 0;
  receivedAmount: number = 0;
  receivedCommAmount: number = 0;
  receivedCrdtAmount: number = 0;

  contractData = [];
  bookExpenseList: any = [];
  outstandingData = [];
  contractRepName = [];
  contractOffRepName = [];
  contractAdvtName = [];
  booksellerName = [];
  newList1 = []
  PaymentBookInDTotal: number;
  deleterec: boolean;
  deleteInc: boolean;
  deleteComm: boolean;

  getBookdeleterecipt: any;
  getdeletereciptinvoice: any;
  getdeletereciptComm: any;

  deleteOrd: boolean;
  deleteOrdpack: boolean;
  getdeleteOrder: any;
  getdeleteOrder1: any;


  invoiceData: any[] = [];
  booksellernamedata2: any;
  bookpymtcrdtdata: any[] = [];
  getdeletecn: any;
  deletecn: boolean = false;
  seller_type_update_btn: boolean = false;
  compl_type_update_btn: boolean = false;

  abhiyan_type_update_btn: boolean = false;
  bookCrdtRegisterdata;
  FilteredbookCrdtdata: any[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    public service: DigisubservicesService,
    public dialog: MatDialog,
    public encr: EncdecriptService,
    private datePipe: DatePipe,
    //private decimalPipe: DecimalPipe
  ) {

    this.BookForm = fb.group({
      bookname: [''],
      granthname: [''],
      bookdesc: [''],

      price: [''],
      saleprice: [''],
      agentprice: [''],

      bookimg: [''],

      authorname: [''],
      prakashanname: [''],

      bookpagesbw: [''],
      bkpinsidecolor: [''],
      bkpcover: [''],

      booksize: [''],

      paperbw: [''],
      paperinsidecolor: [''],
      papercover: [''],

      totalpages: [''],
      binding: [''],

      booklang: [''],
      bookyear: [''],      // ✅ Keep only one
      yearwisebook: [''],

      bookedition: [''],
      bookedtndate: [''],
      bookedtncpoies: [''],

      opening_stock: [''],
      author_honorarium: [''],

      isdelivery: [''],
      isupcoming: [''],
      upcomingdate: [''],

      discountupto: [''],
      bookcategory: ['']
    });

    this.expense = fb.group({
      expnameother: [''],
      subexpnameother: [''],
      start: [''],
      end: [''],
    });

    this.addSellerType = fb.group({
      sellertype: [''],
    });

    this.addDeliveryModeType = fb.group({
      deliverytype: [''],
    });
    this.addComplType = fb.group({
      comptype: [''],
    });
    this.addAbhiyanType = fb.group({
      abhiyantype: [''],
    });


    // const sellerTypes = [
    //   { value: 'स्टाँल', label: 'Individual' },
    //   { value: 'विक्री', label: 'Retailer' },
    //   { value: 'सप्रेम भेट', label: 'Wholesaler' },
    //   { value: 'देणगी', label: 'Distributor' },
    //   { value: 'लेखक', label: 'Distributor' }
    // ];


    this.subform = fb.group({
      subname: [''],
      subname1: [''],
      subname_eng: [''],
      title: ['', [Validators.minLength(2)]],
      name: ['', [Validators.minLength(2)]],
      address: ['', [Validators.minLength(2)]],
      sellertype: ['', [Validators.minLength(2)]],
      comptype: ['', [Validators.minLength(2)]],
      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
      ],
      country: ['', [Validators.minLength(2)]],
      state: ['', [Validators.minLength(2)]],
      district: ['', [Validators.minLength(2)]],
      district_eng: [''], // ✅ Added here
      taluka: ['', [Validators.minLength(2)]],
      mobileNumber: [
        '',
        [Validators.maxLength(10), Validators.pattern('^[7-9][0-9]{9}$')],
      ],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
      ],
      dob: [''],
      doa: [''],
      crepname: [''],
      repmobno1: [''],
      officerep: [''],
      bookdate: [''],
      orderno: [''],
      bookname: [''],
      availablestock: [''],
      authorname: [''],
      complimentaryOption: [''],
      prakashanname: [''],
      iscomplimentary: [''],
      yearwisebook: [''],
      agentprice: [''],
      dispatchto: [''],
      option: [''],
      deliverymode: [''],
      repcompercent: ['', [Validators.pattern('^[0-9]*$')]],
      repcomprice: [''],
      cdno: [''],
      chequeDate: [''],
      bankname: [''],
      pymtmode: [''],
      depositamt: [''],
      bookcopies: [''],
      discount: [''],
      shippingcharging: [''],
      bookSellerGstType: [''],
      gstPercentage: [''],
      gstAmount: [''],
      withoutGstAmount: [''],
      withGstAmount: [''],
      totalAmount: [''],
      DeliveryMode: [''],
      DistributiveRep: [''],
      // SubDistMode: [''],
      SubDistMode: [[]],
      DistributionMode: [''],
      sgstAmount: [''],
      cgstAmount: [''],
      igstAmount: [''],
      gstNumber: [''],
    });

    this.packsubform = this.fb.group({

      /* ================= Subscriber Search ================= */
      subscribersName: [''],
      subscribersNo: [''],
      mobileNumber: [''],

      /* ================= Personal Details ================= */
      title: [''],
      titleEnglish: [''],
      nameRequired: ['', [Validators.required, Validators.minLength(2)]],
      nameEnglish: [''],

      address: ['', Validators.required],
      e_address: [''],
      e_address1: [''],
      e_address2: [''],

      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')]
      ],
      pincodeEnglish: [''],

      country: [''],
      countryEnglish: [''],
      state: [''],
      stateEnglish: [''],
      district: [''],
      districtEnglish: [''],
      taluka: [''],
      talukaEnglish: [''],

      mobileNumberField: [''],
      telephone: [''],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[a-z]{2,3}$')]
      ],

      dob: [''],
      doa: [''],
      representativeName: [''],
      representativeMobile: [''],
      gstNumber: [''],
      remark: [''],
      sellertype: [''],

      /* ================= Booking Details ================= */
      orderno: [''],
      bookdate: ['', Validators.required],
      newordeleted: ['new'],

      crepname: [''],
      repmobno1: [''],
      officerep: [''],

      /* ================= Book Selection ================= */
      bookname: [''],
      availablestock: [''],
      authorname: [''],

      iscomplimentary: [false],
      isSponsor: [false],
      complimentaryOption: [''],

      /* ================= Table Calculations ================= */
      bookcopies: [''],
      discount: [''],
      shippingcharging: [''],
      repcompercent: [''],
      commissionamt: [''],

      /* ================= GST ================= */
      bookSellerGstType: ['NO_GST'],
      gstPercentage: [''],
      gstAmount: [''],
      sgstAmount: [''],
      cgstAmount: [''],
      igstAmount: [''],
      totalAmount: [''],

      /* ================= Dispatch ================= */
      option: [''],
      deliverymode: [''],

      DeliveryMode: [[]],
      DistributiveRep: [''],
      DistributionMode: [[]],
      SubDistMode: [[]],
      recptno: [''],
      crdtvno: [''],
      rep_name: [''],
      seamt: [''],
      receivedamt: [''],
      granthname: [''],
    });



    this.bookpymtrecptform = fb.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      recptno: [''],
      crdtvamt: [''],
      seamt: [''],
      balamt: [''],
      booksellername: [''],
      bname: [''],
      booksellernamesearch: [''],
      newordeleted: [''],
    });
    this.adddeliverymode = fb.group({
      deliverymode: [''],
    });
      this.granthoutstandingform = fb.group({
      start: [''],
      end: [''],
      officerepwise: [''],
      repwise: [''],
      booksellerwise: [''],
      bookwise: [''],
      repname: [''],
      mob: [''],
    });

    this.bookcommrecptform = fb.group({
      date: [''],
      crdtvno: [''],
      recptdate: [''],
      repname: [''],
      rep_address: [''],
      commino: [''],
      commvamt: [''],
      seamt: [''],
      balamt: [''],
      booksellername: [''],
      bookrepnamesearch: [''],
      newordeletedComm: [''],
    });

    this.bsform = fb.group({
      subname: [''],
    });

    this.bookrcptregisterform = fb.group({
      start: [''],
      end: [''],
      repwise: [''],
      billnowise: [''],
      remarkwise: [''],   // <-- Added
      booksellerwise: [''],
      bookwise: [''],
      officerepwise: [''],
      monthwise: [''],
      vistrut: [''],
      sankshipt: [''],
    });

    this.bookcommrcptform = fb.group({
      start: [''],
      end: [''],
      repwise: [''],
      billnowise: [''],
      booksellerwise: [''],
      bookwise: [''],
      officerepwise: [''],
      monthwise: [''],
    })
    this.bookExpenseForm = this.fb.group({

      start_date: [''],
      end_date: [''],
      bookwise: [[]],
      author_name: ['']

    });


    this.bookrepcommisionform = this.fb.group({
      start: [''],
      end: [''],
      repwise: [[]],
      officerepwise: [[]],
      booksellerwise: [[]],
      commissionType: []   // <--- ADD THIS
    });

    this.bookrepcommision1form = this.fb.group({
      // start: [''],
      // end: [''],
      repwise: [[]],
      officerepwise: [[]],
      // booksellerwise: [[]],
      // commissionType: []   // <--- ADD THIS
    });


    this.userprofileForm = fb.group({
      start: [''],
      end: [''],

    });

    this.entryForm = fb.group({
      start: [''],
      end: [''],

    });



    this.booksellercrdtnoteform = fb.group({
      start: [''],
      end: [''],
      repwise: [''],
      prakashanwise: [''],
      booksellerwise: [''],
      monthwise: [''],
      vistrut: [''],
      sankshipt: [''],
    });

    this.bookoutstandingform = fb.group({
      start: [''],
      end: [''],
      officerepwise: [''],
      repwise: [''],
      booksellerwise: [''],
      bookwise: [''],
      repname: [''],
      mob: [''],
    });

    this.bookoutstandingform1 = fb.group({
      start: [''],
      end: [''],
      // officerepwise: [''],
      // repwise: [''],
      booksellerwise: ['']
      // bookwise: [''],
      // repname: [''],
      // mob: [''],
    });

    this.bookName = fb.group({
      bookname: [''],
    });

    this.bookcrdtnoteForm = fb.group({
      todaydate: [''],
      crdtnoteno: [''],
      date: [''],
      repname: [''],
      offrepname: [''],
      bsname: [''],
      crditnoteamt: [''],
      returncopies: [''],
      remark: [''],
      receiver_address: ['']
      // crdtvno: [''],
      // crdtnotedate: [''],
      // crdtno: [''],
      // booksellername: [''],
      // bname: [''],
      // booksellernamesearch: [''],
    });

    this.bookselectedForm = fb.group({
      returncopies: [''],
      crdtnoteamt: [''],
      remark: [''],
    });

    this.distributionForm = fb.group({
      disrep: [''],
      dismode: [''],
      subdismode: [''],
      vajan: [''],
      tapalrate: [''],
    });

    // this.generateform1 = fb.group({
    //   DeliveryMode: [''],
    //   DistributiveRep: [''],
    //   DistributionMode: [''],
    //   SubDistMode: [''],
    // });
    this.booksizeform = fb.group({
      booksize: [''],
    });

    this.authorForm = fb.group({
      authorname: [''],
      address: ['', [Validators.minLength(2)]],
      pincode: [
        '',
        [Validators.maxLength(6), Validators.pattern('^[1-9][0-9]{5}$')],
      ],
      country: ['', [Validators.minLength(2)]],
      state: ['', [Validators.minLength(2)]],
      district: ['', [Validators.minLength(2)]],
      taluka: ['', [Validators.minLength(2)]],
      mob_no: [
        '',
        [Validators.maxLength(10), Validators.pattern('^[7-9][0-9]{9}$')],
      ],
      email: [
        '',
        [Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[a-z]{2,3}$')],
      ],
      pan_no: ['', Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}$')],
      aadhar_no: ['', Validators.pattern('^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$')],
      bank_name: [''],
      branch: [''],
      acc_no: [''],
      ifsc_code: [''],
    });

    this.bookselleraddressForm = fb.group({
      bsname: [''],
      start: [''],
      end: [''],
      country: [''],
      state: [''],
      district: [''],
      taluka: [''],
      office_rep_name: [''],
      repname: [''],
      complimentary: [''],
    });


    this.bookselForm = fb.group({
      vstart_date: [''],
      vend_date: [''],
      estart_date: [''],
      eend_date: [''],
      rep_name: [''],
      book_names: [''],
      book_seller_name: [''],

    });
    this.bookselgranthForm = fb.group({
      vstart_date: [''],
      vend_date: [''],
      estart_date: [''],
      eend_date: [''],
      rep_name: [''],
      book_names: [''],
      book_seller_name: [''],


    });
    this.adddeliverymodeform = fb.group({
      deliverymode: [''],
      subdeliverymode: [''],
    });
    this.AssignDisRepForm = fb.group({
      disrep1: [''],
      dismode: [''],
      dissubmode: [''],
    });
    this.adddeliverymode = fb.group({
      deliverymode: [''],
    });
    this.addsubdeliverymodeform = this.fb.group({
      deliverymode: ['', Validators.required],
      subdeliverymode: ['', Validators.required]
    });

    this.bookcommForm = fb.group({
      start: [''],
      end: [''],
      estart_date: [''],
      eend_date: [''],
      // rep_name: [''],
      rep_name: [''],
      book_seller_name: [''],

    });
    // this.bookcommForm.patchValue({ rep_name: 'XYZ' });





  }

  filteredOptions: Observable<string[]>;
  //  filteredOptions26: Observable<string[]>;
  filteredOptions1: Observable<string[]>;
  filteredOptions2: Observable<string[]>;
  filteredEditions: Observable<string[]>;
  filteredOptions3: Observable<string[]>;
  filteredOptions4: Observable<string[]>;
  filteredOptions5: Observable<string[]>;
  filteredOptions7: Observable<string[]>;
  filteredOptions8: Observable<string[]>;
  filteredOptions9: Observable<string[]>;
  filteredOptions10: Observable<string[]>;
  filteredOptions11: Observable<string[]>;
  filteredOptions26: Observable<string[]>;
  filteredOptions12: Observable<string[]>;
  filteredOptions13: Observable<string[]>;
  filteredOptions14: Observable<string[]>;
  filteredOptions15: Observable<string[]>;
  filteredOptions16: Observable<string[]>;
  filteredOptionspack: Observable<string[]>;
  filteredbookPack: Observable<string[]>;
  columnsToDisplay = [];
  bookStock;
  bookregistrationdetails = [];
  booknames = [];
  bookwisereportData = [];
  repnameList = ['all'];
  getAllRepList = [];
  bookpaymentList = [];
  displayRepoption = false;
  displayCustOption = false;
  getRepSpecificBooks = [];
  gstNumber = '';
  RepInvoiceData = [];
  CustInvoiceData = [];
  countries = [];
  rep_names = [];
  office_rep_names = [];
  book__seller__name = [];
  granth__seller__name=[];
  states = [];
  cities = [];
  titles = [];
  talukas = [];
  issueSellerName;
  issue_seller_name = [];
  book_seller_data;
  book_sellerdata = [];
  bookdata1: any = [];
  book_seller_data_pack;
  uniquedata;
  date = new Date();
  recptno;
  commino;
  invoiceno;
  book_price_total = 0;
  book_sale_price_total = 0;
  book_copies_total = 0;
  shipping_charges_total = 0;
  total_total = 0;
  amtinwords;
  totals = 0;
  bookinvoicedata;
  granthinvoicedata;
  bookorderno;
  bookregistrationdata = [];
  FilteredBookRegistration1 = [];
  FilteredBookRegistrationpackage = []
  // names: any = [];
  sellerTypes: any = [];
  Types: any = [];
  BookDeliveryTypes: any = [];
  compTypes: any = [];
  abhiyanTypes: any = [];

  filteredOptions6: Observable<string[]>;
  booksellerledgercrdtv;
  bookoutstandingdata;
  Filteredbookoutstandingdata = [];
  BookSellerLegderData;
  booksellerledgerrcpt;
  bookbillingdata;
  Filteredbookbillingdata;
  Filteredgranthbillingdata;
  BookBillingData;
  bookRcptRegisterdata;
  bookCommissiondata;
  bookOutstandingdata;
  bookReceiptRegisterdata;
  bookRcptCommisionRegisterdata;
  FilteredbookRcptRegisterdata = [];
  FilteredbookcommRcptRegisterdata = [];
  Filteredrepcommissiondata = [];
  FilteredCommbookRcptRegisterdata = [];
  Filteredbookdata = [];
  Filteredbookdata1 = [];
  bookWiseReport;
  bookdeliverydata;
  edition: string = '1st Edition';
  totalpages: number = 0;
  bookwisereplist;
  discount: any = '';
  iscomplementary: boolean = false;
  isSponsor: boolean = false;

  val1 = 0;

  bookslist;
  latestbooklist;
  crdtnoteno;
  bookregistrationdata1;
  FilteredDeliveryManageBooks = [];
  authorData;
  authornames = [];
  bookSellerAddressData;
  showFilteredBookSellerAddress;
  FilteredBookSellerAddress = [];
  repcommissiondata;
  mainexpId: any;
  mainexpName: any;
  subExpData: any[];
  subexpense: boolean = false;

  mainExpData = [
    {
      id: 35,
      exp_name: 'देणगी',
      source: 'Income'
    }
  ];


  CustGeneratedInvoice = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  invoicegetCustBook = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    billno: new FormControl(''),
    bookwise: new FormControl([]),   // multi-select → array
    cust_name: new FormControl([]),  // single select → string
    selectedItems2: new FormControl(''),
  });






  invoicegetBook = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  bookinvoicegetCustBook = new FormGroup({
    start: new FormControl(''),
    end: new FormControl(''),
    billno: new FormControl(''),
    bookwise: new FormControl([]),   // multi-select → array
    cust_name: new FormControl([]),  // single select → string
    selectedItems2: new FormControl(''),
  });

  gstreportForm = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  public demo1BtnClick1(tabCount: any) {

    this.demo1TabIndex = Number(tabCount);

  }





  userprofileDateRangeStartDate = '';
  userprofileDateRangeEndDate = '';
  userprofileDateRange() {
    if (
      this.userprofileForm.get('start').value != null &&
      this.userprofileForm.get('end').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.userprofileForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.userprofileDateRangeEndDate = formatDate(
        this.userprofileForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitEndDate);
    }
  }

  userprofileDateRange1() {

    const startValue = this.bookselForm.get('vstart_date')?.value;
    const endValue = this.bookselForm.get('vend_date')?.value;

    // ❌ if values not selected, exit
    if (!startValue || !endValue) return;

    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    const financialYearStart = new Date(this.financialYearMin);
    const financialYearEnd = new Date(this.financialYearMax);

    // ❌ 1. Financial year validation
    if (startDate < financialYearStart || endDate > financialYearEnd) {
      alert('Selected dates are not in the financial year range!');

      this.bookselForm.patchValue(
        {
          vstart_date: null,
          vend_date: null
        },
        { emitEvent: false }
      );

      return;
    }

    // ❌ 2. Start > End validation
    if (startDate > endDate) {
      alert('Start date cannot be greater than End date!');

      this.bookselForm.patchValue(
        { vend_date: null },
        { emitEvent: false }
      );

      return;
    }

    // ✅ 3. Store formatted values ONLY for API / display usage
    this.userprofileDateRangeStartDate = formatDate(
      startDate,
      'yyyy-MM-dd',
      'en-IN'
    );

    this.userprofileDateRangeEndDate = formatDate(
      endDate,
      'yyyy-MM-dd',
      'en-IN'
    );

    // ❌ IMPORTANT: DO NOT patch formatted string back to form
    // this.bookselForm.patchValue(...) ❌ REMOVE THIS (it breaks mat-date-range-input)

    // ✅ OPTIONAL: trigger API / filter here
    // this.loadUserProfileData();
  }

  userprofileDateRange2() {
    if (
      this.bookselForm.get('vstart_date').value != null
      // && this.bookselForm.get('vend_date').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.bookselForm.get('vstart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.bookselForm.patchValue({
        vstart_date: this.userprofileDateRangeStartDate,
      })
      // console.log(this.creditdebitEndDate);
    }
  }
  userprofileDateRange3() {
    debugger
    if (
      this.bookselgranthForm.get('vstart_date').value != null &&
      this.bookselgranthForm.get('vend_date').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.bookselgranthForm.get('vstart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.userprofileDateRangeEndDate = formatDate(
        this.bookselgranthForm.get('vend_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.bookselgranthForm.patchValue({
        vstart_date: this.userprofileDateRangeStartDate,
        vend_date: this.userprofileDateRangeEndDate
      })
      // console.log(this.creditdebitEndDate);
    }
  }

  userprofileDateRange4() {
    if (
      this.bookselgranthForm.get('vstart_date').value != null
      // && this.bookselForm.get('vend_date').value != null
    ) {
      this.userprofileDateRangeStartDate = formatDate(
        this.bookselgranthForm.get('vstart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.bookselgranthForm.patchValue({
        vstart_date: this.userprofileDateRangeStartDate,
      })
      // console.log(this.creditdebitEndDate);
    }
  }

  entryDateRangeStartDate = '';
  entryDateRangeEndDate = '';
  entryDateRange() {
    if (
      this.entryForm.get('start').value != null &&
      this.entryForm.get('end').value != null
    ) {
      this.entryDateRangeStartDate = formatDate(
        this.entryForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.entryDateRangeEndDate = formatDate(
        this.entryForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitEndDate);
    }
  }


  entryDateRange1() {

    const startValue = this.bookselForm.get('estart_date')?.value;
    const endValue = this.bookselForm.get('eend_date')?.value;

    if (!startValue || !endValue) return;

    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    const financialYearStart = new Date(this.financialYearMin);
    const financialYearEnd = new Date(this.financialYearMax);

    // ❌ 1. Financial year validation
    if (startDate < financialYearStart || endDate > financialYearEnd) {
      alert('Selected entry dates are not in financial year!');

      this.bookselForm.patchValue(
        {
          estart_date: null,
          eend_date: null
        },
        { emitEvent: false }
      );

      return;
    }

    // ❌ 2. Range validation
    if (startDate > endDate) {
      alert('Start date cannot be greater than End date!');

      this.bookselForm.patchValue(
        { eend_date: null },
        { emitEvent: false }
      );

      return;
    }

    // ✅ Store formatted values ONLY for API / display purpose
    this.entryDateRangeStartDate = formatDate(
      startDate,
      'yyyy-MM-dd',
      'en-IN'
    );

    this.entryDateRangeEndDate = formatDate(
      endDate,
      'yyyy-MM-dd',
      'en-IN'
    );

    // ❌ IMPORTANT: DO NOT patch formatted values back to form
  }
  getBookOutdtandingDateRange3() {


    const start = this.rangeRegistration.get('start')?.value;
    const end = this.rangeRegistration.get('end')?.value;

    if (start != null && end != null) {

      const startDateObj = new Date(start);
      const endDateObj = new Date(end);
      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ✅ FIXED HERE
      //  if (startDateObj < min || startDateObj > max) {
      //    alert('Date is outside the allowed range.');
      //    this.rangeRegistration.get('start')?.setValue(null);
      //    this.rangeRegistration.get('end')?.setValue(null);
      //  }

      this.startDate_custReport = formatDate(
        startDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.endDate_custReport = formatDate(
        endDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.dateIsEnable = true;

      // this.fetchCustData();

    } else {
      this.dateIsEnableReport = false;
      this.dateIsEnable = false;
    }
  }

  entryDateRange2() {
    if (
      this.bookselgranthForm.get('eend_date').value != null &&
      this.bookselgranthForm.get('estart_date').value != null
    ) {
      this.entryDateRangeStartDate = formatDate(
        this.bookselgranthForm.get('estart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      // console.log(this.creditdebitStartDate);

      this.entryDateRangeEndDate = formatDate(
        this.bookselgranthForm.get('eend_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.bookselgranthForm.patchValue({
        estart_date: this.entryDateRangeStartDate,
        eend_date: this.entryDateRangeEndDate
      })
      // console.log(this.creditdebitEndDate);
    }
  }
  // -------------------------
  // For bookcommForm
  // -------------------------



  // -------------------------
  // For bookcommForm
  // -------------------------



userprofileDateRangeComm() {
  const start = this.bookcommForm.get('start')?.value;
  const end = this.bookcommForm.get('end')?.value;

  if (!start || !end) return;

  const startDateObj = new Date(start);
  const endDateObj = new Date(end);

  const min = new Date(this.financialYearMin);
  const max = new Date(this.financialYearMax);

  if (startDateObj < min || startDateObj > max) {
    alert('Start date is outside allowed range');
    this.bookcommForm.get('start')?.setValue('');
    return;
  }

  if (endDateObj < min || endDateObj > max) {
    alert('End date is outside allowed range');
    this.bookcommForm.get('end')?.setValue('');
    return;
  }

  if (endDateObj < startDateObj) {
    alert('End date cannot be before start date');
    this.bookcommForm.get('end')?.setValue('');
  }
}
  filteredSubModes: any[] = [];

  private subModeSub: any;

  getSubDeliveryModes2(): void {

    this.service.getSubDeliveryModehaste().subscribe((res: any) => {

      // PHP returns array directly
      this.subDeliveryModeData = res || [];

      // initial load
      this.filteredSubModes = [...this.subDeliveryModeData];

      const control = this.AssignDisRepForm.get('subdismode');

      if (!control) return;

      // avoid multiple subscriptions
      this.subModeSub?.unsubscribe();

      this.subModeSub = control.valueChanges.subscribe((value: any) => {

        const filterValue = (value || '').toLowerCase();

        this.filteredSubModes = this.subDeliveryModeData.filter((item: any) =>
          item.sub_delivery_mode?.toLowerCase().includes(filterValue)
        );

      });
    });
  }
  private _filterSubModes1(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.subDeliveryModeData.filter((item: any) =>
      item.sub_delivery_mode.toLowerCase().includes(filterValue)
    );
  }
  onDeliveryModeChangelabel(deliveryModeName: string): void {

    this.selectedDeliveryModeName = deliveryModeName;

    if (deliveryModeName === 'हस्ते') {

      this.subform.patchValue({
        DistributionMode: ['हस्ते'],
        SubDistMode: ['हस्ते']
      });

      return;
    }

    // Other delivery modes API call
    this.service.getDistributionModes(deliveryModeName).subscribe({
      next: (res: any) => {
        this.filteredDistributionModes = res.data || [];
      }
    });
  }


  // this.filteredOptions17 = this.AssignDisRepForm.get('dismode')!.valueChanges.pipe(
  //     startWith(''),
  //     map((value: any) => typeof value === 'string' ? value : value?.sub_delivery_mode),
  //     map((name: string) =>
  //       name ? this._filter15(name) : this.subDeliveryModeData.slice()
  //     )
  //   );

  userprofileDateRange2Comm() {
    if (this.bookcommForm.get('vstart_date').value != null) {
      const userprofileDateRangeStartDate = formatDate(
        this.bookcommForm.get('vstart_date').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.bookcommForm.patchValue({
        vstart_date: userprofileDateRangeStartDate,
      });
    }
  }




  entryDateRangeComm() {
    if (
      this.bookcommForm.get('start').value != null &&
      this.bookcommForm.get('end').value != null
    ) {
      const entryDateRangeStartDate = formatDate(
        this.bookcommForm.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      const entryDateRangeEndDate = formatDate(
        this.bookcommForm.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.bookcommForm.patchValue({
        start: entryDateRangeStartDate,
        end: entryDateRangeEndDate
      });
    }
  }

entryDateRangeComm1() {

  const start = this.bookcommForm.get('estart_date')?.value;
  const end = this.bookcommForm.get('eend_date')?.value;

  if (start != null && end != null) {

    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    // ✅ year lock check
    if (startDateObj < min || startDateObj > max) {
      alert('Entry start date is outside allowed range');
      this.bookcommForm.get('estart_date')?.setValue('');
      return;
    }

    if (endDateObj < min || endDateObj > max) {
      alert('Entry end date is outside allowed range');
      this.bookcommForm.get('eend_date')?.setValue('');
      return;
    }

    if (endDateObj < startDateObj) {
      alert('Entry end date cannot be before start date');
      this.bookcommForm.get('eend_date')?.setValue('');
      return;
    }

    const entryDateRangeStartDate = formatDate(
      startDateObj,
      'yyyy-MM-dd',
      'en-IN'
    );

    const entryDateRangeEndDate = formatDate(
      endDateObj,
      'yyyy-MM-dd',
      'en-IN'
    );

    this.bookcommForm.patchValue({
      estart_date: entryDateRangeStartDate,
      eend_date: entryDateRangeEndDate
    });
  }
}
  filterByBillNo() {
    const billNo = this.bookoutstandingform.get('billnowise')?.value;

    if (billNo) {
      this.filteredData = this.bookRcptRegisterdata.filter((item: any) =>
        item.bill_no.toString().includes(billNo)
      );
    } else {
      this.filteredData = this.bookRcptRegisterdata; // reset
    }
  }


  ngOnInit() {
    this.getAllPrintOrderData();
    this.loadDeliveryModes();
    this.getSubDeliveryModes1();
    this.getSubDistributionModes1();
    this.loadDistributorData();
    // this.loadDistributors();
    // this.getSubDistributionModes();
    this.getDeliveryModes1();
    this.getSubModes();
    this.getAllDistributionModes();
    this.getSubDeliveryModes();
    this.getDeliveryModes();
    const start = sessionStorage.getItem('startDate'); // e.g. "2025-04-01"
    const end = sessionStorage.getItem('endDate');     // e.g. "2026-03-31"

    this.financialYearMin = start ? new Date(start) : new Date('1900-01-01');
    this.financialYearMax = end ? new Date(end) : new Date('2099-12-31');
    this.searchBillControl.valueChanges.subscribe((value) => {
      this.bookRcptRegisterdata(value);
    });
    this.searchExpense();
    this.getAuthorList();



    this.demo1BtnClick1(localStorage.getItem("tab"))

    //this.date.setMonth(this.date.getMonth() + 1); // Move to next month
    // const dateString = this.pendingbookdata['voucher_date'];/


    // console.log(this.pendingbookdata.voucher_date);  // Output: 2025-03-10

    this.BookForm.get('bookedition').setValue(this.edition);





    // }


    // this.service.getCrdtNoteNo().subscribe((data) => {
    //   let val = 0;
    //   if (data != null) {
    //     val = parseInt(data['id']) + 1;
    //     //this.crdtnoteno = `BDCN${month}/${year}-${nextyear}/${val}`;
    //     this.bookcrdtnoteForm.get('crdtnoteno').setValue(this.crdtnoteno);
    //     this.bookcrdtnoteForm
    //       .get('date')
    //       .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));
    //   } else {
    //     val = 1;
    //     //this.crdtnoteno = `BDCN${month}/${year}-${nextyear}/${val}`;
    //     this.bookcrdtnoteForm.get('crdtnoteno').setValue(this.crdtnoteno);
    //     this.bookcrdtnoteForm
    //       .get('date')
    //       .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));
    //   }
    // });

    // crdtNotedate = '';
    // invoicedateChange(event) {
    //   console.log(event.value);

    //   this.crdtNotedate = formatDate(
    //     event.value,
    //     'yyyy-MM-dd',
    //     'en-IN',
    //     'GMT+0530'
    //   );
    //   this.getInvoiceNo(this.invoicedate)
    // }

    const currentDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '';



    debugger

    this.service.getBookWiseRep().subscribe((data) => {

      this.bookwisereplist = data;
      this.getContractDetails();

    });
    this.service.getDistributionModeRep1().subscribe((data) => {
      this.distributionmoderepData = data;
      // console.log('distributionmoderepData', this.distributionmoderepData);
    });

    this.service.getRepCommissionData().subscribe((data) => {
      this.repcommissiondata = data;
      this.calculateTotals();
    });

      this.service.getgranthCategory().subscribe({
      next: (data) => {
        console.log('Database data', data);
        this.advtCategorylist = data;
      },
      error: (err) => {
        console.error('Error fetching categories:', err);
      }
    });

    this.service.getBookSellerNames().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.names.push({
          id: data[index]['id'],
          name: data[index]['name'],
        });
      }
    });
    this.getSellerTypes();
    this.getComplTypes();
    this.getAbhiyanTypes();
    this.getbookdeliverymode();




    this.service.getBillNos().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.names.push({
          id: data[index]['id'],
          invoice_no: data[index]['invoice_no'],
        });
      }
    });

    this.service.getBookRepNames().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.names.push({
          id: data[index]['id'],
          name: data[index]['rep_name'],
        });
      }
    });

    this.service.getBookSellerNames1().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.names.push({
          id: data[index]['id'],
          name: data[index]['name'],
        });
      }

      this.names = this.uniqueid(this.names, (a) => a.name);
    });

    this.service.getdataforbookbilling().subscribe((data: any[]) => {
      const start = sessionStorage.getItem('startDate');
      const end = sessionStorage.getItem('endDate');

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // FILTER DATA BASED ON FINANCIAL YEAR RANGE
      this.Filteredbookbillingdata = data.filter((item: any) => {
        const itemDate = new Date(item.invoice_date);  // <-- change to your field
        if (!financialYearStart || !financialYearEnd) return true;
        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      console.log("Filtered billing count:", this.Filteredbookbillingdata.length);

      this.calculateBookBillingData();
    });


    this.service.getDistributorDataForIssueSeller().subscribe((data) => {
      this.distributorList = data;

      // Re-trigger filteredOptions6 after data loads
      this.filteredOptions6 = this.packsubform.get('DistributiveRep').valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => name ? this._filter11(name) : this.distributorList.slice())
      );
    });

    this.service.getDistributorModeDataForIssueSeller().subscribe((data) => {
      this.distributionModeList = data;

      // Re-trigger filteredOptions7 after data loads
      this.filteredOptions7 = this.packsubform.get('distributionMode').valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => name ? this._filter22(name) : this.distributionModeList.slice())
      );
    });

    this.service.getsubdistmodeissue(this.dis_mode).subscribe((data) => {
      this.FilteredsubDistributionModeData = data;

      // Re-trigger filteredOptions28 after data loads
      this.filteredOptions28 = this.packsubform.get('SubDistMode').valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => name
          ? this._filterSubModes(name, this.FilteredsubDistributionModeData)
          : this.FilteredsubDistributionModeData.slice()
        )
      );
    });

    this.service.getdataforgranthbilling().subscribe((data: any[]) => {
      const start = sessionStorage.getItem('startDate');
      const end = sessionStorage.getItem('endDate');

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // FILTER DATA BASED ON FINANCIAL YEAR RANGE
      this.Filteredgranthbillingdata = data.filter((item: any) => {
        const itemDate = new Date(item.invoice_date);  // <-- change to your field
        if (!financialYearStart || !financialYearEnd) return true;
        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      console.log("Filtered billing count:", this.Filteredgranthbillingdata.length);

      // this.calculateBookBillingData();
    });


    this.service.getBookRcptPymtData().subscribe((data: any[]) => {
      console.log(data);

      // 1️⃣ Read FY dates from sessionStorage
      const start = sessionStorage.getItem('startDate');   // e.g. 2025-04-01
      const end = sessionStorage.getItem('endDate');     // e.g. 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 2️⃣ Store full data
      this.bookRcptRegisterdata = data;

      // 3️⃣ Filter based on receipt_date field
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter((item: any) => {
        const itemDate = new Date(item.receipt_date); // 👈 THIS IS YOUR DATE FIELD

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      // 4️⃣ Recalculate total received amount from filtered data
      this.receivedAmount = 0;
      for (let item of this.FilteredbookRcptRegisterdata) {
        this.receivedAmount += parseFloat(item.select_entry_amt) || 0;
      }

      console.log('Filtered:', this.FilteredbookRcptRegisterdata);
      console.log('Total Received:', this.receivedAmount);
    });


    // this.service.getDeliveryMode1().subscribe((data) => {
    //   // console.log('getDeliveryMode', data);
    //   this.delivery_mode = data;
    // });
    this.service.getDeliveryMode1().subscribe((data) => {
      // console.log('getDeliveryMode', data);
      this.delivery_mode = data;
    });


    this.service.getBookDeliveryMOdeList1().subscribe((data) => {
      // console.log('getDeliveryMode', data);
      this.delivery_mode1 = data;
    });
    this.service.getAllSubDistributionModes1().subscribe((res) => {
      this.subdistributionmodesData = res;
    });
    this.service.getsubdistmodeissue(this.dis_mode).subscribe((data) => {
      // console.log(data);
      this.FilteredsubDistributionModeData = data;
    });

    // this.service.getDistributorData().subscribe((data) => {
    //   // console.log(data);
    //   this.distributorList1 = data;
    // });


    this.service.getDistributorData().subscribe((data) => {
      this.distributorList1 = data;

      this.filteredOptionsbook = this.subform.get('DistributiveRep').valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.name),
        map(name => name ? this._filterbook(name) : this.distributorList1.slice())
      );
    });

    // Initialize filteredOptions6 (Distribution Representative)






    // this.service.getSubDeliveryMode3().subscribe((data) => {
    //   this.distributorListDM = data;

    //   this.filteredOptionsbookdm = this.subform.get('DistributionMode').valueChanges.pipe(
    //     startWith(''),
    //     map(value => typeof value === 'string' ? value : value?.sub_delivery_mode),
    //     map(sub_delivery_mode => sub_delivery_mode ? this._filterbookDM(sub_delivery_mode) : this.distributorListDM.slice())
    //   );
    // });

    this.service.getDistributorModeDataForIssueSeller().subscribe((data) => {
      // console.log(data);
      this.distributionModeList = data;
    });
    // this.filteredOptions26 = this.AssignDisRepForm.get(
    //   'disrep1'
    // ).valueChanges.pipe(
    //   startWith(''),
    //   map((value) => (typeof value === 'string' ? value : value.name)),
    //   map((name) =>
    //     name ? this._filter26(name) : this.distributorList.slice()
    //   )
    // );


    this.service.getBookCommRcptPymtData().subscribe((data: any) => {

      const arr = Array.isArray(data) ? data : [];

      const start = sessionStorage.getItem('startDate');
      const end = sessionStorage.getItem('endDate');

      const fyStart = start ? new Date(start) : null;
      const fyEnd = end ? new Date(end) : null;

      // 🔥 Normalize + Filter Data
      this.bookRcptCommisionRegisterdata = arr.map((item: any) => {

        // convert values to number
        item.bill_amount = Number(item.bill_amount) || 0;
        item.rep_commission_amt = Number(item.rep_commission_amt) || 0;
        item.select_entry_amt = Number(item.select_entry_amt) || 0;

        // fix date parsing (important if format is string)
        item.commission_date_obj = new Date(item.commission_date);

        return item;

      }).filter((item: any) => {

        if (!fyStart || !fyEnd) return true;

        return item.commission_date_obj >= fyStart && item.commission_date_obj <= fyEnd;
      });

      // ✅ Use same array everywhere
      this.FilteredCommbookRcptRegisterdata = this.bookRcptCommisionRegisterdata;

      // ✅ Calculate totals AFTER data ready
      this.calculateTotals4();

    });


    this.service.getBookCrdtPymtData().subscribe((data: any[]) => {
      console.log(data);

      // 1️⃣ Read stored financial year dates
      const start = sessionStorage.getItem('startDate');   // e.g. 2025-04-01
      const end = sessionStorage.getItem('endDate');       // e.g. 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 2️⃣ Store original data
      this.bookCrdtRegisterdata = data;

      // 3️⃣ Apply filtering using crdtnote_date
      this.FilteredbookCrdtdata = this.bookCrdtRegisterdata.filter((item: any) => {
        const itemDate = new Date(item.crdtnote_date);   // IMPORTANT: your field

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      // 4️⃣ Recalculate TOTAL credit note amount from filtered results
      this.receivedCrdtAmount = 0;
      for (let row of this.FilteredbookCrdtdata) {
        this.receivedCrdtAmount += parseFloat(row.crdtnote_total) || 0;
      }

      console.log("Filtered Credit Note Data:", this.FilteredbookCrdtdata);
      console.log("Total Credit Amount:", this.receivedCrdtAmount);
    });


    this.getBookSellerOrderNo(
      formatDate(new Date(), 'yyyy-MM-dd', 'en-In', 'GMT+0530')
    );

    this.getBookSellerOrderNoPackage(
      formatDate(new Date(), 'yyyy-MM-dd', 'en-In', 'GMT+0530')
    );

    this.service.getBookCrdtVoucher().subscribe((data) => {
      this.booksellerledgercrdtv = data;
    });

    this.service.getBookOutStandingData().subscribe((data) => {
      // 1️⃣ Read financial year range from sessionStorage
      const start = sessionStorage.getItem('startDate');
      const end = sessionStorage.getItem('endDate');

      const fyStart = start ? new Date(start) : null;
      const fyEnd = end ? new Date(end) : null;

      // 2️⃣ Filter
      this.bookoutstandingdata = data.filter((item: any) => {
        const itemDate = new Date(item.invoice_date);  // <-- your field

        if (!fyStart || !fyEnd) return true; // if not set, show all

        return itemDate >= fyStart && itemDate <= fyEnd;
      });

      // 3️⃣ Store filtered array for table binding
      this.Filteredbookoutstandingdata = this.bookoutstandingdata;
      this.calculateTotals3();
    });


    // this.service.getBookRcptForLedger().subscribe((data) => {
    //   this.booksellerledgerrcpt = data;
    // });

    // this.service.getBookWiseReport().subscribe((data) => {
    //   this.bookWiseReport = data;
    // });

    this.service.getAllBooksData().subscribe((data) => {
      this.bookslist = this.uniqueid(data, (a) => a.bookname);
    });
    this.service.getAllBookData().subscribe((data) => {
      this.Filteredbookdata2 = this.uniqueid(data, (a) => a.bookname);
    });

    this.service.getAllGranthData().subscribe((data) => {
      this.Filteredbookdatagranth = this.uniqueid(data, (a) => a.bookname);
    });

    //   this.service.getAllBookData3().subscribe((data) => {
    //     debugger
    //      this.authorList = this.uniqueid(data, (a) => a.author_name);

    // });



    this.service.getLatestBooksData().subscribe((data) => {
      this.latestbooklist = this.uniqueid(data, (a) => a.bookname);
    });

    this.service.getAllBookData().subscribe((data) => {
      this.bookData = data;
      this.bookdata = this.uniqueid1(this.bookData, it => it.bookid);

      // ✅ Clear the list properly
      this.booknames = [];

      // ✅ Filter based on entryType
      if (this.entryType === 'book') {
        // Only books where isgranth = 'N'
        this.booknames = this.bookdata.filter(item => item.isgranth === 'N');
      }
      else if (this.entryType === 'granth') {
        // Only granth where isgranth = 'Y'
        this.booknames = this.bookdata.filter(item => item.isgranth === 'Y');
      }

      console.log('Filtered full data:', this.booknames);

      // Autocomplete source
      this.Filteredbookdata1 = this.booknames;
    });

    //  this.service.getAllBookDataGranth().subscribe((data) => {
    //   this.bookData = data;
    //   this.bookdata = this.uniqueid1(this.bookData, (it) => it.bookid);
    //   // console.log(this.bookData);
    //   for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
    //     this.booknames.push({ bookname: this.bookdata[index]['bookname'] });
    //   }
    //   console.log("book names", this.booknames)
    //   this.Filteredbookdata2 = this.bookdata;
    // });

    this.service.getAllBookStockData().subscribe((data) => {
      this.bookStockData = data;
      this.Filteredbookdata = this.bookStockData;
      this.bookStockData = this.uniqueid(this.bookStockData, (it) => it.bookid);
      // console.log(this.bookStockData);
      for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
        this.booknames.push({ bookname: this.bookStockData[index]['bookname'] });
      }
    });

    //temporary commenting this code

    // let val = 0;
    // this.service.getBookCustInvoiceId().subscribe((data) => {
    //   if (data['val'] == null) {
    //     val = val + 1;
    //   } else {
    //     val = parseInt(data['val']) + 1;
    //   }
    //   this.invoiceno = `VBD04/${year}-${nextyear}/${val}`;
    // });

    this.service.getBookInvoiceData().subscribe((data: any[]) => {

      // 1️⃣ Add selected:false to every row
      const invoiceList = data.map((item: any) => ({
        ...item,
        selected: false
      }));

      // 2️⃣ Get financial year date range
      const start = sessionStorage.getItem('startDate');  // example: 2025-04-01
      const end = sessionStorage.getItem('endDate');    // example: 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 3️⃣ Filter only invoices inside the financial year
      this.bookinvoicedata = invoiceList.filter((item: any) => {
        const itemDate = new Date(item.date);   // 👈 This is your date field

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      console.log("Filtered Invoice Data:", this.bookinvoicedata);

    });

    this.service.getGranthInvoiceData().subscribe((data: any[]) => {

      // 1️⃣ Add selected:false to every row
      const invoiceList = data.map((item: any) => ({
        ...item,
        selected: false
      }));

      // 2️⃣ Get financial year date range
      const start = sessionStorage.getItem('startDate');  // example: 2025-04-01
      const end = sessionStorage.getItem('endDate');    // example: 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 3️⃣ Filter only invoices inside the financial year
      this.granthinvoicedata = invoiceList.filter((item: any) => {
        const itemDate = new Date(item.date);   // 👈 This is your date field

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      console.log("Filtered Invoice Data:", this.granthinvoicedata);

    });

    this.searchBooks("");

    this.bookpymtrecptform
      .get('date')
      .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));

    this.bookcommrecptform
      .get('date')
      .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));

    this.service.get_AllRepresentative_List().subscribe((data) => {
      this.getAllRepList = data;
    });

    this.service.getBookData1().subscribe((data) => {
      this.bookdata1 = data;
      this.uniquedata = this.uniqueid(this.bookdata1, (it) => it.name);
    });
    this.service.getgranthData1().subscribe((data) => {

      this.granthdata1 = data;
      this.granthunquiedata = this.uniqueid(this.granthdata1, (it) => it.name);
    });


    this.service.getBookDataforDelivery().subscribe((data: any[]) => {
  debugger
  this.bookdeliverydata = data || [];

  const removedIds = (this.getRemovedIds() || []).map(id => Number(id));

  this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter((item: any) => {
    return !removedIds.includes(Number(item.id));
  });
});


    this.service.getBookSellerEntry().subscribe((data) => {
      this.book_seller_data = data;
      for (
        let index = 0;
        index < Object.keys(this.book_seller_data).length;
        index++
      ) {
        this.book_sellerdata.push({
          id: this.book_seller_data[index]['id'],
          name: this.book_seller_data[index]['name'],
          mob_no: this.book_seller_data[index]['mob_no'],
        });
      }
    });
    this.service.getCountry().subscribe((data) => {
      this.countries = data;
    });


    this.service.getBookSellerEntryForBookRegistration().subscribe((data) => {
      this.bookregistrationdata1 = data;
      for (let index = 0; index < this.bookregistrationdata1.length; index++) {
        // this.bookregistrationdata.push({
        //   booking_date: this.bookregistrationdata1[index]['booking_date'],
        //   orderno: this.bookregistrationdata1[index]['orderno'],
        //   name: this.bookregistrationdata1[index]['name'],
        //   district: this.bookregistrationdata1[index]['district'],
        //   mob_no: this.bookregistrationdata1[index]['mob_no'],
        //   crep_name: this.bookregistrationdata1[index]['crep_name'],
        //   office_rep_name: this.bookregistrationdata1[index]['office_rep_name'],
        //   bookname: this.bookregistrationdata1[index]['bookname'],
        //   bookcopies: this.bookregistrationdata1[index]['bookcopies'],
        //   iscomplimentary: this.bookregistrationdata1[index]['iscomplimentary'],
        //   bookprice: this.bookregistrationdata1[index]['bookprice'],
        //   totalafterdiscount:
        //     this.bookregistrationdata1[index]['totalafterdiscount'],
        //   total: this.bookregistrationdata1[index]['total'],
        //   shipping_charges:
        //     this.bookregistrationdata1[index]['shipping_charges'],
        //   receivedamt: this.bookregistrationdata1[index]['receivedamt'],
        //   remainingamt: this.bookregistrationdata1[index]['remainingamt'],
        //   invoiceno: this.bookregistrationdata1[index]['invoiceno'],
        //   rcptno: this.bookregistrationdata1[index]['rcptno'],
        //   repcommissionamt:
        //     this.bookregistrationdata1[index]['repcommissionamt'],
        //   delivery_mode: this.bookregistrationdata1[index]['delivery_mode'],
        // });
      }
    });

    this.service.getBookRegistrationDataWithoutInvoice().subscribe((data) => {

      // this.bookregistrationdata = [];
      console.log("data", data)
      this.debugger
      for (let index = 0; index < data.length; index++) {
        this.bookregistrationdata.push({
          booking_date: data[index]['booking_date'],
          id: data[index]['id'],
          orderno: data[index]['oder_no'], // Correct spelling
          name: data[index]['book_seller_name'],
          receiver_address: data[index]['district'], // Added
          district: data[index]['district'] || '', // Ensure field exists
          mob_no: data[index]['mobile_no'],
          crep_name: data[index]['rep_name'],
          office_rep_name: data[index]['office_rep_name'],
          bookname: data[index]['book_name'],
          bookcopies: data[index]['book_copies'],
          return_copies: data[index]['return_copies'],
          available_stock: data[index]['available_stock'],
          iscomplimentary: data[index]['is_complimentary'],
          complimentaryOption: data[index]['comp_option'],
          bookprice: data[index]['book_price'],
          prakashan_name: data[index]['prakashan_name'],
          totalafterdiscount: data[index]['totalafterdiscount'],
          total: data[index]['total'],
          shipping_charges: data[index]['shipping_charges'],
          receivedamt: data[index]['received_amt'],
          crdtamt: data[index]['credit_amt'],
          remainingamt: data[index]['remaining_amt'],
          invoiceno: data[index]['invoice_no'] || '', // Handle null values
          rcptno: '',
          repcommissionamt: data[index]['rep_commission_amt'],
          delivery_mode: data[index]['delivery_mode'],
        });
      }
      this.FilteredBookRegistration1 = this.bookregistrationdata;
      console.log("FilteredBookRegistration1", this.FilteredBookRegistration1);

      this.bookCopiesTotal = 0;
      this.availableStock = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
        this.shippingCharges += parseInt(data.shipping_charges) || 0;
        this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
        this.recvTotal += parseInt(data.receivedamt) || 0;
        this.creditTotal += parseInt(data.crdtamt) || 0;
        this.remTotal += parseInt(data.remainingamt) || 0;
        this.availableStock += parseInt(data.available_stock) || 0;




      }

    });
    this.service.getBookRegistrationDataWithoutInvoicepackage()
      .subscribe({

        next: (data: any) => {

          console.log('API Response =>', data);

          this.bookregistrationdatapackage = [];

          if (!data || data.length === 0) {
            this.FilteredBookRegistrationpackage = [];
            return;
          }

          data.forEach((item: any) => {

            this.bookregistrationdatapackage.push({

              booking_date: item.booking_date,
              id: item.id,
              orderno: item.oder_no,

              name: item.book_seller_name,
              subscribers_name: item.subscribers_name,
              subscribers_no: item.subscribers_no,
              mobile_number: item.mobile_number,

              address: item.address,
              district: item.district,
              state: item.state,
              country: item.country,
              pincode: item.pincode,

              mob_no: item.rep_mob_no,
              crep_name: item.crep_name,
              office_rep_name: item.office_rep_name,

              bookname: item.book_name,
              bookcopies: Number(item.total_copies || 0),

              return_copies: Number(item.return_copies || 0),
              available_stock: Number(item.available_stock || 0),

              iscomplimentary: item.is_complimentary,
              complimentaryOption: item.comp_option,

              bookprice: Number(item.book_price || 0),

              prakashan_name: item.prakashan_name,

              totalafterdiscount: Number(item.totalafterdiscount || 0),
              total: Number(item.total || 0),

              shipping_charges: Number(item.shipping_charges || 0),

              receivedamt: Number(item.received_amt || 0),
              crdtamt: Number(item.credit_amt || 0),
              remainingamt: Number(item.remaining_balance || 0),

              invoiceno: item.invoice_no,

              repcommissionamt: Number(item.rep_commission_amt || 0),

              representative_name: item.representative_name,
              representative_mobile: item.representative_mobile,

              gst_number: item.gst_number,
              email: item.email,
              telephone: item.telephone,

              seller_type: item.seller_type,
              remark: item.remark,

              recipt_no: item.recipt_no,
              voucher_no: item.voucher_no,
              recipt_amt: Number(item.recipt_amt || 0)

            });

          });

          this.FilteredBookRegistrationpackage =
            [...this.bookregistrationdatapackage];

          this.calculateTotals();

          console.log(
            'FilteredBookRegistrationpackage',
            this.FilteredBookRegistrationpackage
          );
        },

        error: (err) => {
          console.error('API Error =>', err);
        }

      });


    this.service.getIssuesellersname().subscribe((data) => {
      this.issue_seller_name = data;
    });

    this.service.getIssueSellerName().subscribe((data) => {
      this.issueSellerName = data;
    });

    this.service.getAlltitle().subscribe((data) => {
      this.titles = data;
    });

    // Read All Contries
    // this.service.getAllContries().subscribe((data) => {
    //   this.countries = data;
    // });

    this.service.getCountry().subscribe((data) => {
      this.countries = data;
    });

    this.service.getAllRepList().subscribe((data) => {
      this.rep_names = data;
    });
    this.service.getAllOfcRepList().subscribe((data) => {
      this.office_rep_names = data;
    });
    this.service.getAllBookSellerNameList().subscribe((data) => {
      this.book__seller__name = data;
    });


this.service.getAllgranthSellerNameList().subscribe({
  next: (data) => {
    console.log('granth__seller__name raw response:', data);
    this.granth__seller__name = data;
  },
  error: (err) => {
    console.error('getAllgranthSellerNameList failed:', err);
  }
});


    this.service.getBookSellerAddress().subscribe((data) => {
      this.bookSellerAddressData = data;
      this.FilteredBookSellerAddress = this.bookSellerAddressData;
      // console.log(this.bookSellerAddressData);
    });

    // this.service.getAllBooks().subscribe((data) => {
    //   this.bookData = data;

    // for (let index = 0; index < this.bookData.length; index++) {
    //   this.booknames.push(this.bookData[index]['bookname']);
    // }
    // });

    this.service.getPortalAllRepList().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.repnameList.push(data[index]['name']);
      }
    });

    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      this.imgPath = item['file']['name'];
      this.BookForm.get('bookimg').setValue(this.imgPath);
      alert('Your file has been uploaded successfully');
    };

    this.service.getBookRegistration().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        if (
          this.bookregistrationdetails.find(
            (a) => parseInt(a['mobile']) == parseInt(data[index]['mobile'])
          ) == undefined
        ) {
          this.bookregistrationdetails.push({
            book_amount: data[index]['book_amount'],
            book_commision: data[index]['book_commision'],
            book_name: data[index]['book_name'],
            book_qty: data[index]['book_qty'],
            city: data[index]['city'],
            delivery_charges: data[index]['delivery_charges'],
            mobile: data[index]['mobile'],
            name: data[index]['name'],
            received_date: data[index]['received_date'],
            rep_name: data[index]['rep_name'],
            total_amount:
              parseInt(data[index]['book_amount']) -
              parseInt(data[index]['delivery_charges']),
            transport_method: data[index]['transport_method'],
            transporter_name: data[index]['transporter_name'],
            transport_id: data[index]['transport_id'],
            payment_status: data[index]['payment_status'],
            rep_receipt: data[index]['rep_receipt'],
          });
        } else {
          this.bookregistrationdetails.push({
            book_amount: data[index]['book_amount'],
            book_commision: data[index]['book_commision'],
            book_name: data[index]['book_name'],
            book_qty: data[index]['book_qty'],
            city: data[index]['city'],
            delivery_charges: 0,
            mobile: data[index]['mobile'],
            name: data[index]['name'],
            received_date: data[index]['received_date'],
            rep_name: data[index]['rep_name'],
            total_amount:
              parseInt(data[index]['book_amount']) -
              parseInt(data[index]['delivery_charges']),
            transport_method: data[index]['transport_method'],
            transporter_name: data[index]['transporter_name'],
            transport_id: data[index]['transport_id'],
            payment_status: data[index]['payment_status'],
            rep_receipt: data[index]['rep_receipt'],
          });
        }
      }

      setTimeout(() => {
        for (
          let index = 0;
          index < Object.keys(this.bookregistrationdata).length;
          index++
        ) {
          if (
            this.bookregistration_bookname.find(
              (a) => a == this.bookregistrationdata[index]['bookname']
            ) == undefined
          ) {
            if (this.bookregistrationdata[index]['bookname'] != null) {
              this.bookregistration_bookname.push(
                this.bookregistrationdata[index]['bookname']
              );
            }
          }
        }
        this.FilteredBookRegistration = this.bookregistrationdetails;
      }, 2000);
    });

    this.service.getOfficeRepData().subscribe((data) => {
      // console.log(data);
      this.officerepdata = data;
      for (
        let index = 0;
        index < Object.keys(this.officerepdata).length;
        index++
      ) {
        this.officerepnames.push({
          id: this.officerepdata[index]['id'],
          name: this.officerepdata[index]['officerep'],
        });
      }
    });



    this.filteredOptions = this.subform.get('mobileNumber').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.mob_no)),
      map((mob_no) =>
        mob_no ? this._filter(mob_no) : this.book_sellerdata.slice()
      )
    );
    this.filteredOptions17 = this.AssignDisRepForm.get('dismode')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => typeof value === 'string' ? value : value?.sub_delivery_mode),
      map((name: string) =>
        name ? this._filter15(name) : this.subDeliveryModeData.slice()
      )
    );


    this.filteredOptions1 = this.subform.get('subname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter1(name) : this.book_sellerdata.slice()))
    );

    // this.filteredOptionspackage = this.packsubform.get('subname').valueChanges.pipe(
    //   startWith(''),
    //   map((value) => (typeof value === 'string' ? value : value.name)),
    //   map((name) => (name ? this._filter1(name) : this.book_sellerdata.slice()))
    // );



    this.filteredOptions2 = this.subform.get('bookname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.bookname)),
      map((bookname) =>
        bookname ? this._filter2(bookname) : this.booknames.slice()
      )
    );

    // this.filteredEditions = this.subform.get('bookedition')!.valueChanges.pipe(
    //   startWith(''),
    //   map((value) => (typeof value === 'string' ? value : value.bookedition)),
    //   map((bookedition) =>
    //     bookedition ? this._filter2(bookedition) : this.bookdata.slice()
    //   )
    // );

    this.filteredOptions7 = this.bookName.get('bookname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.bookname)),
      map((bookname) =>
        bookname ? this._filter7(bookname) : this.bookdata.slice()
      )
    );

    this.filteredOptions3 = this.subform.get('authorname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.authorname)),
      map((authorname) =>
        authorname ? this._filter3(authorname) : this.bookData.slice()
      )
    );

    this.filteredOptions4 = this.subform.get('crepname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter4(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredOptions5 = this.bsform.get('subname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter5(name) : this.book_sellerdata.slice()))
    );

    this.filteredOptions6 = this.bookpymtrecptform
      .get('booksellernamesearch')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter6(name) : this.names.slice()))
      );

    this.filteredOptionsbook = this.subform.get('DistributiveRep').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filterbook(name) : this.distributorList1.slice()))
    );

    this.filteredOptionsbookdm = this.subform.get('DistributionMode').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filterbookDM(name) : this.distributorListDM.slice()))
    );
    this.filteredOptions8 = this.BookForm.get('bookname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.bookname)),
      map((bookname) =>
        bookname ? this._filter8(bookname) : this.booknames.slice()
      )
    );

    //    this.filteredOptions6 = this.packsubform.get('distributionRepresentativeId').valueChanges.pipe(
    //   startWith(''),
    //   map(value => (typeof value === 'string' ? value : value?.name)),
    //   map(name => name ? this._filter11(name) : this.distributorList.slice())
    // );

    // // Initialize filteredOptions7 (Distribution Mode)
    // this.filteredOptions7 = this.packsubform.get('distributionMode').valueChanges.pipe(
    //   startWith(''),
    //   map(value => (typeof value === 'string' ? value : value?.name)),
    //   map(name => name ? this._filter22(name) : this.distributionModeList.slice())
    // );

    // // Initialize filteredOptions28 (Sub Distribution Mode)
    // this.filteredOptions28 = this.packsubform.get('SubDistMode').valueChanges.pipe(
    //   startWith(''),
    //   map(value => (typeof value === 'string' ? value : value?.name)),
    //   map(name => name
    //     ? this._filterSubModes(name, this.FilteredsubDistributionModeData)
    //     : this.FilteredsubDistributionModeData.slice()
    //   )
    // );

    console.log("filteredOptions8", this.filteredOptions8)

    this.bookcrdtnoteForm
      .get('todaydate')
      .setValue(formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'));

    this.filteredOptions9 = this.bookcrdtnoteForm
      .get('bsname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter9(name) : this.book_sellerdata.slice()
        )
      );

    this.filteredOptions10 = this.bookcrdtnoteForm
      .get('repname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter10(name) : this.issue_seller_name.slice()
        )
      );

    this.filteredOptions11 = this.authorForm
      .get('authorname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) => (name ? this._filter11(name) : this.authornames.slice()))
      );

    this.filteredOptions12 = this.bookselleraddressForm
      .get('bsname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter12(name) : this.book_sellerdata.slice()
        )
      );


    this.filteredOptions13 = this.bookselleraddressForm
      .get('repname')
      .valueChanges.pipe(
        startWith(''),
        map((value) => (typeof value === 'string' ? value : value.name)),
        map((name) =>
          name ? this._filter10(name) : this.issue_seller_name.slice()
        )
      );
    this.filteredOptions14 = this.AssignDisRepForm.get('disrep1')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => typeof value === 'string' ? value : value?.name),
      map((name: string) =>
        name ? this._filter14(name) : this.distributorList.slice()
      )
    );

    this.filteredOptions15 = this.AssignDisRepForm.get('dismode')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => typeof value === 'string' ? value : value?.sub_delivery_mode),
      map((name: string) =>
        name ? this._filter15(name) : this.subDeliveryModeData.slice()
      )
    );

    // 🔹 Sub Mode autocomplete
    this.filteredOptions16 = this.AssignDisRepForm.get('dissubmode')!.valueChanges.pipe(
      startWith(''),
      map((value: any) => typeof value === 'string' ? value : value?.subdistributionmode),
      map((name: string) =>
        name ? this._filter16(name) : this.FilteredsubDistributionModeData.slice()
      )
    );


    this.filteredOptionspack = this.packsubform.get('crepname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) =>
        name ? this._filter4(name) : this.issue_seller_name.slice()
      )
    );

    this.filteredbookPack = this.packsubform.get('bookname').valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.bookname)),
      map((bookname) =>
        bookname ? this._filterpack(bookname) : this.booknames.slice()
      )
    );

    this.getAllDeliveryData();
    // this.readAllBookStock();

    this.columnsToDisplay = [
      'Name',
      'Mobile',
      'Book Name',
      'Received Date',
      'Status',
      'Action',
    ];

    this.getAllVouchers();
    this.getAllVouchersgranth();
    this.getBookPayments();
    this.bookcrdtnote();
    this.getAuthorData();
    this.getAllCommVouchers();


  } //end of ngOninit
  toggleAllSelection6() {

  const control = this.form.get('repwise');

  const allValues = this.rep_names.map(x => x.rep_name);
  const selected = control?.value || [];

  // if already all selected → clear
  if (this.isAllSelected6()) {
    control?.setValue([]);
  } 
  // otherwise select all
  else {
    control?.setValue(allValues);
  }
}
  selectedRepresentativeId: number | null = null;
  /* =========================
     LOAD DELIVERY MODES
  ========================= */
  loadDeliveryModes(): void {
    this.service.getDeliveryMode1().subscribe({
      next: (res: any) => {
        this.deliveryModes = res.data ?? res;
      }
    });
  }
  getSubDeliveryModes1(): void {
    this.service.getSubDeliveryMode3().subscribe((res: any) => {
      console.log('Dropdown Data:', res);
      this.subDeliveryModeData = res.data || res || [];

      // ✅ FIX: Watch AssignDisRepForm 'dismode' — matches your HTML
      this.filteredOptions15 = this.AssignDisRepForm.get('dismode')!.valueChanges.pipe(
        startWith(''),
        map((value: any) =>
          typeof value === 'string' ? value : value?.sub_delivery_mode || ''
        ),
        map((name: string) =>
          name ? this._filter20(name) : this.subDeliveryModeData.slice()
        )
      );
    });
  }


  // ✅ Partial/substring match
  private _filter21(value: string): any[] {
    const filterValue = value.toLowerCase().trim();
    return this.subDeliveryModeData.filter(option =>
      option.sub_delivery_mode?.toLowerCase().includes(filterValue)
    );
  }


  // ✅ Partial/substring match
  private _filter20(value: string): any[] {
    const filterValue = value.toLowerCase().trim();
    return this.subDeliveryModeData.filter(option =>
      option.sub_delivery_mode?.toLowerCase().includes(filterValue)
    );
  }

  getSubDistributionModes1(): void {
    debugger;

    this.service.getAllSubDistributionModes1().subscribe((res: any) => {

      this.subDistributionModeData = res.data || res || [];

      this.filteredOptions16 = this.AssignDisRepForm
        .get('dissubmode')!
        .valueChanges.pipe(
          startWith(''),
          map((value: string) => value || ''),
          map((name: string) =>
            name
              ? this._filter30(name)
              : this.subDistributionModeData.slice()
          )
        );
    });
  }

  private _filter30(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.subDistributionModeData.filter((option: any) =>
      option.subdeliverymode
        ?.toLowerCase()
        .includes(filterValue)
    );
  }

  // loadDistributorData(): void {
  //   this.service.getDistributorData1().subscribe((data: any) => {
  //     this.distributorList1 = data || [];

  //     // ✅ FIX: Watch AssignDisRepForm 'disrep1' — matches your HTML
  //     this.filteredOptions14 = this.AssignDisRepForm.get('disrep1')!.valueChanges.pipe(
  //       startWith(''),
  //       map((value: any) =>
  //         typeof value === 'string' ? value : value?.name || ''
  //       ),
  //       map((name: string) =>
  //         name ? this._filter14(name) : this.distributorList1.slice()
  //       )
  //     );
  //   });
  // }

  // ✅ Partial/substring match — half name returns all matching results
  // private _filter14(value: string): any[] {
  //   const filterValue = value.toLowerCase().trim();
  //   return this.distributorList1.filter(option =>
  //     option.name?.toLowerCase().includes(filterValue)
  //   );
  // }
  // private filterDistributor(value: string): any[] {

  //   const filterValue = (value || '').toLowerCase().trim();

  //   return this.distributorList1.filter((option: any) =>
  //     option.name &&
  //     option.name.toLowerCase().includes(filterValue)
  //   );
  // }

  loadDistributorData(): void {
    this.service.getDistributorData1().subscribe((data: any) => {
      this.distributorList1 = data || [];

      // ✅ FIX: Watch AssignDisRepForm 'disrep1' — matches your HTML
      this.filteredOptions14 = this.AssignDisRepForm.get('disrep1')!.valueChanges.pipe(
        startWith(''),
        map((value: any) =>
          typeof value === 'string' ? value : value?.name || ''
        ),
        map((name: string) =>
          name ? this._filter14(name) : this.distributorList1.slice()
        )
      );
    });
  }

  // ✅ Partial/substring match — half name returns all matching results
  private _filter14(value: string): any[] {
    const filterValue = value.toLowerCase().trim();
    return this.distributorList1.filter(option =>
      option.name?.toLowerCase().includes(filterValue)
    );
  }


  /* =========================
     DELIVERY MODE CHANGE
     → Loads Distribution Modes
     → Resets Distribution + Sub
  ========================= */
  onDeliveryModeChange(deliveryModeName: string): void {

    debugger;

    // =====================================
    // RESET DEPENDENT DROPDOWNS
    // =====================================

    this.subform.patchValue({
      DistributionMode: null,
      SubDistMode: []
    });

    this.filteredDistributionModes = [];
    this.filteredSubDistModes = [];

    // =====================================
    // VALIDATION
    // =====================================

    if (!deliveryModeName) return;

    // =====================================
    // STORE SELECTED NAME
    // =====================================

    this.selectedDeliveryModeName = deliveryModeName;

    // =====================================
    // API CALL WITH NAME
    // =====================================

    this.service
      .getDistributionModes(deliveryModeName)
      .subscribe({

        next: (res: any) => {

          const rawData: any[] = res.data ?? res ?? [];

          // =====================================
          // REMOVE DUPLICATE ENTRIES
          // =====================================

          const uniqueData = rawData.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(
                (t: any) =>
                  (
                    t.sub_delivery_mode ??
                    ''
                  ).toString().trim().toLowerCase()
                  ===
                  (
                    item.sub_delivery_mode ??
                    ''
                  ).toString().trim().toLowerCase()
              )
          );

          // =====================================
          // FINAL ASSIGNMENT
          // =====================================

          this.filteredDistributionModes =
            uniqueData;
        },

        error: (err: any) => {

          console.error(
            'Error loading distribution modes',
            err
          );
        }
      });
  }

  onDeliveryModeChangegranth(selectedModes: string[] | string) {
    // Convert single value to array for consistency
    if (!Array.isArray(selectedModes)) {
      selectedModes = selectedModes ? [selectedModes] : [];
    }

    // 1️⃣ Filter Distributor List
    if (!selectedModes || selectedModes.length === 0) {
      this.filteredDistributorList = [];
    } else if (selectedModes.includes('all')) {
      this.filteredDistributorList = this.distributorList.slice(); // all distributors
    } else {
      this.filteredDistributorList = this.distributorList.filter(rep =>
        selectedModes.includes(rep.delivery_mode)
      );
    }

    // Reset the distributor input so autocomplete reloads
    const distributorControl = this.packsubform.get('DistributiveRep');
    if (distributorControl) {
      distributorControl.reset();

      // Re-bind distributor autocomplete options
      this.filteredOptions6 = distributorControl.valueChanges.pipe(
        startWith(distributorControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter11(name) : this.filteredDistributorList.slice()))
      );
    }

    // 2️⃣ Re-bind Distribution Mode autocomplete options
    const distModeControl = this.packsubform.get('distributionMode');
    if (distModeControl) {
      distModeControl.reset();

      this.filteredOptions7 = distModeControl.valueChanges.pipe(
        startWith(distModeControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
      );
    }
  }
  onDeliveryModeChange1(selectedModes: string[] | string) {
    debugger
    // Convert single value to array for consistency
    if (!Array.isArray(selectedModes)) {
      selectedModes = selectedModes ? [selectedModes] : [];
    }

    // 1️⃣ Filter Distributor List
    if (!selectedModes || selectedModes.length === 0) {
      this.filteredDistributorList = [];
    } else if (selectedModes.includes('all')) {
      this.filteredDistributorList = this.distributorList.slice(); // all distributors
    } else {
      this.filteredDistributorList = this.distributorList.filter(rep =>
        selectedModes.includes(rep.delivery_mode)
      );
    }

    // Reset the distributor input so autocomplete reloads
    const distributorControl = this.subform.get('DistributiveRep');
    if (distributorControl) {
      distributorControl.reset();

      // Re-bind distributor autocomplete options
      this.filteredOptionsdist = distributorControl.valueChanges.pipe(
        startWith(distributorControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filterdist(name) : this.filteredDistributorList.slice()))
      );
    }

    // 2️⃣ Re-bind Distribution Mode autocomplete options
    const distModeControl = this.subform.get('DistributionMode');
    if (distModeControl) {
      distModeControl.reset();

      this.filteredOptions7 = distModeControl.valueChanges.pipe(
        startWith(distModeControl.value || ''),
        map(value => (typeof value === 'string' ? value : value?.name)),
        map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
      );
    }
  }

  resetDeliveryModesgranth() {
    this.selectedModes = [];
    this.packsubform.get('DeliveryMode')?.reset();
    this.filteredDistributorList = [];
  }

  /* =========================
     DISTRIBUTION MODE CHANGE
     → Loads Sub Distribution Modes
  ========================= */
  onDistributionModeChange(distributionModeName: string): void {
    debugger;

    // Reset sub dropdown
    this.subform.patchValue({ SubDistMode: [] });
    this.filteredSubDistModes = [];

    if (!distributionModeName) {
      return;
    }

    this.service.getSubDistributionModes(distributionModeName)
      .subscribe({

        next: (res: any) => {

          const data = Array.isArray(res?.data) ? res.data : [];

          // Remove duplicate sub_distribution_mode
          this.filteredSubDistModes = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex((t: any) =>
                t.sub_distribution_mode?.trim().toLowerCase() ===
                item.sub_distribution_mode?.trim().toLowerCase()
              )
          );

          console.log('Unique Data:', this.filteredSubDistModes);
        },

        error: (err) => {
          console.error('Error fetching sub distribution modes:', err);
          this.filteredSubDistModes = [];
        }
      });
  }
  onDistributionModeChange1(distributionModeName: string): void {

    // reset child
    this.subform.patchValue({ SubDistMode: [] });
    this.filteredSubDistModes = [];

    if (!distributionModeName) return;

    this.service.getSubDistributionModes(distributionModeName)
      .subscribe({

        next: (res: any) => {

          const data = Array.isArray(res?.data) ? res.data : [];

          // remove duplicates safely
          this.filteredSubDistModes = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(t =>
                t.sub_distribution_mode?.trim().toLowerCase() ===
                item.sub_distribution_mode?.trim().toLowerCase()
              )
          );

        },

        error: (err) => {
          console.error(err);
          this.filteredSubDistModes = [];
        }
      });
  }
  handleAddressLabelClick4() {

    debugger

    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need

    const preweekfirstday = this.preweekfirstday;



    this.getLabelforDispatchData4();

  }
  getLabelforDispatchData4(): void {



    const f = this.generateform1.value;



    const filterPayload = {

      bookwise: Array.isArray(f.bookwise)

        ? f.bookwise.join(',')

        : f.bookwise || '',



      booksellerwise: Array.isArray(f.booksellerwise)

        ? f.booksellerwise.join(',')

        : f.booksellerwise || '',



      sellertype: f.sellertype || '',

      country: f.country || '',

      state: f.state || '',

      type: f.type || '',



      district: Array.isArray(f.district)

        ? f.district.join(',')

        : f.district || '',



      taluka: Array.isArray(f.taluka)

        ? f.taluka.join(',')

        : f.taluka || '',



      pincode: Array.isArray(f.pincode)

        ? f.pincode.join(',')

        : f.pincode || '',



      rep_name: Array.isArray(f.repwise)

        ? f.repwise.join(',')

        : f.repwise || '',



      office_rep_name: Array.isArray(f.officerepwise)

        ? f.officerepwise.join(',')

        : f.officerepwise || '',



      distributive_rep: f.DistributiveRep || '',



      delivery_mode: Array.isArray(f.DeliveryMode)

        ? f.DeliveryMode.join(',')

        : f.DeliveryMode || '',



      distribution_mode: Array.isArray(f.DistributionMode)

        ? f.DistributionMode.join(',')

        : f.DistributionMode || '',



      sub_distribution_mode: Array.isArray(f.SubDistMode)

        ? f.SubDistMode.join(',')

        : f.SubDistMode || '',



      start_date: f.start_date || '',

      end_date: f.end_date || '',

      category: f.issueCatregoryId || '',

      show_mobile_no: f.showMobileNo || 'no'

    };



    console.log('PAYLOAD =>', filterPayload);



    this.service

      .getlabelsforIssueSellerDispatch1(filterPayload)

      .subscribe({



        next: (data: any) => {



          console.log(

            'Backend Record Count =>',

            data?.length

          );



          this.labelsforDispatch =

            Array.isArray(data) ? data : [];



          // KEEP ALL RECORDS

          this.FilteredlabelsforDispatch = [

            ...this.labelsforDispatch

          ];



          this.FilteredlabelsforPostStatement = [

            ...this.FilteredlabelsforDispatch

          ];



          console.log(

            'Dialog Record Count =>',

            this.FilteredlabelsforDispatch.length

          );



          this.openAddressLabelDialog5();

        },



        error: (err: any) => {



          console.error(err);

          alert('Error while fetching dispatch labels!');

        }

      });

  }
  openAddressLabelDialog5() {

    this.dialog.open(BookSellerAddressLabelsComponent2Component, {

      data: {

        delivery_mode: this.mode_names,

        rep_names: this.repnames,

        state_name: this.state_names,

        district_name: this.district_names,

        taluka_name: this.taluka_names,

        distributive_reps: this.generateform1.value.DistributiveRep || '',

        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS

        addresslabels: this.FilteredlabelsforDispatch,

        iscustomer: this.iscustomer,

      },

      width: '1300px',

      height: '1300px',

      maxWidth: '100%',

    });

  }

    handleAddressLabelClickgranth1() {

    debugger

    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need

    const preweekfirstday = this.preweekfirstday;



    this.getLabelforDispatchData4granth();

  }
  getLabelforDispatchData4granth(): void {



    const f = this.generateform.value;



    const filterPayload = {

      bookwise: Array.isArray(f.bookwise)

        ? f.bookwise.join(',')

        : f.bookwise || '',



      booksellerwise: Array.isArray(f.booksellerwise)

        ? f.booksellerwise.join(',')

        : f.booksellerwise || '',



      sellertype: f.sellertype || '',

      country: f.country || '',

      state: f.state || '',

      type: f.type || '',



      district: Array.isArray(f.district)

        ? f.district.join(',')

        : f.district || '',



      taluka: Array.isArray(f.taluka)

        ? f.taluka.join(',')

        : f.taluka || '',



      pincode: Array.isArray(f.pincode)

        ? f.pincode.join(',')

        : f.pincode || '',



      rep_name: Array.isArray(f.repwise)

        ? f.repwise.join(',')

        : f.repwise || '',



      office_rep_name: Array.isArray(f.officerepwise)

        ? f.officerepwise.join(',')

        : f.officerepwise || '',



      distributive_rep: f.DistributiveRep || '',



      delivery_mode: Array.isArray(f.DeliveryMode)

        ? f.DeliveryMode.join(',')

        : f.DeliveryMode || '',



      distribution_mode: Array.isArray(f.DistributionMode)

        ? f.DistributionMode.join(',')

        : f.DistributionMode || '',



      sub_distribution_mode: Array.isArray(f.SubDistMode)

        ? f.SubDistMode.join(',')

        : f.SubDistMode || '',



      start_date: f.start_date || '',

      end_date: f.end_date || '',

      category: f.issueCatregoryId || '',

      show_mobile_no: f.showMobileNo || 'no'

    };



    console.log('PAYLOAD =>', filterPayload);



    this.service

      .getlabelsforGranthDispatch1(filterPayload)

      .subscribe({



        next: (data: any) => {



          console.log(

            'Backend Record Count =>',

            data?.length

          );



          this.labelsforDispatch =

            Array.isArray(data) ? data : [];



          // KEEP ALL RECORDS

          this.FilteredlabelsforDispatch = [

            ...this.labelsforDispatch

          ];



          this.FilteredlabelsforPostStatement = [

            ...this.FilteredlabelsforDispatch

          ];



          console.log(

            'Dialog Record Count =>',

            this.FilteredlabelsforDispatch.length

          );



          this.openAddressLabelDialog5granth();

        },



        error: (err: any) => {



          console.error(err);

          alert('Error while fetching dispatch labels!');

        }

      });

  }
  openAddressLabelDialog5granth() {

    this.dialog.open(GranthSellerAddresscomponentgranthwithComponent, {

      data: {

        delivery_mode: this.mode_names,

        rep_names: this.repnames,

        state_name: this.state_names,

        district_name: this.district_names,

        taluka_name: this.taluka_names,

        distributive_reps: this.generateform1.value.DistributiveRep || '',

        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS

        addresslabels: this.FilteredlabelsforDispatch,

        iscustomer: this.iscustomer,

      },

      width: '1300px',

      height: '1300px',

      maxWidth: '100%',

    });

  }
  /* =========================
     REP CHANGE
     → Auto-fills Distribution Mode
     → Auto-fills Sub Distribution Mode
  ========================= */
  onRepresentativeChange(event: any): void {
    debugger
    const repName = event.option.value;
    if (!repName) return;

    this.subform.patchValue({
      DistributionMode: null,
      SubDistMode: []
    });

    this.filteredDistributionModes = [];
    this.filteredSubDistModes = [];

    this.service.getRepAssignedModes(repName).subscribe({
      next: (res: any) => {
        const data: any[] = res.data ?? [];
        if (!data.length) return;

        const disModeName = data[0].dis_mode?.trim().toLowerCase();

        const subModeNames = data.map((d: any) =>
          d.dis_sub_mode?.trim().toLowerCase()
        );

        // STEP 1: load ALL distribution modes for ALL delivery modes
        const tryDeliveryModes = (index: number) => {
          if (index >= this.deliveryModes.length) return;

          const dmName = this.deliveryModes[index].delivery_mode;

          this.service.getDistributionModes(dmName).subscribe({
            next: (distRes: any) => {
              const distModes: any[] = distRes.data ?? distRes;

              const matchedDist = distModes.find((m: any) =>
                m.sub_delivery_mode?.trim().toLowerCase() === disModeName
              );

              if (!matchedDist) {
                tryDeliveryModes(index + 1);
                return;
              }

              // ✅ FOUND MATCH
              this.subform.patchValue({
                DistributionMode: matchedDist.sub_delivery_mode
              });

              this.filteredDistributionModes = distModes;

              // STEP 2: sub modes
              this.service
                .getSubDistributionModes(matchedDist.sub_delivery_mode)
                .subscribe({
                  next: (subRes: any) => {
                    const subModes: any[] = subRes.data ?? subRes;
                    this.filteredSubDistModes = subModes;

                    const matchedSub = subModes
                      .filter((m: any) =>
                        subModeNames.includes(
                          m.sub_distribution_mode?.trim().toLowerCase()
                        )
                      )
                      .map((m: any) => m.sub_distribution_mode);

                    this.subform.patchValue({
                      SubDistMode: matchedSub
                    });
                  }
                });
            }
          });
        };

        tryDeliveryModes(0);
      }
    });
  }
  // ─── Reset Sub Distribution Mode ─────────────────────────────────


  // --- Reset helpers ---
  // resetDistributionMode(): void {
  //   debugger
  //   this.subform.get('DistributionMode')?.reset();
  //   this.subform.get('SubDistMode')?.reset();
  //   this.filteredDistributionModes = [];
  //   this.filteredSubDistModes = [];
  // }

  // resetSubDistMode(): void {
  //   this.subform.get('SubDistMode')?.reset();
  //   this.filteredSubDistModes = [];
  // }

  // --- Select All helpers ---
  // toggleAllDistributionModes(): void {
  //   const ctrl = this.subform.get('DistributionMode');
  //   const allValues = this.filteredDistributionModes.map(m => m.sub_delivery_mode);
  //   const current = ctrl?.value || [];
  //   ctrl?.setValue(current.length === allValues.length ? [] : allValues);
  // }

  // toggleAllSubDistModes(): void {
  //   const ctrl = this.subform.get('SubDistMode');
  //   const allValues = this.filteredSubDistModes.map(m => m.name);
  //   const current = ctrl?.value || [];
  //   ctrl?.setValue(current.length === allValues.length ? [] : allValues);
  // }

  // private _filter14(value: string): any[] {
  //   const filterValue = value.toLowerCase();

  //   return this.distributorList.filter(option =>
  //     option.name.toLowerCase().includes(filterValue)
  //   );
  // }
  private _filter15(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.subDeliveryModeData.filter(option =>
      option.sub_delivery_mode.toLowerCase().includes(filterValue)
    );
  }

  private _filter16(value: string): any[] {
    const filterValue = value.toLowerCase();

    return this.FilteredsubDistributionModeData.filter(option =>
      option.subdistributionmode.toLowerCase().includes(filterValue)
    );
  }
  distributionMode(event: any, selected: any) {

    if (event.isUserInput && event.source.selected) {

      // filter sub modes based on selected mode id
      this.FilteredsubDistributionModeData = this.FilteredsubDistributionModeData.filter(
        item => item.parent_id === selected.id
      );

      // reset submode field
      this.AssignDisRepForm.get('dissubmode')!.setValue('');
    }
  }

  // ---------------- DISPLAY FUNCTIONS ----------------
  displayMode(option: any): string {
    return option ? option.sub_delivery_mode : '';
  }

  displaySubMode(option: any): string {
    return option ? option.subdistributionmode : '';
  }

  // (optional but recommended) display selected value properly
  // displayFn(option: any): string {
  //   return option && option.name ? option.name : '';
  // }
  getDeliveryModes() {
    this.service.getDeliveryMode1().subscribe((res: any) => {
      console.log('API Response:', res);

      this.distributionmodesData1 = res.data || res;
    });
  }
  getAllDistributionModes() {
    this.service.getAllDistributionModes3().subscribe((res: any) => {
      console.log(res);

      this.distributionmodesData = res.data || res;
    });
  }
  addSubDelivery() {
    let subdeliverydata = {
      delivery_mode_id: this.adddeliverymodeform.get('deliverymode').value,
      subdeliverymode: this.adddeliverymodeform.get('subdeliverymode').value,
    };

    this.service.addSubDeliveryMode1(subdeliverydata).subscribe((_data) => {
      window.alert('SubDelivery Mode Added Successfully...');
      // this.adddeliverymodeform.reset();
      // this.ngOnInit();
    });


  }
  dis_mode_show1 = false;
  dis_mode_id1 = 0;
  updatedismode(id) {
    // console.log(this.distributionmodesData);
    for (
      let index = 0;
      index < Object.keys(this.distributionmodesData).length;
      index++
    ) {
      if (id == this.distributionmodesData[index]['id']) {
        this.dis_mode_show1 = true;
        this.dis_mode_id1 = this.distributionmodesData[index]['id'];
        this.adddeliverymodeform
          .get('deliverymode')
          .setValue(this.distributionmodesData[index]['delivery_mode_id']);
        this.adddeliverymodeform
          .get('subdeliverymode')
          .setValue(this.distributionmodesData[index]['sub_delivery_mode']);
      }
    }
  }
  dis_mode_id = 0;
  dis_mode_show = false;
  updateDisMode(id) {
    for (
      let index = 0;
      index < Object.keys(this.distributionmoderepData).length;
      index++
    ) {
      if (id == this.distributionmoderepData[index]['id']) {
        this.dis_mode_show = true;
        this.dis_mode_id = this.distributionmoderepData[index]['id'];
        this.AssignDisRepForm.get('disrep1').setValue(
          this.distributionmoderepData[index]['dis_rep']
        );
        this.AssignDisRepForm.get('dismode').setValue(
          this.distributionmoderepData[index]['dis_mode']
        );
        this.AssignDisRepForm.get('dissubmode').setValue(
          this.distributionmoderepData[index]['dis_sub_mode']
        );
      }
    }
  }
  removeassigndismode(id) {
    if (
      window.confirm('This Operatin is not reversable? Do you want to procced?')
    ) {
      this.service.deleteAssignDisMode1(id).subscribe((_res) => {
        window.alert('Record deleted successfully...');
        this.ngOnInit();
      });
    }
  }
  assignDistributionMode() {
    let data = {
      disrep: this.AssignDisRepForm.get('disrep1').value,
      dismode: this.AssignDisRepForm.get('dismode').value,
      dissubmode: this.AssignDisRepForm.get('dissubmode').value,
    };

    // console.log('data', data);

    this.service.addAssignDistributionMode1(data).subscribe((_data) => {
      window.alert(
        'Distribution Mode Assign to Representative Successfully...'
      );
      this.AssignDisRepForm.reset();
      this.ngOnInit();
    });
  }
  updateassignDistributionMode() {
    let data = {
      id: this.dis_mode_id,
      disrep: this.AssignDisRepForm.get('disrep1').value,
      dismode: this.AssignDisRepForm.get('dismode').value,
      dissubmode: this.AssignDisRepForm.get('dissubmode').value,
    };

    // console.log('data', data);

    this.service.updateAssignDistributionMode1(data).subscribe((_data) => {
      window.alert('Distribution Mode Updated Successfully...');
      this.AssignDisRepForm.reset();
      this.dis_mode_show = false;
      this.ngOnInit();
    });
  }
  removedismode(id) {
    debugger
    if (
      window.confirm('This Operatin is not reversable? Do you want to procced?')
    ) {
      this.service.deleteDisMode1(id).subscribe((_res) => {
        window.alert('Record deleted successfully...');
        this.ngOnInit();
      });
    }
  }
  updateaddSubDelivery() {
    let data = {
      id: this.dis_mode_id1,
      deliverymode: this.adddeliverymodeform.get('deliverymode').value,
      subdeliverymode: this.adddeliverymodeform.get('subdeliverymode').value
    };

    // console.log(data);
    this.service.updateAddSubDeliveryMode1(data).subscribe((_res) => {
      window.alert('Delivery Mode Updated Successfully...');
      this.adddeliverymodeform.reset();
      this.dis_mode_show1 = false;
      this.ngOnInit();
    });
  }
  getSubDeliveryModes() {
    this.service.getSubDeliveryMode3().subscribe((res: any) => {
      console.log('Dropdown Data:', res);
      this.subDeliveryModeData = res.data || res;
    });
  }

  getSubModes() {
    this.service.getSubDeliveryMode1().subscribe((data: any) => {
      this.subdistributionmodesData = data;
    });
  }
  // getSubDistributionModes(p0: numberid: number) {
  //   this.service.getAllSubDistributionModes1().subscribe((res: any) => {
  //     console.log("Sub Modes:", res);
  //     this.subdistributionmodesData = res;
  //   });
  // }

  getDeliveryModes1() {
    this.service.getSubDeliveryMode1().subscribe((res: any) => {
      console.log("Delivery Modes:", res);
      this.subdistributionmodesData = res;
    });
  }
  addDelivery() {

    console.log(this.adddeliverymode.value)
    this.dev_mode = this.adddeliverymode.value.deliverymode

    this.service.addSubDelivery1(this.dev_mode).subscribe((_data) => {
      window.alert('SubDelivery Mode Added Successfully...');
      // this.adddeliverymodeform.reset();
      // this.ngOnInit();
    });
  }
  addSubDeliveryofSub() {
    let subofsubdeliverydata = {
      sub_delivery_mode_id:
        this.addsubdeliverymodeform.get('deliverymode').value,
      subdeliverymode: this.addsubdeliverymodeform.get('subdeliverymode').value
      // vajan: this.addsubdeliverymodeform.get('vajan').value,
      // rate: this.addsubdeliverymodeform.get('rate').value
    };

    this.service.addSubModes1(subofsubdeliverydata).subscribe((_data) => {
      window.alert('Delivery Modes Added Successfully...');
      this.addsubdeliverymodeform.reset();
      this.ngOnInit();
    });
  }
  sub_dis_mode_show = false;
  sub_dis_mode_id = 0;
  updatesubdismode(id) {
    debugger
    // console.log(this.subdistributionmodesData);

    for (
      let index = 0;
      index < Object.keys(this.subdistributionmodesData).length;
      index++
    ) {
      if (id == this.subdistributionmodesData[index]['id']) {
        this.sub_dis_mode_show = true;
        this.sub_dis_mode_id = this.subdistributionmodesData[index]['id'];
        this.addsubdeliverymodeform
          .get('deliverymode')
          .setValue(
            this.subdistributionmodesData[index]['sub_deliver_mode_id']
          );
        this.addsubdeliverymodeform
          .get('subdeliverymode')
          .setValue(this.subdistributionmodesData[index]['subdeliverymode']);



      }
    }
  }
  updateaddSubDeliveryofSub() {

    const payload = {
      id: this.sub_dis_mode_id,
      deliverymode: this.addsubdeliverymodeform.value.deliverymode,
      subdeliverymode: this.addsubdeliverymodeform.value.subdeliverymode
    };

    console.log('Sending payload:', payload); // ✅ debug

    this.service.updateAddSubDeliverySubMode1(payload).subscribe({
      next: (res) => {
        console.log('Response:', res);
        alert('Updated Successfully');
        this.addsubdeliverymodeform.reset();
        this.sub_dis_mode_show = false;
        this.getSubModes();
      },
      error: (err) => {
        console.error('Error:', err);
        alert('Update Failed');
      }
    });
  }
  removesubdismode(id: number) {
    if (window.confirm('This operation is not reversible. Proceed?')) {
      this.service.deleteSubDisMode1(id).subscribe({
        next: () => {
          alert('Record deleted successfully');
          this.ngOnInit();
        },
        error: (err) => {
          console.error(err);
          alert('Delete failed');
        }
      });
    }
  }

  delivery_mode_update_btn: boolean = false;

  update_delivery_modeapi1() {
    debugger
    this.id = this.delivery_update_data.id
    this.dev_mode = this.adddeliverymode.value.deliverymode;
    this.service.updatedeliverymode1(this.id, this.dev_mode).subscribe((_data) => {
      window.alert('Delivery Mode Updated Successfully...');
      this.ngOnInit();
    });
  }

  searchExpense() {

    debugger;

    const bookNames = this.bookExpenseForm.get('bookwise')?.value || [];

    const payload = {
      start_date: this.fixDate(this.bookExpenseForm.value.start_date),
      end_date: this.fixDate(this.bookExpenseForm.value.end_date),
      book_name: bookNames,
      author_name: this.bookExpenseForm.value.author_name || ''
    };

    console.log("Payload sent to API:", payload);

    this.service.getBookExpense(payload).subscribe((res: any) => {

      console.log("API Response:", res);

      if (res.status === "success") {

        this.bookExpenseList = res.data;
        this.calculateTotals5();

        this.loadShippingFromLocal(this.bookExpenseList);

        this.bookExpenseList.forEach((item: any) => {

          item.paper_bill = item.paper_bill ?? '';
          item.printing_bill = item.printing_bill ?? '';
          item.cover = item.cover ?? '';
          item.other = item.other ?? '';

        });

      }

    }, error => {
      console.log("ERROR:", error);
    });

  }


  updateShippingLocal(item: any) {

    let storedShipping = JSON.parse(localStorage.getItem('shippingCharges') || '{}');

    storedShipping[item.book_name] = item.shipping_charges;

    localStorage.setItem('shippingCharges', JSON.stringify(storedShipping));

    this.getTotalExpense(item);

  }
  getAuthorList() {

    this.service.getAllBookData3().subscribe((data: any) => {

      if (data && data.data) {

        const uniqueAuthorMap = new Map();

        data.data.forEach((item: any) => {

          if (item.author_name && item.author_name.trim() !== "") {

            const author = item.author_name.trim();
            const key = author.toLowerCase(); // prevents case duplicates

            if (!uniqueAuthorMap.has(key)) {
              uniqueAuthorMap.set(key, { author_name: author });
            }

          }

        });

        this.authorList = Array.from(uniqueAuthorMap.values());

        console.log("Unique Author List:", this.authorList);

      }

    });

  }
  loadShippingFromLocal(data: any[]) {

    const storedShipping = JSON.parse(localStorage.getItem('shippingCharges') || '{}');

    data.forEach(row => {
      if (storedShipping[row.book_name] !== undefined) {
        row.shipping_charges = storedShipping[row.book_name];
      }
    });

  }
  onPaperBillChange(item: any) {

    item.paper_bill = Number(item.paper_bill) || 0;

  }
  applyFilters1(): void {
    debugger;

    const data = {
      book_name: this.generateform1.value.bookwise || [],

      adesh_from: this.generateform1.value.adesh_from,
      adesh_to: this.generateform1.value.adesh_to,

      // ✅ ADD PUBLISH DATE HERE
      start_publish_date: this.generateform1.value.start_publish_date,
      end_publish_date: this.generateform1.value.end_publish_date
    };

    console.log("Search Payload:", data);

    this.service.getAllissuePrintOrderData2(data).subscribe({

      next: (res: any) => {

        console.log("Response:", res);

        if (res.success) {
          this.printOrderData = res.data;
        } else {
          this.printOrderData = [];
        }

      },

      error: (err) => {
        console.error("API Error:", err);
        this.printOrderData = [];
      }

    });
  }
  onPrintBillChange(item: any) {

    item.printing_bill = Number(item.printing_bill) || 0;

  }
  printTable1() {

    const startDate = this.bookExpenseForm.get('start_date')?.value
      ? new Date(this.bookExpenseForm.get('start_date')?.value).toLocaleDateString('en-GB')
      : '';

    const endDate = this.bookExpenseForm.get('end_date')?.value
      ? new Date(this.bookExpenseForm.get('end_date')?.value).toLocaleDateString('en-GB')
      : '';

    const todayDate = new Date().toLocaleDateString('en-GB');

    const tableElement = document.getElementById('printBookExpense');
    if (!tableElement) return;

    const rows = tableElement.querySelectorAll('tbody tr');

    let paperTotal = 0;
    let printingTotal = 0;
    let processingTotal = 0;
    let coverTotal = 0;
    let otherTotal = 0;
    let shippingTotal = 0;

    rows.forEach((row: any) => {


      paperTotal += parseFloat(row.querySelector('[name^="paper_bill"]')?.value) || 0;
      printingTotal += parseFloat(row.querySelector('[name^="printing_bill"]')?.value) || 0;
      processingTotal += parseFloat(row.querySelector('[name^="processing"]')?.value) || 0;
      coverTotal += parseFloat(row.querySelector('[name^="cover"]')?.value) || 0;
      otherTotal += parseFloat(row.querySelector('[name^="other"]')?.value) || 0;
      shippingTotal += parseFloat(row.querySelector('[name^="shipping_charges"]')?.value) || 0;


    });

    const clonedTable = tableElement.cloneNode(true) as HTMLElement;

    const inputs = clonedTable.querySelectorAll('input');
    inputs.forEach((input: any) => {
      const textNode = document.createTextNode(input.value || '');
      input.parentNode.replaceChild(textNode, input);
    });

    const table = clonedTable.querySelector('table');

    // if (table) {


    // const totalRow = document.createElement('tr');

    // totalRow.innerHTML = `
    //   <td colspan="9" style="font-weight:bold;">Total</td>
    //   <td style="font-weight:bold;">${paperTotal}</td>
    //   <td style="font-weight:bold;">${printingTotal}</td>
    //   <td style="font-weight:bold;">${processingTotal}</td>
    //   <td style="font-weight:bold;">${coverTotal}</td>
    //   <td style="font-weight:bold;">${otherTotal}</td>
    //   <td style="font-weight:bold;">${shippingTotal}</td>
    //   <td colspan="5"></td>
    // `;

    // table.appendChild(totalRow);


    // }

    const printContents = clonedTable.innerHTML;

    const popupWin = window.open('', '_blank', 'width=1200,height=700');

    popupWin?.document.open();
    popupWin?.document.write(`

  <html>
  <head>
  <title>Book Expense Register</title>

  <style>
  body{
    font-family: Arial, Helvetica, sans-serif;
    padding:20px;
  }

  h2{
    text-align:center;
    margin-bottom:10px;
  }

  .date-row{
    display:flex;
    justify-content:space-between;
    margin-bottom:15px;
    font-size:16px;
  }

  table{
    width:100%;
    border-collapse:collapse;
    font-size:14px;
  }

  table, th, td{
    border:1px solid black;
  }

  th, td{
    padding:6px;
    text-align:center;
  }

  .no-print{
    display:none;
  }

  </style>

  </head>

  <body onload="window.print(); window.close()">

  <h2>Book Expense Register</h2>

  <div class="date-row">
    <div>${startDate} to ${endDate}</div>
    <div><b>Print Date:</b> ${todayDate}</div>
  </div>

${printContents}

  </body>
  </html>
  `);

    popupWin?.document.close();

  }


  getColumnTotal(field: string): number {

    let total = 0;

    this.bookExpenseList.forEach((item: any) => {

      total += Number(item[field]) || 0;

    });

    return total;

  }


  getTotalExpense(item: any) {

    const honorarium = Number(item.author_honorarium) || 0;
    const paper = Number(item.paper_bill) || 0;
    const printing = Number(item.printing_bill) || 0;
    const cover = Number(item.cover) || 0;
    const other = Number(item.other) || 0;
    const processing = Number(item.processing) || 0;

    // THIS VALUE COMES FROM UI INPUT
    const shipping = Number(item.shipping_charges) || 0;

    return honorarium + paper + printing + cover + processing + other + shipping;

  }
  export() {

    if (!this.bookExpenseList || this.bookExpenseList.length === 0) {
      return;
    }

    const exportData = this.bookExpenseList.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Book Name': item.book_name,
      'Author': item.author_name,
      'Publish Year': item.bookyear,
      'Prakashan': item.prakashan_name,
      'Book Edition': item.bookedition,
      'Book Price': item.bookprice,
      'Print Copies': item.print_order,
      'लेखक मानधन': item.author_honorarium,

      'पेपर बिल': item.paper_bill || 0,
      'प्रिंटिंग बिल': item.printing_bill || 0,
      'प्रोसेसिंग फी': item.processing || 0,
      'कव्हर': item.cover || 0,
      'इतर': item.other || 0,
      'कुरियर खर्च': item.shipping_charges || 0,

      'एकूण खर्च': this.getTotalExpense(item),

      'बिलिंग रक्कम': item.total_amount,
      'जमा': item.received_amt,
      'येणे बाकी': item.outstanding_amt
    }));

    // ✅ Add TOTAL ROW
    exportData.push({
      'Sr No': '',
      'Book Name': 'TOTAL',
      'Author': '',
      'Publish Year': '',
      'Prakashan': '',
      'Book Edition': '',
      'Book Price': this.totalBookPrice,
      'Print Copies': this.totalPrintOrder,
      'लेखक मानधन': this.totalAuthorHonorarium,

      'पेपर बिल': this.totalPaperBill,
      'प्रिंटिंग बिल': this.totalPrintingBill,
      'प्रोसेसिंग फी': this.totalProcessing,
      'कव्हर': this.totalCover,
      'इतर': this.totalOther,
      'कुरियर खर्च': this.totalShipping,

      'एकूण खर्च': this.totalExpense,

      'बिलिंग रक्कम': this.totalBilling,
      'जमा': this.totalReceived,
      'येणे बाकी': this.totalOutstanding
    });

    // ✅ Convert JSON → Sheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Book Expense Register': worksheet },
      SheetNames: ['Book Expense Register']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const data: Blob = new Blob(
      [excelBuffer],
      { type: 'application/octet-stream' }
    );

    FileSaver.saveAs(data, 'Book_Expense_Register.xlsx');
  }
  updateShipping(item: any) {

    // if user clears field make it 0
    if (!item.shipping_charges) {
      item.shipping_charges = 0;
    }

    // update total calculation
    this.getTotalExpense(item);
  }
  oncover(item: any) {

    item.cover = Number(item.cover) || 0;

  }
  onother(item: any) {

    item.other = Number(item.other) || 0;

  }
  saveRow(item: any) {
    debugger

    const payload = {
      book_name: item.book_name,
      bookyear: this.fixDate(item.bookyear),
      paper_bill: item.paper_bill || 0,
      printing_bill: item.printing_bill || 0,
      processing: item.processing || 0,
      cover: item.cover || 0,
      other: item.other || 0,
    };

    console.log("Payload:", payload);

    this.service.saveBookExpense(payload).subscribe((res: any) => {

      console.log("API Response:", res);

      if (res.status === "success") {
        alert("Saved Successfully");
      }
      else {
        alert(res.message);
      }

    }, (error: any) => {
      console.log(error);
      alert("API Error");
    });

  }
  openEditDialog(item: any, index: number) {

    const dialogRef = this.dialog.open(EditBookExpenseComponent, {
      width: '400px',
      data: item
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        // update table row instantly
        this.bookExpenseList[index] = result;

        // recalculate totals
        this.calculateTotals();

      }

    });

  }
  getBookSellerNames4() {
    this.service.getBookSellerNames().subscribe((data) => {
      this.names = [];
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.names.push({
          id: data[index]['id'],
          name: data[index]['name'],
        });
      }
      // Initially show all names
      this.filteredNames = [...this.names];
    });
  }

  // Filter book sellers based on search text
  filterBookSellers() {
    const searchValue = this.searchText.toLowerCase().trim();

    if (searchValue === '') {
      // If search is empty, show all names
      this.filteredNames = [...this.names];
    } else {
      // Filter names that contain the search text
      this.filteredNames = this.names.filter(item =>
        item.name.toLowerCase().includes(searchValue)
      );
    }
  }

  // Your existing selection change function
  getbooksellerwise4(event: any) {
    const selectedValues = event.value;
    console.log('Selected:', selectedValues);
    // Your logic here
  }

  // Toggle all selection
  toggleAllSelection4() {
    if (this.isAllSelected()) {
      // Deselect all
      this.matSelect.options.forEach((item: any) => {
        if (item.value !== 'ALL') {
          item.deselect();
        }
      });
    } else {
      // Select all filtered items
      this.matSelect.options.forEach((item: any) => {
        if (item.value !== 'ALL') {
          item.select();
        }
      });
    }
  }

  // Check if all items are selected
  isAllSelected(): boolean {
    const selectedCount = this.matSelect.value ? this.matSelect.value.filter((v: string) => v !== 'ALL').length : 0;
    return selectedCount === this.filteredNames.length && this.filteredNames.length > 0;
  }


  dis_mode(dis_mode: any) {
    throw new Error('Method not implemented.');
  }






  contractReportRepName = '';
  getContractRepName(event) {
    this.contractReportRepName = event.value;
  }

  contractReportOffRepName = '';
  getContractOffRepName(event) {
    console.log(event)
    this.contractReportOffRepName = event.value;
  }

  contractReportOffRepName1 = '';
  getContractOffRepNameGranth(event) {
    console.log(event)
    this.contractReportOffRepName1 = event.value;
  }

  bookingdateChange(event) {
    debugger
    this.getBookSellerOrderNo(
      formatDate(event.target.value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
    );
  }

  bookingdateChangepackage(event) {
    this.getBookSellerOrderNoPackage(
      formatDate(event.target.value, 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
    );
  }

  getSellerTypes() {
    this.sellerTypes = [];

    this.service.getBooksellerTypeList().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.sellerTypes.push({
          id: data[index]['id'],
          sellertype: data[index]['sellertype'],
        });
      }
    });
  }


  getbookdeliverymode() {
    this.BookDeliveryTypes = [];
    debugger
    this.service.getBookDeliveryMOdeList().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.BookDeliveryTypes.push({
          id: data[index]['id'],
          delivery_mode: data[index]['delivery_mode'],
        });
      }
    });
  }
  getComplTypes() {
    this.compTypes = [];
    this.service.getBookComplementryList().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.compTypes.push({
          id: data[index]['id'],
          comptype: data[index]['comptype'],
        });
      }
    });
  }

  getAbhiyanTypes() {
    this.abhiyanTypes = [];
    this.service.getBookAbhiyanList().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        this.abhiyanTypes.push({
          id: data[index]['id'],
          abhiyantype: data[index]['abhiyantype'],
        });
      }
    });
  }



  getBookSellerOrderNo(today) {
    debugger
    this.service.getBookSellerId(today).subscribe((data) => {
      // console.log(data);

      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['order_no']);
      } else {
        value = 0;
      }
      // let date = ('0' + this.date.getDate()).slice(-2);
      let selectedDate = new Date(today);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      // Determine financial year
      let financialStartYear;
      let financialEndYear;

      if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar → Previous financial year
        financialStartYear = year - 1;
        financialEndYear = year;
      } else { // Apr to Dec → Current financial year
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      // Generate book order number
      this.bookorderno = `BDO${month}/${startYearShort}-${endYearShort}/${value <= 9 ? '0' + (value + 1) : value + 1
        }`;

      this.subform.get('orderno').setValue(this.bookorderno);




      // let month = ('0' + (new Date(today).getMonth() + 1)).slice(-2);
      // let year = new Date(today).getFullYear().toString().slice(-2);
      // let nextyear = (new Date(today).getFullYear() + 1).toString().slice(-2);
      // this.bookorderno = `BDO${month}${year}-${nextyear}/${
      //   value <= 9 ? '0' + (value + 1) : value + 1
      // }`;
      // this.subform.get('orderno').setValue(this.bookorderno);
    });
  }


  getBookSellerOrderNoPackage(today) {
    this.service.getBookSellerId(today).subscribe((data) => {
      // console.log(data);

      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['order_no']);
      } else {
        value = 0;
      }
      // let date = ('0' + this.date.getDate()).slice(-2);
      let selectedDate = new Date(today);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      // Determine financial year
      let financialStartYear;
      let financialEndYear;

      if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar → Previous financial year
        financialStartYear = year - 1;
        financialEndYear = year;
      } else { // Apr to Dec → Current financial year
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      // Generate book order number
      this.bookorderno = `BDO${month}/${startYearShort}-${endYearShort}/${value <= 9 ? '0' + (value + 1) : value + 1
        }`;

      this.packsubform.get('orderno').setValue(this.bookorderno);




      // let month = ('0' + (new Date(today).getMonth() + 1)).slice(-2);
      // let year = new Date(today).getFullYear().toString().slice(-2);
      // let nextyear = (new Date(today).getFullYear() + 1).toString().slice(-2);
      // this.bookorderno = `BDO${month}${year}-${nextyear}/${
      //   value <= 9 ? '0' + (value + 1) : value + 1
      // }`;
      // this.subform.get('orderno').setValue(this.bookorderno);
    });
  }





  BookCreditNoteData;
  FilteredBookCreditNoteData = [];
  bookcrdtnote() {
    this.service.getBookCrdtNote().subscribe((data) => {
      this.BookCreditNoteData = data;
      this.FilteredBookCreditNoteData = this.BookCreditNoteData;
    });
  }

  private _filter(mob_no: string): any[] {
    const filterValue = mob_no;
    return this.book_sellerdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.mob_no.toLowerCase().includes(filterValue)
    );
  }

  private _filter1(name: string): any[] {
    const filterValue = name;
    return this.book_sellerdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filterpackage(name: string): any[] {
    const filterValue = name;
    return this.book_seller_datapack.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter2(bookname: string): any[] {
    const filterValue = bookname;
    return this.booknames.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.bookname.toLowerCase().includes(filterValue)
    );
  }


  private _filter0(bookedition: string): any[] {
    const filterValue = bookedition;
    return this.bookdata.filter((option) =>
      option.bookedition.toLowerCase().includes(filterValue)
    );
  }



  private _filter7(bookname: string): any[] {
    const filterValue = bookname;
    return this.bookdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.bookname.toLowerCase().includes(filterValue)
    );
  }

  private _filter3(author: string): any[] {
    const filterValue = author;
    return this.bookData.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.author.toLowerCase().includes(filterValue)
    );
  }

  private _filter4(name: string): any[] {
    const filterValue = name;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter5(name: string): any[] {
    const filterValue = name;
    return this.book_sellerdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  // Function to filter and remove duplicates
  private _filter6(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.removeDuplicates(
      this.names.filter(option => option.name.toLowerCase().includes(filterValue))
    );
  }


  private _filterbook(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.distributorList1.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  private _filterbookDM(sub_delivery_mode: string): any[] {
    const filterValue = sub_delivery_mode.toLowerCase();
    return this.distributorListDM.filter(option =>
      option.sub_delivery_mode.toLowerCase().includes(filterValue)
    );
  }

  // Function to remove duplicate names
  private removeDuplicates(array: any[]): any[] {
    return array.filter((value, index, self) =>
      index === self.findIndex((t) => t.name === value.name)
    );
  }

  private _filterpack(bookname: string): any[] {
    const filterValue = bookname;
    return this.booknames.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.bookname.toLowerCase().includes(filterValue)
    );
  }
  private _filterbookp(name: string): any[] {
    const filterValue = name;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }
  // private _filter6(name: string): any[] {
  //   const filterValue = name;
  //   return this.names.filter((option) =>
  //     // option.mobno.toLowerCase().includes(filterValue)
  //     option.name.toLowerCase().includes(filterValue)
  //   );
  // }

  private _filter8(bookname: string): any[] {
    const filterValue = bookname.toLowerCase();;
    return this.booknames.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.bookname.toLowerCase().includes(filterValue)
    );
  }

  private _filter9(name: string): any[] {
    const filterValue = name;
    return this.book_sellerdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter10(name: string): any[] {
    const filterValue = name;
    return this.issue_seller_name.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter11(name: string): any[] {
    const filterValue = name;
    return this.authornames.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  private _filter12(name: string): any[] {
    const filterValue = name;
    return this.book_sellerdata.filter((option) =>
      // option.mobno.toLowerCase().includes(filterValue)
      option.name.toLowerCase().includes(filterValue)
    );
  }

  getallVouchersData: any[] = [];
  FilteredVoucherData: any[] = [];
  getAllVouchers() {
    this.service.getvoucherbybook().subscribe((data: any[]) => {

      // 👉 Raw data
      this.getallVouchersData = data;

      // 1️⃣ Read stored financial year dates
      const start = sessionStorage.getItem('startDate');  // e.g. 2025-04-01
      const end = sessionStorage.getItem('endDate');      // e.g. 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 2️⃣ Filter by voucher_date
      this.FilteredVoucherData = this.getallVouchersData.filter((item: any) => {
        const itemDate = new Date(item.voucher_date);   // YOUR FIELD HERE

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      // 3️⃣ Recalculate totals based on filtered data
      this.priceTotal = 0;
      this.commissionTotal = 0;
      this.remainingTotal = 0;

      for (let row of this.FilteredVoucherData) {
        this.priceTotal += parseFloat(row.price) || 0;
        this.commissionTotal += parseFloat(row.commission) || 0;
        this.remainingTotal += parseFloat(row.remaining_amt) || 0;
      }

      console.log("Filtered Voucher List:", this.FilteredVoucherData);
    });
  }
  FilteredGranthData: any[] = [];
  getallVouchersDatagranth: any[] = [];
  getAllVouchersgranth() {
    this.service.getvoucherbygranth().subscribe((data: any[]) => {

      // 👉 Raw data
      this.getallVouchersDatagranth = data;

      // 1️⃣ Read stored financial year dates
      const start = sessionStorage.getItem('startDate');  // e.g. 2025-04-01
      const end = sessionStorage.getItem('endDate');      // e.g. 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 2️⃣ Filter by voucher_date
      this.FilteredGranthData = this.getallVouchersDatagranth.filter((item: any) => {
        const itemDate = new Date(item.voucher_date);   // YOUR FIELD HERE

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      // 3️⃣ Recalculate totals based on filtered data
      this.granthPriceTotal = 0;
      this.granthCommissionTotal = 0;
      this.granthRemainingTotal = 0;

      for (let row of this.FilteredGranthData) {
        this.granthPriceTotal += parseFloat(row.price) || 0;
        this.granthCommissionTotal += parseFloat(row.commission) || 0;
        this.granthRemainingTotal += parseFloat(row.remaining_amt) || 0;
      }

      console.log("Filtered Voucher List:", this.FilteredGranthData);
    });
  }

  getallCommVouchersData: any[] = [];
  FilteredCommVouchers: any[] = [];
  getAllCommVouchers() {
    this.service.getvoucherbycommision().subscribe((data: any[]) => {

      // Raw data from API
      this.getallCommVouchersData = data;

      // 1️⃣ Read stored financial year dates
      const start = sessionStorage.getItem('startDate');  // Example 2025-04-01
      const end = sessionStorage.getItem('endDate');      // Example 2026-03-31

      const financialYearStart = start ? new Date(start) : null;
      const financialYearEnd = end ? new Date(end) : null;

      // 2️⃣ Filter based on voucher_date
      this.FilteredCommVouchers = this.getallCommVouchersData.filter((item: any) => {
        const itemDate = new Date(item.voucher_date); // ← your field

        if (!financialYearStart || !financialYearEnd || isNaN(itemDate.getTime())) {
          return false;
        }

        return itemDate >= financialYearStart && itemDate <= financialYearEnd;
      });

      // 3️⃣ Recalculate totals from filtered list
      this.commission_Total = 0;
      this.commRemainingTotal = 0;

      for (let row of this.FilteredCommVouchers) {
        this.commission_Total += parseFloat(row.commission) || 0;
        this.commRemainingTotal += parseFloat(row.remaining_amt) || 0;
      }

      console.log("Filtered Commission Vouchers:", this.FilteredCommVouchers);
    });
  }


  // getallVouchersData = [];
  // getAllVouchers() {
  //   this.service.getvoucherbybook().subscribe((data) => {
  //     this.getallVouchersData = data;
  //   });
  // }




  validmobile = false;
  validemail = false;
  validateMobile(event) {
    if (
      this.subform.get('mobileNumber').valid ||
      this.subform.get('repmobno1').valid
    ) {
      this.validmobile = true;
    } else {
      this.validmobile = false;
    }
  }

  // caltotalpages(event) {
  //   let val = parseInt(event.target.value);
  //   this.totalpages = this.totalpages + val;
  //   this.BookForm.get('totalpages').setValue(this.totalpages);
  // }

  caltotalpages() {
    let bookpagesbw = this.BookForm.get('bookpagesbw').value || 0;
    let bkpinsidecolor = this.BookForm.get('bkpinsidecolor').value || 0;
    let bkpcover = this.BookForm.get('bkpcover').value || 0;

    // Ensure values are treated as numbers
    let total = parseInt(bookpagesbw, 10) + parseInt(bkpinsidecolor, 10) + parseInt(bkpcover, 10);

    // Update total pages
    this.BookForm.get('totalpages').setValue(total);
  }
  sponserEnterValue: any = 0;
  sponsorEnter(event: any, book: any) {
    this.sponserEnterValue = parseFloat(event.target.value);

    if (this.discount != 0) {
      this.amount = this.sponserEnterValue * (this.discount / 100);
      this.amt = this.sponserEnterValue - this.amount;
    } else {
      this.amt = this.sponserEnterValue;
    }

    for (let index = 0; index < this.book_data.length; index++) {
      if (this.book_data[index]['bookid'] == book['bookid']) {
        this.book_data[index]['totalad'] = this.amt;
        this.book_data[index]['discount'] = this.discount;
        this.book_data[index]['discountamt'] = this.amount;
        this.book_data[index]['price'] = this.sponserEnterValue;
      }
    }

    // Now calculate the grand total across all books
    // this.calculateSponsorTotal();
  }

  // calculateSponsorTotal() {
  //   this.sponserEnterValue = 0;
  //   for (let book of this.book_data) {
  //     if (book['totalad']) {
  //       this.sponserEnterValue += parseFloat(book['totalad']);
  //     }
  //   }
  // }


  // Call this method whenever a single book total is updated
  calculateTotal1(event: any, book: any) {
    // Update the book.total if needed
    book.total = Number(book.total) || 0;

    // Recalculate the grand total for all books
    this.sponserEnterValue = this.book_data.reduce((acc, curr) => {
      return acc + (Number(curr.total) || 0);
    }, 0);
  }

  toNumber(val: any): number {
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }


  // calculateSponsorTotal(event: any) {

  //   debugger

  //     const inputValue = Number(event.target.value) || 0;


  //   this.sponsor_price_total += Number(inputValue) || 0;
  //   // this.sponsor_discount_total += parseFloat(book.totalad) || 0;
  //   // this.sponsor_copies_total += parseFloat(book.bookcopies) || 0;
  //   // this.sponsor_total += parseFloat(book.total) || 0;


  // }

  sponsor_price_total: number = 0;
  sponsor_discount_total: number = 0;
  sponsor_copies_total: number = 0;
  sponsor_total: number = 0;
  sponsor_total_rep: number = 0;
  sponsor_total_percent: number = 0;
  sponsor_total_shippingcharging: number = 0;

  inputValues: any[] = [];

  calculateSponsorTotal(event: any, field: string, index: number) {
    const value = Number(event.target.value) || 0;

    // Initialize row
    if (!this.inputValues[index]) {
      this.inputValues[index] = {};
    }

    // Store input value
    this.inputValues[index][field] = value;

    // 🔹 Row-wise calculation
    const row = this.inputValues[index];
    const total = row.total || 0;
    const percent = row.percent || 0;

    // If percentage entered → calculate net
    if (field === 'percent' || field === 'total') {
      row.net = (total * percent) / 100;
    }

    // 🔹 Grand totals
    this.sponsor_price_total = this.inputValues.reduce(
      (sum, r) => sum + (+r.price || 0),
      0
    );

    this.sponsor_discount_total = this.inputValues.reduce(
      (sum, r) => sum + (+r.totalad || 0),
      0
    );

    this.sponsor_copies_total = this.inputValues.reduce(
      (sum, r) => sum + (+r.bookcopies || 0),
      0
    );

    this.sponsor_total = this.inputValues.reduce(
      (sum, r) => sum + (+r.total || 0),
      0
    );

    this.sponsor_total_rep = this.inputValues.reduce(
      (sum, r) => sum + (+r.net || 0),
      0
    );

    this.sponsor_total_percent = this.inputValues.reduce(
      (sum, r) => sum + (+r.percent || 0),
      0
    );

    this.sponsor_total_shippingcharging = this.inputValues.reduce(
      (sum, r) => sum + (+r.shippingcharging || 0),
      0
    );


  }



  complementary_total: number = 0;
  complementaryValues: any[] = [];

  updateComplementaryCopies(event: any, book: any, index: number) {
    const value = Number(event.target.value) || 0;

    // Update book object directly so it will be saved
    book.bookcopies = value;

    // Update the row array for total calculation
    if (!this.complementaryValues[index]) {
      this.complementaryValues[index] = {};
    }
    this.complementaryValues[index]['bookcopies'] = value;

    // Calculate total across all rows
    this.complementary_total = this.complementaryValues.reduce(
      (sum, row) => sum + (row['bookcopies'] || 0),
      0
    );
  }



  totall: any = 0
  calculateTotal(event: any, book: any) {
    const inputTotal = parseFloat(event?.target?.value) || 0;

    const roundedInputTotal = this.customFloorLike(inputTotal);

    for (let index = 0; index < this.book_data.length; index++) {
      const currentBook = this.book_data[index];

      if (currentBook['bookid'] === book['bookid']) {
        const discountRaw = currentBook['discountamt'];
        const discount = parseFloat(discountRaw);
        const isDiscountValid = !isNaN(discount) && discount > 0;

        const copies = parseFloat(currentBook['copies']) || 0;
        const saleRate = parseFloat(currentBook['sale_rate']) || 0;

        // If discount is NOT valid or zero
        if (!isDiscountValid) {
          const total = saleRate * copies;
          currentBook['total'] = this.customFloorLike(total);
        } else {
          // Use manually entered total
          currentBook['total'] = roundedInputTotal;
        }

        break;
      }
    }

    // Recalculate total_amt safely
    this.total_amt = 0;
    for (let i = 0; i < this.book_data.length; i++) {
      const bookTotal = parseFloat(this.book_data[i].total);
      if (!isNaN(bookTotal)) {
        this.total_amt += this.customFloorLike(bookTotal);
      }
    }

    console.log("Updated total_amt:", this.total_amt);
  }
  calculateTotals1() {
    this.totalInvoice = this.Filteredbookoutstandingdata
      .reduce((sum, item) => sum + Number(item.invoice_total || 0), 0);

    this.totalReceipt = this.Filteredbookoutstandingdata
      .reduce((sum, item) => sum + Number(item.selecteamt_total || 0), 0);

    this.totalCredit = this.Filteredbookoutstandingdata
      .reduce((sum, item) => sum + Number(item.crdtnote_total || 0), 0);

    this.totalPending = this.Filteredbookoutstandingdata
      .reduce((sum, item) => sum + Number(item.remaining_amt || 0), 0);
  }



  // Custom rounding method as per your scenario
  customFloorLike(value: number): number {
    const decimal = value - Math.floor(value);
    return decimal > 0.5 ? Math.ceil(value) : Math.floor(value);
  }


  amount = 0;
  amt;
  salePrice = 0;
  bookdiscount(event: any, book: any): void {
  const discount = Number(event.target.value) || 0;

  const unitPrice = Number(book.price) || 0; // always original 350, never overwritten

  const copies = Number(book.bookcopies) || 1;

  // discount per copy — this is your "Discount Amount" column
  const discountAmtPerCopy = (unitPrice * discount) / 100;

  // net price per copy after discount
  const netPrice = unitPrice - discountAmtPerCopy;

  // total after discount (scaled by copies)
  const totalAfterDiscount = netPrice * copies;

  book.discount = discount;
  book.discountamt = Number(discountAmtPerCopy.toFixed(2));   // 35 / 70 / 105
  book.totalad = Number(netPrice.toFixed(2));                  // 315 / 280 / 245
  book.total = Number(totalAfterDiscount.toFixed(2));          // scaled by copies

  this.recalculateTotals();
}




  validateEmail(event) {
    if (this.subform.get('email').valid) {
      this.validemail = true;
    } else {
      this.validemail = false;
    }
  }

  validdoa = false;
  validdob = false;
  validgender = false;
  validatedoa(event) {
    this.subform
      .get('doa')
      .setValue(
        formatDate(
          new Date(event.target.value),
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
      );
    if (this.subform.get('doa').valid) {
      this.validdoa = true;
    } else {
      this.validdoa = false;
    }
  }



  allSelectedBook = false;
  allSelectedOther = false;
  allSelectedISN = false;

  @ViewChild('mySel1') skillSel1: MatSelect;
  @ViewChild('mySel') skillSel: MatSelect;
  @ViewChild('isn') skillSel2: MatSelect;

  // Toggle for #mySel
  toggleAllSelection() {
    this.allSelectedOther = !this.allSelectedOther;
    if (this.allSelectedOther) {
      this.skillSel.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel.options.forEach((item: MatOption) => item.deselect());
    }
    this.skillSel.close();
  }
  //   toggleAllSelection2() {

  //   if (this.isAllSelected()) {

  //     this.bookForm.get('author_name').setValue([]);

  //   } else {

  //     const allAuthors = this.authorList.map(a => a.author_name);

  //     this.bookForm.get('author_name').setValue(allAuthors);

  //   }

  // }
  isAllSelected2() {

    const selected = this.bookForm.get('author_name').value;

    return selected && selected.length === this.authorList.length;

  }
  showSelectedItems2: any
  filterOptions(value: string) {
    const filterValue = (value || '').toLowerCase();
    this.uniquedata = this.cust_name.filter(option =>
      option.toLowerCase().includes(filterValue)
    );

    // Optional: if "All" was previously selected, update selectedItems2 to match filtered options
    if (this.allSelected) {
      this.selectedItems2.setValue([...this.uniquedata]);
    }
  }

  selectAllOptions(event: any) {

    event.stopPropagation();
    if (this.allSelected) {
      this.selectedItems2.setValue([]);
      this.allSelected = false;
    } else {
      this.selectedItems2.setValue(this.uniquedata);
      this.allSelected = true;
    }
  }

  updateAllSelectedState() {
    const selected = this.selectedItems2.value || [];
    this.allSelected = selected.length === this.uniquedata.length;
  }




  // Toggle for #mySel1
  toggleAllSelection1() {
    this.allSelectedBook = !this.allSelectedBook;
    if (this.allSelectedBook) {
      this.skillSel1.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel1.options.forEach((item: MatOption) => item.deselect());
    }
    this.skillSel1.close();
  }

  // Toggle for #isn
  toggleAllSelectionISN() {
    this.allSelectedISN = !this.allSelectedISN;
    if (this.allSelectedISN) {
      this.skillSel2.options.forEach((item: MatOption) => item.select());
    } else {
      this.skillSel2.options.forEach((item: MatOption) => item.deselect());
    }
    this.skillSel2.close();
  }
  filterBillNos(searchText: string) {
    if (!searchText) {
      this.filteredBillNos = [...this.bookRcptRegisterdata];
      return;
    }

    const filterValue = searchText.toLowerCase();

    this.filteredBillNos = this.bookRcptRegisterdata.filter((item) =>
      item.bill_no?.toString().toLowerCase().includes(filterValue)
    );
  }
  toggleAllBillNos() {
    const control = this.bookrcptForm.get('billnowise'); // your FormGroup control
    if (control.value?.length === this.bookRcptRegisterdata.length) {
      control.setValue([]); // Deselect all
    } else {
      control.setValue(this.bookRcptRegisterdata.map((item) => item.bill_no)); // Select all
    }
  }

  isIndeterminate() {
    const selectedCount = this.Filteredbookbillingdata
      .slice(0, -1)
      .filter(book => book.selected).length;
    return selectedCount > 0 && selectedCount < this.Filteredbookbillingdata.length - 1;
  }

  showrcpt = false;
  showmsg = false;
  selected_booksellername(event, option) {
    this.debugger
    if (event.isUserInput) {
      this.showrcpt = true;
      this.showmsg = false;
      this.booksDataofCrdtNote = [];
      this.displaybooks = false;
      this.selectedBooks = [];
      this.selectedbooks = false;
      this.service.getBookBillingData(option['name']).subscribe((data) => {
        this.BookBillingData = data;
        this.bookcrdtnoteForm.get('receiver_address')?.setValue(this.BookBillingData[0].receiver_address);
        if (this.BookBillingData.length == 0) {
          this.showmsg = true;
        }
        setTimeout(() => {
          this.showrcpt = false;
        }, 3000);
      });
    }
  }

  displaybooks = false;
  booksDataofCrdtNote;
  billSelected(item) {
    this.debugger
    // this.service.getRcptWiseBooksForCreditNote(item['id']).subscribe((data) => {
    //   this.booksDataofCrdtNote = data;
    //   if (this.booksDataofCrdtNote.length > 0) {
    //     this.displaybooks = true;
    //   }
    // });
    this.calculateCrdtAmt(item);
  }

  selectedBooks = [];
  selectedbooks = false;
  booksSelected(item) {
    if (Object.keys(this.selectedBooks).length != 0) {
      let flag: Boolean = false;
      for (
        let index = 0;
        index < Object.keys(this.selectedBooks).length;
        index++
      ) {
        if (this.selectedBooks[index]['id'] == item['id']) {
          flag = true;
        }
      }
      if (!flag) {
        this.selectedBooks.push({
          id: item['id'],
          book_name: item['book_name'],
          copies: item['copies'],
          netamt: parseInt(item['netamt']) - parseInt(item['discountamt']),
          received_amt: item['received_amt'],
          remaining_amt: item['remaining_amt'],
          shipping_charges: item['shipping_charges'],
          total: parseInt(item['total']) + parseInt(item['shipping_charges']),
          total_amount: item['total_amount'],
          returncopies: 0,
          crdtnoteamt: 0,
          remark: '',
        });
        this.selectedbooks = true;
      }
    } else {
      this.selectedBooks.push({
        id: item['id'],
        book_name: item['book_name'],
        copies: item['copies'],
        netamt: parseInt(item['netamt']) - parseInt(item['discountamt']),
        received_amt: item['received_amt'],
        remaining_amt: item['remaining_amt'],
        shipping_charges: item['shipping_charges'],
        total: parseInt(item['total']) + parseInt(item['shipping_charges']),
        total_amount: item['total_amount'],
        returncopies: 0,
        crdtnoteamt: 0,
        remark: '',
      });
      this.selectedbooks = true;
    }
    // this.selectedbookslength = Object.keys(this.selectedBooks).length;
  }

  copies(event, item) {
    let val = event.target.value;
    for (
      let index = 0;
      index < Object.keys(this.selectedBooks).length;
      index++
    ) {
      if (this.selectedBooks[index]['id'] == item['id']) {
        this.selectedBooks[index]['returncopies'] = val;
      }

    }
  }
  issueName;
  bookingdate;
  advtsizebyCategory;
  getFilterMagPublishDates = ['10-10-2021', ''];
  getMagIssueDatesandNames;
  discountAmtHideShow: boolean = false;
  discount_amt;
  // Add these at the top of the component


  getIssues(e: any) {
    console.log(e);
    this.issueName = e.value;
    this.selectedCategory = e.value;
    this.discountAmtHideShow = this.issueName === 'विशेषांक';

    // Optional discount logic
    if (this.discount_amt && this.issueSellerPrice) {
      this.issueSellerPrice = Number(this.issueSellerPrice) - Number(this.discount_amt);
    }

    // Load digital issue info (optional)
    this.service.getDigiIssueByCategory(e.value).subscribe((data) => {
      this.advtsizebyCategory = data;
    });
    this.service.getDeliveryMode1().subscribe((data: any) => {
      this.distributionmodesData1 = data;
      this.delivery_mode = data;
    });

    this.service.getAllSubDistributionModes().subscribe((res) => {
      this.subdistributionmodesData = res;
    });

    // Load issue names and backup full list
    this.service.getAdvtDatesAndNames(e.value).subscribe((data) => {
      this.getMagIssueDatesandNames = data;
      this.allIssueDates = [...data];  // backup full list for filtering
      this.filteredIssueDates = [...data];  // initially show all
      console.log('Issue Dates and Names:', this.getMagIssueDatesandNames);
    });
  }
  crdtnotetotal = 0;
  crdtNoteAmt(event, item) {
    let val = event.target.value;
    this.crdtnotetotal = 0;
    for (
      let index = 0;
      index < Object.keys(this.selectedBooks).length;
      index++
    ) {
      if (this.selectedBooks[index]['id'] == item['id']) {
        this.selectedBooks[index]['crdtnoteamt'] = val;
      }
      this.crdtnotetotal =
        this.crdtnotetotal + parseInt(this.selectedBooks[index]['crdtnoteamt']);
    }
  }

  remark(event, item) {
    let val = event.target.value;
    for (
      let index = 0;
      index < Object.keys(this.selectedBooks).length;
      index++
    ) {
      if (this.selectedBooks[index]['id'] == item['id']) {
        this.selectedBooks[index]['remark'] = val;
      }
    }
  }

  submitCrdtNote() {
    let crdtnotedata = {
      crdtnoteno: this.bookcrdtnoteForm.get('crdtnoteno').value,
      date: this.bookcrdtnoteForm.get('date').value,
      repname: this.bookcrdtnoteForm.get('repname').value,
      offrepname: this.bookcrdtnoteForm.get('offrepname').value,
      bsname: this.bookcrdtnoteForm.get('bsname').value,
    };

    this.dialog.open(BookCrdtnoteRcptComponent, {
      data: {
        crdtnotedata: crdtnotedata,
        crdtnotetotal: this.crdtnotetotal,
        BookBillingData: this.BookBillingData,
        selectedBooks: this.selectedBooks,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  validatedob(event) {
    this.subform
      .get('dob')
      .setValue(
        formatDate(
          new Date(event.target.value),
          'yyyy-MM-dd',
          'en-IN',
          'GMT+0530'
        )
      );
    if (this.subform.get('dob').valid) {
      this.validdob = true;
    } else {
      this.validdob = false;
    }
  }

  validatefname = false;
  validateName(event) {
    if (this.subform.get('name').valid) {
      this.validatefname = true;
    } else {
      this.validatefname = false;
    }
  }

  selected_repname(event, option) {
    if (event.isUserInput) {
      let data = this.bookwisereplist.filter(
        (a) => a['rep_name'] == option['name']
      );
      // bookwisereplist;
      // this.bookcrdtnoteForm.get('repmobno1').setValue(data[0]['rep_mob_no']);
      this.bookcrdtnoteForm.get('offrepname').setValue(data[0]['off_rep_name']);
    }
  }

  selected_rep_name(event, option) {
    if (event.isUserInput) {
      let data = this.bookwisereplist.filter(
        (a) => a['rep_name'] == option['name']
      );
      // bookwisereplist;
      this.subform.get('repmobno1').setValue(data[0]['rep_mob_no']);
      this.subform.get('officerep').setValue(data[0]['off_rep_name']);
    }
  }


  selected_rep_namepack(event, option) {
    if (event.isUserInput) {
      let data = this.bookwisereplist.filter(
        (a) => a['rep_name'] == option['name']
      );
      // bookwisereplist;
      this.packsubform.get('repmobno1').setValue(data[0]['rep_mob_no']);
      this.packsubform.get('officerep').setValue(data[0]['off_rep_name']);
    }
  }
  saveBookSellerEntry() {
    debugger
    let bookseller = {
      title: this.subform.get('title').value,
      name_eng: this.subform.get('subname_eng').value,
      district_eng: this.subform.get('district_eng')?.value,
      name: this.subform.get('name').value,
      address: this.subform.get('address').value,
      sellertype: this.subform.get('sellertype').value,
      comptype: this.subform.get('comptype').value,
      pincode: this.subform.get('pincode').value,
      country: this.subform.get('country').value,
      state: this.subform.get('state').value,
      district: this.subform.get('district').value,
      taluka: this.subform.get('taluka').value,
      mobileNumber: this.subform.get('mobileNumber').value,
      gstNumber: this.subform.get('gstNumber').value,
      email: this.subform.get('email').value,
      dob: this.subform.get('dob').value,
      doa: this.subform.get('doa').value,
    };

    this.service.addBookSellerEntry(bookseller).subscribe(
      (data) => {
        this.booksellerid = data['id'];
        window.alert('Book Seller Added Successfully...');
        this.subform.reset();
      },
      (error) => {
        window.alert('The Book Seller is Already Present.');
      }
    );
  }
  saveBookSellerEntryPackage() {
    let bookseller = {
      title: this.subform.get('title').value,
      name: this.subform.get('name').value,
      address: this.subform.get('address').value,
      sellertype: this.subform.get('sellertype').value,
      comptype: this.subform.get('comptype').value,
      pincode: this.subform.get('pincode').value,
      country: this.subform.get('country').value,
      state: this.subform.get('state').value,
      district: this.subform.get('district').value,
      taluka: this.subform.get('taluka').value,
      mobileNumber: this.subform.get('mobileNumber').value,
      gstNumber: this.subform.get('gstNumber').value,
      email: this.subform.get('email').value,
      dob: this.subform.get('dob').value,
      doa: this.subform.get('doa').value,
    };

    this.service.addBookSellerEntryPackage(bookseller).subscribe(
      (data) => {
        this.booksellerid = data['id'];
        window.alert('Book Seller Added Successfully...');
        this.subform.reset();
      },
      (error) => {
        window.alert('The Book Seller is Already Present.');
      }
    );
  }

  // addBookSellerEntry() {
  //   debugger;

  //   if (!window.confirm(
  //     'This operation is not reversible. Please verify the details before confirmation!'
  //   )) return;

  //   if (!this.bookselleravailable) {
  //     alert('Book seller is not available!');
  //     return;
  //   }

  //   const bookseller = {
  //     title: this.subform.get('title')?.value,
  //     name_eng: this.subform.get('subname_eng')?.value,
  //     district_eng: this.subform.get('district_eng')?.value,
  //     name: this.subform.get('name')?.value,
  //     address: this.subform.get('address')?.value,
  //     sellertype: this.subform.get('sellertype')?.value,
  //     comptype: this.subform.get('comptype')?.value,
  //     pincode: this.subform.get('pincode')?.value,
  //     country: this.subform.get('country')?.value,
  //     state: this.subform.get('state')?.value,
  //     district: this.subform.get('district')?.value,
  //     taluka: this.subform.get('taluka')?.value,
  //     mobileNumber: this.subform.get('mobileNumber')?.value,
  //     gstNumber: this.subform.get('gstNumber')?.value,
  //     email: this.subform.get('email')?.value,
  //     dob: this.subform.get('dob')?.value,
  //     doa: this.subform.get('doa')?.value,
  //   };

  //   const sellerObservable = this.booksellerid
  //     ? of({ id: this.booksellerid })
  //     : this.service.addBookSellerEntry(bookseller);

  //   sellerObservable.pipe(

  //     concatMap((sellerRes: any) => {

  //       // =========================
  //       // FIXED: DELIVERY + DISTRIBUTION VALUES
  //       // =========================

  //       const deliveryModeValue = this.subform.get('DeliveryMode')?.value;
  //       const distributionModeValue = this.subform.get('DistributionMode')?.value;
  //       const subDistModeValues = this.subform.get('SubDistMode')?.value;
  //       const repName = this.subform.get('DistributiveRep')?.value;

  //       // ✅ Delivery Mode (already correct in your case)
  //       const deliveryModeName =
  //         this.deliveryModes.find(x => x.id === deliveryModeValue)?.delivery_mode
  //         || deliveryModeValue
  //         || '';

  //       // 🔥 FIX 1: Distribution Mode (NOW VALUE is already NAME)
  //       const distributionModeName =
  //         distributionModeValue || '';

  //       // 🔥 FIX 2: Sub Distribution Mode (already NAME array)
  //       const subDistModeNames =
  //         Array.isArray(subDistModeValues)
  //           ? subDistModeValues
  //           : [];

  //       const booking = {
  //         bse_id: sellerRes.id,
  //         orderno: this.subform.get('orderno')?.value,
  //         bookdate: this.subform.get('bookdate')?.value,
  //         dispatchto: this.subform.get('dispatchto')?.value,
  //         option: this.option,

  //         deliverymode: deliveryModeName,
  //         DeliveryMode: deliveryModeName,

  //         DistributionMode: distributionModeName,
  //         SubDistMode: subDistModeNames,

  //         crepname: this.subform.get('crepname')?.value,
  //         repmobno1: this.subform.get('repmobno1')?.value,
  //         officerepname: this.subform.get('officerep')?.value,
  //         repcompercent: this.subform.get('repcompercent')?.value,
  //         repcomprice: this.subform.get('repcomprice')?.value,
  //         cdno: this.subform.get('cdno')?.value,
  //         chequeDate: this.subform.get('chequeDate')?.value,
  //         complimentaryOption: this.subform.get('complimentaryOption')?.value,
  //         bankname: this.subform.get('bankname')?.value,
  //         pymtmode: this.pymtmode,
  //         depositamt: this.subform.get('depositamt')?.value,
  //         invoice_generated: 'N',
  //         iscomplementary: this.iscomplementary ? 'Y' : 'N',
  //         isSponsor: this.isSponsor ? 'Y' : 'N',
  //         crepname2: repName,
  //       };

  //       return this.service.addBookSellerEntryBookingDetails(booking);
  //     }),

  //     concatMap((bookingRes: any) => {

  //       return from(this.book_data).pipe(

  //         concatMap((book) => {

  //           let bookdata: any = {
  //             bse_id: bookingRes.id,
  //             book_name: book.bookname,
  //             author_name: book.author,
  //             yearwisebook: book.yearwisebook,
  //             agentprice: book.agentprice,
  //             total_amt: this.total_amt + this.shipping_total,
  //             totalcopies: book.totalcopies || 0,
  //             iscomplementary: this.iscomplementary ? 'Y' : 'N',
  //             isSponsor: this.isSponsor ? 'Y' : 'N',
  //           };

  //           if (!this.isSponsor && !this.iscomplementary) {
  //             bookdata.book_price = book.price;
  //             bookdata.book_sale_price = book.saleprice;
  //             bookdata.discount = book.discount;
  //             bookdata.discountamt = book.discountamt;
  //             bookdata.totalad = book.totalad || 0;
  //             bookdata.book_copies = book.bookcopies || 0;
  //             bookdata.total = book.total || 0;
  //             bookdata.shippingcharge = book.shippingcharging || 0;
  //             bookdata.repcomprecent = book.repcompercent || 0;
  //             bookdata.commissionamt = book.commissionamt || 0;
  //           }

  //           if (this.isSponsor && !this.iscomplementary) {
  //             const iv = this.inputValues[book as any] || {};
  //             bookdata.book_price = iv.price || 0;
  //             bookdata.discountamt = iv.totalad || 0;
  //             bookdata.book_copies = iv.bookcopies || 0;
  //             bookdata.total = iv.total || 0;
  //             bookdata.reptotal = iv.net || 0;
  //             bookdata.percent = iv.percent;
  //             bookdata.shippingcharge = iv.shippingcharging || 0;
  //           }

  //           if (this.iscomplementary) {
  //             bookdata.book_copies = book.bookcopies || 0;
  //           }

  //           return this.service.addBookData(bookdata);
  //         })
  //       );
  //     }),

  //     finalize(() => {
  //       alert('Data Submitted Successfully...');
  //       this.subform.reset();
  //       this.book_data = [];
  //       this.inputValues = [];
  //       this.booksellerid = null;
  //     })

  //   ).subscribe({
  //     error: (err) => {
  //       console.error(err);
  //       alert('Error while saving data!');
  //     }
  //   });
  // }
  onSubmitPackage() {

    const dialogRef = this.dialog.open(ReceiptpackagebookComponent, {
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
      data: {
        formData: this.packsubform.value,
        bookData: this.book_data,
        inputValues: this.inputValues,
        total_amt: this.total_amt,
        shipping_total: this.shipping_total
      }
    });

    // ✅ AFTER CLICK SAVE IN POPUP

  }


  // addBookSellerEntryPackage() {
  //   debugger;

  //   // -------------------------------
  //   // BOOK SELLER BOOKING DETAILS
  //   // -------------------------------
  //   const booksellerbookingdetails: any = {
  //     // IDs
  //     bse_id: this.booksellerid || null,

  //     // Order / Booking
  //     orderno: this.packsubform.get('orderno')?.value,
  //     bookdate: this.packsubform.get('bookdate')?.value,
  //     recptno: this.packsubform.get('recptno')?.value,
  //     crdtvno: this.packsubform.get('crdtvno')?.value,
  //     newordeleted: this.packsubform.get('newordeleted')?.value,

  //     // Subscriber search fields
  //     subscribersName: this.packsubform.get('subscribersName')?.value,
  //     subscribersNo: this.packsubform.get('subscribersNo')?.value,
  //     mobileNumber: this.packsubform.get('mobileNumber')?.value,

  //     // Personal details
  //     title: this.packsubform.get('title')?.value,
  //     titleEnglish: this.packsubform.get('titleEnglish')?.value,
  //     nameRequired: this.packsubform.get('nameRequired')?.value,
  //     nameEnglish: this.packsubform.get('nameEnglish')?.value,
  //     address: this.packsubform.get('address')?.value,
  //     e_address: this.packsubform.get('e_address')?.value,
  //     e_address1: this.packsubform.get('e_address1')?.value,
  //     e_address2: this.packsubform.get('e_address2')?.value,
  //     pincode: this.packsubform.get('pincode')?.value,
  //     pincodeEnglish: this.packsubform.get('pincodeEnglish')?.value,
  //     country: this.packsubform.get('country')?.value,
  //     countryEnglish: this.packsubform.get('countryEnglish')?.value,
  //     state: this.packsubform.get('state')?.value,
  //     stateEnglish: this.packsubform.get('stateEnglish')?.value,
  //     district: this.packsubform.get('district')?.value,
  //     districtEnglish: this.packsubform.get('districtEnglish')?.value,
  //     taluka: this.packsubform.get('taluka')?.value,
  //     talukaEnglish: this.packsubform.get('talukaEnglish')?.value,
  //     mobileNumberField: this.packsubform.get('mobileNumberField')?.value,
  //     telephone: this.packsubform.get('telephone')?.value,
  //     email: this.packsubform.get('email')?.value,
  //     dob: this.packsubform.get('dob')?.value,
  //     doa: this.packsubform.get('doa')?.value,
  //     representativeName: this.packsubform.get('representativeName')?.value,
  //     representativeMobile: this.packsubform.get('representativeMobile')?.value,
  //     gstNumber: this.packsubform.get('gstNumber')?.value,
  //     remark: this.packsubform.get('remark')?.value,
  //     sellertype: this.packsubform.get('sellertype')?.value,

  //     // ✅ ADDED — Book selection fields (were missing)
  //     bookname: this.packsubform.get('bookname')?.value,
  //     availablestock: this.packsubform.get('availablestock')?.value,
  //     authorname: this.packsubform.get('authorname')?.value,

  //     // ✅ ADDED — Booking info display fields (were missing)
  //     seamt: this.packsubform.get('seamt')?.value,
  //     rep_name: this.packsubform.get('rep_name')?.value,

  //     // Representative fields
  //     crepname: this.packsubform.get('crepname')?.value,
  //     repmobno1: this.packsubform.get('repmobno1')?.value,
  //     officerepname: this.packsubform.get('officerep')?.value,

  //     // Dispatch / Delivery
  //     DeliveryMode: this.packsubform.get('DeliveryMode')?.value,
  //     DistributiveRep: this.packsubform.get('DistributiveRep')?.value,
  //     DistributionMode: this.packsubform.get('DistributionMode')?.value,
  //     SubDistMode: this.packsubform.get('SubDistMode')?.value,

  //     // ✅ FIXED — removed stale 'deliverymode' and 'option' keys that don't exist in form
  //     // (were: dispatchto: this.packsubform.get('option')?.value — no such control)
  //     // (were: deliverymode: this.packsubform.get('deliverymode')?.value — duplicate/wrong key)

  //     // Flags
  //     iscomplimentary: this.iscomplementary ? 'Y' : 'N',  // ✅ FIXED key name (was 'iscomplementary')
  //     isSponsor: this.isSponsor ? 'Y' : 'N',
  //     complimentaryOption: this.packsubform.get('complimentaryOption')?.value,

  //     // GST
  //     bookSellerGstType: this.packsubform.get('bookSellerGstType')?.value || 'NO_GST',
  //     gstPercentage: this.packsubform.get('gstPercentage')?.value || 0,
  //     gstAmount: this.packsubform.get('gstAmount')?.value || 0,
  //     sgstAmount: this.packsubform.get('sgstAmount')?.value || 0,
  //     cgstAmount: this.packsubform.get('cgstAmount')?.value || 0,
  //     igstAmount: this.packsubform.get('igstAmount')?.value || 0,
  //     totalAmount: this.packsubform.get('totalAmount')?.value || 0,

  //     invoice_generated: 'N'
  //   };

  //   // -------------------------------
  //   // SAVE BOOKING
  //   // -------------------------------
  //   this.service.addBookSellerEntryBookingDetailsPackage(booksellerbookingdetails)
  //     .subscribe((res: any) => {
  //       from(this.book_data)
  //         .pipe(
  //           concatMap((book: any, i: number) => {
  //             const bookdata: any = {
  //               bse_id: res.id,
  //               book_name: book.bookname,
  //               author_name: book.author,
  //               yearwisebook: book.yearwisebook,
  //               agentprice: book.agentprice,
  //               total_amt: this.total_amt + this.shipping_total,
  //               totalcopies: book.bookcopies || 0,
  //               iscomplementary: booksellerbookingdetails.iscomplimentary,
  //               isSponsor: booksellerbookingdetails.isSponsor,

  //               // Normal / Sponsor / Complementary fields
  //               book_price: book.price || this.inputValues[i]?.price || 0,
  //               book_sale_price: book.saleprice || 0,
  //               discount: book.discount || 0,
  //               discountamt: book.discountamt || this.inputValues[i]?.totalad || 0,
  //               totalad: book.totalad || this.inputValues[i]?.totalad || 0,
  //               book_copies: book.bookcopies || this.inputValues[i]?.bookcopies || 0,
  //               total: book.total || this.inputValues[i]?.total || 0,
  //               shippingcharge: book.shippingcharging || 0,
  //               repcomprecent: book.repcompercent || 0,
  //               commissionamt: book.commissionamt || 0,

  //               // ✅ ADDED — Sponsor-specific inline input values
  //               sponsor_price: this.inputValues[i]?.price || 0,
  //               sponsor_totalad: this.inputValues[i]?.totalad || 0,
  //               sponsor_copies: this.inputValues[i]?.bookcopies || 0,
  //               sponsor_total: this.inputValues[i]?.total || 0,

  //               // ✅ ADDED — Complementary copies from input
  //               complementary_copies: book.complementarycopies || this.inputValues[i]?.bookcopies || 0,
  //             };

  //             return this.service.addBookDataPackage(bookdata);
  //           }),
  //           finalize(() => {
  //             alert('Data Submitted Successfully...');
  //             this.packsubform.reset();
  //             this.book_data = [];
  //             this.inputValues = [];
  //             location.reload();
  //           })
  //         )
  //         .subscribe();
  //     });
  // }
  getAddressLabelswithMobileNo(): void {
    debugger
    const f = this.generateform1.value;

    const filterPayload: any = {

      // BOOK
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      // BOOK SELLER
      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      // SELLER TYPE
      sellertype: f.sellertype || '',
      type: f.type || '',

      // LOCATION
      country: f.country || '',
      state: f.state || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      // REPRESENTATIVES
      rep_name: Array.isArray(f.repwise)
        ? f.repwise.join(',')
        : f.repwise || '',

      office_rep_name: Array.isArray(f.officerepwise)
        ? f.officerepwise.join(',')
        : f.officerepwise || '',

      // ✅ DISTRIBUTIVE REP — same as getLabelforDispatchData
      distributive_rep: f.DistributiveRep || '',

      // DELIVERY
      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      // DATES
      start_date: f.start_date || '',
      end_date: f.end_date || '',

      category: f.issueCatregoryId || '',

      // ✅ MOBILE — always yes for this method
      show_mobile_no: 'yes'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatch1(filterPayload)
      .subscribe({
        next: (data: any) => {
          console.log('Backend Record Count =>', data?.length);

          this.labelsforDispatch = Array.isArray(data) ? data : [];

          // Deduplicate by subno
          this.FilteredlabelsforDispatch = this.labelsforDispatch.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex((t: any) => t.subno === item.subno)
          );

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log('Dialog Record Count =>', this.FilteredlabelsforDispatch.length);

          this.openAddressLabelMobileDialog2();
        },
        error: (err: any) => {
          console.error('API Error:', err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }

  postingLabelBriefReport(): void {
    debugger

    console.log(
      'FilteredlabelsforDispatch',
      this.FilteredlabelsforDispatch
    );

    this.dialog.open(
      BookSellerPostingLabelBriefComponent,
      {

        data: {

          delivery_mode: this.mode_names || '',
          rep_names: this.repnames || '',

          state_name: this.state_names || '',
          district_name: this.district_names || '',
          taluka_name: this.taluka_names || '',

          addresslabels:
            this.FilteredlabelsforDispatch || [],

          country: this.country_names || '',

          office_rep_name:
            this.officerepnames || '',

          rep_name:
            this.repnames || '',

          name:
            this.sub_names || '',

          pincode:
            this.pincodes || '',

          sub_type:
            this.sub_type || ''

        },

        width: '95%',
        height: '95%',
        maxWidth: '100%',

        disableClose: true

      }
    );

  }

   postingLabelBriefReportgranth(): void {
    debugger

    console.log(
      'FilteredlabelsforDispatch',
      this.FilteredlabelsforDispatch
    );

    this.dialog.open(
      BookSellerPostingLabelBriefComponent,
      {

        data: {

          delivery_mode: this.mode_names || '',
          rep_names: this.repnames || '',

          state_name: this.state_names || '',
          district_name: this.district_names || '',
          taluka_name: this.taluka_names || '',

          addresslabels:
            this.FilteredlabelsforDispatch || [],

          country: this.country_names || '',

          office_rep_name:
            this.officerepnames || '',

          rep_name:
            this.repnames || '',

          name:
            this.sub_names || '',

          pincode:
            this.pincodes || '',

          sub_type:
            this.sub_type || ''

        },

        width: '95%',
        height: '95%',
        maxWidth: '100%',

        disableClose: true

      }
    );

  }
  // show_prati = '';
  // show_prati_hide = false;

  // /* DROPDOWN CHANGE */
  // getPrati(event: any) {

  //   this.show_prati = event.value;

  //   if (this.show_prati === 'yes') {
  //     this.show_prati_hide = true;
  //   } else {
  //     this.show_prati_hide = false;
  //   }
  // }


  /* =========================================
     COMMON PAYLOAD METHOD
  ========================================= */

  getCommonPayload(showPrati: string) {

    const f = this.generateform1.value;

    console.log('FORM VALUE => ', f);

    // ============================================
    // SUB DISTRIBUTION MODE
    // ============================================

    const selectedSubDist =
      this.filteredSubDistModes?.filter(

        (x: any) =>

          (
            Array.isArray(f.SubDistMode)
              ? f.SubDistMode
              : [f.SubDistMode]
          ).includes(x.id)

      );

    const subDistNames =
      selectedSubDist?.length

        ? selectedSubDist
          .map(
            (x: any) =>
              x.sub_distribution_mode
          )
          .join(',')

        : (
          Array.isArray(f.SubDistMode)
            ? f.SubDistMode.join(',')
            : (f.SubDistMode || '')
        );

    // ============================================
    // FINAL PAYLOAD
    // ============================================

    const payload = {

      // =========================
      // BOOK / SELLER FILTERS
      // =========================

      bookwise:
        Array.isArray(f.bookwise)
          ? f.bookwise.join(',')
          : (f.bookwise || ''),

      booksellerwise:
        Array.isArray(f.booksellerwise)
          ? f.booksellerwise.join(',')
          : (f.booksellerwise || ''),

      sellertype:
        f.sellertype || '',

      // =========================
      // LOCATION FILTERS
      // =========================

      country:
        f.country || '',

      state:
        f.state || '',

      type:
        f.type || '',

      district:
        Array.isArray(f.district)
          ? f.district.join(',')
          : (f.district || ''),

      taluka:
        Array.isArray(f.taluka)
          ? f.taluka.join(',')
          : (f.taluka || ''),

      pincode:
        Array.isArray(f.pincode)
          ? f.pincode.join(',')
          : (f.pincode || ''),

      // =========================
      // REPRESENTATIVE FILTERS
      // =========================

      rep_name:
        Array.isArray(f.repwise)
          ? f.repwise.join(',')
          : (f.repwise || ''),

      office_rep_name:
        Array.isArray(f.officerepwise)
          ? f.officerepwise.join(',')
          : (f.officerepwise || ''),

      distributive_rep:
        f.DistributiveRep || '',

      // =========================
      // DELIVERY FILTERS
      // =========================

      delivery_mode:
        f.DeliveryMode || '',

      distribution_mode:
        f.DistributionMode || '',

      sub_distribution_mode:
        subDistNames,

      // =========================
      // DATE FILTERS
      // =========================

      start_date:
        f.start_date || '',

      end_date:
        f.end_date || '',

      issue_date:
        f.issue_date
          ? (
            Array.isArray(f.issue_date)
              ? f.issue_date[0]
              : f.issue_date
                .toString()
                .split(',')[0]
          )
          : '',

      // =========================
      // ISSUE CATEGORY
      // =========================

      category:
        f.issueCatregoryId || '',

      // =========================
      // MOBILE FILTER
      // =========================

      show_mobile_no:
        f.showMobileNo || 'no',

      // =========================
      // PRATI FILTER
      // =========================

      show_prati:
        showPrati

    };

    console.log(
      'FINAL PAYLOAD => ',
      payload
    );

    return payload;
  }

  getDispatchlisteportStatement(updateStatus: boolean) {

    this.generateform1.updateValueAndValidity();

    const formValue = this.generateform1.getRawValue();

    const payload: any = {

      // =========================
      // DELIVERY FILTERS
      // =========================

      delivery_mode: formValue?.DeliveryMode1?.length
        ? formValue.DeliveryMode1
        : (formValue?.DeliveryMode?.length ? formValue.DeliveryMode : []),

      distribution_mode: formValue?.DistributionMode1?.length
        ? formValue.DistributionMode1
        : (formValue?.DistributionMode?.length ? formValue.DistributionMode : []),

      sub_distribution_mode: formValue?.SubDistMode1?.length
        ? formValue.SubDistMode1
        : (formValue?.SubDistMode?.length ? formValue.SubDistMode : []),

      distributive_rep: formValue?.DistributiveRep1
        ? formValue.DistributiveRep1
        : (formValue?.DistributiveRep || ''),

      // =========================
      // DATE FILTER
      // =========================

      start_date: formValue?.start_date || '',
      end_date: formValue?.end_date || '',

      // =========================
      // LOCATION FILTERS
      // =========================

      country: formValue?.country || '',
      state: formValue?.state || '',
      district: formValue?.district?.length
        ? formValue.district
        : [],

      taluka: formValue?.taluka?.length
        ? formValue.taluka
        : [],

      pincode: formValue?.pincode || '',

      // =========================
      // REPRESENTATIVE FILTERS
      // =========================

      rep_name: formValue?.repwise?.length
        ? formValue.repwise
        : '',

      office_rep_name: formValue?.officerepwise?.length
        ? formValue.officerepwise
        : '',

      // =========================
      // OTHER FILTERS
      // =========================

      sellertype: formValue?.sellertype || [],
      type: formValue?.type || [],
      bookwise: formValue?.bookwise || '',
      issue_date: formValue?.issue_date || ''
    };

    console.log('FINAL PAYLOAD:', payload);

    this.service.getIssueSellerDispatchData1(payload).subscribe({
      next: (res: any) => {

        console.log('API RESPONSE:', res);

        if (res?.status !== false) {

          this.filteredIssueSellerList = res || [];

          this.dialog.open(BooksellerdispatchreportlistComponent, {
            data: {
              sellerData: this.filteredIssueSellerList,
              updateStatus: updateStatus
            },
            width: '1200px',
            height: '1300px',
            maxWidth: '100%'
          });

        } else {

          console.error('No data found');

        }
      },

      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }

 getDispatchlisteportStatementgranth(updateStatus: boolean) {

  this.generateform.updateValueAndValidity();

  const formValue = this.generateform.getRawValue();

  const payload: any = {

    // =========================
    // DELIVERY FILTERS
    // =========================

    delivery_mode: formValue?.DeliveryMode1?.length
      ? formValue.DeliveryMode1
      : (formValue?.DeliveryMode?.length ? formValue.DeliveryMode : []),

    distribution_mode: formValue?.DistributionMode1?.length
      ? formValue.DistributionMode1
      : (formValue?.DistributionMode?.length ? formValue.DistributionMode : []),

    sub_distribution_mode: formValue?.SubDistMode1?.length
      ? formValue.SubDistMode1
      : (formValue?.SubDistMode?.length ? formValue.SubDistMode : []),

    distributive_rep: formValue?.DistributiveRep1
      ? formValue.DistributiveRep1
      : (formValue?.DistributiveRep || ''),

    // =========================
    // DATE FILTER
    // =========================

    start_date: formValue?.start_date || '',
    end_date: formValue?.end_date || '',

    // =========================
    // LOCATION FILTERS
    // =========================

    country: formValue?.country || '',
    state: formValue?.state || '',
    district: formValue?.district?.length ? formValue.district : [],
    taluka: formValue?.taluka?.length ? formValue.taluka : [],
    pincode: formValue?.pincode || '',

    // =========================
    // REPRESENTATIVE FILTERS
    // =========================

    rep_name: formValue?.repwise?.length ? formValue.repwise : '',
    office_rep_name: formValue?.officerepwise?.length ? formValue.officerepwise : '',

    // =========================
    // OTHER FILTERS
    // =========================

    sellertype: formValue?.sellertype || [],
    type: formValue?.type || [],
    bookwise: formValue?.bookwise || '',
    issue_date: formValue?.issue_date || ''
  };

  console.log('FINAL PAYLOAD:', payload);

  this.isLoading = true;

  this.service.getIssueSellerDispatchDatagranth(payload).subscribe({
    next: (res: any) => {

      console.log('API RESPONSE:', res);
      this.isLoading = false;

      if (res?.status !== 'error') {

        // ✅ unwrap the "data" array from the API response
        this.filteredIssueSellerList = res?.data || [];

        this.dialog.open(GranthSellerDispatchReportListComponent, {
          data: {
            sellerData: this.filteredIssueSellerList,
            updateStatus: updateStatus
          },
          width: '1200px',
          height: '1300px',
          maxWidth: '100%'
        });

      } else {
        console.error('API returned an error:', res?.message);
      }
    },

    error: (err) => {
      this.isLoading = false;
      console.error('API Error:', err);
    }
  });
}
  getofficelisteportStatement(updateStatus: boolean) {

    debugger;

    const formValue = this.generateform1.getRawValue();

    const payload: any = {

      // =========================
      // DELIVERY FILTERS (REPORT SECTION)
      // =========================

      DeliveryMode:
        formValue?.DeliveryMode1?.length
          ? formValue.DeliveryMode1
          : (formValue?.DeliveryMode?.length ? formValue.DeliveryMode : ''),

      DistributionMode:
        formValue?.DistributionMode1?.length
          ? formValue.DistributionMode1
          : (formValue?.DistributionMode?.length ? formValue.DistributionMode : ''),

      SubDistMode:
        formValue?.SubDistMode1?.length
          ? formValue.SubDistMode1
          : (formValue?.SubDistMode?.length ? formValue.SubDistMode : ''),

      DistributiveRep:
        formValue?.DistributiveRep1
          ? formValue.DistributiveRep1
          : formValue?.DistributiveRep || '',

      // =========================
      // DATE FILTER (FIXED FORM)
      // =========================

      booking_date:
        formValue?.start_date && formValue?.end_date
          ? {
            start: formValue.start_date,
            end: formValue.end_date
          }
          : '',

      // =========================
      // LOCATION FILTERS
      // =========================

      country: formValue?.country || '',
      state: formValue?.state || '',
      district: formValue?.district?.length ? formValue.district : '',
      taluka: formValue?.taluka?.length ? formValue.taluka : '',
      pincode: formValue?.pincode?.length ? formValue.pincode : '',

      // =========================
      // REPRESENTATIVE FILTERS
      // =========================

      repwise: formValue?.repwise?.length ? formValue.repwise : '',
      officerepwise: formValue?.officerepwise?.length
        ? formValue.officerepwise
        : '',

      // =========================
      // OTHER FILTERS
      // =========================

      sellertype: formValue?.sellertype || '',
      type: formValue?.type || '',
      bookwise: formValue?.bookwise?.length ? formValue.bookwise : '',
      issue_date: formValue?.issue_date || ''
    };

    console.log('🔥 FINAL PAYLOAD:', payload);

    this.service.getIssueSellerofficerepData1(payload).subscribe({

      next: (res: any) => {

        console.log('API Response:', res);

        if (res?.status) {

          this.filteredIssueSellerList = res.data || [];

          this.dialog.open(BookSellerpostingOfficerepreportComponentComponent, {
            data: {
              sellerData: this.filteredIssueSellerList,
              updateStatus: updateStatus
            },
            width: '1200px',
            height: '1300px',
            maxWidth: '100%'
          });

        } else {

          console.error('No data found');
        }
      },

      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }


    getofficelisteportStatementgranth(updateStatus: boolean) {

    debugger;

    const formValue = this.generateform.getRawValue();

    const payload: any = {

      // =========================
      // DELIVERY FILTERS (REPORT SECTION)
      // =========================

      DeliveryMode:
        formValue?.DeliveryMode1?.length
          ? formValue.DeliveryMode1
          : (formValue?.DeliveryMode?.length ? formValue.DeliveryMode : ''),

      DistributionMode:
        formValue?.DistributionMode1?.length
          ? formValue.DistributionMode1
          : (formValue?.DistributionMode?.length ? formValue.DistributionMode : ''),

      SubDistMode:
        formValue?.SubDistMode1?.length
          ? formValue.SubDistMode1
          : (formValue?.SubDistMode?.length ? formValue.SubDistMode : ''),

      DistributiveRep:
        formValue?.DistributiveRep1
          ? formValue.DistributiveRep1
          : formValue?.DistributiveRep || '',

      // =========================
      // DATE FILTER (FIXED FORM)
      // =========================

      booking_date:
        formValue?.start_date && formValue?.end_date
          ? {
            start: formValue.start_date,
            end: formValue.end_date
          }
          : '',

      // =========================
      // LOCATION FILTERS
      // =========================

      country: formValue?.country || '',
      state: formValue?.state || '',
      district: formValue?.district?.length ? formValue.district : '',
      taluka: formValue?.taluka?.length ? formValue.taluka : '',
      pincode: formValue?.pincode?.length ? formValue.pincode : '',

      // =========================
      // REPRESENTATIVE FILTERS
      // =========================

      repwise: formValue?.repwise?.length ? formValue.repwise : '',
      officerepwise: formValue?.officerepwise?.length
        ? formValue.officerepwise
        : '',

      // =========================
      // OTHER FILTERS
      // =========================

      sellertype: formValue?.sellertype || '',
      type: formValue?.type || '',
      bookwise: formValue?.bookwise?.length ? formValue.bookwise : '',
      issue_date: formValue?.issue_date || ''
    };

    console.log('🔥 FINAL PAYLOAD:', payload);

    this.service.getGranthSellerofficerepData1(payload).subscribe({

      next: (res: any) => {

        console.log('API Response:', res);

        if (res?.status) {

          this.filteredIssueSellerList = res.data || [];

          this.dialog.open(GranthSellerPostingOffReportComponent, {
            data: {
              sellerData: this.filteredIssueSellerList,
              updateStatus: updateStatus
            },
            width: '1200px',
            height: '1300px',
            maxWidth: '100%'
          });

        } else {

          console.error('No data found');
        }
      },

      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }

  /* =========================================
     WITHOUT PRATI
  ========================================= */

  handleAddressLabelWithoutPrati() {

    const filterPayload = this.getCommonPayload('yes');

    console.log('WITH PRATI PAYLOAD:', filterPayload);

    this.service.getlabelsforIssueSellerDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          this.labelsforDispatch = data;

          this.FilteredlabelsforDispatch = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(
                (t: any) => t.subno === item.subno
              )
          );

          // WITH PRATI DIALOG
          this.openAddressLabelDialogWithoutPrati();
        },

        error: (err: any) => {
          console.error('API Error:', err);
        }

      });
    // });
  }

    handleAddressLabelWithoutPratigranth() {

    const filterPayload = this.getCommonPayload('yes');

    console.log('WITH PRATI PAYLOAD:', filterPayload);

    this.service.getlabelsforGranthDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          this.labelsforDispatch = data;

          this.FilteredlabelsforDispatch = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(
                (t: any) => t.subno === item.subno
              )
          );

          // WITH PRATI DIALOG
          this.openAddressLabelDialogWithoutPratigranth();
        },

        error: (err: any) => {
          console.error('API Error:', err);
        }

      });
    // });
  }
  show_prati_hide: boolean = false;
  // openAddressLabelDialogWithoutPrati(): void {
  //   debugger

  //   const dialogRef = this.dialog.open(
  //     BooksellerwithoutpratiComponent,
  //     {
  //       width: '95%',
  //       height: '90%',
  //       disableClose: false,

  //       data: {
  //         labelsforDispatch: this.labelsforDispatch,
  //         FilteredlabelsforDispatch: this.FilteredlabelsforDispatch,
  //         show_prati: 'no'
  //       }
  //     }
  //   );

  //   dialogRef.afterClosed().subscribe((result) => {
  //     console.log('Without Prati Dialog Closed');
  //   });

  // }

  openAddressLabelDialogWithoutPrati() {

    this.dialog.open(BooksellerwithoutpratiComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }


   openAddressLabelDialogWithoutPratigranth() {

    this.dialog.open(GrantSellerWithoutPratiComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }

  /* =========================================
     WITH PRATI
  ========================================= */

  handleAddressLabelWithPrati() {

    const filterPayload = this.getCommonPayload('yes');

    console.log('WITH PRATI PAYLOAD:', filterPayload);

    this.service.getlabelsforIssueSellerDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          this.labelsforDispatch = data;

          this.FilteredlabelsforDispatch = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(
                (t: any) => t.subno === item.subno
              )
          );

          // WITH PRATI DIALOG
          this.openAddressLabelMobileDialog1();
        },

        error: (err: any) => {
          console.error('API Error:', err);
        }

      });
  }

    handleAddressLabelWithPratigranth() {

    const filterPayload = this.getCommonPayload('yes');

    console.log('WITH PRATI PAYLOAD:', filterPayload);

    this.service.getlabelsforGranthDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          this.labelsforDispatch = data;

          this.FilteredlabelsforDispatch = data.filter(
            (item: any, index: number, self: any[]) =>
              index === self.findIndex(
                (t: any) => t.subno === item.subno
              )
          );

          // WITH PRATI DIALOG
          this.openAddressLabelMobileDialog1();
        },

        error: (err: any) => {
          console.error('API Error:', err);
        }

      });
  }
  openAddressLabelMobileDialog() {

    this.dialog.open(BookSellerAddressLabelsComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }
  openAddressLabelMobileDialog1() {

    this.dialog.open(BooksellerwithpratiComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }
    openAddressLabelMobileDialoggranth() {

    this.dialog.open(GranthSellerWithPratiComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }
  // getAddressLabelswithMobileNo() {

  //   const f = this.generateform1.value;

  //   // Convert Delivery ID → NAME
  //   const selectedDelivery = this.deliveryModes?.find(
  //     (x: any) => x.id == f.DeliveryMode
  //   );

  //   // Convert Distribution ID → NAME
  //   const selectedDistribution = this.filteredDistributionModes?.find(
  //     (x: any) => x.id == f.DistributionMode
  //   );

  //   // ✅ Convert Sub Distribution IDs → NAMES (FIXED)
  //   const selectedSubDist = this.filteredSubDistModes?.filter(
  //     (x: any) => (f.SubDistMode || []).includes(x.id)
  //   );

  //   const subDistNames = selectedSubDist?.length
  //     ? selectedSubDist.map(x => x.sub_distribution_mode).join(',')
  //     : (Array.isArray(f.SubDistMode) ? f.SubDistMode.join(',') : (f.SubDistMode || ''));

  //   const filterPayload: any = {

  //     bookwise: Array.isArray(f.bookwise) ? f.bookwise.join(',') : (f.bookwise || ''),

  //     booksellerwise: Array.isArray(f.booksellerwise)
  //       ? f.booksellerwise.join(',')
  //       : (f.booksellerwise || ''),

  //     country: f.country || '',
  //     state: f.state || '',

  //     district: Array.isArray(f.district)
  //       ? f.district.join(',')
  //       : (f.district || ''),

  //     taluka: Array.isArray(f.taluka)
  //       ? f.taluka.join(',')
  //       : (f.taluka || ''),

  //     pincode: Array.isArray(f.pincode)
  //       ? f.pincode.join(',')
  //       : (f.pincode || ''),

  //     rep_name: Array.isArray(f.repwise)
  //       ? f.repwise.join(',')
  //       : (f.repwise || ''),

  //     office_rep_name: Array.isArray(f.officerepwise)
  //       ? f.officerepwise.join(',')
  //       : (f.officerepwise || ''),

  //     // ID → NAME
  //     delivery_mode: selectedDelivery?.delivery_mode || '',

  //     distribution_mode: selectedDistribution?.sub_delivery_mode || '',

  //     // ✅ FIXED HERE
  //     sub_distribution_mode: subDistNames,

  //     start_date: f.start_date || '',
  //     end_date: f.end_date || '',

  //     issue_date: f.issue_date
  //       ? (Array.isArray(f.issue_date)
  //           ? f.issue_date[0]
  //           : f.issue_date.toString().split(',')[0])
  //       : '',

  //     category: f.issueCatregoryId || '',

  //     show_mobile_no: 'yes'
  //   };

  //   console.log('FINAL PAYLOAD (ALL IDS CONVERTED TO NAMES):', filterPayload);

  //   this.service.getlabelsforIssueSellerDispatch1(filterPayload)
  //     .subscribe({

  //       next: (data: any) => {

  //         this.labelsforDispatch = data;

  //         this.FilteredlabelsforDispatch = data.filter(
  //           (item: any, index: number, self: any[]) =>
  //             index === self.findIndex(t => t.subno === item.subno)
  //         );

  //         // this.openAddressLabelMobileDialog();
  //       },

  //       error: (err: any) => {
  //         console.error('API Error:', err);
  //       }

  //     });
  // }


  // openAddressLabelMobileDialog() {

  //   this.dialog.open(BookSellerAddressLabelsComponent, {

  //     data: {

  //       delivery_mode: this.mode_names || [],
  //       rep_names: this.repnames || [],
  //       state_name: this.state_names || [],
  //       district_name: this.district_names || [],
  //       taluka_name: this.taluka_names || [],

  //       addresslabels: this.FilteredlabelsforDispatch || [],

  //       iscustomer: this.iscustomer,

  //       showMobileNo: true
  //     },

  //     width: '1300px',
  //     height: '1300px',
  //     maxWidth: '100%'
  //   });
  // }
  //   handleAddressLabelClick() {
  //   debugger
  //   const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
  //   const preweekfirstday = this.preweekfirstday;

  //   this.getLabelforDispatchData();
  // }
  // getLabelforDispatchData(): void {

  //   const f = this.generateform1.value;

  //   const filterPayload = {

  //     // =========================
  //     // BOOK / SELLER FILTERS
  //     // =========================

  //     bookwise: Array.isArray(f.bookwise)
  //       ? f.bookwise.join(',')
  //       : f.bookwise || '',

  //     booksellerwise: Array.isArray(f.booksellerwise)
  //       ? f.booksellerwise.join(',')
  //       : f.booksellerwise || '',

  //     // =========================
  //     // LOCATION FILTERS
  //     // =========================

  //     country: f.country || '',
  //     state: f.state || '',

  //     district: Array.isArray(f.district)
  //       ? f.district.join(',')
  //       : f.district || '',

  //     taluka: Array.isArray(f.taluka)
  //       ? f.taluka.join(',')
  //       : f.taluka || '',

  //     pincode: Array.isArray(f.pincode)
  //       ? f.pincode.join(',')
  //       : f.pincode || '',

  //     // =========================
  //     // REPRESENTATIVE FILTERS
  //     // =========================

  //     rep_name: Array.isArray(f.repwise)
  //       ? f.repwise.join(',')
  //       : f.repwise || '',

  //     office_rep_name: Array.isArray(f.officerepwise)
  //       ? f.officerepwise.join(',')
  //       : f.officerepwise || '',

  //     // =========================
  //     // DELIVERY FILTERS
  //     // =========================

  //     delivery_mode: f.DeliveryMode || '',

  //     distribution_mode: f.DistributionMode || '',

  //     sub_distribution_mode: Array.isArray(f.SubDistMode)
  //       ? f.SubDistMode.join(',')
  //       : f.SubDistMode || '',

  //     // =========================
  //     // DATE FILTERS
  //     // =========================

  //     start_date: f.start_date || '',

  //     end_date: f.end_date || '',

  //     issue_date: f.issue_date
  //       ? f.issue_date.toString().split(',')[0]
  //       : '',

  //     // =========================
  //     // CATEGORY
  //     // =========================

  //     category: f.issueCatregoryId || '',

  //     // =========================
  //     // ✅ NEW FILTER
  //     // =========================

  //     show_mobile_no: f.showMobileNo || 'no'
  //   };

  //   console.log('FINAL PAYLOAD:', filterPayload);

  //   this.service.getlabelsforIssueSellerDispatch1(filterPayload)
  //     .subscribe({

  //       next: (data: any) => {

  //         this.labelsforDispatch = data;

  //         // Remove duplicate subno entries
  //         this.FilteredlabelsforDispatch = data.filter(
  //           (item: any, index: number, self: any[]) =>
  //             index === self.findIndex(t => t.subno === item.subno)
  //         );

  //         this.FilteredlabelsforPostStatement = [
  //           ...this.FilteredlabelsforDispatch
  //         ];

  //         this.openAddressLabelDialog();
  //       },

  //       error: (err: any) => {
  //         console.error(err);
  //         alert('Error while fetching dispatch labels!');
  //       }

  //     });
  // }
  // getDatafromLabelsDispatch() {
  //   for (
  //     let index = 0;
  //     index < Object.keys(this.FilteredlabelsforDispatch).length;
  //     index++
  //   ) {
  //     // if (this.FilteredlabelsforDispatch[index]['title'] != '') {
  //     // this.LabelsDispatchTitles.push({
  //     //   title: this.FilteredlabelsforDispatch[index]['title'],
  //     // });
  //     // }

  //     this.LabelsDispatchSubnames.push({
  //       sub_name: this.FilteredlabelsforDispatch[index]['name'],
  //     });

  //     // this.LabelsDispatchSubtypes.push({
  //     //   sub_type: this.FilteredlabelsforDispatch[index]['Subscription_Type'],
  //     // });

  //     // this.LabelsDispatchCountryName.push({
  //     //   country_name: this.FilteredlabelsforDispatch[index]['country'],
  //     // });

  //     // this.LabelsDispatchStateName.push({
  //     //   state_name: this.FilteredlabelsforDispatch[index]['state'],
  //     // });

  //     // this.LabelsDispatchDistrictName.push({
  //     //   district_name: this.FilteredlabelsforDispatch[index]['district'],
  //     // });

  //     // this.LabelsDispatchTalukaName.push({
  //     //   taluka_name: this.FilteredlabelsforDispatch[index]['taluka'],
  //     // });

  //     // this.LabelsDispatchPincode.push({
  //     //   pincode: this.FilteredlabelsforDispatch[index]['pincode'],
  //     // });

  //     this.LabelsDispatchRepNames.push({
  //       rep_name: this.FilteredlabelsforDispatch[index]['rep_name'],
  //     });

  //     this.LabelsDispatchOffRepNames.push({
  //       off_rep_name: this.FilteredlabelsforDispatch[index]['office_rep_name'],
  //     });

  //     // Step 1: Add items to LabelsDispatchDisRepNames
  //     this.LabelsDispatchDisRepNames.push({
  //       dis_rep_name: this.FilteredlabelsforDispatch[index]['distribution_rep'],
  //     });




  //     // this.LabelsDisModes.push({
  //     //   dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
  //     // });

  //     // if (this.FilteredlabelsforDispatch[index]['dis_mode'] != '') {
  //     //   this.LabelsDisModes.push({
  //     //     dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
  //     //   });
  //     // }

  //     // if (this.FilteredlabelsforDispatch[index]['dis_mode'] != '') {
  //     //   this.LabelsSubDisModes.push({
  //     //     dis_mode: this.FilteredlabelsforDispatch[index]['dis_mode'],
  //     //     sub_dis_mode: this.FilteredlabelsforDispatch[index]['dis_sub_mode'],
  //     //   });
  //     // }

  //     this.LabelsDispatchDeliveryModes.push({
  //       mode_name: this.FilteredlabelsforDispatch[index]['delivery_mode'],
  //     });
  //   }

  //   // this.LabelsDispatchTitles = this.uniqueid(
  //   //   this.LabelsDispatchTitles,
  //   //   (a) => a['title']
  //   // );

  //   // this.LabelsDispatchSubnames = this.uniqueid(
  //   //   this.LabelsDispatchSubnames,
  //   //   (a) => a['sub_name']
  //   // );

  //   // this.LabelsDispatchSubtypes = this.uniqueid(
  //   //   this.LabelsDispatchSubtypes,
  //   //   (a) => a['sub_type']
  //   // );
  //   // this.LabelsDispatchSubtypes.sort((a, b) => a.sub_type.localeCompare(b.sub_type));


  //   // this.LabelsDispatchCountryName = this.uniqueid(
  //   //   this.LabelsDispatchCountryName,
  //   //   (a) => a['country_name']
  //   // );

  //   // this.LabelsDispatchStateName = this.uniqueid(
  //   //   this.LabelsDispatchStateName,
  //   //   (a) => a['state_name']
  //   // );

  //   // this.LabelsDispatchDistrictName = this.uniqueid(
  //   //   this.LabelsDispatchDistrictName,
  //   //   (a) => a['district_name']
  //   // );

  //   // this.LabelsDispatchTalukaName = this.uniqueid(
  //   //   this.LabelsDispatchTalukaName,
  //   //   (a) => a['taluka_name']
  //   // );

  //   // this.LabelsDispatchPincode = this.uniqueid(
  //   //   this.LabelsDispatchPincode,
  //   //   (a) => a['pincode']
  //   // );

  //   this.LabelsDispatchRepNames = this.uniqueid(
  //     this.LabelsDispatchRepNames,
  //     (a) => a['rep_name']
  //   );

  //   this.LabelsDispatchOffRepNames = this.uniqueid(
  //     this.LabelsDispatchOffRepNames,
  //     (a) => a['off_rep_name']
  //   );

  //   this.LabelsDispatchDisRepNames = this.uniqueid(
  //     this.LabelsDispatchDisRepNames,
  //     (a) => a['dis_rep_name']
  //   );

  //   // this.LabelsDisModes = this.uniqueid(
  //   //   this.LabelsDisModes,
  //   //   (a) => a['dis_mode']
  //   // );

  //   // this.LabelsSubDisModes = this.uniqueid(
  //   //   this.LabelsSubDisModes,
  //   //   (a) => a['sub_dis_mode']
  //   // );

  //   this.LabelsDispatchDeliveryModes = this.uniqueid(
  //     this.LabelsDispatchDeliveryModes,
  //     (a) => a['mode_name']
  //   );
  //   // console.log('running');

  //   // Step 2: Use a Map to store unique items based on dis_rep_name
  //   let uniqueMap = new Map<string, any>();
  //   this.LabelsDispatchDisRepNames.forEach(item => {
  //     uniqueMap.set(item.dis_rep_name, item);
  //   });

  //   // Step 3: Convert the Map back to an ArrayList
  //   let uniqueArrayList: any[] = Array.from(uniqueMap.values());
  //   this.LabelsDispatchDisRepNames = uniqueArrayList

  // }
  //   getFilteredlabelslistfordispatch() {
  //     if (
  //       this.disrepnames != '' &&
  //       this.subdismode != '' &&
  //       this.dismode1 != ''
  //     ) {
  //       this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
  //         (a) => {
  //           return (
  //             this.disrepnames.includes(a['distribution_rep']) &&
  //             a['dis_sub_mode'] == this.subdismode &&
  //             a['dis_mode'] == this.dismode1 &&
  //             a['delivery_mode'] === 'हस्ते'
  //           );
  //         }
  //       );
  //       // console.log(this.FilteredLabelsListForDispatch);
  //     } else if (
  //       this.disrepnames != '' &&
  //       this.dismode1 != '' &&
  //       this.subdismode == ''
  //     ) {
  //       this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
  //         (a) => {
  //           return (
  //             this.disrepnames.includes(a['distribution_rep']) &&
  //             a['dis_mode'] == this.dismode1 &&
  //             a['delivery_mode'] === 'हस्ते'
  //           );
  //         }
  //       );
  //       // console.log(this.FilteredLabelsListForDispatch);
  //     } else if (
  //       this.disrepnames != '' &&
  //       this.dismode1 == '' &&
  //       this.subdismode == ''
  //     ) {
  //       this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
  //         (a) => {
  //           return (
  //             this.disrepnames.includes(a['distribution_rep']) &&
  //             a['delivery_mode'] === 'हस्ते'
  //           );
  //         }
  //       );
  //       // console.log(this.FilteredLabelsListForDispatch);
  //     } else {
  //       this.FilteredLabelsListForDispatch = this.labelsforDispatch.filter(
  //         (a) => {
  //           return a['delivery_mode'] === 'हस्ते';
  //         }
  //       );
  //       // console.log(this.FilteredLabelsListForDispatch);
  //     }
  //   }
  //    openAddressLabelDialog() {
  //     debugger
  //       console.log('Opening dialog with:', this.FilteredlabelsforDispatch);

  //       this.dialog.open(BookSellerAddressLabelsComponent, {
  //         data: {
  //           delivery_mode: this.mode_names,
  //           rep_names: this.repnames,
  //           state_name: this.state_names,
  //           district_name: this.district_names,
  //           taluka_name: this.taluka_names,
  //           addresslabels: this.FilteredlabelsforDispatch,
  //           iscustomer: this.iscustomer,
  //         },
  //         width: '1300px',
  //         height: '1300px',
  //         maxWidth: '100%',
  //       });
  //     }
  //  filteredLabelDispatchData(): void {
  //     debugger;
  //     this.FilteredlabelsforDispatch = [...this.labelsforDispatch];

  //     this.FilteredlabelsforDispatch = this.FilteredlabelsforDispatch.filter(
  //       (item, index, self) =>
  //         index === self.findIndex(t => t.subno === item.subno)
  //     );

  //     console.log('FilteredlabelsforDispatch:', this.FilteredlabelsforDispatch);
  //   }
  // book-seller.component.ts
  // issueBookingSellerList: any[] = [];
  // // book_data: any[] = [];
  // bookselleravailable = false;
  // booksellerid: any;

  // Add these flags in your component class
  showSponsorSection = false;
  showComplementarySection = false;


  showEditBooking(book: any) {
    debugger;

    this.service.getBookSellerBookingById(book.rcpt_id).subscribe(res => {

      console.log('EDIT RESPONSE', res);

      this.bookingId = res.id;

      const deliveryMode = res.DeliveryMode || res.delivery_mode || null;
      const distributionMode = res.DistributionMode || null;

      const subDistMode: string[] = res.SubDistMode
        ? (Array.isArray(res.SubDistMode)
          ? res.SubDistMode.map((x: any) => String(x))
          : String(res.SubDistMode)
            .split(',')
            .map((x: string) => x.trim())
            .filter((x: string) => x))
        : [];

      // ✅ STEP 1: Patch all fields EXCEPT DistributionMode and SubDistMode first
      this.subform.patchValue({
        orderno: res.orderno,
        bookdate: res.booking_date && res.booking_date !== '0000-00-00'
          ? new Date(res.booking_date)
          : null,
        dispatchto: res.dispatch_to,
        option: res.option,

        DeliveryMode: deliveryMode,

        crepname: res.crep_name,
        repmobno1: res.rep_mob_no,
        officerep: res.office_rep_name,
        repcompercent: res.rep_com_percent,
        repcomprice: res.rep_com_price,
        cdno: res.chq_drft_no,

        chequeDate: res.chq_date && res.chq_date !== '0000-00-00'
          ? new Date(res.chq_date)
          : null,

        bankname: res.bank_name,
        pymtmode: res.pymt_mode,
        depositamt: res.deposit_amt,

        iscomplementary: res.is_complimentary === 'Y',
        isSponsor: res.isSponsor === 'Y',

        DistributiveRep: res.DistributiveRep || '',
        DistributionMode: null,   // ✅ keep null for now
        SubDistMode: [],           // ✅ keep empty for now

        bookSellerGstType: res.bookSellerGstType || 'NO_GST',
        gstPercentage: res.gstPercentage || 0,
        gstAmount: res.gstAmount || 0,
        igstAmount: res.igstAmount || 0,
        cgstAmount: res.cgstAmount || 0,
        sgstAmount: res.sgstAmount || 0
      });

      // ✅ STEP 2: Trigger DeliveryMode change so filteredDistributionModes gets populated
      if (deliveryMode) {
        this.onDeliveryModeChange(deliveryMode); // this populates filteredDistributionModes
      }

      // ✅ STEP 3: After filteredDistributionModes is populated, set DistributionMode and SubDistMode
      setTimeout(() => {
        this.subform.patchValue({
          DistributionMode: distributionMode,
          SubDistMode: subDistMode
        });

        // ✅ STEP 4: Trigger DistributionMode change so SubDistMode options get populated
        if (distributionMode) {
          this.onDistributionModeChange(distributionMode);
        }

        // ✅ STEP 5: After SubDistMode options are populated, re-set SubDistMode
        setTimeout(() => {
          this.subform.patchValue({
            SubDistMode: subDistMode
          });
        }, 100);

      }, 100);

      this.showComplementarySection = res.is_complimentary === 'Y';
      this.showSponsorSection = res.isSponsor === 'Y';

      this.booksellerid = res.bse_id;
      this.bookselleravailable = true;

      this.book_data = [];

      if (res.books?.length) {

        res.books.forEach((b: any) => {

          const salePrice = Number(b.book_sale_price) || 0;
          const copies = Number(b.book_copies) || 0;

          this.book_data.push({
            id: b.id,
            bookname: b.book_name || '',
            author: b.author_name || '',

            price: Number(b.book_price) || 0,
            saleprice: salePrice,

            discount: Number(b.discount) || 0,
            discountamt: Number(b.discountamt) || 0,

            totalad: Number(b.totalafterdiscount) || salePrice,

            bookcopies: copies,
            total: b.total || 0,
            total_amt: b.total_amount || 0,

            shippingcharging: Number(b.shippingcharging) || 0,

            repcompercent: Number(b.rep_commission_precent) || 0,
            commissionamt: Number(b.rep_commission_amt) || 0
          });

        });
      }

      this.recalculateTotals();
    });
  }
  // showEditBooking(book: any) {
  //     debugger;

  //     this.service.getBookSellerBookingById(book.rcpt_id).subscribe(res => {
  //       console.log('EDIT RESPONSE', res);

  //       this.bookingId = res.id;

  //       const deliveryMode = res.DeliveryMode || res.delivery_mode || null;
  //       const distributionMode = res.DistributionMode || null;

  //       const subDistMode: string[] = res.SubDistMode
  //         ? (Array.isArray(res.SubDistMode)
  //           ? res.SubDistMode.map((x: any) => String(x))
  //           : String(res.SubDistMode)
  //             .split(',')
  //             .map((x: string) => x.trim())
  //             .filter((x: string) => x))
  //         : [];

  //       // ✅ STEP 1: PATCH BASIC FORM (ONLY SAFE VALUES)
  //       this.subform.patchValue({
  //         orderno: res.orderno,
  //         bookdate: res.booking_date && res.booking_date !== '0000-00-00'
  //           ? new Date(res.booking_date)
  //           : null,
  //         dispatchto: res.dispatch_to,
  //         option: res.option,

  //         DeliveryMode: deliveryMode,

  //         crepname: res.crep_name,
  //         repmobno1: res.rep_mob_no,
  //         officerep: res.office_rep_name,
  //         repcompercent: res.rep_com_percent,
  //         repcomprice: res.rep_com_price,
  //         cdno: res.chq_drft_no,
  //         chequeDate: res.chq_date && res.chq_date !== '0000-00-00'
  //           ? new Date(res.chq_date)
  //           : null,
  //         bankname: res.bank_name,
  //         pymtmode: res.pymt_mode,
  //         depositamt: res.deposit_amt,
  //         iscomplementary: res.is_complimentary === 'Y',
  //         isSponsor: res.isSponsor === 'Y',
  //         DistributiveRep: res.DistributiveRep || '',
  //         DistributionMode: null,   // ⚠️ will set later properly
  //         SubDistMode: [],
  //         bookSellerGstType: res.bookSellerGstType || 'NO_GST',
  //         gstPercentage: res.gstPercentage || 0,
  //         gstAmount: res.gstAmount || 0,
  //         igstAmount: res.igstAmount || 0,
  //         cgstAmount: res.cgstAmount || 0,
  //         sgstAmount: res.sgstAmount || 0,
  //       });

  //       this.showComplementarySection = res.is_complimentary === 'Y';
  //       this.showSponsorSection = res.isSponsor === 'Y';
  //       this.booksellerid = res.bse_id;
  //       this.bookselleravailable = true;

  //       this.book_data = [];
  //       if (res.books?.length) {
  //         res.books.forEach((b: any) => {
  //           this.book_data.push({
  //             id: b.id,
  //             bookname: b.book_name || '',
  //             author: b.author_name || '',
  //             price: b.book_price || 0,
  //             saleprice: b.book_sale_price || 0,
  //             discount: b.discount || 0,
  //             discountamt: b.discountamt || 0,
  //             totalad: (b.book_sale_price || 0) - (b.discountamt || 0),
  //             bookcopies: b.book_copies || 0,
  //             total: b.total || 0,
  //             total_amt: b.total_amount || 0,
  //             shippingcharging: b.shippingcharging || 0,
  //             repcompercent: this.safeNum(b.rep_commission_precent || 0),
  //             commissionamt: b.rep_commission_amt || 0,
  //           });
  //         });
  //       }

  //       // ==============================
  //       // ✅ STEP 2: CASCADE FLOW FIXED
  //       // ==============================

  //       if (!deliveryMode) {
  //         this.recalculateTotals();
  //         return;
  //       }

  //       // STEP 2.1: Delivery Mode
  //       this.onDeliveryModeChange(deliveryMode);

  //       setTimeout(() => {

  //         // STEP 2.2: Representative
  //         if (res.DistributiveRep) {
  //           this.subform.patchValue({ DistributiveRep: res.DistributiveRep });

  //           this.onRepresentativeChange({
  //             option: { value: res.DistributiveRep }
  //           });
  //         }

  //         setTimeout(() => {

  //           // STEP 2.3: Distribution Mode
  //           if (distributionMode) {
  //             this.subform.patchValue({ DistributionMode: distributionMode });

  //             this.onDistributionModeChange(distributionMode);
  //           }

  //           setTimeout(() => {

  //             // STEP 2.4: Sub Distribution Mode (IMPORTANT FIX)
  //             if (subDistMode.length) {

  //               // ensure options are loaded first
  //               if (this.filteredSubDistModes?.length) {
  //                 this.subform.patchValue({
  //                   SubDistMode: subDistMode
  //                 });
  //               } else {
  //                 setTimeout(() => {
  //                   this.subform.patchValue({
  //                     SubDistMode: subDistMode
  //                   });
  //                 }, 400);
  //               }
  //             }

  //             this.recalculateTotals();

  //           }, 700);

  //         }, 700);

  //       }, 700);
  //     });
  //   }
  handleAddressLabelClick() {
    debugger
    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
    const preweekfirstday = this.preweekfirstday;

    this.getLabelforDispatchData();
  }
  getLabelforDispatchData(): void {

    const f = this.generateform1.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      rep_name: Array.isArray(f.repwise)
        ? f.repwise.join(',')
        : f.repwise || '',

      office_rep_name: Array.isArray(f.officerepwise)
        ? f.officerepwise.join(',')
        : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialog();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }

   handleAddressLabelClickgranth() {
    debugger
    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
    const preweekfirstday = this.preweekfirstday;

    this.getLabelforDispatchDatagranth();
  }

   getLabelforDispatchDatagranth(): void {

    const f = this.generateform.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      rep_name: Array.isArray(f.repwise)
        ? f.repwise.join(',')
        : f.repwise || '',

      office_rep_name: Array.isArray(f.officerepwise)
        ? f.officerepwise.join(',')
        : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforGranthDispatch1(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialoggranth();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }
  
  openAddressLabelDialoggranth() {
    this.dialog.open(GranthSellerAddressLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  openAddressLabelMobileDialog2() {
    debugger

    this.dialog.open(BookSellerAddressLabelsComponentsComponent, {

      data: {

        delivery_mode: this.mode_names || [],
        rep_names: this.repnames || [],
        state_name: this.state_names || [],
        district_name: this.district_names || [],
        taluka_name: this.taluka_names || [],

        addresslabels: this.FilteredlabelsforDispatch || [],

        iscustomer: this.iscustomer,

        showMobileNo: true
      },

      width: '1300px',
      height: '1300px',
      maxWidth: '100%'
    });
  }
  getStatewiseStatement(stateWiseStatementUpdateStatus: boolean): void {

    const formValue = this.generateform1.getRawValue();

    // Take dispatch date from form first; if not present, fall back to this.dispatchdate
    //  dispatchdate: formValue.dispatchdate || '',

    // console.log('Dispatch Date =>', dispatchDate);

    const requestData = {

      dispatchdate: formValue.dispatchdate || '',

      start_date: formValue.start_date || '',
      end_date: formValue.end_date || '',

      country: formValue.country || '',
      state: formValue.state || [],
      district: formValue.district || [],
      taluka: formValue.taluka || [],
      pincode: formValue.pincode || [],

      book_name: formValue.bookwise || [],
      booksellerwise: formValue.booksellerwise || [],
      sellertype: formValue.sellertype || [],
      type: formValue.type || [],

      representative_name: formValue.repwise || [],
      office_representative: formValue.officerepwise || [],

      delivery_mode: formValue.DeliveryMode || [],
      distribution_mode: formValue.DistributionMode || [],
      sub_distribution_mode: formValue.SubDistMode || [],

      updateStatus: stateWiseStatementUpdateStatus
    };

    console.log('REQUEST DATA =>', requestData);

    this.dialog.open(BookSellerStatewisestatementComponent, {
      width: '1200px',
      maxWidth: '100%',
      height: '1300px',
      data: requestData
    });
  }
  getDistrictwiseStatement(districtwiseStatementUpdateStatus: boolean): void {

    const formValue = this.generateform1.value;

    console.log('FORM VALUE =>', formValue);

    const requestData = {

      // Get dispatch date from form
      dispatchdate: formValue.dispatchdate || '',

      start_date: formValue.start_date || '',
      end_date: formValue.end_date || '',

      country: formValue.country || '',
      state: formValue.state || '',
      district: formValue.district || [],
      taluka: formValue.taluka || [],
      pincode: formValue.pincode || [],

      book_name: formValue.bookwise || [],
      booksellerwise: formValue.booksellerwise || [],
      sellertype: formValue.sellertype || [],
      type: formValue.type || [],

      representative_name: formValue.repwise || [],
      office_representative: formValue.officerepwise || [],
      distributive_rep: formValue.DistributiveRep || '',

      delivery_mode: formValue.DeliveryMode || [],
      distribution_mode: formValue.DistributionMode || [],
      sub_distribution_mode: formValue.SubDistMode || [],

      updateStatus: districtwiseStatementUpdateStatus
    };

    console.log('REQUEST DATA =>', requestData);

    this.dialog.open(BooksellerDistrictwiseStatementComponentComponent, {
      width: '1200px',
      maxWidth: '100%',
      data: requestData
    });
  }
  openAddressLabelDialog() {
    this.dialog.open(BookSellerAddressLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  showEditBookingPackage(book: any) {
    this.service.getBookSellerBookingByIdPackage(book.rcpt_id).subscribe(res => {

      this.bookingId = res.id;

      this.subform.patchValue({
        orderno: res.orderno,
        bookdate: res.booking_date && res.booking_date !== '0000-00-00' ? new Date(res.booking_date) : null,
        dispatchto: res.dispatch_to,
        option: res.option,
        deliverymode: res.delivery_mode,
        crepname: res.crep_name,
        repmobno1: res.rep_mob_no,
        officerep: res.office_rep_name,
        repcompercent: res.rep_com_percent,
        repcomprice: res.rep_com_price,
        cdno: res.chq_drft_no,
        chequeDate: res.chq_date && res.chq_date !== '0000-00-00' ? new Date(res.chq_date) : null,
        bankname: res.bank_name,
        pymtmode: res.pymt_mode,
        depositamt: res.deposit_amt,
        iscomplementary: res.is_complimentary === 'Y',
        isSponsor: res.isSponsor === 'Y',
        DeliveryMode: res.DeliveryMode ? (Array.isArray(res.DeliveryMode) ? res.DeliveryMode : [res.DeliveryMode]) : [],
        DistributiveRep: res.DistributiveRep || '',
        DistributionMode: res.DistributionMode ? (Array.isArray(res.DistributionMode) ? res.DistributionMode : [res.DistributionMode]) : [],
        SubDistMode: res.SubDistMode ? (Array.isArray(res.SubDistMode) ? res.SubDistMode : [res.SubDistMode]) : [],
        bookSellerGstType: res.bookSellerGstType || 'NO_GST',
        gstPercentage: res.gstPercentage || 0,
        gstAmount: res.gstAmount || 0,
        igstAmount: res.igstAmount || 0,
        cgstAmount: res.cgstAmount || 0,
        sgstAmount: res.sgstAmount || 0
      });

      this.showComplementarySection = res.is_complimentary === 'Y';
      this.showSponsorSection = res.isSponsor === 'Y';
      this.booksellerid = res.bse_id;
      this.bookselleravailable = true;

      if (res.books && res.books.length) {
        res.books.forEach(b => {
          const exists = this.book_data?.some(book => book.bookname === b.book_name);
          if (!exists) {
            const bookObj = {
              id: b.id,
              bookname: b.book_name || '',
              author: b.author_name || '',
              price: b.book_price || 0,
              saleprice: b.book_sale_price || 0,
              discount: b.discount || 0,
              discountamt: b.discountamt || 0,
              totalad: (b.book_sale_price || 0) - (b.discountamt || 0),
              bookcopies: b.book_copies || 0,
              total: b.total || 0,
              total_amt: b.total_amount || 0,
              shippingcharging: b.shippingcharging || 0,
              repcompercent: this.safeNum(b.rep_commission_precent || 0),
              commissionamt: b.rep_commission_amt || 0,
              // bookSellerGstType: b.book_seller_gst_type || 'NO_GST',
              // gstPercentage: b.gst_percentage || 0,
              // gstAmount: b.gst_amount || 0,
              // withoutGstAmount: b.without_gst_amount || 0,
              // withGstAmount: b.with_gst_amount || 0
            };
            this.book_data = [...(this.book_data || []), bookObj];
          }
        });
      }

      setTimeout(() => this.recalculateTotals(), 200);
    });
  }


  getAllBookData() {
    this.service.getAllBookData().subscribe((data) => {

      this.bookData = data;
      this.bookdata = this.uniqueid1(this.bookData, it => it.bookid);

      // clear old list
      this.booknames = [];

      for (let index = 0; index < this.bookdata.length; index++) {

        // BOOK → isgranth = 'N'
        if (this.entryType === 'book' && this.bookdata[index].isgranth === 'N') {
          this.booknames.push(this.bookdata[index]);
        }

        // GRANTH → isgranth = 'Y'
        if (this.entryType === 'granth' && this.bookdata[index].isgranth === 'Y') {
          this.booknames.push(this.bookdata[index]);
        }
      }

      console.log('Filtered full data:', this.booknames);

      // initialize autocomplete after data update
      this.initAutocomplete();
    });
  }
  initAutocomplete() {
    this.filteredOptions8 = this.BookForm.get('bookname')!.valueChanges.pipe(
      startWith(''),
      map(value => value || ''),
      map(value =>
        this.booknames.filter(option =>
          option.bookname.toLowerCase().includes(value.toLowerCase())
        )
      )
    );
  }

  gettalukaname(event) {
    debugger
    const selectedValues: string[] = event.value; // Array (because multiple)

    this.pindcodelist = []; // Reset pincode list
    // this.yourForm.get('pincode')?.reset(); // Reset pincode selection

    this.taluka_names = selectedValues;

    this.service.pincodebttaluka(this.taluka_names).subscribe((data) => {
      console.log("Pincode data:", data); // 👈 Check console
      this.pindcodelist = data;           // Make sure data has { pincode: "XXXXX" }
    });
  }
  show_mob_no = '';
  show_mob_no_hide = false;
  getmob_no(event) {
    // console.log(event.value);
    this.show_mob_no = event.value;
    if (this.show_mob_no == 'yes') {
      this.show_mob_no_hide = true;
    } else if (this.show_mob_no == 'no') {
      this.show_mob_no_hide = false;
    }
  }

  getPrati(event: any) {
    this.show_prati = event.value;

    if (this.show_prati == 'yes') {
      this.show_prati_hide = true;
    } else if (this.show_prati == 'no') {
      this.show_prati_hide = false;
    }
  }
  addBookSellerEntry() {
    this.debugger;
    if (!window.confirm(
      'This operation is not reversible. Please verify the details before confirmation!'
    )) return;

    if (!this.bookselleravailable) {
      window.alert('Book seller is not available!');
      return;
    }

    // Prepare booking details
    const booksellerbookingdetails: any = {
      bse_id: this.booksellerid,
      orderno: this.subform.get('orderno').value,
      bookdate: this.subform.get('bookdate').value,
      dispatchto: this.subform.get('dispatchto').value,
      option: this.option,
      deliverymode: this.subform.get('deliverymode').value,
      crepname: this.subform.get('crepname').value,
      repmobno1: this.subform.get('repmobno1').value,
      officerepname: this.subform.get('officerep').value,
      repcompercent: this.subform.get('repcompercent').value,
      repcomprice: this.subform.get('repcomprice').value,
      cdno: this.subform.get('cdno').value,
      chequeDate: this.subform.get('chequeDate').value,
      complimentaryOption: this.subform.get('complimentaryOption').value,
      bankname: this.subform.get('bankname').value,
      pymtmode: this.pymtmode,
      depositamt: this.subform.get('depositamt').value,
      invoice_generated: 'N',
      iscomplementary: this.iscomplementary ? 'Y' : 'N',
      isSponsor: this.isSponsor ? 'Y' : 'N',
      DeliveryMode: this.subform.get('DeliveryMode').value,        // array from multi-select
      DistributiveRep: this.subform.get('DistributiveRep').value,  // string or array
      DistributionMode: this.subform.get('DistributionMode').value, // array from multi-select
      SubDistMode: this.subform.get('SubDistMode').value,

      gstAmount: this.subform.get('gstAmount')?.value || 0,
      sgstAmount: this.subform.get('sgstAmount')?.value || 0,
      cgstAmount: this.subform.get('cgstAmount')?.value || 0,
      igstAmount: this.subform.get('igstAmount')?.value || 0,
      // totalAmount: this.subform.get('totalAmount')?.value || 0,
      gstPercentage: this.subform.get('gstPercentage')?.value || 0,
      bookSellerGstType: this.subform.get('bookSellerGstType')?.value || 'NO_GST'

    };

    // Save booking
    this.service.addBookSellerEntryBookingDetails(booksellerbookingdetails)
      .subscribe((data1) => {
        // Save each book
        from(this.book_data)
          .pipe(
            concatMap((book, i) => {
              let bookdata: any = {
                bse_id: data1['id'],
                book_name: book.bookname,
                author_name: book.author,
                yearwisebook: book.yearwisebook,
                agentprice: book.agentprice,
                total_amt: this.total_amt + this.shipping_total,
                totalcopies: book.totalcopies || 0,
                iscomplementary: booksellerbookingdetails.iscomplementary,
                isSponsor: booksellerbookingdetails.isSponsor,

                // GST fields for each book
                // gstType: this.gstType,
                // gstPercentage: this.gstPercentage,
                // gstAmount: this.gstAmount,
                // withoutGstAmount: this.withoutGstAmount,
                // withGstAmount: this.withGstAmount

              };

              if (!this.isSponsor && !this.iscomplementary) {
                bookdata.book_price = book.price;
                bookdata.book_sale_price =
                  Number(book.discount) === 0
                    ? 0
                    : book.saleprice;

                bookdata.discount = book.discount;
                bookdata.discountamt = book.discountamt;
                bookdata.totalad = book.totalad || 0;
                bookdata.book_copies = book.bookcopies || 0;
                bookdata.total = book.total || 0;
                bookdata.shippingcharge = book.shippingcharging || 0;
                bookdata.repcomprecent = book.repcompercent || 0;
                bookdata.commissionamt = book.commissionamt || 0;
              }

              if (this.isSponsor && !this.iscomplementary) {
                const iv = this.inputValues[i] || {};
                bookdata.book_price = iv.price || 0;
                bookdata.discountamt = iv.totalad || 0;
                 bookdata.shippingcharge = iv.shippingcharging || 0;
                bookdata.book_copies = iv.bookcopies || 0;
                bookdata.total = iv.total || 0;
                bookdata.reptotal = iv.net || 0;
                bookdata.percent = iv.percent;
              }

              if (this.iscomplementary) {
                bookdata.book_copies = book.bookcopies || 0;
              }

              return this.service.addBookData(bookdata);
            }),
            finalize(() => {
              window.alert('Data Submitted Successfully...');
              this.subform.reset();
              this.book_data = [];
              this.inputValues = [];
              location.reload();
            })
          )
          .subscribe();
      });
  }


  //  handDeliveryLabel(updateStatus: any) {
  //   debugger
  //   const req1: any = {
  //     "issue_date": this.issuedate,
  //     "dist_type": this.dis_mode,
  //     "sub_dist_type": this.sub_mode,
  //     "dist_rep": this.dist_rep_name,
  //     "country": this.country_names,
  //     "state": this.state_names,
  //     "rep_name": this.repnames,
  //     "off_rep_name": this.officerepnames,
  //     "district": this.district_names,
  //     "taluka": this.taluka_names,
  //     "dev_mode": this.dev_mode,
  //     "pincode": this.pincodes,
  //     // "title": this.title1,
  //     // "subtype": this.sub_types
  //   }

  //   this.service
  //     .getissuenewapi1(req1)
  //     .subscribe((res) => {
  //       this.disRepData1 = res;
  //       // console.log(this.disRepData);

  //       // if(confi)

  //       this.service.getSbhetdata(this.issuedate).subscribe((res) => {
  //         this.labeldata = res;
  //         console.log(this.labeldata, "this. label");
  //         let data = this.dialog.open(IssueSellerLabelsOfHandDeliveryComponent, {
  //           data: {

  //             data1: this.labeldata,
  //             data2: this.disRepData1,
  //             name: this.person_name,
  //             isuuedate: this.issuedate,
  //             dispatchdate: this.dispatchdate,
  //             dist_name: this.dist_rep_name,
  //             dis_mode: this.dismode1,
  //             dis_sub_mode: this.subdismode,
  //             updateStatus: updateStatus,
  //             deleveryMode: this.mode_names,
  //             state: this.generateform.value.statename,
  //             taluka: this.generateform.value.talukaname,
  //             pincode: this.generateform.value.pincode,

  //           },
  //           width: '1200px',
  //           height: '1300px',
  //           maxWidth: '100%',
  //         });

  //         data.afterClosed().subscribe((result) => {
  //           if (result['data'] == 'refresh') {
  //             this.handDeliveryData = result['val'];
  //             // if (localStorage.getItem('goto') == 'delivery_mode') {
  //             // this.demo1BtnClick1();
  //             //   localStorage.removeItem('goto');
  //             // }
  //           }
  //         });
  //       });

  //     });

  //   // console.log(this.labeldata, "compare data 1")
  //   // console.log(this.disRepData1, "compare data 2")
  // }

  handleAddressLabelClick2(isParcelLabel: boolean): void {
    debugger;

    const curweekfirstday = this.curweekfirstday;
    const preweekfirstday = this.preweekfirstday;

    console.log('Is Parcel Label:', isParcelLabel);

    this.getLabelforDispatchData2(isParcelLabel);
  }
  printOrdergranth() {
  debugger;

  const f = this.generateform.value;

  const filterPayload = {
    bookwise: Array.isArray(f.bookwise) ? f.bookwise.join(',') : (f.bookwise || ''),
    booksellerwise: Array.isArray(f.booksellerwise) ? f.booksellerwise.join(',') : (f.booksellerwise || ''),
    sellertype: f.sellertype || '',
    type: f.type || '',
    country: f.country || '',
    state: f.state || '',
    district: Array.isArray(f.district) ? f.district.join(',') : (f.district || ''),
    taluka: Array.isArray(f.taluka) ? f.taluka.join(',') : (f.taluka || ''),
    pincode: Array.isArray(f.pincode) ? f.pincode.join(',') : (f.pincode || ''),
    rep_name: Array.isArray(f.repwise) ? f.repwise.join(',') : (f.repwise || ''),
    office_rep_name: Array.isArray(f.officerepwise) ? f.officerepwise.join(',') : (f.officerepwise || ''),
    distributive_rep: f.DistributiveRep || '',
    delivery_mode: Array.isArray(f.DeliveryMode) ? f.DeliveryMode.join(',') : (f.DeliveryMode || ''),
    distribution_mode: Array.isArray(f.DistributionMode) ? f.DistributionMode.join(',') : (f.DistributionMode || ''),
    sub_distribution_mode: Array.isArray(f.SubDistMode) ? f.SubDistMode.join(',') : (f.SubDistMode || ''),
    start_date: f.start_date || '',
    end_date: f.end_date || '',

    // Selected Issue Names
    category: Array.isArray(f.issue_date)
      ? this.filteredIssueDates
          .filter(item => f.issue_date.includes(item.id))
          .map(item => item.issueName)
          .join(',')
      : '',

    show_mobile_no: 'yes'
  };

  console.log('SENDING PAYLOAD 👉', filterPayload);

  const dialogRef = this.dialog.open(
    BookSellerPrintOrderStatementgranthComponent,
    {
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      data: filterPayload
    }
  );

  dialogRef.afterClosed().subscribe(() => {
    this.getAllPrintOrderDatagranth();
  });
}
    getAllPrintOrderDatagranth(): void {


  this.service.getAllissuePrintOrderDatagranth()
  .subscribe({

    next:(res:any)=>{


      console.log("Print Order List API =>",res);


      if(res.success && res.data)
      {

        this.printOrderDatagranth = res.data;

      }
      else
      {

        this.printOrderDatagranth = [];

      }


    },


    error:(err)=>{

      console.log(err);

      this.printOrderDatagranth=[];

    }


  });


}
     handDeliverygranth(updateStatus: boolean): void {
    debugger

    const f = this.generateform.value;


    const req1 = {

      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      rep_name: Array.isArray(f.repwise)
        ? f.repwise.join(',')
        : f.repwise || '',

      office_rep_name: Array.isArray(f.officerepwise)
        ? f.officerepwise.join(',')
        : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      // ✅ FIXED HERE
      distribution_mode: f.subdismode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('REQUEST =>', req1);

    this.service. getgranthsaleSbhetdata2(req1).subscribe({
      next: (res: any[]) => {

        console.log('API RESPONSE =>', res);

        this.dialog.open(GranthSellerHandDeliveryComponent, {
          width: '1200px',
          maxWidth: '100%',
          height: '900px',
          data: {
            reportData: res,
            updateStatus: updateStatus,
            bookwise: req1.bookwise 
          }
        });

      },
      error: (err) => {
        console.error(err);
      }
    });
  }
   openAddressLabelDialoggranthdis() {
    debugger
    this.dialog.open(GranthSellerDispatchLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  
  
  getLabelforDispatchDatadis(): void {

    const f = this.generateform.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      // rep_name: Array.isArray(f.repwise)
      //   ? f.repwise.join(',')
      //   : f.repwise || '',

      // office_rep_name: Array.isArray(f.officerepwise)
      //   ? f.officerepwise.join(',')
      //   : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      // show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatchgranth(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialoggranthdis();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }
    handleAddressLabelClickgranthdis() {
    debugger
    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
    const preweekfirstday = this.preweekfirstday;

    this.getLabelforDispatchDatadis();
  }
  
  
  openAddressLabelDialogparcel() {
    debugger
    this.dialog.open(BookSellerpracelLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
   handleAddressLabelClickgranthparcel(isParcelLabel: boolean): void {
    debugger;

    const curweekfirstday = this.curweekfirstday;
    const preweekfirstday = this.preweekfirstday;

    console.log('Is Parcel Label:', isParcelLabel);

    this.getLabelforDispatchDataparcel(isParcelLabel);
  }
  getLabelforDispatchDataparcel(isParcelLabel: boolean): void {

    const f = this.generateform.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      // rep_name: Array.isArray(f.repwise)
      //   ? f.repwise.join(',')
      //   : f.repwise || '',

      // office_rep_name: Array.isArray(f.officerepwise)
      //   ? f.officerepwise.join(',')
      //   : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      // show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatchgranthparcel(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialog4();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }



  getLabelforDispatchData2(isParcelLabel: boolean): void {

    const f = this.generateform1.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      // rep_name: Array.isArray(f.repwise)
      //   ? f.repwise.join(',')
      //   : f.repwise || '',

      // office_rep_name: Array.isArray(f.officerepwise)
      //   ? f.officerepwise.join(',')
      //   : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      // show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatch4(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialog4();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }
  openAddressLabelDialog4() {
    debugger
    this.dialog.open(BookSellerpracelLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }

  handleAddressLabelClick1() {
    debugger
    const curweekfirstday = this.curweekfirstday;  // or pass the values from where you need
    const preweekfirstday = this.preweekfirstday;

    this.getLabelforDispatchData1();
  }
  getLabelforDispatchData1(): void {

    const f = this.generateform1.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      // rep_name: Array.isArray(f.repwise)
      //   ? f.repwise.join(',')
      //   : f.repwise || '',

      // office_rep_name: Array.isArray(f.officerepwise)
      //   ? f.officerepwise.join(',')
      //   : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : f.DistributionMode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      // show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('PAYLOAD =>', filterPayload);

    this.service
      .getlabelsforIssueSellerDispatch3(filterPayload)
      .subscribe({

        next: (data: any) => {

          console.log(
            'Backend Record Count =>',
            data?.length
          );

          this.labelsforDispatch =
            Array.isArray(data) ? data : [];

          // KEEP ALL RECORDS
          this.FilteredlabelsforDispatch = [
            ...this.labelsforDispatch
          ];

          this.FilteredlabelsforPostStatement = [
            ...this.FilteredlabelsforDispatch
          ];

          console.log(
            'Dialog Record Count =>',
            this.FilteredlabelsforDispatch.length
          );

          this.openAddressLabelDialog3();
        },

        error: (err: any) => {

          console.error(err);
          alert('Error while fetching dispatch labels!');
        }
      });
  }
  openAddressLabelDialog3() {
    debugger
    this.dialog.open(BookSellerdispatchLabelsComponent, {
      data: {
        delivery_mode: this.mode_names,
        rep_names: this.repnames,
        state_name: this.state_names,
        district_name: this.district_names,
        taluka_name: this.taluka_names,
        distributive_reps: this.generateform1.value.DistributiveRep || '',
        bookwise: this.generateform1.value.bookwise || '',  // ✅ ADD THIS
        addresslabels: this.FilteredlabelsforDispatch,
        iscustomer: this.iscustomer,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  printOrder() {
    debugger
    const f = this.generateform1.value;

    const filterPayload = {
      bookwise: Array.isArray(f.bookwise) ? f.bookwise.join(',') : (f.bookwise || ''),
      booksellerwise: Array.isArray(f.booksellerwise) ? f.booksellerwise.join(',') : (f.booksellerwise || ''),
      sellertype: f.sellertype || '',
      type: f.type || '',
      country: f.country || '',
      state: f.state || '',
      district: Array.isArray(f.district) ? f.district.join(',') : (f.district || ''),
      taluka: Array.isArray(f.taluka) ? f.taluka.join(',') : (f.taluka || ''),
      pincode: Array.isArray(f.pincode) ? f.pincode.join(',') : (f.pincode || ''),
      rep_name: Array.isArray(f.repwise) ? f.repwise.join(',') : (f.repwise || ''),
      office_rep_name: Array.isArray(f.officerepwise) ? f.officerepwise.join(',') : (f.officerepwise || ''),
      distributive_rep: f.DistributiveRep || '',
      delivery_mode: Array.isArray(f.DeliveryMode) ? f.DeliveryMode.join(',') : (f.DeliveryMode || ''),
      distribution_mode: Array.isArray(f.DistributionMode) ? f.DistributionMode.join(',') : (f.DistributionMode || ''),
      sub_distribution_mode: Array.isArray(f.SubDistMode) ? f.SubDistMode.join(',') : (f.SubDistMode || ''),
      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      show_mobile_no: 'yes'
    };

    console.log('SENDING PAYLOAD 👉', filterPayload);

    const dialogRef = this.dialog.open(BookSellerPrintOrderStatementComponent, {
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      data: filterPayload
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getAllPrintOrderData();
    });
  }
  printOrderData: any[] = [];

  getAllPrintOrderData() {
    this.service.getAllissuePrintOrderData1().subscribe((res: any) => {

      console.log('API Response', res);

      if (res.success) {
        this.printOrderData = res.data;
      } else {
        this.printOrderData = [];
      }

    });
  }

  getpincode(event) {
    debugger
    this.pincodes = event.value;
    // this.filteredLabelDispatchData();
  }


  entryType: string = 'book';

  onEntryTypeChange() {

    // 🔹 Reset whole form but keep entryType-based fields clean
    this.BookForm.reset();

    // 🔹 Clear flags
    this.bookavailable = false;
    this.book_id = null;

    // 🔹 Clear autocomplete data
    this.booknames = [];
    this.filteredOptions8 = null;

    // 🔹 Reload data based on entry type
    this.getAllBookData(); // you can filter inside this by entryType
  }


  recalculateTotals() {
    if (!this.book_data?.length) {
      this.total_amt = 0;
      this.shipping_total = 0;
      this.commissiontotal = 0;
      this.comprecentagetotal = 0;
      this.sponsor_price_total = 0;
      this.sponsor_discount_total = 0;
      this.sponsor_copies_total = 0;
      this.sponsor_total = 0;
      this.complementary_total = 0;
      return;
    }

    this.total_amt = 0;
    this.shipping_total = 0;
    this.commissiontotal = 0;
    this.comprecentagetotal = 0;

    this.book_data.forEach(b => {
      const total = this.safeNum(b.total);
      const shipping = this.safeNum(b.shippingcharging);
      const repCommPercent = this.safeNum(b.repcompercent);
      const commissionAmt = this.safeNum(b.commissionamt);

      this.total_amt += total;
      this.shipping_total += shipping;
      this.comprecentagetotal += repCommPercent;
      this.commissiontotal += commissionAmt; // just sum actual commission, no extra multiplication
    });

    if (this.isSponsor) {
      this.sponsor_price_total = this.book_data.reduce((sum, b) => sum + this.safeNum(b.price), 0);
      this.sponsor_discount_total = this.book_data.reduce((sum, b) => sum + this.safeNum(b.totalad), 0);
      this.sponsor_copies_total = this.book_data.reduce((sum, b) => sum + this.safeNum(b.bookcopies), 0);
      this.sponsor_total = this.book_data.reduce((sum, b) => sum + this.safeNum(b.total), 0);
    }

    if (this.iscomplementary) {
      this.complementary_total = this.book_data.reduce((sum, b) => sum + this.safeNum(b.bookcopies), 0);
    }
  }





  onSubmit() {
    if (!window.confirm(
      'This operation is not reversible. Please verify the details before confirmation!'
    )) return;

    if (!this.bookselleravailable) {
      window.alert('Book seller is not available!');
      return;
    }

    if (this.bookingId) {
      this.updateBookSellerEntry(); // update existing booking
    } else {
      this.addBookSellerEntry(); // add new booking
    }
  }

  // onSubmitPackage() {
  //   if (!window.confirm(
  //     'This operation is not reversible. Please verify the details before confirmation!'
  //   )) return;

  //   if (!this.bookselleravailable) {
  //     window.alert('Book seller is not available!');
  //     return;
  //   }

  //   if (this.bookingId) {
  //     this.updateBookSellerEntrypackage(); // update existing booking
  //   } else {
  //     this.addBookSellerEntryPackage(); // add new booking
  //   }
  // }

  updateBookSellerEntry() {

    if (!window.confirm('This operation is not reversible. Please verify the details before confirmation!')) {
      return;
    }

    if (!this.bookselleravailable) {
      window.alert('Book seller is not available!');
      return;
    }

    const booksellerbookingdetails: any = {
      id: this.bookingId,
      bse_id: this.booksellerid,

      orderno: this.subform.get('orderno')?.value,
      bookdate: this.subform.get('bookdate')?.value,
      dispatchto: this.subform.get('dispatchto')?.value,
      option: this.option,

      deliverymode: this.subform.get('deliverymode')?.value,

      crepname: this.subform.get('crepname')?.value,
      repmobno1: this.subform.get('repmobno1')?.value,
      officerepname: this.subform.get('officerep')?.value,

      repcompercent: this.subform.get('repcompercent')?.value,
      repcomprice: this.subform.get('repcomprice')?.value,

      cdno: this.subform.get('cdno')?.value,
      chequeDate: this.subform.get('chequeDate')?.value,

      bankname: this.subform.get('bankname')?.value,
      pymtmode: this.pymtmode,

      depositamt: this.subform.get('depositamt')?.value,

      iscomplementary: this.iscomplementary ? 'Y' : 'N',
      isSponsor: this.isSponsor ? 'Y' : 'N',

      DeliveryMode: this.subform.get('DeliveryMode')?.value,
      DistributiveRep: this.subform.get('DistributiveRep')?.value,
      DistributionMode: this.subform.get('DistributionMode')?.value,
      SubDistMode: this.subform.get('SubDistMode')?.value,

      gstAmount: this.subform.get('gstAmount')?.value || 0,
      sgstAmount: this.subform.get('sgstAmount')?.value || 0,
      cgstAmount: this.subform.get('cgstAmount')?.value || 0,
      igstAmount: this.subform.get('igstAmount')?.value || 0,
      gstPercentage: this.subform.get('gstPercentage')?.value || 0,
      bookSellerGstType: this.subform.get('bookSellerGstType')?.value || 'NO_GST'
    };

    this.service.updateBookSellerEntryBookingDetails(booksellerbookingdetails)
      .subscribe((data: any) => {

        const existingBooks = this.book_data.filter((b: any) => b.id);

        from(existingBooks)
          .pipe(

            concatMap((book: any) => {

              const salePrice = Number(book.saleprice) || 0;
              const discountPercent = Number(book.discount) || 0;
              const copies = Number(book.bookcopies) || 0;
              const shippingCharge = Number(book.shippingcharging) || 0;

              // Discount Amount
              const discountAmt =
                Number(book.discountamt) ||
                ((salePrice * discountPercent) / 100);

              // Taxable Amount (after discount)
              const taxableAmount =
                Number(book.totalad) ||
                (salePrice - discountAmt);

              // Row Total
              const rowTotal =
                taxableAmount * copies;

              const bookdata: any = {

                id: book.id,
                bse_id: data.id,

                book_name: book.bookname,
                author_name: book.author,

                yearwisebook: book.yearwisebook || '',
                agentprice: Number(book.agentprice) || 0,

                iscomplementary: booksellerbookingdetails.iscomplementary,
                isSponsor: booksellerbookingdetails.isSponsor,

                book_price: Number(book.price) || 0,
                book_sale_price: salePrice,

                discount: discountPercent,
                discountamt: discountAmt,

                // Taxable Amount
                totalad: taxableAmount,

                book_copies: copies,

                // Total Before Shipping
                total: rowTotal,

                shippingcharge: shippingCharge,

                repcomprecent: Number(book.repcompercent) || 0,
                commissionamt: Number(book.commissionamt) || 0,

                totalcopies: Number(book.totalcopies) || 0,

                // Final Amount
                total_amt: rowTotal + shippingCharge
              };

              console.log('BOOK UPDATE DATA =>', bookdata);

              return this.service.updateBookData(bookdata);

            }),

            finalize(() => {

              window.alert('Booking Updated Successfully');

              this.resetForm();

            })

          )
          .subscribe({

            error: (err) => {
              console.error(err);
              window.alert('Error while updating booking.');
            }

          });

      });

  }
  updateBookSellerEntrypackage() {
    if (!window.confirm('This operation is not reversible. Please verify the details before confirmation!')) return;
    if (!this.bookselleravailable) {
      window.alert('Book seller is not available!');
      return;
    }

    // Prepare main booking details
    const booksellerbookingdetails: any = {
      id: this.bookingId,
      bse_id: this.booksellerid,
      orderno: this.subform.get('orderno').value,
      bookdate: this.subform.get('bookdate').value,
      dispatchto: this.subform.get('dispatchto').value,
      option: this.option,
      deliverymode: this.subform.get('deliverymode').value,
      crepname: this.subform.get('crepname').value,
      repmobno1: this.subform.get('repmobno1').value,
      officerepname: this.subform.get('officerep').value,
      repcompercent: this.subform.get('repcompercent').value,
      repcomprice: this.subform.get('repcomprice').value,
      cdno: this.subform.get('cdno').value,
      chequeDate: this.subform.get('chequeDate').value,
      bankname: this.subform.get('bankname').value,
      pymtmode: this.pymtmode,
      depositamt: this.subform.get('depositamt').value,
      iscomplementary: this.iscomplementary ? 'Y' : 'N',
      isSponsor: this.isSponsor ? 'Y' : 'N',
      DeliveryMode: this.subform.get('DeliveryMode').value,
      DistributiveRep: this.subform.get('DistributiveRep').value,
      DistributionMode: this.subform.get('DistributionMode').value,
      SubDistMode: this.subform.get('SubDistMode').value,
      gstAmount: this.subform.get('gstAmount')?.value || 0,
      sgstAmount: this.subform.get('sgstAmount')?.value || 0,
      cgstAmount: this.subform.get('cgstAmount')?.value || 0,
      igstAmount: this.subform.get('igstAmount')?.value || 0,
      // totalAmount: this.subform.get('totalAmount')?.value || 0,
      gstPercentage: this.subform.get('gstPercentage')?.value || 0,
      bookSellerGstType: this.subform.get('bookSellerGstType')?.value || 'NO_GST'
    };

    // Update main booking first
    this.service.updateBookSellerEntryBookingDetailsPackage(booksellerbookingdetails).subscribe(data => {

      const existingBooks = this.book_data.filter(b => b.id);        // Existing books → UPDATE
      const newBooks = this.book_data.filter(b => !b.id || b.isNew); // New books → INSERT

      // 1️⃣ Update existing books
      from(existingBooks).pipe(
        concatMap(book => {
          // Find matching input values by bookid (if any)
          const iv = this.inputValues.find(iv => iv.bookid === book.bookid) || {};

          const bookdata: any = {
            id: book.id,
            bse_id: data['id'],
            book_name: book.bookname,
            author_name: book.author,
            yearwisebook: book.yearwisebook,
            agentprice: book.agentprice,
            total_amt: this.total_amt + this.shipping_total,
            totalcopies: book.totalcopies || 0,
            iscomplementary: booksellerbookingdetails.iscomplementary,
            isSponsor: booksellerbookingdetails.isSponsor,
            // gstAmount: book.gstAmount,
            // withoutGstAmount: book.withoutGstAmount,
            // withGstAmount: book.withGstAmount,
            // totalAmount: this.total_amt,
            // bookSellerGstType: book.bookSellerGstType,
            // gstPercentage: book.gstPercentage
          };

          // Price & commission handling
          if (!this.isSponsor && !this.iscomplementary) {
            bookdata.book_price = iv.price ?? book.price;
            bookdata.book_sale_price = iv.saleprice ?? book.saleprice;
            bookdata.discount = iv.discount ?? book.discount ?? 0;
            bookdata.discountamt = iv.totalad ?? book.discountamt ?? 0;
            bookdata.totalad = iv.totalad ?? book.totalad ?? 0;
            bookdata.book_copies = iv.bookcopies ?? book.bookcopies ?? 0;
            bookdata.total = iv.total ?? book.total ?? 0;
            bookdata.shippingcharge = book.shippingcharges ?? 0;
            bookdata.repcomprecent = book.repcompercent ?? 0;
            bookdata.commissionamt = book.commissionamt ?? 0;
          }

          if (this.isSponsor && !this.iscomplementary) {
            bookdata.book_price = iv.price ?? book.price;
            bookdata.discountamt = iv.totalad ?? book.totalad ?? 0;
            bookdata.book_copies = iv.bookcopies ?? book.bookcopies ?? 0;
            bookdata.total = iv.total ?? book.total ?? 0;
          }

          if (this.iscomplementary) {
            bookdata.book_copies = book.bookcopies ?? 0;
          }

          return this.service.updateBookDataPackage(bookdata);
        }),
        finalize(() => {
          // 2️⃣ Insert new books after updating existing
          if (newBooks.length > 0) {
            const payload = {
              bookingId: this.bookingId,
              bse_id: this.booksellerid,
              books: newBooks.map(b => {
                const iv = this.inputValues.find(iv => iv.bookid === b.bookid) || {};
                return {
                  bse_id: data['id'],
                  book_name: b.bookname,
                  author_name: b.author,
                  yearwisebook: b.yearwisebook,
                  agentprice: b.agentprice,
                  total_amt: this.total_amt + this.shipping_total,
                  totalcopies: b.totalcopies || 0,
                  iscomplementary: booksellerbookingdetails.iscomplementary,
                  isSponsor: booksellerbookingdetails.isSponsor,
                  gstAmount: b.gstAmount,
                  withoutGstAmount: b.withoutGstAmount,
                  withGstAmount: b.withGstAmount,
                  totalAmount: this.total_amt,
                  bookSellerGstType: b.bookSellerGstType,
                  gstPercentage: b.gstPercentage,
                  book_price: iv.price ?? b.price,
                  book_sale_price: iv.saleprice ?? b.saleprice,
                  discount: iv.discount ?? b.discount ?? 0,
                  discountamt: iv.totalad ?? b.discountamt ?? 0,
                  totalad: iv.totalad ?? b.totalad ?? 0,
                  book_copies: iv.bookcopies ?? b.bookcopies ?? 0,
                  total: iv.total ?? b.total ?? 0,
                  shippingcharge: b.shippingcharging ?? 0,
                  repcomprecent: b.repcompercent ?? 0,
                  commissionamt: b.commissionamt ?? 0
                };
              })
            };

            this.service.saveBookingPackage(payload).subscribe(() => {
              window.alert('Booking updated & new books added successfully!');
              this.resetForm();
            });
          } else {
            window.alert('Booking updated successfully!');
            this.resetForm();
          }
        })
      ).subscribe();

    });
  }

  // helper to reset
  resetForm() {
    this.subform.reset();
    this.book_data = [];
    this.inputValues = [];
    location.reload();
  }


  addBook(book: any) {
    const newBook = {
      id: null,   // 👈 important: null means new book
      bookname: book.bookname || '',
      author: book.author_name || '',
      price: book.book_price || 0,
      saleprice: book.book_price || 0,
      discount: 0,
      discountamt: 0,
      totalad: book.book_price || 0,
      bookcopies: 1,
      total: 0,
      total_amt: 0,
      shippingcharging: 0,
      repcompercent: 0,
      commissionamt: 0,
      bookSellerGstType: 'NO_GST',
      gstPercentage: 0,
      gstAmount: 0,
      withoutGstAmount: 0,
      withGstAmount: 0,
      isNew: true   // 👈 flag to identify new books
    };

    this.book_data.push(newBook);
    this.recalculateTotals();
  }

  saveBooking() {
    const payload = {
      bookingId: this.bookingId,
      bse_id: this.booksellerid, // <-- include the bookseller id
      books: this.book_data.map(b => ({
        id: b.id, // if null → backend inserts
        bookname: b.bookname,
        author: b.author,
        price: b.price,
        saleprice: b.saleprice,
        discount: b.discount,
        discountamt: b.discountamt,
        totalad: b.totalad,
        bookcopies: b.bookcopies,
        shippingcharging: b.shippingcharging,
        repcompercent: b.repcompercent,
        commissionamt: b.commissionamt,
        bookSellerGstType: b.bookSellerGstType,
        gstPercentage: b.gstPercentage,
        gstAmount: b.gstAmount,
        withoutGstAmount: b.withoutGstAmount,
        withGstAmount: b.withGstAmount
      }))
    };

    this.service.saveBooking(payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          alert('Booking saved successfully!');
        } else {
          console.error('Save failed:', res.error);
        }
      },
      error: err => console.error('API error:', err)
    });
  }

  saveBookingPackage() {
    const payload = {
      bookingId: this.bookingId,
      bse_id: this.booksellerid, // <-- include the bookseller id
      books: this.book_data.map(b => ({
        id: b.id, // if null → backend inserts
        bookname: b.bookname,
        author: b.author,
        price: b.price,
        saleprice: b.saleprice,
        discount: b.discount,
        discountamt: b.discountamt,
        totalad: b.totalad,
        bookcopies: b.bookcopies,
        shippingcharging: b.shippingcharging,
        repcompercent: b.repcompercent,
        commissionamt: b.commissionamt,
        bookSellerGstType: b.bookSellerGstType,
        gstPercentage: b.gstPercentage,
        gstAmount: b.gstAmount,
        withoutGstAmount: b.withoutGstAmount,
        withGstAmount: b.withGstAmount
      }))
    };

    this.service.saveBookingPackage(payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          alert('Booking saved successfully!');
        } else {
          console.error('Save failed:', res.error);
        }
      },
      error: err => console.error('API error:', err)
    });
  }

  updatebookseller() {
    debugger
    let bookseller = {
      bse_id: this.booksellerid,
      title: this.subform.get('title').value,
      name: this.subform.get('name').value,
      name_eng: this.subform.get('subname_eng').value,
      sellertype: this.subform.get('sellertype').value,
      comptype: this.subform.get('comptype').value,
      address: this.subform.get('address').value,
      pincode: this.subform.get('pincode').value,
      country: this.subform.get('country').value,
      state: this.subform.get('state').value,
      district: this.subform.get('district').value,
      district_eng: this.subform.get('district_eng')?.value,
      taluka: this.subform.get('taluka').value,
      mobileNumber: this.subform.get('mobileNumber').value,
      gstNumber: this.subform.get('gstNumber').value,
      email: this.subform.get('email').value,
      dob: this.subform.get('dob').value,
      doa: this.subform.get('doa').value,
    };

    this.service.updateBookSellerEntry(bookseller).subscribe((data) => {
      window.alert('Book Seller Details Updated Successfully....');
    });
  }


  updatebooksellerPackage() {
    let bookseller = {
      bse_id: this.booksellerid,
      title: this.subform.get('title').value,
      name: this.subform.get('name').value,
      sellertype: this.subform.get('sellertype').value,
      comptype: this.subform.get('comptype').value,
      address: this.subform.get('address').value,
      pincode: this.subform.get('pincode').value,
      country: this.subform.get('country').value,
      state: this.subform.get('state').value,
      district: this.subform.get('district').value,
      taluka: this.subform.get('taluka').value,
      mobileNumber: this.subform.get('mobileNumber').value,
      gstNumber: this.subform.get('gstNumber').value,
      email: this.subform.get('email').value,
      dob: this.subform.get('dob').value,
      doa: this.subform.get('doa').value,
    };

    this.service.updateBookSellerEntryPackage(bookseller).subscribe((data) => {
      window.alert('Book Seller Details Updated Successfully....');
    });
  }

  deletebookseller() {
    if (!this.booksellerid) {
      window.alert('Book Seller ID is missing.');
      return;
    }

    const confirmDelete = window.confirm('Are you sure you want to delete this Book Seller?');

    if (confirmDelete) {
      this.service.deleteBookSellerEntry(this.booksellerid).subscribe({
        next: () => {
          window.alert('Book Seller Deleted Successfully.');
          // Optionally reset the form or navigate away
          this.subform.reset();
          this.bookselleravailable = false;
        },
        error: (err) => {
          console.error('Error deleting book seller:', err);
          window.alert('Failed to delete the Book Seller.');
        }
      });
    }
  }


  deletebooksellerPackage() {
    if (!this.booksellerid) {
      window.alert('Book Seller ID is missing.');
      return;
    }

    const confirmDelete = window.confirm('Are you sure you want to delete this Book Seller?');

    if (confirmDelete) {
      this.service.deleteBookSellerEntryPackage(this.booksellerid).subscribe({
        next: () => {
          window.alert('Book Seller Deleted Successfully.');
          // Optionally reset the form or navigate away
          this.subform.reset();
          this.bookselleravailable = false;
        },
        error: (err) => {
          console.error('Error deleting book seller:', err);
          window.alert('Failed to delete the Book Seller.');
        }
      });
    }
  }


  remove(book) {
    this.tempdata = this.book_data;
    for (
      let index1 = 0;
      index1 <= Object.keys(this.tempdata).length;
      index1++
    ) {
      if (this.tempdata[index1]['bookid'] == book['bookid']) {
        this.tempdata.splice(index1, 1);
      }
      // if (Object.keys(this.tempdata).length == 0) {
      //   // this.tempdata = [];
      //   this.subform.get('bookname').reset();
      //   this.subform.get('authorname').reset();
      // }
    }
    for (let index = 0; index < Object.keys(this.book_data).length; index++) {
      if (this.book_data[index]['bookid'] == book['bookid']) {
        this.book_data.splice(index, 1);
      }
      if (Object.keys(this.book_data).length == 0) {
        // this.tempdata = [];
        this.subform.get('bookname').setValue('');
        this.subform.get('authorname').setValue('');
      }
    }

    this.total_amt = 0;
    this.shipping_total = 0;
    for (let index = 0; index < Object.keys(this.book_data).length; index++) {
      this.total_amt = this.total_amt + this.book_data[index]['total'];
      this.shipping_total =
        this.shipping_total +
        parseInt(this.book_data[index]['shippingcharges']);
    }

    // this.calculateSponsorTotal(event,field,index);
  }


  updateremove(book: any) {
    if (!window.confirm(`Are you sure you want to delete the book "${book.bookname}"?`)) {
      return;
    }

    // If book has an ID, delete from server
    if (book.id) {
      this.service.deleteBookEntry(book.id).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.removeBookLocally(book);
          } else {
            console.error('Failed to remove book:', res.error);
          }
        },
        error: err => console.error('API error:', err)
      });
    } else {
      // New book not saved yet, just remove locally
      this.removeBookLocally(book);
    }
  }

  // Helper function to remove a book locally and recalc totals
  removeBookLocally(book: any) {
    this.book_data = this.book_data.filter(b => b !== book);

    // Reset form fields if no books left
    if (this.book_data.length === 0) {
      this.subform.get('bookname').setValue('');
      this.subform.get('authorname').setValue('');
    }

    this.recalculateTotals();
    console.log(`Book ${book.bookname} removed locally.`);
  }



  bookcopies: any = 0;
  total_amt = 0;
  bookcopies1(event: any, option: any) {
    const copies = Number(event.target.value) || 0;
    option['bookcopies'] = copies;

    const bookPrice = parseFloat(option['price']) || 0;
    const salePrice = parseFloat(option['saleprice']) || 0;

    // Discount
    let discountPercent = option['discount'];

    let discountAmount = parseFloat(option['discountamt']) || 0; // ✅ no rounding, keep exact value

    // 👉 COMPLEMENTARY CASE
    if (this.iscomplementary) {
      option['total'] = 0;
      option['totalad'] = 0;
      option['discountamt'] = 0;
    } else {
      let pricePerCopy: number;

      if (
        discountPercent === null ||
        discountPercent === '' ||
        discountPercent === undefined
      ) {
        // 1️⃣ No discount entered → use sale price
        pricePerCopy = salePrice;
      } else {
        // 2️⃣ Discount entered → always calculate on book price
        pricePerCopy = bookPrice - discountAmount;
      }

      option['totalad'] = Number(pricePerCopy.toFixed(2)); // ✅ per copy, no multiply
      option['total'] = this.customFloorLike(pricePerCopy * copies); // ✅ rounding only on total
    }

    // UPDATE TOTAL AMOUNT
    this.total_amt = this.book_data.reduce((sum, book) => {
      return sum + (parseFloat(book['total']) || 0);
    }, 0);

    this.gstCalculation();
  }
  handDelivery(updateStatus: boolean): void {
    debugger

    const f = this.generateform1.value;


    const req1 = {

      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : f.bookwise || '',

      booksellerwise: Array.isArray(f.booksellerwise)
        ? f.booksellerwise.join(',')
        : f.booksellerwise || '',

      sellertype: f.sellertype || '',
      country: f.country || '',
      state: f.state || '',
      type: f.type || '',

      district: Array.isArray(f.district)
        ? f.district.join(',')
        : f.district || '',

      taluka: Array.isArray(f.taluka)
        ? f.taluka.join(',')
        : f.taluka || '',

      pincode: Array.isArray(f.pincode)
        ? f.pincode.join(',')
        : f.pincode || '',

      rep_name: Array.isArray(f.repwise)
        ? f.repwise.join(',')
        : f.repwise || '',

      office_rep_name: Array.isArray(f.officerepwise)
        ? f.officerepwise.join(',')
        : f.officerepwise || '',

      distributive_rep: f.DistributiveRep || '',

      delivery_mode: Array.isArray(f.DeliveryMode)
        ? f.DeliveryMode.join(',')
        : f.DeliveryMode || '',

      // ✅ FIXED HERE
      distribution_mode: f.subdismode || '',

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : f.SubDistMode || '',

      start_date: f.start_date || '',
      end_date: f.end_date || '',
      category: f.issueCatregoryId || '',
      show_mobile_no: f.showMobileNo || 'no'
    };

    console.log('REQUEST =>', req1);

    this.service.getIssuesaleSbhetdata2(req1).subscribe({
      next: (res: any[]) => {

        console.log('API RESPONSE =>', res);

        this.dialog.open(BookSellerHandDeliveryComponent, {
          width: '1200px',
          maxWidth: '100%',
          height: '900px',
          data: {
            reportData: res,
            updateStatus: updateStatus,
            bookwise: req1.bookwise 
          }
        });

      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  printJavak() {
    debugger

    const f = this.generateform1.value;

    const req1 = {
      bookwise: Array.isArray(f.bookwise)
        ? f.bookwise.join(',')
        : (f.bookwise || ''),

      distribution_mode: Array.isArray(f.DistributionMode)
        ? f.DistributionMode.join(',')
        : (f.DistributionMode || ''),

      sub_distribution_mode: Array.isArray(f.SubDistMode)
        ? f.SubDistMode.join(',')
        : (f.SubDistMode || ''),

      start_date: f.start_date || '',
      end_date: f.end_date || ''
    };

    console.log('Payload Sending:', req1);

    this.dialog.open(BooksellerPrintJavakComponent, {
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
      data: {
        issuedate: this.issuedate,
        filters: req1      // ✅ send req1
      }
    });
  }





  shippingcharging = 0;
  shipping_total = 0;

  bookshipping(event: any, book: any) {
    debugger

    const value = Number(event.target.value) || 0;

    // DIRECT UPDATE (no findIndex needed)
    book.shippingcharging = value;

    this.recalculateTotals();
  }








  comprecentage: number;
  comprecentagetotal;
  commission: number;
  commissiontotal;
  calcommission(event: any, book: any) {
    const newPercent = Number(event.target.value) || 0;

    // Update only the target book
    this.book_data = this.book_data.map(b => {
      if (b.bookid === book.bookid) {
        b.repcompercent = newPercent;
        b.commissionamt = Math.round(this.safeNum(b.total) * newPercent / 100);
      }
      return b;
    });

    // Recalculate totals for all books
    this.recalculateTotals();
  }


  gstCalculation() {
    const gstType = this.subform.get('bookSellerGstType')?.value;
    const gstPercentage = Number(this.subform.get('gstPercentage')?.value) || 0;
    const state = this.subform.get('state')?.value;

    // Base amount = sum of all book totals + shipping
    const netAmount = this.book_data.reduce((sum, book) => sum + (parseFloat(book.total) || 0), 0) + this.shipping_total;

    let gstAmount = 0;
    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    let totalAmount = netAmount;

    if (gstType === 'INCLUDING') {
      const baseAmount = netAmount / (1 + gstPercentage / 100);
      gstAmount = netAmount - baseAmount;
      totalAmount = netAmount;

    } else if (gstType === 'EXCLUDING') {
      gstAmount = netAmount * gstPercentage / 100;
      totalAmount = netAmount + gstAmount;
    } else { // NO_GST
      gstAmount = 0;
      totalAmount = netAmount;
    }

    // Split GST into SGST/CGST or IGST
    if (state === 'महाराष्ट्र') {
      sgst = cgst = gstAmount / 2;
      igst = 0;
    } else {
      sgst = cgst = 0;
      igst = gstAmount;
    }

    // Patch values into reactive form
    this.subform.patchValue({
      gstAmount: gstAmount.toFixed(2),
      sgstAmount: sgst.toFixed(2),
      cgstAmount: cgst.toFixed(2),
      igstAmount: igst.toFixed(2),
      totalAmount: totalAmount.toFixed(2)
    }, { emitEvent: false });
  }


  gstCalculationpack() {
    const gstType = this.packsubform.get('bookSellerGstType')?.value;
    const gstPercentage = Number(this.packsubform.get('gstPercentage')?.value) || 0;
    const state = this.packsubform.get('state')?.value;

    // Base amount = sum of all book totals + shipping
    const netAmount = this.book_data.reduce((sum, book) => sum + (parseFloat(book.total) || 0), 0) + this.shipping_total;

    let gstAmount = 0;
    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    let totalAmount = netAmount;

    if (gstType === 'INCLUDING') {
      const baseAmount = netAmount / (1 + gstPercentage / 100);
      gstAmount = netAmount - baseAmount;
      totalAmount = netAmount;

    } else if (gstType === 'EXCLUDING') {
      gstAmount = netAmount * gstPercentage / 100;
      totalAmount = netAmount + gstAmount;
    } else { // NO_GST
      gstAmount = 0;
      totalAmount = netAmount;
    }

    // Split GST into SGST/CGST or IGST
    if (state === 'महाराष्ट्र') {
      sgst = cgst = gstAmount / 2;
      igst = 0;
    } else {
      sgst = cgst = 0;
      igst = gstAmount;
    }

    // Patch values into reactive form
    this.packsubform.patchValue({
      gstAmount: gstAmount.toFixed(2),
      sgstAmount: sgst.toFixed(2),
      cgstAmount: cgst.toFixed(2),
      igstAmount: igst.toFixed(2),
      totalAmount: totalAmount.toFixed(2)
    }, { emitEvent: false });
  }



  tempdata = [];
  selected_id(event, option, book) {
    debugger
    if (!event.isUserInput) return;

    // Set author
    this.subform.get('authorname').setValue(option['author']);

    this.service.getBookData(option['bookid']).subscribe({
      next: (data) => {
        const bookInfo = data[0];
        const availableStock = this.safeNum(bookInfo['available_stock']);
        this.subform.get('availablestock').setValue(availableStock);

        if (availableStock <= 0) {
          alert('This book cannot be added because available stock is negative.');
          return;
        }

        // Prepare numeric-safe values
        const totalAmt = this.safeNum(this.total_amt);
        const shippingCharge = this.safeNum(this.shippingcharging);
        const bookCopies = this.safeNum(this.bookcopies);
        const repCommPercent = this.safeNum(this.comprecentage);
        const commissionAmt = this.safeNum(this.commission);

        const newBook = {
          author: bookInfo['author'] || '',
          bookid: bookInfo['bookid'] || 0,
          bookname: bookInfo['bookname'] || '',
          bookcopies: bookCopies,
          price: bookInfo['price'],
          saleprice: bookInfo['saleprice'],
          yearwisebook: bookInfo['yearwisebook'] || '',
          agentprice: this.safeNum(bookInfo['agentprice']),
          totals: totalAmt + shippingCharge,  // safe addition
          totalcopies: availableStock,
          shippingcharges: shippingCharge,
          repcomprecent: repCommPercent,
          commissionamt: commissionAmt,
          totalad: totalAmt,
          isNew: true
        };

        // Prevent duplicate booknames
        const exists = this.book_data?.some(b => b.bookname === newBook.bookname);
        if (!exists) {
          this.book_data = [...(this.book_data || []), newBook];
        } else {
          alert('This book is already added!');
        }

        // Recalculate totals
        this.recalculateTotals();
      },
      error: (err) => console.error('API error:', err)
    });
  }


  uniqueid(data, key) {
    return [...new Map(data.map((x) => [key(x), x])).values()];
  }


  uniqueid1(arr: any[], keyFn: (item: any) => any): any[] {
    const seen = new Set();
    return arr.filter((item) => {
      const key = keyFn(item);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  selected_idpack(event, option, book) {
    debugger
    if (!event.isUserInput) return;

    // Set author
    this.packsubform.get('authorname').setValue(option['author']);

    this.service.getGranthData(option['bookid']).subscribe({
      next: (data) => {
        const bookInfo = data[0];
        const availableStock = this.safeNum(bookInfo['available_stock']);
        this.packsubform.get('availablestock').setValue(availableStock);

        if (availableStock <= 0) {
          alert('This book cannot be added because available stock is negative.');
          return;
        }

        // Prepare numeric-safe values
        const totalAmt = this.safeNum(this.total_amt);
        const shippingCharge = this.safeNum(this.shippingcharging);
        const bookCopies = this.safeNum(this.bookcopies);
        const repCommPercent = this.safeNum(this.comprecentage);
        const commissionAmt = this.safeNum(this.commission);

        const newBook = {
          author: bookInfo['author'] || '',
          bookid: bookInfo['bookid'] || 0,
          bookname: bookInfo['bookname'] || '',
          bookcopies: bookCopies,
          price: bookInfo['price'],
          saleprice: bookInfo['saleprice'],
          yearwisebook: bookInfo['yearwisebook'] || '',
          agentprice: this.safeNum(bookInfo['agentprice']),
          totals: totalAmt + shippingCharge,  // safe addition
          totalcopies: availableStock,
          shippingcharges: shippingCharge,
          repcomprecent: repCommPercent,
          commissionamt: commissionAmt,
          totalad: totalAmt,
          isNew: true
        };

        // Prevent duplicate booknames
        const exists = this.book_data?.some(b => b.bookname === newBook.bookname);
        if (!exists) {
          this.book_data = [...(this.book_data || []), newBook];
        } else {
          alert('This book is already added!');
        }

        // Recalculate totals
        this.recalculateTotals();
      },
      error: (err) => console.error('API error:', err)
    });
  }
  bsname = '';
  tempdatas = [];
  selected(event, option) {
    if (event.isUserInput) {
      this.service.getBookSellerLedgerData(option['name']).subscribe((data) => {
        this.BookSellerLegderData = data;
        this.tempdatas = [];
        for (let index = 0; index < Object.keys(data).length; index++) {
          let flag: Boolean = false;
          if (Object.keys(this.tempdatas).length != 0) {
            this.tempdatas = data[index];
            console.log(this.tempdatas);
            // if(this.tempdatas[index]['invoice_no'])
            this.tempdatas[index]['invoice_no'] = '';
            this.tempdatas[index]['invoice_date'] = '0000-00-00';
            this.tempdatas[index]['invoice_total'] = '';
          } else {
            this.tempdatas = data[index];
            console.log(this.tempdatas);
          }
        }
        console.log(this.tempdatas);
      });
    }
  }

  booksellerid = 0;
  bookselleravailable: boolean = false;
  selected_name(event, id) {
    debugger
    if (event.isUserInput) {

      // ⭐ ADD THIS (sync both names)
      this.subform.patchValue({
        subname: id.name,
        subname_eng: id.name_eng
      });

      this.service.getSubData(id.id).subscribe((data) => {
        console.log('data', data);

        this.booksellerid = data[0]['id'];
        this.bookselleravailable = true;

        this.subform.patchValue({
          title: data[0]['title'],
          mobileNumber: data[0]['mobno'],
          gstNumber: data[0]['gstNumber'],
          name: data[0]['name'],
          subname_eng: data[0]['name_eng'],

          address: data[0]['address'],
          sellertype: data[0]['sellertype'],
          pincode: data[0]['spin'],
          country: data[0]['country'],
          state: data[0]['state'],
          email: data[0]['email'],
          dob: data[0]['dob'],
          doa: data[0]['anniversary']
        });

        this.getCountry({ value: data[0]['country'] });

        setTimeout(() => {
          this.getState({ value: data[0]['state'] });
        }, 500);

        setTimeout(() => {
          this.getDistricts({ value: data[0]['city'] });
        }, 2000);

        setTimeout(() => {
          this.subform.patchValue({
            district: data[0]['city'],
            district_eng: data[0]['district_eng'] || '',
            taluka: data[0]['taluka']
          });
        }, 1000);

      });
    }
  }

  selected_namepack(option: any) {
    debugger;

    if (!option || !option.id) {
      return;
    }

    this.issueid = option.id;
    this.isExistingSeller = true;

    this.service.getSubscriberData(option.id).subscribe((data) => {
      if (data.length > 0) {
        const seller = data[0];

        this.packsubform.patchValue({
          subscribersName: seller.name,
          subscribersNo: seller.subno,
          mobileNumber: seller.mobileNumber,
          title: seller.title,
          nameRequired: seller.name,
          nameEnglish: seller.e_name,
          address: seller.address,
          e_address: seller.e_address,
          e_address1: seller.e_address1,
          e_address2: seller.e_address2,
          pincode: seller.pincode,
          country: seller.country,
          countryEnglish: seller.e_country,
          state: seller.state,
          stateEnglish: seller.e_state,
          district: seller.district,
          districtEnglish: seller.e_district,
          taluka: seller.taluka,
          talukaEnglish: seller.e_taluka,
          mobileNumberField: seller.mobileNumber,
          telephone: seller.telephone,
          email: seller.email,
          dob: seller.dob,
          doa: seller.date_of_marriage,
          representativeName: seller.repname,
          representativeMobile: seller.repmobno,
          gstNumber: seller.gst_no,
          remark: seller.remark,
          sellertype: seller.issueSellerType,
        });

        this.select(seller.issueSellerType);
        this.getcountryforupdate(seller.country, seller.district);
      }
    });
  }

  selected_namepackmob(event: any) {
    const selectedMobile = event.option.value;

    const selectedObj = this.sub_mob_no.find(
      (x) => x.mobno === selectedMobile
    );

    if (!selectedObj || !selectedObj.id) {
      return;
    }

    this.issueid = selectedObj.id;
    this.isExistingSeller = true;

    this.service.getSubscriberData(selectedObj.id).subscribe((data) => {
      if (data.length > 0) {
        const seller = data[0];

        this.packsubform.patchValue({
          subscribersName: seller.name,
          subscribersNo: seller.subno,
          mobileNumber: seller.mobileNumber,
          title: seller.title,
          nameRequired: seller.name,
          nameEnglish: seller.e_name,
          address: seller.address,
          e_address: seller.e_address,
          e_address1: seller.e_address1,
          e_address2: seller.e_address2,
          pincode: seller.pincode,
          country: seller.country,
          countryEnglish: seller.e_country,
          state: seller.state,
          stateEnglish: seller.e_state,
          district: seller.district,
          districtEnglish: seller.e_district,
          taluka: seller.taluka,
          talukaEnglish: seller.e_taluka,
          mobileNumberField: seller.mobileNumber,
          telephone: seller.telephone,
          email: seller.email,
          dob: seller.dob,
          doa: seller.date_of_marriage,
          representativeName: seller.repname,
          representativeMobile: seller.repmobno,
          gstNumber: seller.gst_no,
          remark: seller.remark,
          sellertype: seller.issueSellerType,
        });

        this.select(seller.issueSellerType);
        this.getcountryforupdate(seller.country, seller.district);
      }
    });
  }

  getcountryforupdate(id: any, districtId: any) {
    let country = this.countries.find((a) => a.country_name == id);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
        this.getStateForUpdate(this.selectedState, districtId)
      });

    } else {
    }
  }
  getStateForUpdate(id: any, districtId: any) {
    let state = this.states.find((a) => a.state_name == id);
    if (state != undefined) {
      if (state.state_name != 'Maharashtra' || state.state_name != 'महाराष्ट्र') {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service.getDistrict(parseInt(state['state_id'])).subscribe((data) => {
        this.cities = data;
        // this.selectedCity = this.cities['district_name'];
        this.getDistrictsForUpdate(districtId);
      });
    }
  }
  getDistrictsForUpdate(id: any) {
    console.log(id);
    let district = this.cities.find((a) => a.district_name == id);
    if (district != undefined) {
      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        // this.selectedTaluka = this.talukas['taluka_name'];
        console.log("T=" + this.talukas)
        console.log("C=" + this.cities)
      });
    }
  }


  // selected_name(event: any, id: any) {
  //   if (event.isUserInput) {
  //     this.service.getSubData(id.id).subscribe((data: any[]) => {
  //       if (!data || data.length === 0) return;
  //       const seller = data[0];

  //       // Patch form values
  //       this.subform.patchValue({
  //         subname: seller.name,
  //         title: seller.title,
  //         mobileNumber: seller.mobno,
  //         name: seller.name,
  //         address: seller.address,
  //         pincode: seller.spin,
  //         country: seller.country,
  //         state: seller.state,
  //         district: seller.city,
  //         taluka: seller.taluka,
  //         email: seller.email,
  //         dob: seller.dob,
  //         doa: seller.anniversary
  //       });

  //       // Dependent fetches
  //       this.getCountry({ value: seller.country });
  //       setTimeout(() => this.getState({ value: seller.state }), 500);
  //       setTimeout(() => this.getDistricts({ value: seller.city }), 2000);

  //       // Fetch booking list
  //       this.getBookSellerList(seller.name);
  //     });
  //   }
  // }

  getBusinessReport1() {
    const formValue = this.businessForm.value;

    const payload: any = {
      start_date: formValue.start ? formatDate(formValue.start, 'yyyy-MM-dd', 'en-US') : null,
      end_date: formValue.end ? formatDate(formValue.end, 'yyyy-MM-dd', 'en-US') : null,
      rep_name: formValue.officerepwise,
      district: formValue.district,
      taluka: formValue.taluka
    };

    this.service.getBusinessReport(payload).subscribe({
      next: (res: any) => {
        // The API now returns flat month keys: Apr, May, ..., Mar
        this.businessReportList = res?.data || [];
        console.log('Business Report:', this.businessReportList);
      },
      error: (err) => console.error(err)
    });
  }


  issueSellerIds: any;
  issueid: any;

  selected_namebooking(selectedOption: any) {
    if (!selectedOption) return;

    this.issueSellerIds = selectedOption.id;
    this.issueid = selectedOption.id;

    this.subform.patchValue({ subname: selectedOption.name });

    // Populate dependent fields
    this.selected_name({ isUserInput: true }, selectedOption);

    // Fetch booking list correctly
    this.getBookSellerList(selectedOption.name);

  }


  displaySellerName(seller: any): string {
    return seller && seller.name ? seller.name : '';
  }
  issueSellerIds1: any;
  issueid1: any;
  selected_namebooking1(selectedOption: any) {
    debugger
    if (!selectedOption) return;

    this.issueSellerIds1 = selectedOption.id;
    this.issueid1 = selectedOption.id;

    this.packsubform.patchValue({ subname: selectedOption.name });

    // Populate dependent fields
    this.selected_name({ isUserInput: true }, selectedOption);

    // Fetch booking list correctly
    this.getBookSellerList1(selectedOption.name);
  }
  getPincode(event) {
    if (this.subform.get('pincode').valid) {
      this.service
        .getPincodeData(parseInt(this.subform.get('pincode').value))
        .subscribe((data) => {
          if (data && data.length > 0) {
            this.populateLocationFields(data[0]);
          }
        });
    }
  }

  populateLocationFields(locationData: any) {
    // Set and load country -> states
    this.subform.get('country').setValue(locationData['country_name']);
    this.loadStatesAndSetState(locationData);
  }

  loadStatesAndSetState(locationData: any) {
    this.getCountry({ value: locationData['country_name'] });

    // Wait for states to load
    setTimeout(() => {
      this.subform.get('state').setValue(locationData['state_name']);
      this.loadDistrictsAndSetDistrict(locationData);
    }, 200);
  }

  loadDistrictsAndSetDistrict(locationData: any) {
    this.getState({ value: locationData['state_name'] });

    // Wait for districts to load
    setTimeout(() => {
      this.subform.get('district').setValue(locationData['district_name']);
      this.loadTalukasAndSetTaluka(locationData);
    }, 200);
  }

  loadTalukasAndSetTaluka(locationData: any) {
    this.getDistricts({ value: locationData['district_name'] });

    // Wait for talukas to load
    setTimeout(() => {
      this.subform.get('taluka').setValue(locationData['taluka_name']);
    }, 200);
  }

  //getPincode

  // getPincode(event) {
  //   if (this.subform.get('pincode').valid) {
  //     this.service
  //       .getPincodeDetails(parseInt(this.subform.get('pincode').value))
  //       .subscribe((data) => {
  //         this.subform
  //           .get('taluka')
  //           .setValue(data[0]['PostOffice'][0]['Block']);
  //         this.getCountry({ value: data[0]['PostOffice'][0]['Country'] });
  //         this.subform
  //           .get('district')
  //           .setValue({ name: data[0]['PostOffice'][0]['District'] });
  //         this.subform
  //           .get('state')
  //           .setValue({ state_name: data[0]['PostOffice'][0]['State'] });
  //         this.subform
  //           .get('country')
  //           .setValue(data[0]['PostOffice'][0]['Country']);
  //         this.selectedCity = data[0]['PostOffice'][0]['District'];
  //         this.selectedState = data[0]['PostOffice'][0]['State'];
  //       });
  //   }
  // } //getPincode

  // getCountry(event) {
  //   let country = this.countries.find((a) => a.name == event.value);
  //   if (country != undefined) {
  //     this.service
  //       .getstates(parseInt(country['country_code']))
  //       .subscribe((data) => {
  //         this.states = data;
  //       });
  //   } else {
  //   }
  // } //getcountry

  getCountry(event) {
    // console.log(event);
    let country = this.countries.find((a) => a.country_name == event.value);
    // console.log(country);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
      });
    } else {
    }
  } //getcountry

  showigst = false;
  getState(event) {
    // console.log(event);
    // console.log(this.states);
    this.selectedState = this.states['state_id'];
    let state = this.states.find((a) => a.state_name === event.value);
    // console.log(state);
    if (state != undefined) {
      if (
        state.state_name != 'Maharashtra' ||
        state.state_name != 'महाराष्ट्र'
      ) {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service
        .getDistrict(parseInt(state['state_id']))
        .subscribe((data) => {
          this.cities = data;
          this.selectedCity = this.cities['district_name'];
          this.getDistricts({ value: data[0]['city'] });
          // console.log('cities', this.cities);
        });
    } else {
    }
  } //get state


  getDistricts(event) {
    console.log(event.value);
    this.selectedCity = this.cities['district_id'];
    let district = this.cities.find((a) => a.district_name == event.value);
    if (district != undefined) {

      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        this.selectedTaluka = this.talukas['taluka_name'];
      });
    }
  }

  deliverymode;
  durationn(event) {
    this.deliverymode = event.value;
  }

  pymtmode;
  selectedpymtmode(event) {
    // this.subform.get('deliverymode').setValue(event.target.value);
    this.pymtmode = event.value;
  }

  getBookPayments() {
    this.service.getBookPendingPayment().subscribe((res) => {
      this.bookpaymentList = [];
      for (let index = 0; index < Object.keys(res).length; index++) {
        this.bookpaymentList.push({
          rep_id: parseInt(res[index]['repId']),
          name: res[index]['repName'],
          id: parseInt(res[index]['id']),
          claim_name: res[index]['name'],
          totalAmount: parseInt(res[index]['totalAmount']),
          payoptn: res[index]['payoptn'],
          repName: res[index]['repName'],
          repmobile: res[index]['repmobile'],
          rep_receipt: res[index]['rep_receipt'],
          task: 'book',
        });
      }
    });
  }

  displayBookPayment(paymentdetails) {
    this.dialog.open(SubscriptionAccountsComponent, {
      data: {
        rep: paymentdetails,
        view: false,
      },
    });
  }

  pendingbookdata;
  displayItemId(book, ele) {
    this.pendingbookdata = book;
    console.log(this.pendingbookdata)

    this.demo1BtnClick();
  } //end of displayId


  pendingbookdatagranth;
  displayItemIdgranth(granth, ele) {
    debugger
    this.pendingbookdatagranth = granth;
    console.log(this.pendingbookdatagranth)

    this.demo1BtngranthClick();
  }
  pendingbookcommdata;
  displayItemCommId(book, ele) {
    this.pendingbookcommdata = book;
    console.log(this.pendingbookcommdata)

    this.demoCommBtnClick();
  } //end of displayId

  bookregistration_bookname = ['all'];

  readAllBookStock() {
    this.service.ReadAllBookStock().subscribe((bs) => {
      this.bookStock = bs;
    });
  }

  addbooksize() {
    if (this.booksizeform.get('booksize').value != '') {
      this.service
        .addbooksize(this.booksizeform.get('booksize').value)
        .subscribe((data) => {
          window.alert('Book size added successfully...');
          this.booksizeform.reset();
        });
    } else {
      window.alert('Please Enter the book size');
    }
  }

  ConvertToInt(val) {
    return parseFloat(val);
  }

  filterBookwiseReport;
  filterBookwiseReportTotal = {
    totalbookcopies: 0,
    totalbookprice: 0,
    totalafterdiscount: 0,
    total: 0,
    totalshipping_charges: 0,
    totaldepositamt: 0,
    totalamount: 0,
    totalstock: 0,
    availablestock: 0,
  };
  getBookwiseReport(book_name, start_date, end_date) {
    this.service
      .getBookwiseReport(book_name, start_date, end_date)
      .subscribe((data) => {
        this.filterBookwiseReport = data;
        console.log(this.filterBookwiseReport);
        this.filterBookwiseReportTotal = {
          totalbookcopies: 0,
          totalbookprice: 0,
          totalafterdiscount: 0,
          total: 0,
          totalshipping_charges: 0,
          totaldepositamt: 0,
          totalamount: 0,
          totalstock: 0,
          availablestock: 0,
        };
        for (
          let index = 0;
          index < Object.keys(this.filterBookwiseReport).length;
          index++
        ) {
          this.filterBookwiseReportTotal['totalbookcopies'] += parseFloat(
            this.filterBookwiseReport[index]['bookcopies']
          );
          this.filterBookwiseReportTotal['totalbookprice'] += parseFloat(
            this.filterBookwiseReport[index]['bookprice']
          );
          this.filterBookwiseReportTotal['totalafterdiscount'] += parseFloat(
            this.filterBookwiseReport[index]['totalafterdiscount']
          );
          this.filterBookwiseReportTotal['total'] += parseFloat(
            this.filterBookwiseReport[index]['total']
          );
          this.filterBookwiseReportTotal['totaldepositamt'] += parseFloat(
            this.filterBookwiseReport[index]['depositamt']
          );
          this.filterBookwiseReportTotal['totalshipping_charges'] += parseFloat(
            this.filterBookwiseReport[index]['shipping_charges']
          );
          this.filterBookwiseReportTotal['totalamount'] += parseFloat(
            this.filterBookwiseReport[index]['totalamount']
          );
          this.filterBookwiseReportTotal['totalstock'] += parseFloat(
            this.filterBookwiseReport[index]['totalstock']
          );
          this.filterBookwiseReportTotal['availablestock'] += parseFloat(
            this.filterBookwiseReport[index]['availablestock']
          );
        }

        setTimeout(() => {
          this.showbooks = false;
        }, 2000);
      });
  }

  option;
  select(event) {
    this.option = event.value;
  }

  showbooks = false;
  getAllDeliveryData() {
    this.bookDeliveryData = [];
    this.deliveredBooks = [];

    this.service.getalldeliverydetails().subscribe((data) => {
      for (let index = 0; index < Object.keys(data).length; index++) {
        if (data[index]['isdelivered'] == 'N') {
          this.bookDeliveryData.push(data[index]);
        } else {
          this.deliveredBooks.push(data[index]);
        }
      }
    });

  }

  /*name of the excel-file which will be downloaded. */
  fileName = 'ExcelSheet.xlsx';

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  fileNamee = 'BookSheet.xlsx';
  exportexcel1(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-tablee');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileNamee);
  }

  displayDiscount = false;
  getSalePrice(event) {
    if (parseInt(event.target.value) > 0) {
      this.displayDiscount = true;
    } else {
      this.displayDiscount = false;
    }
  }

  displayucoming = false;
  getSearchTerm(event) {
    let status = event.target.value;
    if (status == 'Y') {
      this.displayucoming = true;
    } else {
      this.displayucoming = false;
    }
  }

  // EditBooks(id) {
  //   let book = this.bookData.find((a) => parseInt(a.bookid) == parseInt(id));
  //   let data = this.dialog.open(EditBookComponent, {
  //     data: {
  //       book: book,
  //       view: false,
  //     },
  //   });

  //   data.afterClosed().subscribe((a) => {
  //     this.ngOnInit();
  //   });
  // }

  EditBooks(id) {
    let book = this.latestbooklist.find((a) => parseInt(a.bookid) == parseInt(id));
    let data = this.dialog.open(EditBookComponent, {
      data: {
        book: book,
        view: false,
      },
      height: '90%',
      width: '85%',
      maxWidth: '100%'
    });

    data.afterClosed().subscribe((a) => {
      if (a) {  // Ensure dialog returned data before reloading
        this.ngOnInit();
        setTimeout(() => {
          this.caltotalpages(); // Recalculate total pages after form updates
        }, 0);
      }
    });
  }


  // Toggle select all
  // List of items and selected items
  issueBookingSellerList: any[] = [];

  // Fetch seller booking list
  getBookSellerList(subname: string) {
    const payload = { issuesellerbooking: { subname } };
    this.service.getBookSellerList(payload).subscribe((res: any[]) => {
      this.issueBookingSellerList = (res || []).map(item => ({
        ...item,
        invoice_total: Number(item.invoice_total) || 0,
        remaining_amt: Number(item.remaining_amt) || 0
      }));
      this.selectedItems = [];
      this.selectAll = false;
    });
  }

  issueBookingSellerListpackage: any[] = [];
  getBookSellerList1(subname: string) {
    const payload = { issuesellerbooking: { subname } };
    this.service.getBookSellerList1(payload).subscribe((res: any[]) => {
      this.issueBookingSellerListpackage = (res || []).map(item => ({
        ...item,
        invoice_total: Number(item.invoice_total) || 0,
        remaining_amt: Number(item.remaining_amt) || 0
      }));
      this.selectedItems = [];
      this.selectAll = false;
    });
  }
  // Toggle all checkboxes
  toggleSelectAll() {
    this.selectAll = !this.selectAll;
    this.selectedItems = this.selectAll ? [...this.issueBookingSellerList] : [];
  }
  // allSelected: boolean = false;

  // allSelected: boolean = false;

  toggleSelectAll2(event: any) {
    this.allSelected = event.checked;

    this.bookRcptCommisionRegisterdata.forEach(item => {
      item.selected = this.allSelected;
    });
  }
  onRowCheckboxChange(item: any, event: any) {
    item.selected = event.checked;

    // Update header checkbox state
    this.allSelected = this.bookRcptCommisionRegisterdata.every(
      item => item.selected
    );
  }

  // Helper for template [checked]
  isSelected(item: any): boolean {
    return this.selectedItems.some(selected => selected.id === item.id);
  }
  getSelectedRows1() {
    return this.bookRcptCommisionRegisterdata.filter(
      (item: any) => item.selected1
    );
  }

  toggleSelectAllPackage() {
    this.selectAll = !this.selectAll;
    this.selectedItems = this.selectAll ? [...this.issueBookingSellerListpackage] : [];
  }

  // Toggle individual item
  toggleSelection(item: any) {
    const index = this.selectedItems.findIndex(selected => selected.id === item.id);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(item);
    }
    this.selectAll = this.selectedItems.length === this.issueBookingSellerList.length;
  }

  // Helper for template [checked]
  // isSelected(item: any): boolean {
  //   return this.selectedItems.some(selected => selected.id === item.id);
  // }

  ViewBooks(id) {
    let book = this.bookData.find((a) => parseInt(a.bookid) == parseInt(id));
    this.dialog.open(ViewBookComponent, {
      data: {
        book: book,
        view: false,
      },
    });
  }

  update(item) {
    this.dialog.open(UpdateOfficeRepresentativeComponent, {
      data: {
        item: item,
        type: 'book',
      },
    });
    this.service.getBookWiseRep().subscribe((data) => {
      this.bookwisereplist = data;
    });
  }

  removebook(id) {
    if (window.confirm('Do you really want to remove the book?')) {
      this.service.removeBook(id).subscribe((data) => {
        if (data.message === "You can't delete this book. It is already used in active bookings.") {
          alert("You can't delete this book. It is already used in active bookings.");
        }
        else if (data.message === "Book successfully deleted.") {
          alert("Book successfully deleted.");

          // Refresh full book list
          this.service.getAllBookData().subscribe((data) => {
            this.bookData = data;
            this.bookdata = this.uniqueid(this.bookData, (it) => it.bookid);

            // Also update the filtered list
            this.Filteredbookdata1 = [...this.bookdata]; // copy the updated list
          });
        }
        else {
          alert("Failed to update book status.");
        }
      });
    }
  }


  ordinal_suffix_of(i) {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + 'st';
    }
    if (j == 2 && k != 12) {
      return i + 'nd';
    }
    if (j == 3 && k != 13) {
      return i + 'rd';
    }
    return i + 'th';
  }

  bookavailable: Boolean = false;
  selected_bookname(option: any) {

    if (!option || !option.bookname) return;

    // 🔹 Reset first (important when switching Book ↔ Granth)
    this.BookForm.reset({
      bookname: option.bookname
    });

    // 🔹 Edition logic (same for both)
    this.service.getBookEdition(option.bookname).subscribe((data) => {
      const edition =
        this.ordinal_suffix_of(parseInt(data[0]?.count || 0) + 1) + ' Edition';
      this.BookForm.get('bookedition')?.setValue(edition);
    });

    // 🔹 Find selected record
    const selectedData = this.bookData.find(
      b => b.bookname === option.bookname
    );

    if (!selectedData) return;

    // 🔥 Auto-fill ONLY when editing existing entry
    this.bookavailable = true;
    this.book_id = selectedData.bookid;

    this.BookForm.patchValue({
      bookdesc: selectedData.bookdesc,
      authorname: selectedData.author,
      prakashanname: selectedData.prakashan_name,
      agentprice: selectedData.agentprice,
      bookpagesbw: selectedData.bkpagesbw,
      bkpinsidecolor: selectedData.bkpinsidecolor,
      bkpcover: selectedData.bkpcover,
      totalpages: selectedData.book_pages,
      booksize: selectedData.booksize,
      paperbw: selectedData.paperbw,
      paperinsidecolor: selectedData.paperinsidecolor,
      papercover: selectedData.papercover,
      binding: selectedData.binding,
      booklang: selectedData.language,
      bookcategory: selectedData.bookcategory,
      isupcoming: selectedData.isupcoming,
      upcomingdate: selectedData.upcomingdate
    });

    // 🔹 Opening stock
    this.service.getAllBookStockData().subscribe(stockData => {
      const stock = stockData.find(
        s => s.bookname === option.bookname
      );
      this.BookForm.get('opening_stock')
        ?.setValue(stock?.available_stock || '');
    });
  }
  


  start_date1;
  end_date1;
  getbookoutstaningdate() {
    if (
      this.bookoutstandingform.get('start').value != null &&
      this.bookoutstandingform.get('end').value != null
    ) {
      this.start_date1 = formatDate(
        new Date(this.bookoutstandingform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.end_date1 = formatDate(
        new Date(this.bookoutstandingform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  officerepname = '';
  getofficerepname(event) {
    this.officerepname = event.target.value;
  }

  contractReportType = '';
  getContractReportType(event) {
    debugger
    // console.log(event.value);
    this.contractReportType = event.value;
  }
  granthReportType = '';
  getgranthReportType(event) {
    debugger
    // console.log(event.value);
    this.granthReportType = event.value;
  }
  contractttReportType = '';
  getReportType(event) {
    // console.log(event.value);
    this.contractttReportType = event.value;
  }

  contracttReportType = '';
  getContracttReportType(event) {
    // console.log(event.value);
    this.contractReportType = event.value;
  }

  // showOutstandingReports() {
  //   // console.log(this.contractData);
  //   if (this.contracttReportType !== '') {
  //     this.dialog.open(OutstandingReportComponent, {
  //       data: {
  //         Filteredbookoutstandingdata: this.Filteredbookoutstandingdata,
  //         startDate: this.bookoutstandingform.value.start,
  //         endDate: this.bookoutstandingform.value.end,
  //         //repName: this.bookoutstandingform.value.Repname,
  //         //advtName: this.bookoutstandingform.value.Advtname,

  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });
  //   }
  //   else {
  //     alert('Please select report type');
  //   }
  // }

  // showOutstandingReports() {
  //   if (this.contractReportType !== '') {
  //     const startDateRaw = this.bookoutstandingform.value.start;
  //     const endDateRaw = this.bookoutstandingform.value.end;

  //     const formatDate = (date: any): string => {
  //       const d = new Date(date);
  //       const year = d.getFullYear();
  //       const month = String(d.getMonth() + 1).padStart(2, '0');
  //       const day = String(d.getDate()).padStart(2, '0');
  //       return `${year}-${month}-${day}`; // Note the double hyphen
  //     };

  //     const formattedStartDate = formatDate(startDateRaw);
  //     const formattedEndDate = formatDate(endDateRaw);

  //     this.dialog.open(OutstandingReportComponent, {
  //       data: {
  //         Filteredbookoutstandingdata: this.Filteredbookoutstandingdata,
  //         startDate: formattedStartDate,
  //         endDate: formattedEndDate,
  //         // repName: this.bookoutstandingform.value.Repname,
  //         // advtName: this.bookoutstandingform.value.Advtname,
  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });
  //   } else {
  //     alert('Please select report type');
  //   }
  // }

  private _filterdist(name: any): any[] {
    const filterValue = name.toLowerCase();
    return this.filteredDistributorList.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  private _filterSubModes(name: string, list: any[]): any[] {
    const filterValue = name.toLowerCase();
    return list.filter(option => option.name.toLowerCase().includes(filterValue));
  }


  // Filter method
  private _filter22(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.distributionModeList.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  // onDeliveryModeChange1(selectedModes: string[] | string) {
  //   debugger
  //   // Convert single value to array for consistency
  //   if (!Array.isArray(selectedModes)) {
  //     selectedModes = selectedModes ? [selectedModes] : [];
  //   }

  //   // 1️⃣ Filter Distributor List
  //   if (!selectedModes || selectedModes.length === 0) {
  //     this.filteredDistributorList = [];
  //   } else if (selectedModes.includes('all')) {
  //     this.filteredDistributorList = this.distributorList.slice(); // all distributors
  //   } else {
  //     this.filteredDistributorList = this.distributorList.filter(rep =>
  //       selectedModes.includes(rep.delivery_mode)
  //     );
  //   }

  //   // Reset the distributor input so autocomplete reloads
  //   const distributorControl = this.subform.get('DistributiveRep');
  //   if (distributorControl) {
  //     distributorControl.reset();

  //     // Re-bind distributor autocomplete options
  //     this.filteredOptionsdist = distributorControl.valueChanges.pipe(
  //       startWith(distributorControl.value || ''),
  //       map(value => (typeof value === 'string' ? value : value?.name)),
  //       map(name => (name ? this._filterdist(name) : this.filteredDistributorList.slice()))
  //     );
  //   }

  //   // 2️⃣ Re-bind Distribution Mode autocomplete options
  //   const distModeControl = this.subform.get('DistributionMode');
  //   if (distModeControl) {
  //     distModeControl.reset();

  //     this.filteredOptions7 = distModeControl.valueChanges.pipe(
  //       startWith(distModeControl.value || ''),
  //       map(value => (typeof value === 'string' ? value : value?.name)),
  //       map(name => (name ? this._filter22(name) : this.distributionModeList.slice()))
  //     );
  //   }
  // }

  resetDeliveryModes() {
    this.selectedModes = [];
    this.subform.get('DeliveryMode')?.reset();
    this.filteredDistributorList = [];
  }


  selectedModes1: string[] = [];

  toggleAllSelectionpl() {
    if (this.selectedModes.length === this.delivery_mode.length) {
      this.selectedModes = [];
    } else {
      this.selectedModes1 = this.delivery_mode.map(x => x.delivery_mode);
    }
    this.subform.get('DeliveryMode')?.setValue(this.selectedModes1);
    this.onDeliveryModeChange1(this.selectedModes1); // update distributor list
  }

  //  selectedModes1: string[] = [];

  //   toggleAllSelectionpl() {
  //     if (this.selectedModes.length === this.delivery_mode.length) {
  //       this.selectedModes = [];
  //     } else {
  //       this.selectedModes1 = this.delivery_mode.map(x => x.delivery_mode);
  //     }
  //     this.packsubform.get('DeliveryMode')?.setValue(this.selectedModes1);
  //     this.onDeliveryModeChangegranth(this.selectedModes1); // update distributor list
  //   }

  selectedModes2: string[] = [];

  toggleAllSelectiondpl(event: Event) {
    event.stopPropagation();

    this.filteredOptionsbookdm.subscribe((options: any[]) => {

      if (this.selectedModes2.length === options.length) {
        this.selectedModes2 = [];
      } else {
        this.selectedModes2 = options.map(x => x.sub_delivery_mode);
      }

      this.packsubform.get('DistributionMode')?.setValue(this.selectedModes2);
      this.onDeliveryModeChange3(this.selectedModes2);
    });
  }


  resetDistributionModeModes1() {
    this.selectedModes2 = [];
    this.packsubform.get('DistributionMode')?.reset();
    this.FilteredsubDistributionModeData = [];
  }

  onDeliveryModeChange3(selectedModes: string[]) {
    if (!selectedModes) return;

    if (selectedModes.includes('all')) {
      selectedModes = this.distributorListDM.map(m => m.dis_mode); // FIX
    }

    this.service.getsubdistmodeissueseller(selectedModes).subscribe((data) => {
      this.FilteredsubDistributionModeData = data;

      this.filteredOptions28 = this.subform.get('SubDistMode')!.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.sub_delivery_mode),
        map(sub_delivery_mode => sub_delivery_mode
          ? this._filterSubModes(sub_delivery_mode, this.FilteredsubDistributionModeData)
          : this.FilteredsubDistributionModeData.slice()
        )
      );
    });
  }

  selectedModes3: string[] = [];

  // Toggle All selection manually
  toggleAllSelectionspl(event: Event) {
    event.stopPropagation(); // prevent selectionChange issues

    this.filteredOptions28.subscribe((options: any[]) => {
      if (this.selectedModes3.length === options.length) {
        // All selected → deselect all
        this.selectedModes3 = [];
      } else {
        // Select all
        this.selectedModes3 = options.map(x => x.name);
      }

      // Update form control manually
      this.packsubform.get('SubDistMode')?.setValue(this.selectedModes3);

      // Call backend manually
      this.callSubDistributionModeBackend(this.selectedModes3);
    });
  }

  callSubDistributionModeBackend(selectedModes3: string[]) {
    if (!selectedModes3 || selectedModes3.length === 0) return;

    // Replace 'All' with full list if needed
    if (selectedModes3.includes('all')) {
      selectedModes3 = this.FilteredsubDistributionModeData.map(m => m.name);
    }
  }
  // Reset manually
  resetsubDeliveryModes1() {
    this.selectedModes = [];
    this.subform.get('SubDistMode')?.reset();
  }
  showOutstandingReports() {
    debugger
    this.dialog.open(OutstandingReportComponent, {
      data: {

        outstandingData: this.outstandingData,
        startDate: this.getbookoutStartDate,
        endDate: this.getbookoutEndDate,


        repName: this.representativeNameArray,
        offRepName: this.offRepNameArray,
        booksellerName: this.bookSellerNameArray,
        reportType: this.contractReportType,
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });


    // "rep_name": this.CreditNoteForm.value.rep_name,
    // "start_date": this.CreditNoteForm.value.start,
    // "end_date": this.CreditNoteForm.value.end,
    // "off_rep_name": this.CreditNoteForm.value.off_rep_name,
    // // "issue_name":this.CreditNoteForm.value.issue_cat,
    // "issue_name": this.CreditNoteForm.value.issuename,
    // "issue_date": this.CreditNoteForm

    // }
    // else {
    //   alert('Please select report type');
    // }
  }
  showOutstandingReportsGranth() {

  debugger;

  const formValue = this.granthoutstandingform.value;


  const dialogData = {

    outstandingData: this.outstandingData,

    startDate: formValue.start,
    endDate: formValue.end,

    repName: formValue.repname || [],
    mobile: formValue.mob || '',

    officeRepWise: formValue.officerepwise || [],
    repWise: formValue.repwise || [],
    bookSellerWise: formValue.booksellerwise || [],
    bookWise: formValue.bookwise || [],

    representativeNameArray: this.representativeNameArray,
    offRepNameArray: this.offRepNameArray,
    bookSellerNameArray: this.bookSellerNameArray,

    reportType: this.contractReportType

  };


  switch(this.contractReportType)
  {

    case 'GranthoutstandingInDetails':

      this.dialog.open(GranthOutstandingReportComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;



    case 'Bookoutstandingbriefly':

      this.dialog.open(GranthOutstandingBriefComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;



    case 'unpaidOutstandingInDetails':

      this.dialog.open(UnpaidGranthOutstandingDetailComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;



    case 'unpaidOutstandingbriefly':

      this.dialog.open(UnpaidGranthOutstandingBriefComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;



    case 'OfficeRepbriefly':

      this.dialog.open(OfficeRepBrieflyGranthComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;



    case 'OfficeRepUnpaidbriefly':

      this.dialog.open(OfficeRepUnpaidBrieflyGranthComponent,{
        data:dialogData,
        width:'1200px',
        height:'90vh',
        maxWidth:'100%'
      });

    break;


    default:

      console.log("No report selected");

    break;

  }

}


  // showReceiptReports() {
  //   if (!this.contractReportType || this.contractReportType.trim() === '') {
  //     alert('Please select report type');
  //     return;
  //   }
  //   if(this.contractReportType !="Monthwise"){
  //     debugger
  //   this.dialog.open(BookReceiptReportComponent, {
  //     data: {

  //       FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
  //       reportType: this.contractReportType,
  //       startDate: this.getbookrcptStartDate,
  //       endDate: this.getbookrcptEndDate,
  //       repName: this.bookrcptregisterform.value.repwise,
  //       billnowise: this.bookrcptregisterform.value.billnowise,
  //       booksellerwise: this.bookrcptregisterform.value.booksellerwise,
  //       // bookwise: this.bookrcptregisterform.value.bookwise,
  //       officerepwise: this.bookrcptregisterform.value.officerepwise,


  //     },
  //     height: '1300px',
  //     width: '95%',
  //     maxWidth: '100%',
  //   }); 

  //   }
  //   if (this.contractReportType == "InDetail-Officer") {
  //      (document.activeElement as HTMLElement)?.blur();
  //     debugger

  //     this.dialog.open(BookReceiptIndetailOfficerComponent, {
  //       data: {

  //         FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
  //         reportType: this.contractReportType,
  //         startDate: this.getbookrcptStartDate,
  //         endDate: this.getbookrcptEndDate,
  //         repName: this.bookrcptregisterform.value.repwise,
  //         billnowise: this.bookrcptregisterform.value.billnowise,
  //         booksellerwise: this.bookrcptregisterform.value.booksellerwise,
  //         // bookwise: this.bookrcptregisterform.value.bookwise,
  //         officerepwise: this.bookrcptregisterform.value.officerepwise,


  //       },
  //       height: '1300px',
  //       width: '95%',
  //       maxWidth: '100%',
  //     });

  //   }

  //   else{
  //     debugger
  //   this.dialog.open(BookPymtMonthwiseReportComponent, {
  //     data: {

  //       FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
  //       reportType: this.contractReportType,
  //       startDate: this.getbookrcptStartDate,
  //       endDate: this.getbookrcptEndDate,
  //       repName: this.bookrcptregisterform.value.repwise,
  //       billnowise: this.bookrcptregisterform.value.billnowise,
  //       booksellerwise: this.bookrcptregisterform.value.booksellerwise,
  //       // bookwise: this.bookrcptregisterform.value.bookwise,
  //       officerepwise: this.bookrcptregisterform.value.officerepwise,


  //     },
  //     height: '1300px',
  //     width: '95%',
  //     maxWidth: '100%',
  //   }); 

  //   }

  // }
  showReceiptReports() {
    // Remove focus from the currently active (focused) element before opening a dialog
    (document.activeElement as HTMLElement)?.blur();

    if (this.contractReportType != "Monthwise" && this.contractReportType != "InDetail-Officer" && this.contractReportType != "InDetailALL"
      && this.contractReportType != "VeryBriefly-Officer" && this.contractReportType != "All Briefly" && this.contractReportType != "Office Rep InDetails" && this.contractReportType != "Office Rep -Briefly" && this.contractReportType != "Briefly-Officer"
    ) {
      // For other report types
      this.dialog.open(BookReceiptReportComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }

    else if (this.contractReportType == 'InDetail-Officer') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptIndetailOfficerComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == 'Office Rep -Briefly') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(OfficeRepBrieflyComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == 'InDetailALL') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptIndetailallComponent, {

        data: {

          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          // billnowise: this.bookrcptregisterform.value.billnowise,
          // booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == "All Briefly") {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptAllBrieflyComponent, {

        data: {

          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          // billnowise: this.bookrcptregisterform.value.billnowise,
          // booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == "Office Rep InDetails") {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(OfficeRepInDetailsComponent, {

        data: {

          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          // billnowise: this.bookrcptregisterform.value.billnowise,
          // booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }

    //   else if (this.contractReportType == "Office Rep- In Details") {
    //   (document.activeElement as HTMLElement)?.blur();

    //   this.dialog.open(BookReceiptOfficeRepInDetailsComponent, {

    //     data: {

    //       FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
    //       reportType: this.contractReportType,
    //       startDate: this.getbookrcptStartDate,
    //       endDate: this.getbookrcptEndDate,
    //       repName: this.bookrcptregisterform.value.repwise,
    //       // billnowise: this.bookrcptregisterform.value.billnowise,
    //       // booksellerwise: this.bookrcptregisterform.value.booksellerwise,
    //       officerepwise: this.bookrcptregisterform.value.officerepwise,
    //     },
    //     height: '1300px',
    //     width: '95%',
    //     maxWidth: '100%',
    //   });
    // }

    else if (this.contractReportType == "VeryBriefly-Officer") {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptVeryBrieflyOfficerComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == "Briefly-Officer") {
      debugger
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptBrieflyOfficerComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else {
      // When reportType is exactly "Monthwise"
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookReceiptMonthwiseComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.bookrcptregisterform.value.start),
          endDate: this.fixDate(this.bookrcptregisterform.value.end),
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
  }
  viewPrintOrder(data: any) {
    this.dialog.open(BooksellerViewPrintOrderComponentComponent, {
      data: data, // ✅ pass directly
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  updatePrintOrder(row: any) {
    debugger

    console.log(row);
    this.dialog.open(BookSellerUpdatePrintOrderComponent, {
      data: {
        id: row.id,
        order_id: row.order_id
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
     viewPrintOrdergranth(data: any) {
    this.dialog.open(SellerGrantViewPrintOrderComponent, {
      data: data, // ✅ pass directly
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
   updatePrintOrdergranth(row: any) {
    debugger

    console.log(row);
    this.dialog.open(GranthSellerUpdatePrintOrderComponent, {
      data: {
        id: row.id,
        order_id: row.order_id
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  showContractReportReminder1() {

    debugger;

    const start = this.Sendreminderform.value.start;
    const end = this.Sendreminderform.value.end;

    const formattedStartDate = start
      ? formatDate(start, 'yyyy-MM-dd', 'en-IN')
      : '';

    const formattedEndDate = end
      ? formatDate(end, 'yyyy-MM-dd', 'en-IN')
      : '';

    if (!this.contractReportType) {
      alert('Please select report type');
      return;
    }

    if (this.contractReportType === 'send-reminder1') {

      this.dialog.open(SendReminderLetterBookComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.fixDate(formattedStartDate),
          endDate: this.fixDate(formattedEndDate),
          repName: this.Sendreminderform.value.repwise,   // ✅ FIX
          booksellername: this.Sendreminderform.value.booksellername,
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
    else if (this.contractReportType === 'send-reminder2') {

      this.dialog.open(SendReminderLetterRepBookComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.fixDate(formattedStartDate),
          endDate: this.fixDate(formattedEndDate),
          repName: this.Sendreminderform.value.repwise,   // ✅ FIX
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
  }


  showContractReportReminderGranth() {

    debugger;

    const start = this.Sendreminderformgranth.value.start;
    const end = this.Sendreminderformgranth.value.end;

    const formattedStartDate = start
      ? formatDate(start, 'yyyy-MM-dd', 'en-IN')
      : '';

    const formattedEndDate = end
      ? formatDate(end, 'yyyy-MM-dd', 'en-IN')
      : '';

    if (!this.contractReportType) {
      alert('Please select report type');
      return;
    }

    if (this.contractReportType === 'send-reminder1') {

      this.dialog.open(SendReminderLetterGranthComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.fixDate(formattedStartDate),
          endDate: this.fixDate(formattedEndDate),
          repName: this.Sendreminderformgranth.value.repwise,   // ✅ FIX
          booksellername: this.Sendreminderformgranth.value.booksellername,
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
    else if (this.contractReportType === 'send-reminder2') {

      this.dialog.open(SendReminderLetterRepBookComponent, {
        data: {
          contractData: this.contractData,
          startDate: this.fixDate(formattedStartDate),
          endDate: this.fixDate(formattedEndDate),
          repName: this.Sendreminderformgranth.value.repwise,   // ✅ FIX
          reportType: this.contractReportType,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

    }
  }


  showReceiptReports1() {
    debugger
    // Remove focus from the currently active (focused) element before opening a dialog
    (document.activeElement as HTMLElement)?.blur();

    if (this.contractReportType != "briefly1" && this.contractReportType != "Monthwise" && this.contractReportType != "InDetail-Officer"
      && this.contractReportType != "VeryBriefly-Officer" && this.contractReportType != "Briefly-Officer"
    ) {
      // For other report types
      this.dialog.open(BookCreditNoteReportComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }

    else if (this.contractReportType == 'briefly1') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookCreditNoteReportBrieflyComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == 'Monthwise') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookCreditNoteReportMonthwiseComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == 'InDetail-Officer') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookCreditNoteReportInDetailOfficerComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
    else if (this.contractReportType == 'VeryBriefly-Officer') {
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookCreditNoteReportVeryBrieflyOfficerComponent, {

        data: {

          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          // billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }



    //   else if (this.contractReportType == "Office Rep- In Details") {
    //   (document.activeElement as HTMLElement)?.blur();

    //   this.dialog.open(BookReceiptOfficeRepInDetailsComponent, {

    //     data: {

    //       FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
    //       reportType: this.contractReportType,
    //       startDate: this.getbookrcptStartDate,
    //       endDate: this.getbookrcptEndDate,
    //       repName: this.bookrcptregisterform.value.repwise,
    //       // billnowise: this.bookrcptregisterform.value.billnowise,
    //       // booksellerwise: this.bookrcptregisterform.value.booksellerwise,
    //       officerepwise: this.bookrcptregisterform.value.officerepwise,
    //     },
    //     height: '1300px',
    //     width: '95%',
    //     maxWidth: '100%',
    //   });
    // }



    else {
      // When reportType is exactly "Monthwise"
      (document.activeElement as HTMLElement)?.blur();

      this.dialog.open(BookCreditNoteReportBrieflyOfficerComponent, {
        data: {
          FilteredbookRcptRegisterdata: this.FilteredbookRcptRegisterdata,
          reportType: this.contractReportType,
          startDate: this.getbookrcptStartDate,
          endDate: this.getbookrcptEndDate,
          repName: this.bookrcptregisterform.value.repwise,
          billnowise: this.bookrcptregisterform.value.billnowise,
          booksellerwise: this.bookrcptregisterform.value.booksellerwise,
          officerepwise: this.bookrcptregisterform.value.officerepwise,
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });
    }
  }
  showReceiptReports2() {
    debugger

    (document.activeElement as HTMLElement)?.blur();

    // this.getbookrcptStartDate = this.rangeRegistration.value.start;
    // this.getbookrcptEndDate = this.rangeRegistration.value.end;

    // console.log("Start", this.getbookrcptStartDate);
    // console.log("End", this.getbookrcptEndDate);


    // ------------------------ InDetail -------------------------
    if (this.contractReportType == 'InDetail') {

      this.dialog.open(BookRegistrationLedgerReportComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%'
      });

      return;
    }

    // ------------------------ InDetail-Officer -------------------------
    if (this.contractReportType == 'briefly1') {

      this.dialog.open(BookRegistrationLedgerReportBrieflyComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ VeryBriefly-Officer -------------------------
    if (this.contractReportType == 'Monthwise') {

      this.dialog.open(BookRegistrationLedgerReportVBrieflyComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ Briefly-Officer -------------------------
    if (this.contractReportType == 'InDetail-Officer') {

      this.dialog.open(BookRegistrationLedgerReportInDetailOfficerComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }
    if (this.contractReportType == 'VeryBriefly-Officer') {

      this.dialog.open(BookRegistrationLedgerReportVeryBrieflyOfficerComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ Monthwise -------------------------
    if (this.contractReportType == 'Briefly-Officer') {

      this.dialog.open(BookRegistrationLedgerReportBrieflyOfficerComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.contractReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }


  }

  showgranthledgerReports2() {
    debugger

    (document.activeElement as HTMLElement)?.blur();

    // this.getbookrcptStartDate = this.rangeRegistration.value.start;
    // this.getbookrcptEndDate = this.rangeRegistration.value.end;

    // console.log("Start", this.getbookrcptStartDate);
    // console.log("End", this.getbookrcptEndDate);


    // ------------------------ InDetail -------------------------
    if (this.granthReportType == 'InDetail') {

      this.dialog.open(GranthRegistaionLedgerIndetailReportComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%'
      });

      return;
    }

    // ------------------------ InDetail-Officer -------------------------
    if (this.granthReportType == 'briefly1') {

      this.dialog.open(GranthRegistrationLedgerReportBriflyComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ VeryBriefly-Officer -------------------------
    if (this.granthReportType == 'Monthwise') {

      this.dialog.open(GranthRegistrationLedgerBriflyReportComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ Briefly-Officer -------------------------
    if (this.granthReportType == 'InDetail-Officer') {

      this.dialog.open(GranthRegistrationLedgerIndetailOfficerReportComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }
    if (this.granthReportType == 'VeryBriefly-Officer') {

      this.dialog.open(GranthRegistrationLedgerVeryBriflyOfficerReportComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }

    // ------------------------ Monthwise -------------------------
    if (this.granthReportType == 'Briefly-Officer') {

      this.dialog.open(GranthRegistrationLedgerBrieflyOfficerComponent, {
        data: {
          FilteredBookRegistration1: this.FilteredBookRegistration1,
          reportType: this.granthReportType,
          startDate: this.fixDate(this.rangeRegistration.value.start),
          endDate: this.fixDate(this.rangeRegistration.value.end),
          rep_name: this.rangeRegistration.value.repwise,
          office_rep_name: this.rangeRegistration.value.officerepwise || '',
          book_seller_name: this.rangeRegistration.value.cust_name,
          book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
          commissionFilter: this.selectedCommissionFilter || '', // Added
          complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
          // officerepwise: this.bookrcptregisterform.value.officerepwise,
          bill_no: '',
          // book_seller_name: '',
          // book: ''
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%',
      });

      return;
    }


      if (this.granthReportType === 'VeryBriefly-Officergranth') {

  console.log(this.FilteredBookRegistration1);

  this.dialog.open(RegistrationReportGranthVeryBrieflyComponent, {

    width: '95%',
    height: '90vh',
    maxWidth: '100%',

    data: {

      FilteredBookRegistration1: this.FilteredBookRegistration1 || [],

      reportType: this.granthReportType,

      startDate: this.fixDate(this.rangeRegistration.value.start),

      endDate: this.fixDate(this.rangeRegistration.value.end),

      rep_name: this.rangeRegistration.value.repwise || '',

      office_rep_name: this.rangeRegistration.value.officerepwise || '',

      book_seller_name: this.rangeRegistration.value.cust_name || '',

      book_name: this.rangeRegistration.value.bookwise || '',

      commissionFilter: this.selectedCommissionFilter || '',

      complimentaryFilter: this.selectedComplimentaryFilter || '',

      bill_no: ''

    }

  });

  return;
}

  }
  showReceiptReports3() {
    (document.activeElement as HTMLElement)?.blur();

    // const startDate = this.rangeRegistration.value.start;
    // const endDate = this.rangeRegistration.value.end;
    // const rep_name = this.bookrcptregisterform.value.repwise;
    // const office_rep_name = this.bookrcptregisterform.value.officerepwise;

    // 1️⃣ All Rep Book Commission
    if (this.contractReportType === 'All Rep Book Commission') {

      this.dialog.open(AllRepBookCommissionComponent, {
        data: {
          reportType: this.contractReportType,

          startDate: this.bookrepcommisionform.value.start,
          endDate: this.bookrepcommisionform.value.end,

          // ✔ CORRECT VARIABLE NAMES
          rep_name: this.bookrepcommisionform.value.repwise,
          office_rep_name: this.bookrepcommisionform.value.officerepwise,

          book_seller_name: this.bookrepcommisionform.value.booksellerwise
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%'
      });

      return;
    }


    // 2️⃣ Paid Commission
    if (this.contractReportType === 'Rep Commission Paid') {

      this.dialog.open(RepCommissionPaidComponent, {
        data: {
          reportType: this.contractReportType,

          startDate: this.bookrepcommisionform.value.start,
          endDate: this.bookrepcommisionform.value.end,

          // ✔ CORRECT VARIABLE NAMES
          rep_name: this.bookrepcommisionform.value.repwise,
          office_rep_name: this.bookrepcommisionform.value.officerepwise,

          book_seller_name: this.bookrepcommisionform.value.booksellerwise
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%'
      });

      return;
    }

    // 3️⃣ Unpaid Commission
    if (this.contractReportType === 'Rep unpaid Commission') {

      this.dialog.open(RepUnpaidCommissionComponent, {
        data: {
          reportType: this.contractReportType,

          startDate: this.bookrepcommisionform.value.start,
          endDate: this.bookrepcommisionform.value.end,

          // ✔ CORRECT VARIABLE NAMES
          rep_name: this.bookrepcommisionform.value.repwise,
          office_rep_name: this.bookrepcommisionform.value.officerepwise,

          book_seller_name: this.bookrepcommisionform.value.booksellerwise
        },
        height: '1300px',
        width: '95%',
        maxWidth: '100%'
      });

      return;
    }
  }

  toggleSelectAll1(event: any) {
    const checked = event.checked;

    this.allSelectedtable = checked;
    this.someSelected = false;

    this.FilteredDeliveryManageBooks.forEach(book => {
      book.is_selected = checked;
    });
  }

  toggleRow(book: any, event: any) {
    book.is_selected = event.checked;

    const total = this.FilteredDeliveryManageBooks.length;
    const selected = this.FilteredDeliveryManageBooks.filter(b => b.is_selected).length;

    this.allSelectedtable = selected === total;
    this.someSelected = selected > 0 && selected < total;
  }
  getSelectedRows() {
    return this.FilteredDeliveryManageBooks.filter(b => b.is_selected);
  }
  getRemovedIds(): number[] {
    return JSON.parse(localStorage.getItem('removedBookIds') || '[]');
  }
  // getRemovedIds(): number[] {
  //   return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
  // }
  removeFromList(ids: number[]): void {
    this.FilteredDeliveryManageBooks = this.FilteredDeliveryManageBooks.filter(
      (item: any) => !ids.includes(Number(item.id))
    );
  }







  repname1 = '';
  getrepname(event) {
    this.repname1 = event.target.value;
  }

  booksellername1 = '';
  getbooksellername(event) {
    this.booksellername1 = event.target.value;
  }

  book_name1 = '';
  getbookname(event) {
    this.book_name1 = event.target.value;
    console.log(this.book_name1)
  }

  getTotalBilling() {
    if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) > -1
      );
    } else {
      this.service.getBookOutStandingData().subscribe((data) => {
        this.bookoutstandingdata = data;
        this.Filteredbookoutstandingdata = this.bookoutstandingdata;
        this.calculateTotals3();
      });
    }

    console.log(
      'this.Filteredbookoutstandingdata',
      this.Filteredbookoutstandingdata
    );

    this.dialog.open(ShowBookSellerOutstandingDataComponent, {
      data: {
        officerepname: this.officerepname,
        booksellerdata: this.Filteredbookoutstandingdata,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }
  calculateGrandTotals() {
    this.totalInvoice = 0;
    this.totalReceipt = 0;
    this.totalCredit = 0;
    this.totalPending = 0;

    this.Filteredbookoutstandingdata.forEach((item: any) => {
      this.totalInvoice += Number(item["invoice_total"]);
      this.totalReceipt += Number(item["selecteamt_total"]);
      this.totalCredit += Number(item["crdtnote_total"]);
      this.totalPending += Number(item["remaining_amt"]);
    });
  }

  getPendingBilling() {
    if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 && a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 && a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 == undefined &&
      this.end_date1 == undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 == ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 != '' &&
      this.booksellername1 == '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname != '' &&
      this.repname1 == '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.office_rep_name
            .toLowerCase()
            .indexOf(this.officerepname.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else if (
      this.start_date1 != undefined &&
      this.end_date1 != undefined &&
      this.officerepname == '' &&
      this.repname1 != '' &&
      this.booksellername1 != '' &&
      this.book_name1 != ''
    ) {
      this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter(
        (a) =>
          a['invoice_date'] >= this.start_date1 &&
          a['invoice_date'] <= this.end_date1 &&
          a.rep_name.toLowerCase().indexOf(this.repname1.toLowerCase()) > -1 &&
          a.name.toLowerCase().indexOf(this.booksellername1.toLowerCase()) >
          -1 &&
          a.book_name.toLowerCase().indexOf(this.book_name1.toLowerCase()) >
          -1 &&
          a['remaining_amt'] > 0
      );
    } else {
      this.service.getBookOutStandingData().subscribe((data) => {
        this.bookoutstandingdata = data;
        this.Filteredbookoutstandingdata = this.bookoutstandingdata;

      });
    }

    this.dialog.open(ShowBookSellerOutstandingDataComponent, {
      data: {
        officerepname: this.officerepname,
        booksellerdata: this.Filteredbookoutstandingdata,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  imageChange = false;
  ImageUploads(event) {
    if (event.target.value == '') {
      this.imageChange = false;
    } else {
      this.imageChange = true;
    }
  }
saveBookSellerEntry1() {
  console.log(this.packsubform);

  if (this.packsubform.get('nameRequired').value == '' ||
      this.packsubform.get('nameRequired').value == null) {
    alert('Please enter Name before saving.');
    return;
  }

  let bookdata = {
    subno: this.packsubform.get('subscribersNo').value,
    title: this.packsubform.get('title').value,
    e_title: this.packsubform.get('titleEnglish').value,
    name: this.packsubform.get('nameRequired').value,
    e_name: this.packsubform.get('nameEnglish').value,
    address: this.packsubform.get('address').value,
    e_address: this.packsubform.get('e_address').value,
    e_address1: this.packsubform.get('e_address1').value,
    e_address2: this.packsubform.get('e_address2').value,
    pincode: this.packsubform.get('pincode').value,
    e_pincode: this.packsubform.get('pincodeEnglish').value,
    country: this.packsubform.get('country').value,
    e_country: this.packsubform.get('countryEnglish').value,
    state: this.packsubform.get('state').value,
    e_state: this.packsubform.get('stateEnglish').value,
    district: this.packsubform.get('district').value,
    e_district: this.packsubform.get('districtEnglish').value,
    taluka: this.packsubform.get('taluka').value,
    e_taluka: this.packsubform.get('talukaEnglish').value,
    mobileNumber: this.packsubform.get('mobileNumber').value,
    mobileNumberField: this.packsubform.get('mobileNumberField').value,
    telephone: this.packsubform.get('telephone').value,
    email: this.packsubform.get('email').value,
    dob: this.packsubform.get('dob').value,
    doa: this.packsubform.get('doa').value,
    repname: this.packsubform.get('representativeName').value,
    repmobno: this.packsubform.get('representativeMobile').value,
    gst_no: this.packsubform.get('gstNumber').value,
    remark: this.packsubform.get('remark').value,
    sellertype: this.packsubform.get('sellertype').value,
  };

  console.log({ bookdata });

  this.service.addSub(bookdata).subscribe(
    (data) => {
      this.bookSellerId = data['id'];

      window.alert('Book Seller Data Added Successfully...');

      this.packsubform.reset();
      this.bookselleravailable = true;

      this.getSubNames(null);
      this.getSubNo(null);
      this.getSubMobileNo(null);

      this.ngOnInit();
    },
    (_error) => {
      alert('Looks like Subscriber No. is already in use.');
      this.getSubNo(null);
    }
  );
}
  getSubNo(event) {
    if (event.target.value) {
      this.service.getSubNos(event.target.value).subscribe((res) => {
        // console.log(res);
        this.sub_no = res;
      });
    }
  }
updatebookseller1() {
  console.log(this.packsubform);

  if (!this.bookSellerId) {
    alert('No record selected to update.');
    return;
  }

  let bookdata = {
    id: this.bookSellerId,
    subno: this.packsubform.get('subscribersNo').value,
    title: this.packsubform.get('title').value,
    e_title: this.packsubform.get('titleEnglish').value,
    name: this.packsubform.get('nameRequired').value,
    e_name: this.packsubform.get('nameEnglish').value,
    address: this.packsubform.get('address').value,
    e_address: this.packsubform.get('e_address').value,
    e_address1: this.packsubform.get('e_address1').value,
    e_address2: this.packsubform.get('e_address2').value,
    pincode: this.packsubform.get('pincode').value,
    e_pincode: this.packsubform.get('pincodeEnglish').value,
    country: this.packsubform.get('country').value,
    e_country: this.packsubform.get('countryEnglish').value,
    state: this.packsubform.get('state').value,
    e_state: this.packsubform.get('stateEnglish').value,
    district: this.packsubform.get('district').value,
    e_district: this.packsubform.get('districtEnglish').value,
    taluka: this.packsubform.get('taluka').value,
    e_taluka: this.packsubform.get('talukaEnglish').value,
    mobileNumber: this.packsubform.get('mobileNumber').value,
    mobileNumberField: this.packsubform.get('mobileNumberField').value,
    telephone: this.packsubform.get('telephone').value,
    email: this.packsubform.get('email').value,
    dob: this.packsubform.get('dob').value,
    doa: this.packsubform.get('doa').value,
    repname: this.packsubform.get('representativeName').value,
    repmobno: this.packsubform.get('representativeMobile').value,
    gst_no: this.packsubform.get('gstNumber').value,
    remark: this.packsubform.get('remark').value,
    sellertype: this.packsubform.get('sellertype').value,
  };

  console.log({ bookdata });

  // this.service.updateBookSellerEntry(bookdata).subscribe(
  //   (data) => {
  //     window.alert('Book Seller Data Updated Successfully...');

  //     this.packsubform.reset();
  //     this.bookselleravailable = false;
  //     this.bookSellerId = null;

  //     this.getSubNames(null);
  //     this.getSubNo(null);
  //     this.getSubMobileNo(null);

  //     this.ngOnInit();
  //   },
  //   (_error) => {
  //     alert('Update failed. Please try again.');
  //   }
  // );
}

cancelEdit() {
  this.packsubform.reset();
  this.bookselleravailable = false;
  this.bookSellerId = null;
}
  book_id = 0;
  save() {
    if (!this.bookavailable) {
      this.uploader.uploadAll();

      setTimeout(() => {
        let bookbasicsdata = {
          bookname: this.BookForm.get('bookname').value,
          authorname: this.BookForm.get('authorname').value,
          bookdesc: this.BookForm.get('bookdesc').value,
          prakashanname: this.BookForm.get('prakashanname').value,
          // yearwisebook: this.BookForm.get('yearwisebook').value,
          bookpagesbw: this.BookForm.get('bookpagesbw').value,
          bkpinsidecolor: this.BookForm.get('bkpinsidecolor').value,
          bkpcover: this.BookForm.get('bkpcover').value,
          totalpages: this.BookForm.get('totalpages').value,
          booksize: this.BookForm.get('booksize').value,
          paperbw: this.BookForm.get('paperbw').value,
          paperinsidecolor: this.BookForm.get('paperinsidecolor').value,
          papercover: this.BookForm.get('papercover').value,
          binding: this.BookForm.get('binding').value,
          booklang: this.BookForm.get('booklang').value,
          book_img: this.BookForm.get('bookimg').value,
          isupcoming: this.BookForm.get('isupcoming').value,
          upcomingdate: this.BookForm.get('upcomingdate').value,
          bookcategory: this.BookForm.get('bookcategory').value,
          isgranth: this.entryType === 'granth' ? 'Y' : 'N',
        };

        this.service.AddNewBook(bookbasicsdata).subscribe((res) => {
          this.book_id = res['id'];

          let bookeditiondata = {
            bookid: this.book_id,
            bookyear: this.BookForm.value['bookyear'],
            bookprice: this.BookForm.value['price'],
            booksaleprice: this.BookForm.value['saleprice'],
            yearwisebook: this.BookForm.value['yearwisebook'],
            agentprice: this.BookForm.get('agentprice').value,
            discountupto: this.BookForm.value['discountupto'],
            bookedition: this.BookForm.value['bookedition'],
            bookedtndate: this.BookForm.value['bookedtndate'],
            bookedtncpoies: this.BookForm.value['bookedtncpoies'],
            opening_stock: this.BookForm.value['opening_stock'],
            author_honorarium: this.BookForm.value['author_honorarium'],
            deliverychargesinclude: this.BookForm.value['isdelivery'],
          };

          this.service
            .AddNewBookAvailableStock(
              this.book_id,
              this.BookForm.value['bookedition'],
              this.BookForm.value['bookedtncpoies'],
              this.BookForm.value['opening_stock']
            )
            .subscribe((data) => { });

          this.service.AddNewBookStock(bookeditiondata).subscribe((res) => {
            window.alert('Book added Successfully !');
            //fetching all books getAllBooks()
            this.service.getAllBookData().subscribe((data) => {
              this.bookData = data;
              this.bookdata = this.uniqueid(this.bookData, (it) => it.bookid);
              this.BookForm.reset();
            });
          });
        });
      }, 3000);
    } else {
      let bookeditiondata = {
        bookid: this.book_id,
        bookyear: this.BookForm.value['bookyear'],

        bookprice: this.BookForm.value['price'],
        booksaleprice: this.BookForm.value['saleprice'],
        yearwisebook: this.BookForm.value['yearwisebook'],
        agentprice: this.BookForm.value['agentprice'],
        discountupto: this.BookForm.value['discountupto'],
        bookedition: this.BookForm.value['bookedition'],
        bookedtndate: this.BookForm.value['bookedtndate'],
        bookedtncpoies: this.BookForm.value['bookedtncpoies'],
        opening_stock: this.BookForm.value['opening_stock'],
        author_honorarium: this.BookForm.value['author_honorarium'],
        deliverychargesinclude: this.BookForm.value['isdelivery'],
      };

      let total_copies = parseInt(this.BookForm.value['bookedtncpoies']);
      let available_stock = parseInt(this.BookForm.value['bookedtncpoies']);
      // for (let index = 0; index < Object.keys(this.bookData).length; index++) {
      //   if (this.bookData[index]['bookid'] == this.book_id) {
      //     total_copies = parseInt(this.bookData[index]['total_copies']);
      //     available_stock = parseInt(this.bookData[index]['available_stock']);
      //     break;
      //   }
      // }

      this.service
        .UpdateNewBookAvailableStock(
          this.book_id,
          this.BookForm.value['bookedition'],
          total_copies,
          available_stock
        )
        .subscribe((data) => { });

      this.service.AddNewBookStock(bookeditiondata).subscribe((res) => {
        window.alert('Book Edition added Successfully !');
        //fetching all books getAllBooks()
        this.service.getAllBookData().subscribe((data) => {
          this.bookData = data;
          this.bookdata = this.uniqueid(this.bookData, (it) => it.bookid);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        });
      });
    }
  }

  UpdateBookStock(id) {
    let book = this.bookStock.find((a) => {
      return a.bookid == id;
    });
    this.dialog.open(EditBookStockComponent, {
      data: {
        book: book,
        view: false,
      },
    });
  }

  EditBookDelivery(id) {
    let book = this.bookDeliveryData.find((a) => {
      return a.id == id;
    });
    this.dialog.open(EditBookDeliveryComponent, {
      data: {
        book: book,
        view: false,
      },
    });
  }

  EditDeliveredBook(id) {
    let book = this.FilteredDeliveryBooks.find((a) => {
      return a.id == id;
    });
    this.dialog.open(EditBookDeliveryComponent, {
      data: {
        book: book,
        view: true,
      },
    });
  }

  // ✅ Single consistent key
  readonly STORAGE_KEY = 'removedBookIds';

  // ✅ Load removed IDs once on init
  removedBookIds: number[] = JSON.parse(localStorage.getItem('removedBookIds') || '[]');

  markAsDelivered(book: any, index: number) {
    const dialogRef = this.dialog.open(BookstoresendmessageComponent, {
      data: { book },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.action === 'done' && result?.bookId != null) {

        // ✅ Save to localStorage
        const bookId = Number(result.bookId);
        if (!this.removedBookIds.includes(bookId)) {
          this.removedBookIds.push(bookId);
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.removedBookIds));
        }

        // ✅ Remove from UI instantly
        this.FilteredDeliveryManageBooks = this.FilteredDeliveryManageBooks.filter(
          item => Number(item.id) !== bookId
        );
        this.Filter = this.Filter.filter(
          item => Number(item.id) !== bookId
        );
      }
    });
  }


  // Optional: when loading the table, only show books not delivered

  loadBooks() {
    this.service.getAllBooks().subscribe((data: any) => {

      this.FilteredDeliveryManageBooks = data || [];

      // 🔥 apply stored removals AFTER data load
      this.applyStoredRemovals();

      this.Filter = [...this.FilteredDeliveryManageBooks];
    });
  }
  // getRemovedIds(): number[] {
  //   return (JSON.parse(localStorage.getItem('removedBookIds') || '[]'))
  //     .map((x: any) => Number(x));
  // }

  sub_data: any;
  getSubNames(event) {
    // console.log(event.target.value);
    if (event.target.value) {
      this.service.getSubNames(event.target.value).subscribe((res) => {
        // console.log(res);
        this.sub_data = res;
      });
    }
  }
  sub_mob_no: any;
  getSubMobileNo(event) {
    if (event.target.value.length >= 2) {
      this.service.getSubMobNos(event.target.value).subscribe((res) => {
        // console.log(res);
        this.sub_mob_no = res;
      });
    }
  }
  CancelBook(id) {
    if (window.confirm('Do you really want to cancel this book?')) {
      let cancel_date = formatDate(
        new Date(),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.service.CancelDeliveryStatus(id, cancel_date).subscribe((data) => {
        let singlebook = this.FilteredDeliveryManageBooks.find(
          (a) => (a['bid'] = id)
        );
        let bookstock = this.bookStock.find((a) => {
          return a.bookname == singlebook['book_name'];
        });
        this.updateCancelBookStock(bookstock, singlebook);
        window.alert('Book has been Canceled !');
        this.getAllDeliveryData();
      });
    }
  }

  updateCancelBookStock(bookstock, singlebook) {
    let new_available =
      parseInt(bookstock['available_stock']) + parseInt(singlebook['book_qty']);
    let new_total =
      parseInt(bookstock['total_stock']) + parseInt(singlebook['book_qty']);
    let updateDate = formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
    this.service.updateBookStock(bookstock['bs_id']).subscribe((bs) => {
      this.service
        .AddupdatedBookStock(
          bookstock['bookid'],
          new_total,
          new_available,
          'Cancel Book Added ' + updateDate
        )
        .subscribe((data) => {
          window.alert('Book Stock has been updated ');
        });
    });
  }

  FilteredDeliveryBooks = [];
  deliveredendDate;
  deliveredStartDate;

  getChangedDate() {
    if (
      this.range.get('start').value != null &&
      this.range.get('end').value != null
    ) {
      let startdate = formatDate(
        new Date(this.range.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      let endDate = formatDate(
        new Date(this.range.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.deliveredStartDate = startdate;
      this.deliveredendDate = endDate;
      this.FilteredDeliveryBooks = this.deliveredBooks.filter((a) => {
        return a['delivery_date'] >= startdate && a['delivery_date'] <= endDate;
      });
    }
  }
  update_delivery_mode1(item) {
    this.delivery_update_data = item
    this.delivery_mode_update_btn = true


    this.adddeliverymode.patchValue({
      deliverymode: item.delivery_mode,
    })
    // this.id = id;
    // this.service.deletedelmode(id).subscribe((_data) => {
    //   window.alert('Delivery Mode Delete Successfully...');
    //   this.ngOnInit();
    // });
  }
  delivery_mode2(id) {
    // this.id = id;
    this.service.deletedelmode1(id).subscribe((_data) => {
      window.alert('Delivery Mode Delete Successfully...');
      this.ngOnInit();
    });
  }

  cancel(book) {
    if (window.confirm('Do you really want to cancel receipt')) {

      this.service.getBookDataForCancel(book['rcpt_id']).subscribe((data) => {

        // 👉 CHECK IF API RETURNED ALERT MESSAGE
        if (data && data.message === "Please delete the receipt first") {
          window.alert("Please delete the receipt first");
          return; // 🚫 STOP cancellation
        }

        // ====== YOUR EXISTING LOGIC ======
        for (let index = 0; index < Object.keys(data).length; index++) {
          let available_stock;

          this.service.getBookDataforCancel(data[index]['book_name'])
            .subscribe((data1) => {

              available_stock =
                parseInt(data1[0]['available_stock']) +
                parseInt(data[index]['book_copies']);

              this.service.UpdateNewBookAvailableStock(
                data1[0]['bookid'],
                data1[0]['bookedition'],
                data1[0]['total_copies'],
                available_stock
              ).subscribe();
            });
        }

        this.service.UpdateRcptCancellation(book['rcpt_id']).subscribe(() => {
          window.alert('Receipt has been cancelled..');
          location.reload();
        });

      });
    }
  }

  cancelgranth(data: any[]) {
    if (window.confirm('Do you really want to cancel receipt')) {

      for (let index = 0; index < data.length; index++) {

        let available_stock = 0;

        this.service.getBookDataForCancelPackage(data[index]['book_name'])
          .subscribe((data1: any) => {

            if (data1 && data1.length > 0) {

              available_stock =
                parseInt(data1[0]['available_stock']) +
                parseInt(data[index]['book_copies']);

              this.service.UpdateNewBookAvailableStock(
                data1[0]['bookid'],
                data1[0]['bookedition'],
                data1[0]['total_copies'],
                available_stock
              ).subscribe(() => {
                console.log(`✅ Stock updated for ${data[index]['book_name']}`);
              });

            } else {
              console.warn(`❌ No book data found for ${data[index]['book_name']}`);
            }
          });
      }

    }
  }

  cancelseller(book: any) {
    if (!window.confirm('Do you really want to cancel receipt?')) return;

    // Step 1: Check for active payment receipts
    this.service.checkActiveReceipts(book['orderno']).subscribe(
      (resp: any) => {
        if (resp.exists) {
          window.alert('Please delete active book payment receipts first!');
          return; // Stop cancellation
        }

        // Step 2: Fetch books related to this receipt
        this.service.getBookDataForCancel(book['rcpt_id']).subscribe(
          (bookItems: any[]) => {
            // Step 3: Update stock for each book
            bookItems.forEach((item: any) => {
              this.service.getBookDataforCancel(item['book_name']).subscribe((data1: any) => {
                const available_stock =
                  parseInt(data1[0]['available_stock']) + parseInt(item['book_copies']);

                this.service.UpdateNewBookAvailableStock(
                  data1[0]['bookid'],
                  data1[0]['bookedition'],
                  data1[0]['total_copies'],
                  available_stock
                ).subscribe(
                  () => {
                    console.log(`Stock updated for book: ${item['book_name']}`);
                  },
                  (error) => {
                    console.error(`Failed to update stock for ${item['book_name']}:`, error);
                  }
                );
              });
            });

            // Step 4: Cancel the receipt
            this.service.UpdateRcptCancellation1(book['rcpt_id']).subscribe(
              () => {
                window.alert('Receipt has been cancelled successfully.');
                location.reload();
              },
              (error) => {
                console.error('Failed to cancel receipt:', error);
                window.alert('Failed to cancel receipt. Please try again.');
              }
            );
          },
          (error) => {
            console.error('Error fetching book data for cancellation:', error);
            window.alert('Failed to fetch book data for cancellation. Please try again.');
          }
        );
      },
      (error) => {
        console.error('Error checking active receipts:', error);
        window.alert('Could not check active receipts. Please try again.');
      }
    );
  }

  cancelsellerPackage(book: any) {
    if (!window.confirm('Do you really want to cancel receipt?')) return;

    // Step 1: Check for active payment receipts
    this.service.checkActiveReceiptsPackage(book['orderno']).subscribe(
      (resp: any) => {
        if (resp.exists) {
          window.alert('Please delete active book payment receipts first!');
          return; // Stop cancellation
        }

        // Step 2: Fetch books related to this receipt
        this.service.getBookDataForCancelPackage(book['rcpt_id']).subscribe(
          (bookItems: any[]) => {
            // Step 3: Update stock for each book
            bookItems.forEach((item: any) => {
              this.service.getBookDataforCancelPackage(item['book_name']).subscribe((data1: any) => {
                const available_stock =
                  parseInt(data1[0]['available_stock']) + parseInt(item['book_copies']);

                this.service.UpdateNewBookAvailableStock(
                  data1[0]['bookid'],
                  data1[0]['bookedition'],
                  data1[0]['total_copies'],
                  available_stock
                ).subscribe(
                  () => {
                    console.log(`Stock updated for book: ${item['book_name']}`);
                  },
                  (error) => {
                    console.error(`Failed to update stock for ${item['book_name']}:`, error);
                  }
                );
              });
            });

            // Step 4: Cancel the receipt
            this.service.UpdateRcptCancellation1(book['rcpt_id']).subscribe(
              () => {
                window.alert('Receipt has been cancelled successfully.');
                location.reload();
              },
              (error) => {
                console.error('Failed to cancel receipt:', error);
                window.alert('Failed to cancel receipt. Please try again.');
              }
            );
          },
          (error) => {
            console.error('Error fetching book data for cancellation:', error);
            window.alert('Failed to fetch book data for cancellation. Please try again.');
          }
        );
      },
      (error) => {
        console.error('Error checking active receipts:', error);
        window.alert('Could not check active receipts. Please try again.');
      }
    );
  }

  custname = '';
  repname = '';
  manageStartDate;
  manageendDate;
  dateIsEnableReport: boolean = false;

  // getChangedDate_managebook() {

  //   const startValue = this.Managerange.get('start')?.value;
  //   const endValue = this.Managerange.get('end')?.value;

  //   if (startValue != null && endValue != null) {

  //     const startDateObj = new Date(startValue);
  //     const endDateObj = new Date(endValue);

  //     const min = new Date(this.financialYearMin);
  //     const max = new Date(this.financialYearMax);

  //     let startdate = formatDate(
  //       startDateObj,
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );

  //     let endDate = formatDate(
  //       endDateObj,
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );

  //     // ✅ VALIDATION (fixed variables)
  //     if (startDateObj < min || startDateObj > max) {
  //       alert('Date is outside the allowed range.');

  //       this.Managerange.get('start')?.setValue(null);
  //       this.Managerange.get('end')?.setValue(null);

  //       return;
  //     }

  //     this.manageStartDate = startdate;
  //     this.manageendDate = endDate;

  //     this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter((a) => {
  //       const bookingDate = new Date(a['bookingdate']);

  //       return (
  //         bookingDate >= startDateObj &&
  //         bookingDate <= endDateObj
  //       );
  //     });

  //   } else {
  //     this.dateIsEnableReport = false;
  //     return;
  //   }
  // }

getChangedDate_managebook() {

  const startValue = this.Managerange.get('start')?.value;
  const endValue = this.Managerange.get('end')?.value;

  if (startValue != null && endValue != null) {

    const startDateObj = new Date(startValue);
    const endDateObj = new Date(endValue);

    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    let startdate = formatDate(
      startDateObj,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    let endDate = formatDate(
      endDateObj,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    // ✅ VALIDATION (fixed variables)
    if (startDateObj < min || startDateObj > max) {
      alert('Date is outside the allowed range.');

      this.Managerange.get('start')?.setValue(null);
      this.Managerange.get('end')?.setValue(null);

      return;
    }

    this.manageStartDate = startdate;
    this.manageendDate = endDate;

    // ✅ ADDED GUARD — bookdeliverydata may not be loaded yet
    if (!this.bookdeliverydata || !Array.isArray(this.bookdeliverydata)) {
      console.warn('getChangedDate_managebook: bookdeliverydata not ready yet');
      this.FilteredDeliveryManageBooks = [];
      return;
    }

    this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter((a) => {
      const bookingDate = new Date(a['bookingdate']);

      return (
        bookingDate >= startDateObj &&
        bookingDate <= endDateObj
      );
    });

  } else {
    this.dateIsEnableReport = false;
    return;
  }
}


  //   getpincode(event) {
  //   debugger
  //   this.pincodes = event.value;
  //   // this.filteredLabelDispatchData();
  // }

  getRep_name(repname) {
    if (this.custname != '') {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.name.toLowerCase().indexOf(this.custname.toLowerCase()) > -1 &&
            item.rep.toLowerCase().indexOf(repname.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.rep.toLowerCase().indexOf(repname.toLowerCase()) > -1
          );
        }
      );
    }
  }

  reset_repname(event) {
    this.repname = '';

    if (this.custname != '') {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.name.toLowerCase().indexOf(this.custname.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate
          );
        }
      );
    }
  }

  getcust_name(cust_name) {
    if (this.repname != '') {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.name.toLowerCase().indexOf(cust_name.toLowerCase()) > -1 &&
            item.rep.toLowerCase().indexOf(this.repname.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.name.toLowerCase().indexOf(cust_name.toLowerCase()) > -1
          );
        }
      );
    }
  }

  reset_custname(event) {
    this.custname = '';

    if (this.repname != '') {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate &&
            item.rep.toLowerCase().indexOf(this.repname.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
        (item) => {
          return (
            item['bookingdate'] >= this.manageStartDate &&
            item['bookingdate'] <= this.manageendDate
          );
        }
      );
    }
  }

  cust_name_delivery = '';
  getcust_name_deliveredBook(cust_name_delivery) {
    this.FilteredDeliveryBooks = this.deliveredBooks.filter((item) => {
      return (
        item['delivery_date'] >= this.deliveredStartDate &&
        item['delivery_date'] <= this.deliveredendDate &&
        item.name.toLowerCase().indexOf(cust_name_delivery.toLowerCase()) > -1
      );
    });
  }

  reset_custname_deliveredBook(event) {
    this.cust_name_delivery = '';

    this.FilteredDeliveryBooks = this.bookDeliveryData.filter((item) => {
      return (
        item['delivery_date'] >= this.deliveredStartDate &&
        item['delivery_date'] <= this.deliveredendDate
      );
    });
  }

  FilteredBookRegistration = [];
  startDate_registration = '';
  enddate_registration = '';
  cust_name_registration = '';
  selectedCommissionFilter = '';
  rep_name_registration = '';
  selectedComplimentaryFilter = '';
  book_name_registration = '';

  getChangedDateRegistration() {
    if (
      this.rangeRegistration.get('start').value != null &&
      this.rangeRegistration.get('end').value != null
    ) {
      let startdate = formatDate(
        new Date(this.rangeRegistration.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      let endDate = formatDate(
        new Date(this.rangeRegistration.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.startDate_registration = startdate;
      this.enddate_registration = endDate;

      this.FilteredBookRegistration1 = this.bookregistrationdata.filter((a) => {
        return (
          new Date(a['booking_date']) >= new Date(startdate) &&
          new Date(a['booking_date']) <= new Date(endDate)
        );
      });
      console.log("FilteredBookRegistration1", this.FilteredBookRegistration1);
      this.bookCopiesTotal = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
        this.shippingCharges += parseInt(data.shipping_charges) || 0;
        this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
        this.recvTotal += parseInt(data.receivedamt) || 0;
        this.creditTotal += parseInt(data.crdtamt) || 0;
        this.remTotal += parseInt(data.remainingamt) || 0;




      }
    }
  }



  filterCommissionData(selectedValue: string): void {
    switch (selectedValue) {
      case 'paidCommission':
        this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => item.receivedamt > 0);
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;

      case 'unpaidCommission':
        this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => item.remainingamt > 0);
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;

      case 'All':
      default:
        this.FilteredBookRegistration1 = [...this.bookregistrationdata];
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;
    }
  }

  filterCommissionData1(selectedValue: string): void {
    switch (selectedValue) {
      case 'Y':
        this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => item.iscomplimentary === 'Y');
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;

      case 'N':
        this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => item.iscomplimentary === 'N');
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;

      case 'All':
      default:
        this.FilteredBookRegistration1 = [...this.bookregistrationdata];
        this.bookCopiesTotal = 0;
        this.shippingCharges = 0;
        this.totalTotal = 0;
        this.recvTotal = 0;
        this.creditTotal = 0;
        this.remTotal = 0;

        for (let data of this.FilteredBookRegistration1) {
          this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
          this.shippingCharges += parseInt(data.shipping_charges) || 0;
          this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
          this.recvTotal += parseInt(data.receivedamt) || 0;
          this.creditTotal += parseInt(data.crdtamt) || 0;
          this.remTotal += parseInt(data.remainingamt) || 0;




        }
        break;
    }
  }



  searchBookRegistration() {
    debugger
    this.FilteredBookRegistration1 = [];
    this.bookregistrationdata = []; // initialize if needed

    const payload = {
      start_date: formatDate(new Date(this.rangeRegistration.value.start), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
      end_date: formatDate(new Date(this.rangeRegistration.value.end), 'yyyy-MM-dd', 'en-IN', 'GMT+0530'),
      // FilteredBookRegistration1: this.FilteredBookRegistration1,
      // reportType: this.contractReportType,
      // startDate: this.fixDate(this.rangeRegistration.value.start),
      // endDate: this.fixDate(this.rangeRegistration.value.end),
      rep_name: this.rangeRegistration.value.repwise,
      office_rep_name: this.rangeRegistration.value.officerepwise || '',
      book_seller_name: this.rangeRegistration.value.cust_name,
      book_name: this.rangeRegistration.value.bookwise, // ✅ FIXED
      commissionFilter: this.selectedCommissionFilter || '', // Added
      complimentaryFilter: this.selectedComplimentaryFilter || '', // Added
    };

    this.service.getBookRegistrationReport(payload).subscribe((data: any) => {
      this.FilteredBookRegistration1 = [];

      for (let index = 0; index < data.length; index++) {
        const item = data[index];

        this.FilteredBookRegistration1.push({
          booking_date: item.booking_date,
          id: item.id,
          orderno: item.oder_no,
          name: item.book_seller_name,
          receiver_address: item.district || '',
          district: item.district || '',
          mob_no: item.mobile_no || '',
          crep_name: item.rep_name || '',
          office_rep_name: item.office_rep_name || '',
          bookname: item.book_name || '',
          bookcopies: parseInt(item.book_copies) || 0,
          return_copies: parseInt(item.return_copies) || 0,
          available_stock: parseInt(item.available_stock) || 0,
          iscomplimentary: item.is_complimentary || '',
          complimentaryOption: item.complimentaryOption || '',
          bookprice: parseFloat(item.book_price) || 0,
          prakashan_name: item.prakashan_name || '',
          totalafterdiscount: parseFloat(item.totalafterdiscount) || 0,
          total: parseFloat(item.total) || 0,
          shipping_charges: parseFloat(item.shipping_charges) || 0,
          receivedamt: parseFloat(item.received_amt) || 0,
          crdtamt: parseFloat(item.credit_amt) || 0,
          remainingamt: parseFloat(item.remaining_amt) || 0,
          invoiceno: item.invoice_no || '',
          rcptno: '',
          repcommissionamt: parseFloat(item.rep_commission_amt) || 0,
          delivery_mode: item.delivery_mode || ''
        });
      }

      // Reset totals
      this.bookCopiesTotal = 0;
      this.bookretrunCopiesTotal = 0;
      this.availableStock = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;
      this.repCommissionTotal = 0; // ✅ NEW

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += data.bookcopies;
        this.bookretrunCopiesTotal += data.return_copies;
        this.availableStock += data.available_stock;
        this.shippingCharges += data.shipping_charges;
        this.totalTotal += data.total + data.shipping_charges;
        this.recvTotal += data.receivedamt;
        this.creditTotal += data.crdtamt;
        this.remTotal += data.remainingamt;
        this.repCommissionTotal += data.repcommissionamt; // ✅ NEW
      }

      console.log("FilteredBookRegistration1:", this.FilteredBookRegistration1);
    });
  }


  advtInvoiceReportType;
  getAdvtInvoiceReportType(e) {
    this.advtInvoiceReportType = e.value;
  }

  openAdvtInvoiceRegister() {
    debugger

    // this.issuedatelist = this.advtinvoiceForm.value.issuedate.split(',')[0];
    this.dialog.open(BooksellerbillingregisterreportComponent, {
      data: {
        startDate: this.fixDate(this.BookbillingRegister.value.start),
        endDate: this.fixDate(this.BookbillingRegister.value.end),
        customername: this.BookbillingRegister.value.cust_name,
        rep_name: this.BookbillingRegister.value.repwise || '',
        office_rep_name: this.BookbillingRegister.value.officerepwise || '',

        reportType: this.advtInvoiceReportType,

      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    });
  }
  openAdvtInvoiceRegister1() {

    const formValue = this.businessForm.value;

    const dialogData = {
      startDate: this.fixDate(formValue.start),
      endDate: this.fixDate(formValue.end),
      office_rep_name: formValue.officerepwise || '',
      district: formValue.district || '',
      taluka: formValue.taluka || '',
      reportType: this.advtInvoiceReportType
    };

    // ✅ CONDITION BASED OPEN
    if (this.advtInvoiceReportType === 'In Detail') {

      this.dialog.open(BusinessReportIndetailComponentComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    } else if (this.advtInvoiceReportType === 'Briefly') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(BusinessReportComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }
    else if (this.advtInvoiceReportType === 'Monthwise') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(MonthwiseReportComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }
    else if (this.advtInvoiceReportType === 'office Rep In Detail') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(BusinessReportVeryBriefly1Component, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }
    else if (this.advtInvoiceReportType === 'bookwise') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(BookwiseReportComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }
    else if (this.advtInvoiceReportType === 'Office Rep -Briefly') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(OfficeRepMonthwiseReportComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }

  }
 openGranthInvoiceRegister1() {

    const formValue = this.businessForm.value;

    const dialogData = {
      startDate: this.fixDate(formValue.start),
      endDate: this.fixDate(formValue.end),
      office_rep_name: formValue.officerepwise || '',
      district: formValue.district || '',
      taluka: formValue.taluka || '',
      reportType: this.advtInvoiceReportType
    };

    // ✅ CONDITION BASED OPEN
    if (this.advtInvoiceReportType === 'In Detail') {

      this.dialog.open(BusinessReportIndetailGranthComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    } else if (this.advtInvoiceReportType === 'Briefly') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(BussinessReportBriflyGranthComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }

    else if (this.advtInvoiceReportType === 'office Rep In Detail') {

      // ✅ THIS IS YOUR SECOND REPORT
      this.dialog.open(GranthBussinessOfficeRepIndetailsComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }
  
    else if (this.advtInvoiceReportType === 'Office Rep -Briefly') {

    
      this.dialog.open(GranthBussinessOfficeRepIndetailsofficerepwiseComponent, {
        data: dialogData,
        width: '1200px',
        height: '90vh',
        maxWidth: '100%'
      });

    }

  }


  getRep_name_registration(repname) {
    if (this.cust_name_registration != '') {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name
              .toLowerCase()
              .indexOf(this.cust_name_registration.toLowerCase()) > -1 &&
            item.crep_name.toLowerCase().indexOf(repname.toLowerCase()) > -1
          );
        }
      );

      this.bookCopiesTotal = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
        this.shippingCharges += parseInt(data.shipping_charges) || 0;
        this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
        this.recvTotal += parseInt(data.receivedamt) || 0;
        this.creditTotal += parseInt(data.crdtamt) || 0;
        this.remTotal += parseInt(data.remainingamt) || 0;




      }
    } else {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.crep_name.toLowerCase().indexOf(repname.toLowerCase()) > -1
          );
        }
      );
      this.bookCopiesTotal = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
        this.shippingCharges += parseInt(data.shipping_charges) || 0;
        this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
        this.recvTotal += parseInt(data.receivedamt) || 0;
        this.creditTotal += parseInt(data.crdtamt) || 0;
        this.remTotal += parseInt(data.remainingamt) || 0;




      }
    }
    this.bookCopiesTotal = 0;
    this.shippingCharges = 0;
    this.totalTotal = 0;
    this.recvTotal = 0;
    this.creditTotal = 0;
    this.remTotal = 0;

    for (let data of this.FilteredBookRegistration1) {
      this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
      this.shippingCharges += parseInt(data.shipping_charges) || 0;
      this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
      this.recvTotal += parseInt(data.receivedamt) || 0;
      this.creditTotal += parseInt(data.crdtamt) || 0;
      this.remTotal += parseInt(data.remainingamt) || 0;




    }
  }

  getRepNameRegistration(repName: string, isOfficeRep: boolean = false) {

    this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => {

      const bookingDateMatch =
        item.booking_date >= this.startDate_registration &&
        item.booking_date <= this.enddate_registration;

      const customerMatch = this.cust_name_registration
        ? item.name.toLowerCase()
          .includes(this.cust_name_registration.toLowerCase())
        : true;

      const repMatch = isOfficeRep
        ? item.office_rep_name?.toLowerCase().includes(repName.toLowerCase())
        : item.crep_name?.toLowerCase().includes(repName.toLowerCase());

      return bookingDateMatch && customerMatch && repMatch;
    });

    // this.calculateTotals();
  }

  reset_repname_registration(event) {
    this.rep_name_registration = '';

    if (this.cust_name_registration != '') {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name
              .toLowerCase()
              .indexOf(this.cust_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration
          );
        }


      );
    }
  }

  getcust_name_registration(cust_name) {
    if (this.rep_name_registration != '') {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name.toLowerCase().indexOf(cust_name.toLowerCase()) > -1 &&
            item.crep_name
              .toLowerCase()
              .indexOf(this.rep_name_registration.toLowerCase()) > -1
          );
        }
      );

      this.bookCopiesTotal = 0;
      this.shippingCharges = 0;
      this.totalTotal = 0;
      this.recvTotal = 0;
      this.creditTotal = 0;
      this.remTotal = 0;

      for (let data of this.FilteredBookRegistration1) {
        this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
        this.shippingCharges += parseInt(data.shipping_charges) || 0;
        this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
        this.recvTotal += parseInt(data.receivedamt) || 0;
        this.creditTotal += parseInt(data.crdtamt) || 0;
        this.remTotal += parseInt(data.remainingamt) || 0;

      }
    } else {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name.toLowerCase().indexOf(cust_name.toLowerCase()) > -1
          );
        }
      );
    }
    this.bookCopiesTotal = 0;
    this.shippingCharges = 0;
    this.totalTotal = 0;
    this.recvTotal = 0;
    this.creditTotal = 0;
    this.remTotal = 0;

    for (let data of this.FilteredBookRegistration1) {
      this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
      this.shippingCharges += parseInt(data.shipping_charges) || 0;
      this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
      this.recvTotal += parseInt(data.receivedamt) || 0;
      this.creditTotal += parseInt(data.crdtamt) || 0;
      this.remTotal += parseInt(data.remainingamt) || 0;
    }
  }

  getbook_name_registration(b_name) {
    if (this.rep_name_registration != '') {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name.toLowerCase().indexOf(b_name.toLowerCase()) > -1 &&
            item.crep_name
              .toLowerCase()
              .indexOf(this.rep_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.name.toLowerCase().indexOf(b_name.toLowerCase()) > -1
          );
        }
      );
    }
  }

  reset_custname_registration(event) {
    this.cust_name_registration = '';

    if (this.rep_name_registration != '') {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration &&
            item.crep_name
              .toLowerCase()
              .indexOf(this.rep_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
        (item) => {
          return (
            item['booking_date'] >= this.startDate_registration &&
            item['booking_date'] <= this.enddate_registration
          );
        }
      );
    }
  }

  paymentStatus = '';
  FilterPayment(event) {
    let status = event.value;
    this.paymentStatus = status;

    if (this.rep_name_registration != '' && this.cust_name_registration != '') {
      this.FilteredBookRegistration = this.bookregistrationdetails.filter(
        (item) => {
          return (
            item['received_date'] >= this.startDate_registration &&
            item['received_date'] <= this.enddate_registration &&
            item.payment_status.toLowerCase().indexOf(status.toLowerCase()) >
            -1 &&
            item.name
              .toLowerCase()
              .indexOf(this.cust_name_registration.toLowerCase()) > -1 &&
            item.rep_name
              .toLowerCase()
              .indexOf(this.rep_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else if (this.cust_name_registration == '' || status == 'all') {
      this.FilteredBookRegistration = this.bookregistrationdetails.filter(
        (item) => {
          return (
            item['received_date'] >= this.startDate_registration &&
            item['received_date'] <= this.enddate_registration &&
            item.payment_status.toLowerCase().indexOf(status.toLowerCase()) >
            -1 &&
            item.rep_name
              .toLowerCase()
              .indexOf(this.rep_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else if (this.rep_name_registration == '' || status == 'all') {
      this.FilteredBookRegistration = this.bookregistrationdetails.filter(
        (item) => {
          return (
            item['received_date'] >= this.startDate_registration &&
            item['received_date'] <= this.enddate_registration &&
            item.payment_status.toLowerCase().indexOf(status.toLowerCase()) >
            -1 &&
            item.name
              .toLowerCase()
              .indexOf(this.cust_name_registration.toLowerCase()) > -1
          );
        }
      );
    } else {
      this.FilteredBookRegistration = this.bookregistrationdetails.filter(
        (item) => {
          return (
            item['received_date'] >= this.startDate_registration &&
            item['received_date'] <= this.enddate_registration
          );
        }
      );
    }
  }

  ischecked = false;
  getMarkAsDevliveryValue(event) { }



  getContractDetails() {
    debugger
    this.bookwisereplist.forEach((book) => {
      if (book['rep_name']) {
        this.contractRepName.push({ name: book['rep_name'] });
      }
      if (book['off_rep_name']) {
        this.contractOffRepName.push({ name: book['off_rep_name'] });
      }
      if (book['advt_name']) {
        this.contractAdvtName.push({ name: book['advt_name'] });
      }
    });
    console.log("representativename", this.contractRepName.length)

    this.contractRepName = this.uniqueid(this.contractRepName, (a) => a.name);
    this.contractOffRepName = this.uniqueid(
      this.contractOffRepName,
      (a) => a.name
    );
    this.contractAdvtName = this.uniqueid(this.contractAdvtName, (a) => a.name);
  }
  calculateCommissionTotals(): void {

    this.totalInvoiceAmount = 0;
    this.totalReceivedAmount = 0;
    this.totalCommission = 0;
    this.totalPaidCommission = 0;
    this.totalUnpaidCommission = 0;

    this.repcommissiondata.forEach((rep: any) => {

      this.totalInvoiceAmount += Number(rep.invoice_total || 0);
      this.totalReceivedAmount += Number(rep.invoice_received_amt || 0);
      this.totalCommission += Number(rep.rep_commission_amt || 0);
      this.totalPaidCommission += Number(rep.received_amt || 0);
      this.totalUnpaidCommission += Number(rep.remaining_amt || 0);

    });
  }

  getBookNameRegistration(event: any) {
    const value = event.target.value?.trim();

    if (value && value.length >= 1) {
      this.service.getBookNameList(value).subscribe((res: any[]) => {
        this.filteredBookNames = res || [];
      });
    } else {
      this.filteredBookNames = [];
    }
  }

  getbookrcptStartDate;
  getbookrcptEndDate;
  getBookReceiptDateRange() {
    if (
      this.bookrcptregisterform.get('start').value != null &&
      this.bookrcptregisterform.get('end').value != null
    ) {
      this.getbookrcptStartDate = formatDate(
        new Date(this.bookrcptregisterform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.getbookrcptEndDate = formatDate(
        new Date(this.bookrcptregisterform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate)
          );
        }
      );
    }
  }
  getBookReceiptDateRange1() {

    if (
      this.bookrcptregisterform.get('start').value != null &&
      this.bookrcptregisterform.get('end').value != null
    ) {

      const startValue = this.bookrcptregisterform.get('start').value;
      const endValue = this.bookrcptregisterform.get('end').value;

      const startDateObj = new Date(startValue);
      const endDateObj = new Date(endValue);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      this.getbookrcptStartDate = formatDate(
        startDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.getbookrcptEndDate = formatDate(
        endDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      // ✅ kept same logic, only fixed variables
      if (startDateObj < min || startDateObj > max) {
        alert('Date is outside the allowed range.');
        this.bookrcptregisterform.get('start')?.setValue(null);
        this.bookrcptregisterform.get('end')?.setValue(null);
      }

    } else {
      this.dateIsEnableReport = false;
      return;
    }

    this.FilteredbookCrdtdata = this.bookRcptRegisterdata.filter((a) => {
      return (
        new Date(a['crdtnote_date']) >= new Date(this.getbookrcptStartDate) &&
        new Date(a['crdtnote_date']) <= new Date(this.getbookrcptEndDate)
      );
    });

  }

  getbookcommrcptStartDate;
  getbookcommrcptEndDate;
  // getBookCommReceiptDateRange() {
  //   if (
  //     this.bookcommrcptform.get('start').value != null &&
  //     this.bookcommrcptform.get('end').value != null
  //   ) {
  //     this.getbookcommrcptStartDate = formatDate(
  //       new Date(this.bookcommrcptform.get('start').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );

  //     this.getbookcommrcptEndDate = formatDate(
  //       new Date(this.bookcommrcptform.get('end').value),
  //       'yyyy-MM-dd',
  //       'en-IN',
  //       'GMT+0530'
  //     );

  //     this.FilteredCommbookRcptRegisterdata = this.bookRcptCommisionRegisterdata.filter(
  //       (a) => {
  //         return (
  //           new Date(a['commission_date']) >=
  //           new Date(this.getbookcommrcptStartDate) &&
  //           new Date(a['commission_date']) <= new Date(this.getbookcommrcptEndDate)
  //         );
  //       }
  //     );
  //   }
  // }



  getBookInvoiceDateRange() {

    const startValue = this.bookrepcommisionform.get('start')?.value;
    const endValue = this.bookrepcommisionform.get('end')?.value;

    if (startValue != null && endValue != null) {

      const startDateObj = new Date(startValue);
      const endDateObj = new Date(endValue);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ✅ validation (your same style)


    } else {
      this.dateIsEnableReport = false;
      return;
    }

    // 🔴 IMPORTANT SAFETY CHECK (prevents TS/runtime error)
    if (!startValue || !endValue) {
      this.Filteredrepcommissiondata = [];
      return;
    }

    // ✅ formatting
    this.getbookrcptStartDate = formatDate(
      new Date(startValue),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.getbookrcptEndDate = formatDate(
      new Date(endValue),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

    this.dateIsEnableReport = true;

    // ✅ filter
    this.Filteredrepcommissiondata = this.repcommissiondata.filter((a) => {

      const invoiceDate = new Date(a['invoice_date']);

      // return (
      //   invoiceDate >= startDateObj &&
      //   invoiceDate <= endDateObj
      // );
    });

    console.log('Filteredrepcommissiondata', this.Filteredrepcommissiondata);
  }
  getBookOutdtandingDateRange8() {

    const start = this.bookcommrcptform.get('start')?.value;
    const end = this.bookcommrcptform.get('end')?.value;

    if (start && end) {

      const startDateObj = new Date(start);
      const endDateObj = new Date(end);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ✅ YOUR CONDITION APPLIED
      if (startDateObj < min || startDateObj > max) {
        alert('Date is outside the allowed range.');

        this.bookcommrcptform.get('start')?.setValue(null);
        this.bookcommrcptform.get('end')?.setValue(null);

        return;
      }

      this.dateIsEnableReport = true;

    } else {
      this.dateIsEnableReport = false;
      return;
    }
  }
  calculateBookOutstandingTotals(): void {

    this.totalInvoice = 0;
    this.totalReceipt = 0;
    this.totalCredit = 0;
    this.totalPending = 0;

    if (!this.Filteredbookoutstandingdata || this.Filteredbookoutstandingdata.length === 0) {
      return;
    }

    this.Filteredbookoutstandingdata.forEach((item: any) => {

      this.totalInvoice += Number(item.invoice_total || 0);
      this.totalReceipt += Number(item.selecteamt_total || 0);
      this.totalCredit += Number(item.crdtnote_total || 0);
      this.totalPending += Number(item.remaining_amt || 0);

    });
  }

  getbookoutStartDate;
  getbookoutEndDate;
  getBookOutdtandingDateRange() {

    if (
      this.bookoutstandingform.get('start').value != null &&
      this.bookoutstandingform.get('end').value != null
    ) {

      const startValue = this.bookoutstandingform.get('start').value;
      const endValue = this.bookoutstandingform.get('end').value;

      const startDateObj = new Date(startValue);
      const endDateObj = new Date(endValue);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      this.getbookoutStartDate = formatDate(
        startDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.getbookoutEndDate = formatDate(
        endDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      // ✅ fixed validation (same logic, corrected variables)
      //  if (startDateObj < min || startDateObj > max) {
      //    alert('Date is outside the allowed range.');
      //    this.bookoutstandingform.get('start')?.setValue(null);
      //    this.bookoutstandingform.get('end')?.setValue(null);
      //  }

    } else {
      this.dateIsEnableReport = false;
      return;
    }

    this.Filteredbookoutstandingdata = this.bookoutstandingdata.filter((a) => {
      return (
        new Date(a['invoice_date']) >= new Date(this.getbookoutStartDate) &&
        new Date(a['invoice_date']) <= new Date(this.getbookoutEndDate)
      );
    });

    console.log('Filteredbookoutstandingdata', this.Filteredbookoutstandingdata);
  }
  getBookOutdtandingDateRange1() {

    const start = this.Sendreminderform.get('start')?.value;
    const end = this.Sendreminderform.get('end')?.value;

    if (start && end) {

      const startDateObj = new Date(start);
      const endDateObj = new Date(end);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ✅ validation FIRST (fixed variables)
      // if (startDateObj < min || startDateObj > max) {
      //   alert('Date is outside the allowed range.');
      //   this.Sendreminderform.get('start')?.setValue(null);
      //   this.Sendreminderform.get('end')?.setValue(null);
      //   return;
      // }

      this.getbookoutStartDate = formatDate(
        start,
        'yyyy-MM-dd',
        'en-IN'
      );

      this.getbookoutEndDate = formatDate(
        end,
        'yyyy-MM-dd',
        'en-IN'
      );

    } else {
      this.dateIsEnableReport = false;
      return;
    }

    this.Filteredbookoutstandingdata =
      this.bookoutstandingdata.filter(a => {

        const invDate = new Date(a.invoice_date);

        return invDate >= new Date(this.getbookoutStartDate)
          && invDate <= new Date(this.getbookoutEndDate);

      });

    console.log(
      'Reminder Filtered Data : ',
      this.Filteredbookoutstandingdata
    );
  }






  repnamewise = '';
  getrepwise(event) {
    this.repnamewise = event.target.value;

    if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1
          );
        }
      );
    } else if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1
          );
        }
      );
    }
  }

  billnowise = '';
  getbillnowise(event) {
    this.billnowise = event.target.value;
    if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null &&
      this.billnowise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1 &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1 &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null &&
      this.billnowise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) > -1
          );
        }
      );
    }
  }

  booksellerwise = '';
  getbooksellerwise(event) {
    debugger
    this.booksellerwise = event.target.value;
    if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null &&
      this.billnowise != '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1 &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) >
            -1 &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise != '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1 &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) >
            -1 &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null &&
      this.billnowise != '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) >
            -1 &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise != '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.bill_no.toLowerCase().indexOf(this.billnowise.toLowerCase()) >
            -1 &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate != null &&
      this.getbookrcptEndDate != null &&
      this.billnowise == '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            new Date(a['receipt_date']) >=
            new Date(this.getbookrcptStartDate) &&
            new Date(a['receipt_date']) <= new Date(this.getbookrcptEndDate) &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise != '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise == '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.rep_name.toLowerCase().indexOf(this.repnamewise.toLowerCase()) >
            -1 &&
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.repnamewise == '' &&
      this.getbookrcptStartDate == null &&
      this.getbookrcptEndDate == null &&
      this.billnowise == '' &&
      this.booksellerwise != ''
    ) {
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata.filter(
        (a) => {
          return (
            a.book_seller_name
              .toLowerCase()
              .indexOf(this.booksellerwise.toLowerCase()) > -1
          );
        }
      );
    }
  }
  getCountry1(event) {
    // console.log(event);
    // console.log(event.value);
    let country = this.countries.find((a) => a.country_name == event.value);
    if (country != undefined) {
      this.service.getState(country['country_code']).subscribe((data) => {
        this.states = data;
        // console.log(this.states);
      });
    } else {
    }
  } //getcountry

  // showigst = false;
  getState1(event) {
    // console.log(event);
    // console.log(event.value);
    // this.selectedState = this.states['state_id'];
    let state = this.states.find((a) => a.state_name == event.value);
    // console.log(state);
    // console.log(this.states);
    if (state != undefined) {
      if (
        state.state_name != 'Maharashtra' ||
        state.state_name != 'महाराष्ट्र'
      ) {
        this.showigst = true;
      } else {
        this.showigst = false;
      }

      this.service
        .getDistrict(parseInt(state['state_id']))
        .subscribe((data) => {
          this.cities = data;
          this.selectedCity = this.cities['district_name'];
          // console.log(this.cities);
        });
    } else {
    }
  } //get state

  getDistricts1(event) {
    console.log(event.value);
    this.selectedCity = this.cities['district_id'];
    let district = this.cities.find((a) => a.district_name == event.value);
    if (district != undefined) {

      const req = {
        "district_id": [district['district_id']]
      }
      this.service.getTaluka1(req).subscribe((data) => {
        this.talukas = data;
        this.selectedTaluka = this.talukas['taluka_name'];
      });
    }
  }

  getbookcrdtStartDate;
  getbookcrdtEndDate;
  getBookCreditDateRange() {
    if (
      this.booksellercrdtnoteform.get('start').value != null &&
      this.booksellercrdtnoteform.get('end').value != null
    ) {
      this.getbookcrdtStartDate = formatDate(
        new Date(this.booksellercrdtnoteform.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getbookcrdtEndDate = formatDate(
        new Date(this.booksellercrdtnoteform.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

    }
  }

  getbookwiseStartDate;
  getbookwiseEndDate;
  getBookDateRange() {
    if (
      this.BookrangeRegistration.get('start').value != null &&
      this.BookrangeRegistration.get('end').value != null
    ) {
      this.getbookwiseStartDate = formatDate(
        new Date(this.BookrangeRegistration.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getbookwiseEndDate = formatDate(
        new Date(this.BookrangeRegistration.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      //this.FilteredBookRegistration = this.bookregistrationdetails.filter(a => { return new Date(a['received_date']) >= new Date(startdate) && new Date(a['received_date']) <= new Date(endDate) });
    }
  }

  getbookbillingStartDate;
  getbookbillingEndDate;
  getBookBillingDateRange() {
    if (
      this.BookbillingRegister.get('start').value != null &&
      this.BookbillingRegister.get('end').value != null
    ) {
      this.getbookbillingStartDate = formatDate(
        new Date(this.BookbillingRegister.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getbookbillingEndDate = formatDate(
        new Date(this.BookbillingRegister.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate
        );
      });

      this.calculateBookBillingData();
    }
  }

  applyDateValidation() {

    const startValue = this.businessForm.get('start')?.value;
    const endValue = this.businessForm.get('end')?.value;

    // if one is empty, do nothing
    if (!startValue || !endValue) return;

    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    // ❌ Rule 1: Start should not be greater than End
    if (startDate > endDate) {
      alert("Start date cannot be greater than End date!");

      this.businessForm.patchValue(
        { end: null },
        { emitEvent: false }
      );

      return;
    }

    // ❌ Rule 2: Financial Year Validation
    if (
      startDate < this.financialYearMin ||
      endDate > this.financialYearMax
    ) {
      alert("Selected dates must be within financial year!");

      this.businessForm.reset();
      return;
    }

    // ✅ Valid case
    console.log("Valid Date Range:", startDate, endDate);

    // 👉 You can call API or filter data here
    this.onDateFilterChange(startDate, endDate);
  }
  onDateFilterChange(startDate: Date, endDate: Date) {
    console.log("Call API or filter table here");
  }


  calculateBookBillingData() {

    // ✅ RESET TOTALS
    this.totalInvoice = 0;
    this.totalReceipt = 0;
    this.totalCredit = 0;
    this.totalPending = 0;

    this.Filteredbookbillingdata.forEach(book => {

      const invoice = this.toNumber(book.invoice_total);
      const credit = this.toNumber(book.crdtnote_total);
      const pending = this.toNumber(book.remaining_amt);

      // ✅ SAME FORMULA AS HTML
      const receipt = invoice - credit - pending;

      this.totalInvoice += invoice;
      this.totalReceipt += receipt;
      this.totalCredit += credit;
      this.totalPending += pending;
    });

    console.log('TOTAL INVOICE:', this.totalInvoice);
    console.log('TOTAL RECEIPT:', this.totalReceipt);
    console.log('TOTAL CREDIT:', this.totalCredit);
    console.log('TOTAL PENDING:', this.totalPending);
  }



  invoice_no;
  getinvoice_no(event) {
    if (this.invoice_no != '') {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate &&
          a.invoice_no.toLowerCase()(this.invoice_no.toLowerCase()) > -1
        );
      });
    } else {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate
        );
      });
    }
    this.calculateBookBillingData();
  }
  // getinvoice_no1(event){
  //   this.invoice_no="";
  // }

  reset_invoice_no(event) {
    this.invoice_no = '';
    if (this.cust_name != undefined) {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate &&
          a.name.toLowerCase().indexOf(this.cust_name.toLowerCase()) > -1
        );
      });
    } else {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate
        );
      });
    }
    this.calculateBookBillingData();
  }

  cust_name;
  getcustomer_name(event) {
    if (this.cust_name != '' && this.invoice_no != undefined) {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate &&
          a.invoice_no.toLowerCase().indexOf(this.invoice_no.toLowerCase()) >
          -1 &&
          a.name.toLowerCase().indexOf(this.cust_name.toLowerCase()) > -1
        );
      });
    } else if (this.cust_name != '' && this.invoice_no == undefined) {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate &&
          a.name.toLowerCase().indexOf(this.cust_name.toLowerCase()) > -1
        );
      });
    } else {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate
        );
      });
    }
    this.calculateBookBillingData();
  }

  reset_cust_name(event) {
    this.cust_name = '';
    if (this.invoice_no != '') {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate &&
          a.invoice_no.toLowerCase().indexOf(this.invoice_no.toLowerCase()) > -1
        );
      });
    } else {
      this.Filteredbookbillingdata = this.bookbillingdata.filter((a) => {
        return (
          a['invoice_date'] >= this.getbookbillingStartDate &&
          a['invoice_date'] <= this.getbookbillingEndDate
        );
      });
    }
    this.calculateBookBillingData();
  }

  booksellernamedata;
  updatedbookbooksellernamedata: any;
  booksellernamedata1;
  // booksellernamedata2;
  searchbooksellername() {
    this.booksellernamedata1 = [];
    const req: any = {
      "receiver_name": this.bookpymtrecptform.value.booksellernamesearch, // get value from form
    };

    this.booksellernamedata = [];
    this.service.getBookSellerSpecificData3(this.bookpymtrecptform.value.booksellernamesearch)
      .subscribe((res) => {
        // Store API response in temp array
        this.booksellernamedata1 = res;
        console.log('booksellermetadat', this.booksellernamedata1);
      });

    // Filter after a short delay
    setTimeout(() => {
      this.booksellernamedata = [];
      this.booksellernamedata = this.booksellernamedata1.filter(
        (a) => a.receiver_name === this.bookpymtrecptform.value.booksellernamesearch
      );
      console.log('Filtered Book Seller Data:', this.booksellernamedata);
    }, 700);
  }



  searchbookrepname() {
    console.log('Click')
    this.booksellernamedata1 = [];
    this.service.getBookCommisionSpecificData().subscribe((data) => {
      for (let index = 0; index < data.length; index++) {
        this.booksellernamedata1.push(data[index]);
      }
      console.log('booksellermetadat', this.booksellernamedata1)
    });

    setTimeout(() => {
      this.booksellernamedata = [];
      this.booksellernamedata = this.booksellernamedata1.filter(
        (a) => a.rep_name === this.rep_name

      );
    }, 1000);
    console.log('booksellermetadat', this.booksellernamedata1)

  }

  CalculateAmount(book: any, event: any): void {
    // If user changes the percentage manually
    const percentage = parseFloat(event.target.value);

    // Use existing percent from API if invalid input
    const validPercentage = !isNaN(percentage) && percentage >= 0
      ? percentage
      : parseFloat(book.percent) || 0;

    // Store the percentage value
    book.commissionPercentage = validPercentage;

    // Calculate commission amount
    const receivedAmount = parseFloat(book.invoice_received_amt) || 0;
    book.commissionAmount = (receivedAmount * validPercentage) / 100;

    // Round to 2 decimals
    book.commissionAmount = Math.round(book.commissionAmount * 100) / 100;

    // Optional: If you’re tracking a selected amount
    if (book.selectedAmount && book.selectedAmount > 0) {
      book.selectedAmount = book.commissionAmount;
    }
  }


  searchbookselname() {

    this.bookselnamedata1 = [];

    const clean = (v: any) => v && v !== '' ? v : null;

    const request = {
      req1: {
        vstart_date: clean(this.bookselForm.value.vstart_date),
        vend_date: clean(this.bookselForm.value.vend_date),
        estart_date: clean(this.bookselForm.value.estart_date),
        eend_date: clean(this.bookselForm.value.eend_date),
        rep_name: clean(this.bookselForm.value.rep_name),
        book_names: clean(this.bookselForm.value.book_names),
        book_seller_name: clean(this.bookselForm.value.book_seller_name),
      }
    };

    console.log("FINAL REQUEST GOING TO PHP:", request);

    this.service.getBookSelSpecificData(request).subscribe(
      (data) => {
        this.FilteredVoucherData = data;
        this.priceTotal = 0;
        this.commissionTotal = 0;
        this.remainingTotal = 0;

        for (let d of this.FilteredVoucherData) {
          this.priceTotal += parseInt(d.price) || 0;
          this.commissionTotal += parseInt(d.commission) || 0;
          this.remainingTotal += parseInt(d.remaining_amt) || 0;
        }
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  }
 searchgranth(bookName: string): void {
    const selectedBook = bookName?.trim() !== '' ? bookName : 'All';

    const formattedStartDate = this.datePipe.transform(this.searchBookStockStartDate, 'yyyy-MM-dd');
    const formattedEndDate = this.datePipe.transform(this.searchBookStockEndDate, 'yyyy-MM-dd');

    const request = {
      book_name: selectedBook,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    };

    this.resultData1 = [];

    // Reset totals
    this.complementryTotal = 0;
    this.abhiyanTotal = 0;
    this.soldCopiesTotal = 0;
    this.totalSellTotal = 0;
    this.availableTotal = 0;
    this.printorderTotal = 0;
    this.openingstockTotal = 0;
    this.openingValueTotal = 0;
    this.balanceStockTotal = 0;
    this.valueOfBookTotal = 0;
    this.totalBillingTotal = 0;
    this.receivedAmtTotal = 0;
    this.creditAmountTotal = 0;
    this.outstandingAmtTotal = 0;

    this.service.getgranthStockOpeningData(request).subscribe(
      (data: any[]) => {
        if (data.length > 0) {
          this.resultData1 = data;

          // Loop to calculate totals
          for (let item of this.resultData) {
            this.complementryTotal += parseInt(item.complementry) || 0;
            this.abhiyanTotal += parseInt(item.abhiyan) || 0;
            this.soldCopiesTotal += parseInt(item.sold_copies) || 0;
            this.totalSellTotal += parseInt(item.total_sell) || 0;
            this.availableTotal += parseInt(item.balance_stock) || 0;
            this.printorderTotal += parseInt(item.print_order) || 0;
            this.openingstockTotal += parseInt(item.opening_stock) || 0;
            this.openingValueTotal += parseFloat(item.opening_value_of_book) || 0;
            this.balanceStockTotal += parseInt(item.balance_stock) || 0;
            this.valueOfBookTotal += parseFloat(item.value_of_book) || 0;
            this.totalBillingTotal += parseFloat(item.total_biiling) || 0;
            this.receivedAmtTotal += parseFloat(item.received_amt) || 0;
            this.creditAmountTotal += parseFloat(item.credit_amount) || 0;
            this.outstandingAmtTotal += parseFloat(item.outstanding_amt) || 0;
          }

          console.log('All Totals:', {
            complementry: this.complementryTotal,
            abhiyan: this.abhiyanTotal,
            sold_copies: this.soldCopiesTotal,
            total_sell: this.totalSellTotal,
            available_stock: this.availableTotal,
            print_order: this.printorderTotal,
            opening_stock: this.openingstockTotal,
            opening_value_of_book: this.openingValueTotal,
            balance_stock: this.balanceStockTotal,
            // balance_stock1:this.balanceStockTotal,
            value_of_book: this.valueOfBookTotal,
            total_biiling: this.totalBillingTotal,
            received_amt: this.receivedAmtTotal,
            credit_amount: this.creditAmountTotal,
            outstanding_amt: this.outstandingAmtTotal
          });

        } else {
          alert("No Record Found...!!!");
        }
      },
      (error) => {
        console.error('Error while fetching data', error);
      }
    );
  }

  searchbookselnamegranth() {

    this.bookselnamedata1 = [];

    const clean = (v: any) => v && v !== '' ? v : null;

    const request = {
      req1: {
        vstart_date: clean(this.bookselgranthForm.value.vstart_date),
        vend_date: clean(this.bookselgranthForm.value.vend_date),
        estart_date: clean(this.bookselgranthForm.value.estart_date),
        eend_date: clean(this.bookselgranthForm.value.eend_date),
        rep_name: clean(this.bookselgranthForm.value.rep_name),
        book_names: clean(this.bookselgranthForm.value.book_names),
        book_seller_name: clean(this.bookselgranthForm.value.book_seller_name),
      }
    };

    console.log("FINAL REQUEST GOING TO PHP:", request);

    this.service.getGranthSelSpecificData(request).subscribe(
      (data) => {
        this.FilteredGranthData = data;
        this.granthPriceTotal = 0;
        this.granthCommissionTotal = 0;
        this.granthRemainingTotal = 0;

        for (let d of this.FilteredGranthData) {
          this.granthPriceTotal += parseInt(d.price) || 0;
          this.granthCommissionTotal += parseInt(d.commission) || 0;
          this.granthRemainingTotal += parseInt(d.remaining_amt) || 0;
        }
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  }

  fixDate(d: any) {
    if (!d) return null;
    const date = new Date(d);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().split('T')[0];
  }
  distribution(event, option) {
    if (event.isUserInput) {
      let val = option['name'];
    }
  }
  searchbookselname1() {
    debugger;

    // Clear previous data
    this.bookselnamedata1 = [];

    const request = {
      start: this.fixDate(this.BookbillingRegister.value.start),
      end: this.fixDate(this.BookbillingRegister.value.end),
      invoice_no: this.BookbillingRegister.value.invoice_no || '',
      cust_name: this.BookbillingRegister.value.cust_name || '',

      // ✅ FIXED MAPPING
      rep_name: this.BookbillingRegister.value.repwise || [],
      office_rep_name: this.BookbillingRegister.value.officerepwise || []
    };

    console.log('API Request:', request);

    this.service.getBookSelSpecificData2(request).subscribe(
      (data: any[]) => {
        this.Filteredbookbillingdata = data || [];
        console.log('billingData count:', this.Filteredbookbillingdata.length);
        this.calculateBookBillingData();
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }



  searchbookselname2() {

    debugger
    this.bookselnamedata1 = [];  // Clear the previous data
    const request = {
      req1: {
        start: this.invoicegetCustBook.value.start,
        end: this.invoicegetCustBook.value.end,
        bookwise: this.invoicegetCustBook.value.bookwise,
        cust_name: Array.isArray(this.invoicegetCustBook.value.cust_name)
          ? this.invoicegetCustBook.value.cust_name.map((c: any) => c.name) // ✅ only names
          : []
      }
    };



    this.service.getBookSelSpecificData3(request).subscribe((data) => {
      this.bookinvoicedata = data.map((item: any) => ({ ...item, selected: false }));
    },

    );
  }

  // searchBooks(bookName: string): void {
  //   const selectedBook = bookName?.trim() !== '' ? bookName : 'All';


  //   const formattedStartDate = this.datePipe.transform(this.searchBookStockStartDate, 'yyyy-MM-dd');
  //   const formattedEndDate = this.datePipe.transform(this.searchBookStockEndDate, 'yyyy-MM-dd');


  //   const request = {
  //     book_name: selectedBook,
  //     start_date: formattedStartDate,
  //     end_date: formattedEndDate
  //   };
  //   this.resultData = []
  //   this.service.getBookStockOpeningData(request).subscribe(
  //     (data: any[]) => {
  //       if (data.length > 0) {
  //         this.resultData = data;
  //         console.log('Fetched Data:', this.resultData);
  //       } else {
  //         alert("No Record Found...!!!")
  //       }


  //     },
  //     (error) => {

  //       console.error('Error while fetching data', error);
  //     }
  //   );
  // }
  debugger
  searchBooks(bookName: string): void {
    const selectedBook = bookName?.trim() !== '' ? bookName : 'All';

    const formattedStartDate = this.datePipe.transform(this.searchBookStockStartDate, 'yyyy-MM-dd');
    const formattedEndDate = this.datePipe.transform(this.searchBookStockEndDate, 'yyyy-MM-dd');

    const request = {
      book_name: selectedBook,
      start_date: formattedStartDate,
      end_date: formattedEndDate
    };

    this.resultData = [];

    // Reset totals
    this.complementryTotal = 0;
    this.abhiyanTotal = 0;
    this.soldCopiesTotal = 0;
    this.totalSellTotal = 0;
    this.availableTotal = 0;
    this.printorderTotal = 0;
    this.openingstockTotal = 0;
    this.openingValueTotal = 0;
    this.balanceStockTotal = 0;
    this.valueOfBookTotal = 0;
    this.totalBillingTotal = 0;
    this.receivedAmtTotal = 0;
    this.creditAmountTotal = 0;
    this.outstandingAmtTotal = 0;

    this.service.getBookStockOpeningData(request).subscribe(
      (data: any[]) => {
        if (data.length > 0) {
          this.resultData = data;

          // Loop to calculate totals
          for (let item of this.resultData) {
            this.complementryTotal += parseInt(item.complementry) || 0;
            this.abhiyanTotal += parseInt(item.abhiyan) || 0;
            this.soldCopiesTotal += parseInt(item.sold_copies) || 0;
            this.totalSellTotal += parseInt(item.total_sell) || 0;
            this.availableTotal += parseInt(item.balance_stock) || 0;
            this.printorderTotal += parseInt(item.print_order) || 0;
            this.openingstockTotal += parseInt(item.opening_stock) || 0;
            this.openingValueTotal += parseFloat(item.opening_value_of_book) || 0;
            this.balanceStockTotal += parseInt(item.balance_stock) || 0;
            this.valueOfBookTotal += parseFloat(item.value_of_book) || 0;
            this.totalBillingTotal += parseFloat(item.total_biiling) || 0;
            this.receivedAmtTotal += parseFloat(item.received_amt) || 0;
            this.creditAmountTotal += parseFloat(item.credit_amount) || 0;
            this.outstandingAmtTotal += parseFloat(item.outstanding_amt) || 0;
          }

          console.log('All Totals:', {
            complementry: this.complementryTotal,
            abhiyan: this.abhiyanTotal,
            sold_copies: this.soldCopiesTotal,
            total_sell: this.totalSellTotal,
            available_stock: this.availableTotal,
            print_order: this.printorderTotal,
            opening_stock: this.openingstockTotal,
            opening_value_of_book: this.openingValueTotal,
            balance_stock: this.balanceStockTotal,
            // balance_stock1:this.balanceStockTotal,
            value_of_book: this.valueOfBookTotal,
            total_biiling: this.totalBillingTotal,
            received_amt: this.receivedAmtTotal,
            credit_amount: this.creditAmountTotal,
            outstanding_amt: this.outstandingAmtTotal
          });

        } else {
          alert("No Record Found...!!!");
        }
      },
      (error) => {
        console.error('Error while fetching data', error);
      }
    );
  }


  //   searchrepname() {
  //      this.bookselnamedata1 = [];  // Clear the previous data
  //     // const request = {
  //     //   "req1": this.bookselForm.value
  //   // this.bookselnamedata1 = [];  
  //   const request = {
  //       "req1": this.bookcommForm.value
  //     }

  //   // const request = this.bookcommForm.value;  // send values directly

  //   this.service.getBookRepSpecificData(request).subscribe((data) => {
  //     this.getallCommVouchersData = data;
  //     this.priceTotal = 0;
  //     this.commissionTotal = 0;
  //     this.remainingTotal = 0;

  //     for (let data1 of this.getallCommVouchersData) {
  //       this.priceTotal += parseInt(data1.price) || 0;
  //       this.commissionTotal += parseInt(data1.commission) || 0;
  //       this.remainingTotal += parseInt(data1.remaining_amt) || 0;
  //     }
  //   },
  //   (error) => {
  //     console.error('Error fetching data:', error);
  //   });
  // }

// searchrepname() {
//   this.bookselnamedata1 = [];  // Clear the previous data

//   const vstart = this.bookcommForm.value.start;
//   const vend = this.bookcommForm.value.end;
//   const estart = this.bookcommForm.value.estart_date;
//   const eend = this.bookcommForm.value.eend_date;

//   // ✅ year lock check before building request
//   if (
//     !this.isDateWithinFinancialYear(vstart, 'Voucher start date') ||
//     !this.isDateWithinFinancialYear(vend, 'Voucher end date') ||
//     !this.isDateWithinFinancialYear(estart, 'Entry start date') ||
//     !this.isDateWithinFinancialYear(eend, 'Entry end date')
//   ) {
//     return;
//   }

//   if (vstart && vend && new Date(vend) < new Date(vstart)) {
//     alert('Voucher end date cannot be before start date');
//     return;
//   }

//   if (estart && eend && new Date(eend) < new Date(estart)) {
//     alert('Entry end date cannot be before start date');
//     return;
//   }

//   const request = {
//     vstart_date: vstart,
//     vend_date: vend,
//     estart_date: estart,
//     eend_date: eend,
//     rep_name: this.bookcommForm.value.rep_name,
//     book_seller_name: this.bookcommForm.value.book_seller_name,
//   }

//   // ... rest of your existing logic (API call, filtering, etc.) goes here
// }
 searchrepname() {
  debugger;

  this.bookselnamedata1 = [];
  this.FilteredCommVouchers = [];

  const request = {
    vstart_date: this.bookcommForm.value.start,
    vend_date: this.bookcommForm.value.end,
    estart_date: this.bookcommForm.value.estart_date,
    eend_date: this.bookcommForm.value.eend_date,
    rep_name: this.bookcommForm.value.rep_name,
    book_seller_name: this.bookcommForm.value.book_seller_name
  };

  this.service.getBookRepSpecificData(request).subscribe(
    (response: any) => {

      console.log("API Response:", response);

      if (response.status) {

        this.FilteredCommVouchers = response.data || [];

        this.priceTotal = 0;
        this.commissionTotal = 0;
        this.remainingTotal = 0;

        this.FilteredCommVouchers.forEach((item: any) => {

          // Add only if your API returns price
          this.priceTotal += Number(item.price || 0);

          this.commissionTotal += Number(item.commission || 0);

          this.remainingTotal += Number(item.remaining_amt || 0);

        });

      } else {

        this.FilteredCommVouchers = [];
        alert(response.message);

      }

    },
    (error) => {

      console.error("Error fetching data:", error);
      this.FilteredCommVouchers = [];

    }
  );
}

  bookmName: any;
  searchbook() {
    //bookdata


    if (!this.bookmName || this.bookmName.trim() === '') {
      this.service.getAllBookData().subscribe((data) => {
        this.bookData = data;
        this.bookdata = this.uniqueid(this.bookData, (it) => it.bookid);
        // console.log(this.bookData);
        for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
          this.booknames.push({ bookname: this.bookdata[index]['bookname'] });
        }
      });

    } else {
      this.booksellernamedata1 = [];
      const request = {
        "bookname": this.bookmName
      }
      this.service.getBookSearch(request).subscribe((data) => {
        this.bookdata = data;  // Assign the new data
        // for (let index = 0; index < data.length; index++) {
        //    this.booksellernamedata1.push(data[index]);
        // }
      });

      setTimeout(() => {
        this.booksellernamedata = [];

        // Filter data based on bookname (you can adjust the condition as needed)
        this.booksellernamedata = this.booksellernamedata1.filter(
          (a) => a.bookname === this.bookName // Assuming you want to filter by bookname
        );
      }, 1000);

    }


  }
  get grandTotal(): number {
  
  const shipping = Number(this.shipping_total) || 0;
  const sponsorShipping = Number(this.sponsor_total_shippingcharging) || 0;

  return shipping +  sponsorShipping;
}




  filterData() {
    // Filter based on receiver_name (assuming you want to filter by this.name)
    this.bookselnamedata = this.bookselnamedata1.filter(
      (a) => a.book_seller_name === this.name  // Use book_seller_name here
    );
    console.log('Filtered Data:', this.bookselnamedata);
  }





  bookpymtrcptdata = [];
  invoice_total = 0;
  remainingamt: number = 0;
  click: boolean = false;




  selectedItem(book) {
    debugger;
    this.calculateRcptAmt(book);
  }
  selectedItem1(book) {
    debugger;
    this.calculateRcptAmt1(book);
  }


  dialogdata;
  bookpricedata = [];
  calculateRcptAmt(book) {
    console.log(book);
    debugger


    const previouslyFocusedElement = document.activeElement as HTMLElement;
    this.bookpymtrcptdata.push(book);

    const dialogdata = this.dialog.open(AddBookPerPriceComponent, {
      data: {
        book: book,
        crdtAmt: parseFloat(this.bookpymtrecptform.get('crdtvamt').value),
        seAmt: parseFloat(this.bookpymtrecptform.get('seamt').value),
        balAmt: parseFloat(this.bookpymtrecptform.get('balamt').value),
        bookName: this.bookpymtrecptform.get('bname').value,
        bal: book.pay_amt - book.rcv_amt,
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe((res) => {
      debugger
      this.bookpricedata.push(res.data);

      console.log(res.data)
      console.log("bookreciptdta", this.bookpricedata);
      let bookIndex = this.booksellernamedata.findIndex(book => book.id === res.id);
      if (bookIndex !== -1) {
        this.booksellernamedata[bookIndex]['remaining_amt'] = res.remaining_amt;
        console.log(`Updated remaining_amt for book ID ${res.id}:`, res.remaining_amt);
      } else {
        console.warn(`Book ID ${res.id} not found in booksellernamedata`);
      }
      let rcvd_amt = 0;
      for (
        let index = 0;
        index < Object.keys(this.bookpricedata).length;
        index++
      ) {
        for (
          let index1 = 0;
          index1 < Object.keys(this.bookpricedata[index]).length;
          index1++
        ) {
          rcvd_amt =
            rcvd_amt + parseInt(this.bookpricedata[index][index1]['rcvd_amt']);
        }
      }
      let val = this.bookpymtrecptform.get('crdtvamt').value;
      this.bookpymtrecptform.get('seamt').setValue(parseInt(res.selecetdAmt));
      this.bookpymtrecptform.get('balamt').setValue(parseInt(res.balanceAmt));
      this.invoice_total = rcvd_amt;
      if (this.bookpymtrecptform.get('balamt').value <= 0) {
        this.click = !this.click;
      }
    });


  }
  calculateRcptAmt1(book) {
    console.log('Selected book:', book);
    debugger;

    // Push the book to local array
    this.bookpymtrcptdata.push(book);

    // Open dialog and pass the proper crdtvAmt from backend payload
    const dialogdata = this.dialog.open(AddBookPerPriceComponent1Component, {
      data: {
        book: book,
        //  crdtAmt: parseFloat(this.bookpymtrecptform.get('crdtvAmt').value), 
        // crdtAmt: parseFloat(book.crdtvAmt) || 0, 
        seAmt: parseFloat(book.select_entry_amt) || 0,
        balAmt: parseFloat(book.bal_amt) || 0,
        //  bookName: this.bookpymtrecptform.get('bname').value || '',
        // bal: book.pay_amt - book.rcv_amt || 0,
        //  bookName: this.bname,
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {
      if (!res) return;

      debugger;
      this.bookpricedata.push(res.data);

      console.log('Dialog returned data:', res.data);
      console.log("bookreciptdta", this.bookpricedata);

      // Update remaining amount in main book array
      const bookIndex = this.booksellernamedata.findIndex(b => b.id === res.id);
      if (bookIndex !== -1) {
        this.booksellernamedata[bookIndex]['remaining_amt'] = res.remaining_amt;
        console.log(`Updated remaining_amt for book ID ${res.id}:`, res.remaining_amt);
      } else {
        console.warn(`Book ID ${res.id} not found in booksellernamedata`);
      }

      // Calculate total received amount
      let rcvd_amt = 0;
      for (let index = 0; index < this.bookpricedata.length; index++) {
        for (let index1 = 0; index1 < this.bookpricedata[index].length; index1++) {
          rcvd_amt += parseInt(this.bookpricedata[index][index1]['rcvd_amt']) || 0;
        }
      }

      // Update form controls and invoice total
      this.bookpymtrecptform.get('seamt').setValue(parseInt(res.selecetdAmt) || 0);
      this.bookpymtrecptform.get('balamt').setValue(parseInt(res.balanceAmt) || 0);
      this.invoice_total = rcvd_amt;

      if ((this.bookpymtrecptform.get('balamt').value || 0) <= 0) {
        this.click = !this.click;
      }
    });
  }

  updatedata;
  updatePerBooksRate(book) {
    this.updatedata = [];
    for (let index = 0; index < this.bookpricedata.length; index++) {
      for (
        let index1 = 0;
        index1 < this.bookpricedata[index].length;
        index1++
      ) {
        if (this.bookpricedata[index][index1]['id'] === book['id']) {
          this.updatedata.push(this.bookpricedata[index][index1]);
        }
      }
    }
    const dialogdata = this.dialog.open(UpdateBookPerPriceComponent, {
      data: {
        book: book,
        updatedata: this.updatedata,
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {
      for (let index2 = 0; index2 < res.data.length; index2++) {
        for (let index = 0; index < this.bookpricedata.length; index++) {
          for (
            let index1 = 0;
            index1 < this.bookpricedata[index].length;
            index1++
          ) {
            if (
              this.bookpricedata[index][index1]['bookid'] ===
              res.data[index2]['bookid']
            ) {
              this.bookpricedata[index][index1]['rcvd_amt'] =
                res.data[index2]['rcvd_amt'];
              this.bookpricedata[index][index1]['remaining_amt'] =
                res.data[index2]['remaining_amt'];
            }
          }
        }
      }

      for (
        let index = 0;
        index < Object.keys(this.bookpymtrcptdata).length;
        index++
      ) {
        if (this.bookpymtrcptdata[index]['id'] == res.id) {
          this.booksellernamedata[index]['remaining_amt'] = res.remaining_amt;
        }
      }
      let rcvd_amt = 0;
      for (
        let index = 0;
        index < Object.keys(this.bookpricedata).length;
        index++
      ) {
        for (
          let index1 = 0;
          index1 < Object.keys(this.bookpricedata[index]).length;
          index1++
        ) {
          rcvd_amt =
            rcvd_amt + parseInt(this.bookpricedata[index][index1]['rcvd_amt']);
        }
      }
      let val = this.bookpymtrecptform.get('crdtvamt').value;
      this.bookpymtrecptform.get('seamt').setValue(parseInt(res.value));
      this.bookpymtrecptform.get('balamt').setValue(val - parseInt(res.value));
      this.invoice_total = rcvd_amt;
      if (this.bookpymtrecptform.get('balamt').value <= 0) {
        this.click = !this.click;
      }
    });
  }


  updatePerBooksRate1(book) {
    debugger
    const previouslyFocusedElement = document.activeElement as HTMLElement;
    this.bookpymtcrdtdata.push(book);
    const dialogdata = this.dialog.open(AddBookCreditPrice1Component, {
      data: {
        book: book,
        seAmt: parseFloat(this.bookcrdtnoteForm.get('crditnoteamt').value),
        seCopies: parseFloat(this.bookcrdtnoteForm.get('returncopies').value),
        bsname: this.bookcrdtnoteForm.get('bsname').value,
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',

    });

    dialogdata.afterClosed().subscribe((res) => {
      debugger;
      if (!res || !res.data) {
        console.warn("No data returned from dialog.");
        return;
      }

      this.bookcreditdata.push(res.data);

      console.log(res.data);
      console.log("bookcreditdata", this.bookcreditdata);

      let bookIndex = this.BookBillingData.findIndex(b => b.id === res.id);
      if (bookIndex !== -1) {
        this.BookBillingData[bookIndex]['remaining_amt'] = res.remaining_amt;
        this.BookBillingData[bookIndex]['total_remaining_amt'] = res.remaining_amt;
        this.BookBillingData[bookIndex]['credit_amount'] = res.value;
        this.BookBillingData[bookIndex]['credit_note_amount'] = parseInt(res.selecetdAmt) || 0;
        this.BookBillingData[bookIndex]['return_copies'] = res.retCopies;
        this.BookBillingData[bookIndex]['remarks'] = res.newRemark;

        // ✅ Also set remark into form so it’s accessible later
        if (res.newRemark) {
          this.bookcrdtnoteForm.get('remark').setValue(res.newRemark);
        }

        console.log(`Updated remaining_amt for book ID ${res.id}:`, res.remainingamt);

        if (!this.UpdatedBillingData) {
          this.UpdatedBillingData = [];
        }
        this.UpdatedBillingData.push(this.BookBillingData[bookIndex]);
      } else {
        console.warn(`Book ID ${res.id} not found in BookBillingData`);
      }

      // Calculate total received amount
      let rcvd_amt = 0;
      for (let index = 0; index < Object.keys(this.bookcreditdata).length; index++) {
        for (let index1 = 0; index1 < Object.keys(this.bookcreditdata[index]).length; index1++) {
          rcvd_amt += parseInt(this.bookcreditdata[index][index1]['rcvd_amt']) || 0;
        }
      }

      // Update form values
      this.bookcrdtnoteForm.get('crditnoteamt').setValue(parseInt(res.selecetdAmt) || 0);
      this.bookcrdtnoteForm.get('returncopies').setValue(parseInt(res.returnCopies) || 0);

      this.invoice_total = rcvd_amt;
    });
  }
  calculateTotals(): void {
    this.totalInvoiceAmount = 0;
    this.totalInvoiceReceived = 0;
    this.totalCommission = 0;
    this.totalPaidCommission = 0;
    this.totalUnpaidCommission = 0;

    this.repcommissiondata.forEach((rep: any) => {
      this.totalInvoiceAmount += Number(rep.invoice_total || 0);
      this.totalInvoiceReceived += Number(rep.invoice_received_amt || 0);
      this.totalCommission += Number(rep.rep_commission_amt || 0);
      this.totalPaidCommission += Number(rep.received_amt || 0);
      this.totalUnpaidCommission += Number(rep.remaining_amt || 0);
    });
  }


  bookpymtrcptCommdata = [];

  selectedInvItem(book) {
    debugger;
    this.calculateCommRcptAmt(book);
  }

  dialog3data;
  bookcommipricedata = [];
  calculateCommRcptAmt(book) {
    console.log(book);
    debugger


    const previouslyFocusedElement = document.activeElement as HTMLElement;
    this.bookpymtrcptCommdata.push(book);

    const dialog1data = this.dialog.open(AddBookPerCommisionPriceComponent, {
      data: {
        book: book,
        crdtAAmt: parseFloat(this.bookcommrecptform.get('commvamt').value),
        seAAmt: parseFloat(this.bookcommrecptform.get('seamt').value),
        balAAmt: parseFloat(this.bookcommrecptform.get('balamt').value),
        bal: book.pay_amt - book.rcv_amt,
        comssionrec: book.commissionAmount || (book.invoice_received_amt * (book.percent / 100))
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });
    dialog1data.afterClosed().subscribe((res) => {
      debugger
      this.bookcommipricedata.push(res.data);

      console.log(res.data)
      console.log("bookreciptdta", this.bookcommipricedata);
      let bookIndex = this.booksellernamedata.findIndex(book => book.id === res.id);
      if (bookIndex !== -1) {
        this.booksellernamedata[bookIndex]['received_amt'] = res.value;
        this.booksellernamedata[bookIndex]['comm_note_total'] = res.value;

        this.booksellernamedata[bookIndex]['remaining_amt'] = res.remaining_amt;

        this.updatedbookbooksellernamedata = this.updatedbookbooksellernamedata || [];
        this.updatedbookbooksellernamedata.push(this.booksellernamedata[bookIndex]);

        console.log(`Updated comm_remaining_amt for book ID ${res.id}:`, res.comm_remaining_amt);
      } else {
        console.warn(`Book ID ${res.id} not found in booksellernamedata`);
      }
      let rcvd_amt = 0;
      for (
        let index = 0;
        index < Object.keys(this.bookcommipricedata).length;
        index++
      ) {
        for (
          let index1 = 0;
          index1 < Object.keys(this.bookcommipricedata[index]).length;
          index1++
        ) {
          rcvd_amt =
            rcvd_amt + parseInt(this.bookcommipricedata[index][index1]['comm_rcvd_amt']);
        }
      }
      let val = this.bookcommrecptform.get('commvamt').value;
      this.bookcommrecptform.get('seamt').setValue(parseFloat(res.selecetdAmt));
      this.bookcommrecptform.get('balamt').setValue(parseInt(res.balanceAmt));
      // const result = (val - parseFloat(res.value)).toFixed(2);
      // this.bookcommrecptform.get('balamt').setValue(parseFloat(result));

      this.invoice_total = rcvd_amt;
      if (this.bookcommrecptform.get('balamt').value <= 0) {
        this.click = !this.click;
      }
    });
  }


  addbookpymtcomm() {
    let actualVal = this.deleteComm ? this.val1 : this.val1 + 1;

    let data = {
      date: this.bookcommrecptform.get('date').value,
      crdtvno: this.bookcommrecptform.get('crdtvno').value,
      recptdate: this.bookcommrecptform.get('recptdate').value,
      repname: this.bookcommrecptform.get('repname').value,
      rep_address: this.bookcommrecptform.get('repname').value,
      commino: this.bookcommrecptform.get('commino').value,
      commvamt: this.bookcommrecptform.get('commvamt').value,
      // offrepname: this.bookcommrecptform.get('offrepname').value,
      // rep_address : this.bookcommrecptform.get('rep_address').value,
      seamt: this.bookcommrecptform.get('seamt').value,
      balamt: this.bookcommrecptform.get('balamt').value,
      booksellername: this.bookcommrecptform.get('booksellername').value,
      // billno: this.bookcommrecptform[0]['invoice_no'],


      value: actualVal,
    };

    this.dialog.open(BookCommRcptComponent, {
      data: {
        data: data,
        bookpymtrcptCommdata: this.bookpymtrcptCommdata,
        book: "",
        bookcommipricedata: this.bookcommipricedata,
        BookBillingData: this.updatedbookbooksellernamedata,
        billno: this.bookcommipricedata['invoice_no'],

        // val: data['seamt'],
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  updateCommidata;
  updatePerBooksCommisionRate(item: any) {

    this.updateCommidata = [];

    for (let i = 0; i < this.bookcommipricedata.length; i++) {
      for (let j = 0; j < this.bookcommipricedata[i].length; j++) {

        if (this.bookcommipricedata[i][j]['id'] === item['id']) {
          this.updateCommidata.push(this.bookcommipricedata[i][j]);
        }

      }
    }

    const dialogdata = this.dialog.open(UpdateBookPerPriceComponent, {
      data: {
        book: item,  // 🔥 pass full row
        bill_no: item.bill_no,
        invoice_no: item.invoice_no,   // if exists
        updateCommidata: this.updateCommidata
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {
      if (!res) return;

      // (your existing logic unchanged)
    });
  }

  public demo1TabIndex = 0;
  public demo1BtnClick() {
    const tabCount = 24;
    this.demo1TabIndex = (this.demo1TabIndex + 1) % tabCount;
    this.bookrcptsetvalue();
  }

  public demo1BtngranthClick() {

    const tabCount = 24;
    this.demo1TabIndex = (this.demo1TabIndex - 2) % tabCount;
    this.bookrcptsetvaluegranth();
  }

  public demoCommBtnClick() {
    const tabCount = 24;
    this.demo1TabIndex = (this.demo1TabIndex + 1) % tabCount;
    this.bookcommrcptsetvalue();
  }

  bookrcptsetvalue() {

    const dateString = this.pendingbookdata.voucher_date; // Use this date instead of current date
    const selectedDate = new Date(dateString);

    let date = ('0' + selectedDate.getDate()).slice(-2);
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    let year = selectedDate.getFullYear();

    let financialStartYear, financialEndYear;

    // Determine financial year based on selected date
    if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar
      financialStartYear = year - 1;
      financialEndYear = year;
    } else { // Apr to Dec
      financialStartYear = year;
      financialEndYear = year + 1;
    }

    let shortStartYear = financialStartYear.toString().slice(-2);
    let shortEndYear = financialEndYear.toString().slice(-2);

    // Use dateString as the request date
    const req: any = {
      "date": dateString
    };

    this.service.getPymtRcptNo(req).subscribe((data) => {
      console.log('val1', data[0]['receipt_no']);
      let valSet;

      if (data[0]['receipt_no'] === undefined) {
        this.val1 = 1;
        valSet = 1;
      } else {
        valSet = parseInt(data[0]['receipt_no']) + 1;
        this.val1 = parseInt(data[0]['receipt_no']);
      }

      // Generate receipt number based on dateString
      this.recptno = `BDR${month}/${shortStartYear}-${shortEndYear}/${valSet}`;
      this.bookpymtrecptform.get('recptno').setValue(this.recptno);
    });




    this.bookpymtrecptform
      .get('crdtvno')
      .setValue(this.pendingbookdata['voucher_no']);
    this.bookpymtrecptform
      .get('recptdate')
      .setValue(this.pendingbookdata['voucher_date']);
    this.bookpymtrecptform
      .get('repname')
      .setValue(this.pendingbookdata['rep_name']);
    this.bookpymtrecptform
      .get('crdtvamt')
      .setValue(this.pendingbookdata['remaining_amt']);
    this.bookpymtrecptform
      .get('booksellername')
      .setValue(this.pendingbookdata['book_seller_name']);
    this.bookpymtrecptform
      .get('bname')
      .setValue(this.pendingbookdata['book_names']);


    let name = this.bookpymtrecptform.get('repname').value;
    let names = this.names.filter(
      (a) => a['name'] === this.pendingbookdata['rep_name']
    );
  }

  bookrcptsetvaluegranth() {
    debugger

    const dateString = this.pendingbookdatagranth.voucher_date;
    const selectedDate = new Date(dateString);

    const month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    const year = selectedDate.getFullYear();

    let fyStart, fyEnd;
    if (selectedDate.getMonth() + 1 < 4) {
      fyStart = year - 1;
      fyEnd = year;
    } else {
      fyStart = year;
      fyEnd = year + 1;
    }

    const shortStart = fyStart.toString().slice(-2);
    const shortEnd = fyEnd.toString().slice(-2);

    /** -------- Receipt No -------- */
    const req = { date: dateString };

    this.service.getPymtRcptNo(req).subscribe(data => {

      let nextNo = data[0]?.receipt_no
        ? Number(data[0].receipt_no) + 1
        : 1;

      const receiptNo = `BDR${month}/${shortStart}-${shortEnd}/${nextNo}`;

      // const sellerCount = (this.pendingbookdatagranth.book_seller_name || '')
      //   .split(',')
      //   .filter((n: string) => n.trim() !== '').length || 1;

      this.packsubform.patchValue({
        recptno: receiptNo,
        crdtvno: this.pendingbookdatagranth.voucher_no,
        rep_name: this.pendingbookdatagranth.rep_name,
        seamt: this.pendingbookdatagranth.price 
      });
    });
  }


  bookcommrcptsetvalue() {





    const dateString = this.pendingbookcommdata.voucher_date; // Use this date instead of current date
    const selectedDate = new Date(dateString);

    let date = ('0' + selectedDate.getDate()).slice(-2);
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    let year = selectedDate.getFullYear();

    let financialStartYear, financialEndYear;

    // Determine financial year based on selected date
    if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar
      financialStartYear = year - 1;
      financialEndYear = year;
    } else { // Apr to Dec
      financialStartYear = year;
      financialEndYear = year + 1;
    }

    let shortStartYear = financialStartYear.toString().slice(-2);
    let shortEndYear = financialEndYear.toString().slice(-2);

    // Use dateString as the request date
    const req: any = {
      "date": dateString
    };

    this.service.getCommPymtRcptNo(req).subscribe((data) => {
      console.log('val1', data[0]['commission_no']);
      let valSet;

      if (data[0]['commission_no'] === undefined) {
        this.val1 = 1;
        valSet = 1;
      } else {
        valSet = parseInt(data[0]['commission_no']) + 1;
        this.val1 = parseInt(data[0]['commission_no']);
      }

      // Generate receipt number based on dateString
      this.commino = `BCN${month}/${shortStartYear}-${shortEndYear}/${valSet}`;
      this.bookcommrecptform.get('commino').setValue(this.commino);
    });


    this.bookcommrecptform
      .get('crdtvno')
      .setValue(this.pendingbookcommdata['voucher_no']);
    this.bookcommrecptform
      .get('recptdate')
      .setValue(this.pendingbookcommdata['voucher_date']);
    this.bookcommrecptform
      .get('repname')
      .setValue(this.pendingbookcommdata['rep_name']);

    // const formattedValue = this.decimalPipe.transform(this.pendingbookcommdata['remaining_amt'], '1.0-2');

    // this.bookcommrecptform.get('commvamt')?.setValue(formattedValue);

    this.bookcommrecptform
      .get('commvamt')
      .setValue(this.pendingbookcommdata['remaining_amt']);


    this.bookcommrecptform
      .get('booksellername')
      .setValue(this.pendingbookcommdata['book_seller_name']);

    let name = this.bookpymtrecptform.get('rep_name').value;
    let names = this.names.filter(
      (a) => a['rep_name'] === this.pendingbookdata['rep_name']
    );



  }

  openBookCommReceipt() {

    const selectedRows = this.bookRcptCommisionRegisterdata.filter(
      (item: any) => item.selected
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one record");
      return;
    }

    this.dialog.open(BookCommissionNoteRegisterComponent, {
      data: {
        receiptdata: selectedRows
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

  }

  addbookpymtrcpt() {
    debugger
    let actualVal = this.deleterec ? this.val1 : this.val1 + 1;

    let data = {
      date: this.bookpymtrecptform.get('date').value,
      crdtvno: this.bookpymtrecptform.get('crdtvno').value,
      recptdate: this.bookpymtrecptform.get('recptdate').value,
      repname: this.bookpymtrecptform.get('repname').value,
      recptno: this.bookpymtrecptform.get('recptno').value,
      crdtvamt: this.bookpymtrecptform.get('crdtvamt').value,
      seamt: this.bookpymtrecptform.get('seamt').value,
      booksellername: this.bookpymtrecptform.get('booksellername').value,
      bname: this.bookpymtrecptform.get('bname').value,
      balamt: this.bookpymtrecptform.get('balamt').value,
      billno: this.booksellernamedata[0]['invoice_no'],

      value: actualVal,
    };

    this.dialog.open(BookstorereceiptComponent, {
      data: {
        data: data,
        bookpymtrcptdata: this.bookpymtrcptdata,
        book: this.pendingbookdata,
        bookpricedata: this.bookpricedata,
        booksellername: this.bookpymtrecptform.get('booksellernamesearch')
          .value,
        billno: this.booksellernamedata['invoice_no'],
        val: data['seamt'],
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }


  openBookTwoReceipt() {
    debugger
    this.dialog.open(BooktworeciptComponent, {
      data: {
        receiptdata: this.newList1,

      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

  }











  getBookReceiptRegister() {
    console.log(this.bookrcptregisterform.value)

    //     let booksellerwiseString;
    //     let bookString;
    //     if (Array.isArray(this.bookrcptregisterform.value.bookwise)) {
    //       // If it's an array (multi-select case)
    //       bookString = this.bookrcptregisterform.value.bookwise.join(", ");
    //     } else {
    //       // If it's a single value (single select case)
    //       bookString = this.bookrcptregisterform.value.bookwise;
    //     }

    // if (Array.isArray(this.bookrcptregisterform.value.booksellerwise)) {
    //   // If it's an array (multi-select case)
    //   booksellerwiseString = this.bookrcptregisterform.value.booksellerwise.join(", ");
    // } else {
    //   // If it's a single value (single select case)
    //   booksellerwiseString = this.bookrcptregisterform.value.booksellerwise;
    // }

    const req: any = {
      "start_receipt_date": this.bookrcptregisterform.value.start,
      "end_receipt_date": this.bookrcptregisterform.value.end,
      "bill_no": this.bookrcptregisterform.value.billnowise,
      "book": this.bookrcptregisterform.value.bookwise,
      "rep_name": this.bookrcptregisterform.value.repwise,
      "office_rep_name": this.bookrcptregisterform.value.officerepwise,
      "book_seller_name": this.bookrcptregisterform.value.booksellerwise,

    }

    this.service.getBookReceiptRegisterSearch(req).subscribe((data) => {

      this.bookRcptRegisterdata = data;
      this.FilteredbookRcptRegisterdata = this.bookRcptRegisterdata
      this.PaymentBookInDTotal = 0;
      console.log(this.bookRcptRegisterdata, "data receipt")
      debugger

      for (let data1 of this.bookRcptRegisterdata) {

        //this.PaymentBookInDTotal += parseInt(data1.rcv_amt) || 0;
        this.PaymentBookInDTotal += parseInt(data1.select_entry_amt) || 0;
      }
    });


  }
  getBookReceiptRegister1() {

    const form = this.bookrcptregisterform.value;

    const req: any = {

      start_crdtnote_date: this.fixDate(form.start),

      end_crdtnote_date: this.fixDate(form.end),

      bill_no: form.billnowise,
      book: form.bookwise,
      rep_name: form.repwise,
      office_rep_name: form.officerepwise,
      remark: form.remarkwise,
      book_seller_name: form.booksellerwise
    };


    this.service.getBookReceiptRegisterSearch1(req)
      .subscribe((res: any) => {

        console.log(res);

        this.bookCrdtRegisterdata = res.data;

        this.FilteredbookCrdtdata = this.bookCrdtRegisterdata;

        this.receivedCrdtAmount =
          this.FilteredbookCrdtdata.reduce((sum, item) => {

            return sum + (Number(item.crdtnote_total) || 0);

          }, 0);

      });
  }


  getBookCommissionDateFilter() {

    console.log(this.bookrepcommisionform.value);

    const startDate = formatDate(this.bookrepcommisionform.value.start, 'yyyy-MM-dd', 'en-US');
    const endDate = formatDate(this.bookrepcommisionform.value.end, 'yyyy-MM-dd', 'en-US');

    const req: any = {
      start_date: startDate,
      end_date: endDate,

      rep_name: this.bookrepcommisionform.value.repwise,
      office_rep_name: this.bookrepcommisionform.value.officerepwise,
      book_seller_name: this.bookrepcommisionform.value.booksellerwise,

      // ✅ SEND COMMISSION TYPE FILTER
      commission_filter: this.bookrepcommisionform.value.commissionType || "All"
    };

    this.service.getBookOutstandingSearch2(req).subscribe((data) => {
      this.repcommissiondata = data;
      this.calculateTotals();
    });

  }


  getBookCommissionDateFilter1() {
    debugger

    const repwise = this.bookrepcommision1form.value.repwise || [];
    const officerepwise = this.bookrepcommision1form.value.officerepwise || [];

    const req = {
      rep_name: repwise.includes('ALL') ? [] : repwise,
      office_rep_name: officerepwise.includes('ALL') ? [] : officerepwise
    };

    this.service.getBookOutstandingSearch1(req).subscribe((data: any[]) => {
      this.bookwisereplist = data;
      this.getContractDetails();
    });
  }




  getBookOutstandingDateFilter() {
    console.log(this.bookoutstandingform.value)

    const startDate = formatDate(this.bookoutstandingform.value.start, 'yyyy-MM-dd', 'en-US');
    const endDate = formatDate(this.bookoutstandingform.value.end, 'yyyy-MM-dd', 'en-US');
    const req: any = {
      "start_date": startDate,
      "end_date": endDate,
      //"bill_no":this.bookoutstandingform.value.billnowise,
      //"book":this.bookoutstandingform.value.bookwise,
      "rep_name": this.bookoutstandingform.value.repwise,
      "office_rep_name": this.bookoutstandingform.value.officerepwise,
      "book_seller_name": this.bookoutstandingform.value.booksellerwise,
    }

    this.service.getBookOutstandingSearch(req).subscribe((data) => {

      this.bookOutstandingdata = data;

      this.Filteredbookoutstandingdata = [];
      this.Filteredbookoutstandingdata = this.bookOutstandingdata
      console.log(this.Filteredbookoutstandingdata, "data bookOutstandingdata")
      this.calculateTotals3();
    });


  }

  getBookReceiptDateFilter() {
    debugger;

    const formValue = this.bookrcptregisterform.value;
    console.log('Form Values:', formValue);

    /* ==============================
       RECEIPT DATE FORMAT (IMPORTANT)
    ============================== */
    const startDate = formValue.start
      ? formatDate(formValue.start, 'yyyy-MM-dd', 'en-US')
      : '';

    const endDate = formValue.end
      ? formatDate(formValue.end, 'yyyy-MM-dd', 'en-US')
      : '';

    /* ==============================
       REQUEST PAYLOAD
    ============================== */
    const req: any = {
      start_date: startDate,        // ✅ FIXED
      end_date: endDate,            // ✅ FIXED (no double underscore)
      bill_no: formValue.billnowise || '',
      book: formValue.bookwise || '',
      rep_name: formValue.repwise || '',
      office_rep_name: formValue.officerepwise || '',
      book_seller_name: formValue.booksellerwise || ''
    };

    console.log('Final Payload:', req);

    /* ==============================
       API CALL
    ============================== */
    this.service.getBookReceiptRegisterrSearch(req).subscribe(
      (res: any) => {
        this.bookReceiptRegisterdata = Array.isArray(res?.data) ? res.data : [];
        this.FilteredbookRcptRegisterdata = [...this.bookReceiptRegisterdata];

        /* ==============================
           TOTAL CALCULATION
        ============================== */
        this.receivedAmount = this.FilteredbookRcptRegisterdata.reduce(
          (sum: number, item: any) =>
            sum + (Number(item.select_entry_amt) || 0),
          0
        );

        console.log('Filtered Data:', this.FilteredbookRcptRegisterdata);
        console.log('Total select_entry_amt:', this.receivedAmount);
      },
      error => {
        console.error('API Error:', error);
        this.bookReceiptRegisterdata = [];
        this.FilteredbookRcptRegisterdata = [];
        this.receivedAmount = 0;
      }
    );
  }

  calculateTotals2(): void {
    // Reset totals
    this.totalInvoice = 0;
    this.totalReceipt = 0;
    this.totalCredit = 0;
    this.totalPending = 0;

    this.Filteredbookoutstandingdata.forEach(item => {
      this.totalInvoice += Number(item.invoice_total || 0);
      this.totalReceipt += Number(item.selecteamt_total || 0);
      this.totalCredit += Number(item.crdtnote_total || 0);
      this.totalPending += Number(item.remaining_amt || 0);
    });
  }


  selectAll1(event: any) {
    const checked = event.checked;

    this.allSelectedtable = checked;

    this.FilteredDeliveryManageBooks.forEach(book => {
      book.is_selected = checked;
    });
  }

  /* ================= SINGLE ROW CHANGE ================= */
  onRowSelectionChange() {
    this.allSelectedtable =
      this.FilteredDeliveryManageBooks.length > 0 &&
      this.FilteredDeliveryManageBooks.every(book => book.is_selected);
  }

  /* ================= GET SELECTED ROWS ================= */
  getSelectedBooks1() {
    return this.FilteredDeliveryManageBooks.filter(book => book.is_selected);
  }






  getBookCommisionReceiptDateFilter() {

    const formValue = this.bookcommrcptform.value;

    const startDate = formValue.start
      ? formatDate(formValue.start, 'yyyy-MM-dd', 'en-US')
      : null;

    const endDate = formValue.end
      ? formatDate(formValue.end, 'yyyy-MM-dd', 'en-US')
      : null;

    const cleanArray = (val: any) => {
      if (!val) return null;
      const arr = Array.isArray(val)
        ? val.filter(v => v && v !== 'ALL')
        : [val];
      return arr.length ? arr : null;
    };

    const req: any = {};

    // ✅ Send only if exists
    if (startDate && endDate) {
      req.start_date = startDate;
      req.end_date = endDate;
    }

    if (cleanArray(formValue.repwise)) req.rep_name = cleanArray(formValue.repwise);
    if (cleanArray(formValue.billnowise)) req.bill_no = cleanArray(formValue.billnowise);
    if (cleanArray(formValue.bookwise)) req.book_name = cleanArray(formValue.bookwise);
    if (cleanArray(formValue.officerepwise)) req.office_rep_name = cleanArray(formValue.officerepwise);
    if (cleanArray(formValue.booksellerwise)) req.book_seller_name = cleanArray(formValue.booksellerwise);

    console.log("🔥 FINAL REQUEST:", req);

    this.service.getBookCommisionReceiptRegisterrSearch(req)
      .subscribe({
        next: (res: any) => {

          const data = res?.data || res || [];

          this.bookRcptCommisionRegisterdata = data;
          this.FilteredCommbookRcptRegisterdata = data;

          this.receivedCommAmount = data.reduce((sum: number, item: any) => {
            return sum + (Number(item.select_entry_amt) || 0);
          }, 0);
          this.calculateTotals4();

          console.log("✅ Total:", this.receivedCommAmount);
        },
        error: (err) => {
          console.error("❌ API ERROR:", err);
        }
      });
  }



  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  exportExcelv(): void {
    const selectedData = this.bookRcptCommisionRegisterdata.filter(item => item.selected);
    const exportData = (selectedData.length > 0 ? selectedData : this.bookRcptCommisionRegisterdata);

    if (!exportData || exportData.length === 0) {
      alert('No data available to export.');
      return;
    }

    const rows = exportData.map((item, index) => ({
      'Sr No': index + 1,
      'Voucher No': item.voucher_no,
      'Voucher Date': item.voucher_date ? new Date(item.voucher_date).toLocaleDateString('en-GB') : '',
      'Commission No': item.commission_no,
      'Commission Date': item.voucher_date ? new Date(item.voucher_date).toLocaleDateString('en-GB') : '',
      'Representative Name': item.rep_name,
      'Office Representative': item.office_rep_name,
      'Book Seller': item.book_seller_name,
      'Bill Date': item.billdate ? new Date(item.billdate).toLocaleDateString('en-GB') : '',
      'Bill No': item.bill_no,
      'Bill Amount': item.bill_amount,
      'Rep Commission Amount': item.rep_commission_amt,
      'Rep Paid Amount': item.select_entry_amt,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Auto column widths
    const colWidths = Object.keys(rows[0]).map(key => ({
      wch: Math.max(key.length, ...rows.map(r => String(r[key as keyof typeof r] ?? '').length)) + 2
    }));
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Book Commission Register');

    const fileName = `Book_Commission_Register_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  }
  getTotal(arg0: string, dataToExport: any) {
    throw new Error('Method not implemented.');
  }
  exportExceld(fileName: string): void {
    let exportData: any[] = [];

    if (fileName === 'Pending_credit_voucher_book') {

      // Data rows
      exportData = this.FilteredVoucherData.map((book: any, i: number) => ({
        'Sr.No.': i + 1,
        'Voucher No.': book.voucher_no,
        'Voucher Date': book.voucher_date,
        'Entry Date': book.entry_date,
        'Rep. Name': book.rep_name,
        'Book Seller Name': book.book_seller_name,
        'Book Name': book.book_names,
        'Book Amount': book.price,
        'Commission': book.commission,
        'Remaining Amount': book.remaining_amt,
        'Cheque No': book.cheque_no == 0 ? '-' : book.cheque_no,
        'Bank Name': book.bank,
        'Cheque Date': book.chequeDate === '0000-00-00' ? '-' : book.chequeDate,
        'Branch Name': book.branch_name,
      }));

      // Total/footer row
      exportData.push({
        'Sr.No.': `Total: ${this.getallVouchersData?.length || 0}`,
        'Voucher No.': '',
        'Voucher Date': '',
        'Entry Date': '',
        'Rep. Name': '',
        'Book Seller Name': '',
        'Book Name': '',
        'Book Amount': this.priceTotal,
        'Commission': this.commissionTotal,
        'Remaining Amount': this.remainingTotal,
        'Cheque No': '',
        'Bank Name': '',
        'Cheque Date': '',
        'Branch Name': '',
      });

    } else if (fileName === 'Pending_credit_voucher_granth') {

      // Data rows
      exportData = this.FilteredGranthData.map((granth: any, i: number) => ({
        'Sr.No.': i + 1,
        'Voucher No.': granth.voucher_no,
        'Voucher Date': granth.voucher_date,
        'Entry Date': granth.entry_date,
        'Rep. Name': granth.rep_name,
        'Book Seller Name': granth.book_seller_name,
        'Granth Name': granth.book_names,
        'Granth Amount': granth.price,
        'Commission': granth.commission,
        'Remaining Amount': granth.remaining_amt,
        'Cheque No': granth.cheque_no == 0 ? '-' : granth.cheque_no,
        'Bank Name': granth.bank,
        'Cheque Date': granth.chequeDate === '0000-00-00' ? '-' : granth.chequeDate,
        'Branch Name': granth.branch_name,
      }));

      // Total/footer row
      exportData.push({
        'Sr.No.': `Total: ${this.getallVouchersDatagranth?.length || 0}`,
        'Voucher No.': '',
        'Voucher Date': '',
        'Entry Date': '',
        'Rep. Name': '',
        'Book Seller Name': '',
        'Granth Name': '',
        'Granth Amount': this.granthPriceTotal,
        'Commission': this.granthCommissionTotal,
        'Remaining Amount': this.granthRemainingTotal,
        'Cheque No': '',
        'Bank Name': '',
        'Cheque Date': '',
        'Branch Name': '',
      });
    }

    // Generate and download Excel file
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Sheet1': worksheet },
      SheetNames: ['Sheet1']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, `${fileName}_${new Date().getTime()}.xlsx`);
  }
  exportExcell(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  exportExcel3(reportName: string) {

    // Prepare Excel data (exclude Action column)
    const excelData = this.bookwisereplist.map((item: any, index: number) => ({
      'Sr. No': index + 1,
      'Representative Name': item.rep_name,
      'Representative Mobile No': item.rep_mob_no,
      'Representative District': item.district,
      'Office Representative': item.off_rep_name
    }));

    // Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Report': worksheet },
      SheetNames: ['Report']
    };

    // File name with date
    const fileName = `${reportName}_${new Date().toISOString().slice(0, 10)}.xlsx`;

    // Export
    XLSX.writeFile(workbook, fileName);
  }
  exportExcel5(type: 'Pending_credit_voucher_book' | 'Pending_credit_voucher_granth') {
    let dataToExport: any[] = [];

    if (type === 'Pending_credit_voucher_book') {
      dataToExport = this.FilteredVoucherData.map(item => ({
        'Voucher No.': item.voucher_no,
        'Voucher Date': item.voucher_date,
        'Entry Date': item.entry_date,
        'Rep. Name': item.rep_name,
        'Book Seller Name': item.book_seller_name,
        'Book Name': item.book_names,
        'Book Amount': item.price,
        'Commission': item.commission,
        'Remaining Amount': item.remaining_amt,
        'Cheque No.': item.cheque_no === 0 ? '-' : item.cheque_no,
        'Bank Name': item.bank,
        'Cheque Date': item.chequeDate === '0000-00-00' ? '-' : item.chequeDate,
        'Branch Name': item.branch_name
      }));
    } else if (type === 'Pending_credit_voucher_granth') {
      dataToExport = this.FilteredGranthData.map(item => ({
        'Voucher No.': item.voucher_no,
        'Voucher Date': item.voucher_date,
        'Entry Date': item.entry_date,
        'Rep. Name': item.rep_name,
        'Book Seller Name': item.book_seller_name,
        'Granth Name': item.book_names,
        'Granth Amount': item.price,
        'Commission': item.commission,
        'Remaining Amount': item.remaining_amt,
        'Cheque No.': item.cheque_no === 0 ? '-' : item.cheque_no,
        'Bank Name': item.bank,
        'Cheque Date': item.chequeDate === '0000-00-00' ? '-' : item.chequeDate,
        'Branch Name': item.branch_name
      }));
    }

    // Create worksheet and workbook
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, type);

    // Save Excel file
    XLSX.writeFile(wb, `${type}_${new Date().toISOString().slice(0, 10)}.xlsx`);
  }



  exportExcel1(fileName: string) {
    const table: HTMLTableElement = document.getElementById('print-section') as HTMLTableElement;
    const rows = Array.from(table.rows);

    const data = [];

    // Manually add table headers
    const headers = ['Sr.No.', 'Book Name', 'Author', 'Book Page', 'Price', 'Sale Price'];
    data.push(headers);

    // Loop through table rows and extract only needed columns
    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].cells;
      const rowData = [
        cells[0]?.innerText.trim(), // SR.NO.
        cells[1]?.innerText.trim(), // BOOK NAME
        cells[2]?.innerText.trim(), // AUTHOR
        cells[3]?.innerText.trim(), // BOOK PAGE
        cells[4]?.innerText.trim(), // PRICE
        cells[5]?.innerText.trim(), // SALE PRICE
        // Skip cells[6] (Image) and cells[7] (Action)
      ];
      data.push(rowData);
    }

    // Create worksheet and workbook
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Save to file
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  exportExcel4(reportName: string): void {

    const selectedData = this.FilteredCommbookRcptRegisterdata
      .filter((item: any) => item.is_selected === true);

    if (!selectedData || selectedData.length === 0) {
      alert('Please select at least one record to export');
      return;
    }

    // 🔹 Map only required columns (clean Excel)
    const exportData = selectedData.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Commission Date': item.commission_date,
      'Commission No': item.commission_no,
      'Voucher No': item.voucher_no,
      'Voucher Date': item.voucher_date,
      'Book Seller Name': item.book_seller_name,
      'Representative Name': item.rep_name,
      'Office Rep Name': item.office_rep_name,
      'Bill No': item.bill_no,
      'Bill Date': item.billdate,
      'Bill Amount': item.bill_amount,
      'Commission Amount': item.rep_commission_amt,
      'Received Commission Amount': item.select_entry_amt
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Book Commission');

    XLSX.writeFile(workbook, `${reportName}.xlsx`);
  }
  calculateTotals5() {

    this.totalBookPrice = 0;
    this.totalPrintOrder = 0;
    this.totalAuthorHonorarium = 0;

    this.totalPaperBill = 0;
    this.totalPrintingBill = 0;
    this.totalProcessing = 0;
    this.totalCover = 0;
    this.totalOther = 0;
    this.totalShipping = 0;
    this.totalExpense = 0;
    this.totalBilling = 0;
    this.totalReceived = 0;
    this.totalOutstanding = 0;

    this.bookExpenseList.forEach((item: any) => {

      const bookPrice = Number(item.bookprice || 0);
      const printOrder = Number(item.print_order || 0);
      const honorarium = Number(item.author_honorarium || 0);

      const paper = Number(item.paper_bill || 0);
      const printing = Number(item.printing_bill || 0);
      const processing = Number(item.processing || 0);
      const cover = Number(item.cover || 0);
      const other = Number(item.other || 0);
      const shipping = Number(item.shipping_charges || 0);

      const totalExp = paper + printing + processing + cover + other + shipping;

      this.totalBookPrice += bookPrice;
      this.totalPrintOrder += printOrder;
      this.totalAuthorHonorarium += honorarium;

      this.totalPaperBill += paper;
      this.totalPrintingBill += printing;
      this.totalProcessing += processing;
      this.totalCover += cover;
      this.totalOther += other;
      this.totalShipping += shipping;
      this.totalExpense += totalExp;
      this.totalBilling += Number(item.total_amount || 0);
      this.totalReceived += Number(item.received_amt || 0);
      this.totalOutstanding += Number(item.outstanding_amt || 0);

    });

  }

  calculateTotals4() {
    this.totalBillAmount = this.bookRcptCommisionRegisterdata
      .reduce((sum, item) => sum + Number(item.bill_amount || 0), 0);

    this.totalRepCommission = this.bookRcptCommisionRegisterdata
      .reduce((sum, item) => sum + Number(item.rep_commission_amt || 0), 0);

    this.totalSelectEntry = this.bookRcptCommisionRegisterdata
      .reduce((sum, item) => sum + Number(item.select_entry_amt || 0), 0);
  }




  printTable() {
    let tableHeader = `
    <tr>
      <th>SR.NO.</th>
      <th>BOOK NAME</th>
      <th>AUTHOR</th>
      <th>BOOK PAGE</th>
      <th>PRICE</th>
      <th>SALE PRICE</th>
    </tr>`;

    let tableBody = this.Filteredbookdata1.map((book, index) => `
    <tr>
      <td>${index + 1}</td>
      <td>${book["bookname"]}</td>
      <td>${book["author"]}</td>
      <td>${book["book_pages"]}</td>
      <td>${book["price"]}</td>
      <td>${book["saleprice"]}</td>
    </tr>`).join('');

    const printContent = `
    <html>
    <head>
      <title>Book List</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 12pt;
          padding: 20px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 10px;
        }
        th, td {
          border: 1px solid black;
          padding: 8px;
          text-align: left;
        }
        thead {
          background-color: #f0f0f0;
        }
        @media print {
          .noPrint {
            display: none !important;
          }
        }
      </style>
    </head>
    <body>
      <h2>Book List</h2>
      <table>
        <thead>${tableHeader}</thead>
        <tbody>${tableBody}</tbody>
      </table>
    </body>
    </html>
  `;

    const printWindow = window.open('', '', 'height=700,width=900');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    } else {
      alert("Unable to open print window. Please allow pop-ups.");
    }
  }

  // printBookStockTable1() {
  //   const tableHeader = `
  //     <tr>
  //       <th>Sr.No.</th>
  //       <th>Book Name</th>
  //       <th>Author Name</th>
  //       <th>Prakashan Name</th>
  //       <th>Publish Year</th>
  //       <th>Book Edition</th>
  //       <th>Opening Stock</th>
  //       <th>Opening Value<th>
  //       <th>Print Order</th>
  //       <th>Book Price</th>
  //       <th>Book Sale Price</th>
  //       <th>Agent Price</th>
  //       <th>Complementry</th>
  //       <th>Abhiyan</th>
  //       <th>Sold Copies</th>
  //       <th>Total Sell</th>
  //       <th>Available Stock</th>
  //       <th>Closing Value</th>
  //       <th>Total Amount</th>
  //       <th>Receipt Amount</th>
  //       <th>Credit Amount</th>
  //     </tr>`;

  //   const tableBody = this.resultData.map((book: any, index: number) => `
  //     <tr>
  //       <td>${index + 1}</td>
  //       <td>${book.book_name}</td>
  //       <td>${book.author_name}</td>
  //       <td>${book.prakashan_name}</td>
  //       <td>${book.bookyear}</td>
  //       <td>${book.bookedition}</td>
  //       <td>${book.opening_stock}</td>
  //       <td>${book.opening_value_of_book}</td>
  //       <td>${book.print_order}</td>
  //       <td>${book.bookprice}</td>
  //       <td>${book.booksaleprice}</td>
  //       <td>${book.agentprice}</td>
  //       <td>${book.complementry}</td>
  //       <td>${book.abhiyan}</td>
  //       <td>${book.sold_copies}</td>
  //       <td>${book.total_sell}</td>
  //       <td>${book.balance_stock}</td>
  //       <td>${book.value_of_book}</td>
  //       <td>${book.total_biiling}</td>
  //       <td>${book.received_amt}</td>
  //       <td>${book.credit_amount}</td>

  //     </tr>
  //   `).join('');

  //   const printContent = `
  //     <html>
  //     <head>
  //       <title>Book Stock Report</title>
  //       <style>
  //         @page {
  //           size: A3 landscape;
  //           margin: 1cm;
  //         }
  //         body {
  //           font-family: Arial, sans-serif;
  //           font-size: 10pt;
  //           padding: 20px;
  //         }
  //         table {
  //           width: 100%;
  //           border-collapse: collapse;
  //           margin-top: 10px;
  //           table-layout: fixed;
  //         }
  //         th, td {
  //           border: 1px solid #000;
  //           padding: 4px;
  //           text-align: center;
  //           word-break: break-word;
  //           font-size: 9pt;
  //         }
  //         thead {
  //           background-color: #f2f2f2;
  //         }
  //         h2 {
  //           text-align: center;
  //           margin-bottom: 20px;
  //         }
  //         .noPrint {
  //           display: none !important;
  //         }
  //       </style>
  //     </head>
  //     <body>
  //       <h2>Book Stock Report</h2>
  //       <table>
  //         <thead>${tableHeader}</thead>
  //         <tbody>${tableBody}</tbody>
  //       </table>
  //     </body>
  //     </html>
  //   `;

  //   const printWindow = window.open('', '', 'height=800,width=1200');
  //   if (printWindow) {
  //     printWindow.document.write(printContent);
  //     printWindow.document.close();
  //     printWindow.focus();
  //     setTimeout(() => {
  //       printWindow.print();
  //       printWindow.close();
  //     }, 500);
  //   } else {
  //     alert("Popup blocked! Please allow pop-ups for this site.");
  //   }
  // }

  // printTableTillClosingValue() {
  //   const tableHeader = `
  //     <tr>
  //       <th>Sr.No.</th>
  //       <th>Book Name</th>
  //       <th>Author Name</th>
  //       <th>Prakashan Name</th>
  //       <th>Publish Year</th>
  //       <th>Book Edition</th>
  //       <th>Opening Stock</th>
  //       <th>Print Order</th>
  //       <th>Book Price</th>
  //       <th>Book Sale Price</th>
  //       <th>Agent Price</th>
  //       <th>Complementry</th>
  //       <th>Abhiyan</th>
  //       <th>Sold Copies</th>
  //       <th>Total Sell</th>
  //       <th>Available Stock</th>
  //       <th>Closing Value</th>
  //     </tr>`;

  //   const tableBody = this.resultData.map((book: any, index: number) => `
  //     <tr>
  //       <td>${index + 1}</td>
  //       <td>${book.book_name}</td>
  //       <td>${book.author_name}</td>
  //       <td>${book.prakashan_name}</td>
  //       <td>${book.bookyear}</td>
  //       <td>${book.bookedition}</td>
  //       <td>${book.opening_stock}</td>
  //       <td>${book.print_order}</td>
  //       <td>${book.bookprice}</td>
  //       <td>${book.booksaleprice}</td>
  //       <td>${book.agentprice}</td>
  //       <td>${book.complementry}</td>
  //       <td>${book.abhiyan}</td>
  //       <td>${book.sold_copies}</td>
  //       <td>${book.total_sell}</td>
  //       <td>${book.balance_stock}</td>
  //       <td>${book.value_of_book}</td>
  //     </tr>
  //   `).join('');

  //   const printContent = `
  //     <html>
  //     <head>
  //       <title>Book Stock Report</title>
  //       <style>
  //         @page {
  //           size: A4 landscape;
  //           margin: 1cm;
  //         }
  //         body {
  //           font-family: Arial, sans-serif;
  //           font-size: 10pt;
  //           padding: 20px;
  //         }
  //         table {
  //           width: 100%;
  //           border-collapse: collapse;
  //           margin-top: 10px;
  //           table-layout: fixed;
  //         }
  //         th, td {
  //           border: 1px solid #000;
  //           padding: 4px;
  //           text-align: center;
  //           word-break: break-word;
  //           font-size: 9pt;
  //         }
  //         thead {
  //           background-color: #f2f2f2;
  //         }
  //         h2 {
  //           text-align: center;
  //           margin-bottom: 20px;
  //         }
  //         .noPrint {
  //           display: none !important;
  //         }
  //       </style>
  //     </head>
  //     <body>
  //       <h2>Book Stock Report</h2>
  //       <table>
  //         <thead>${tableHeader}</thead>
  //         <tbody>${tableBody}</tbody>
  //       </table>
  //     </body>
  //     </html>
  //   `;

  //   const printWindow = window.open('', '', 'height=800,width=1000');
  //   if (printWindow) {
  //     printWindow.document.write(printContent);
  //     printWindow.document.close();
  //     printWindow.focus();
  //     setTimeout(() => {
  //       printWindow.print();
  //       printWindow.close();
  //     }, 500);
  //   } else {
  //     alert("Popup blocked! Please allow pop-ups for this site.");
  //   }
  // }
  printBookStockTable1() {
    // Step 1: Calculate totals
    let openingstockTotal = 0;
    let openingValueTotal = 0;
    let printorderTotal = 0;
    let complementryTotal = 0;
    let abhiyanTotal = 0;
    let soldCopiesTotal = 0;
    let totalSellTotal = 0;
    let availableTotal = 0;
    let valueOfBookTotal = 0;
    let totalBillingTotal = 0;
    let receivedAmtTotal = 0;
    let creditAmountTotal = 0;

    this.resultData.forEach((book: any) => {
      openingstockTotal += parseFloat(book.opening_stock) || 0;
      openingValueTotal += parseFloat(book.opening_value_of_book) || 0;
      printorderTotal += parseFloat(book.print_order) || 0;
      complementryTotal += parseFloat(book.complementry) || 0;
      abhiyanTotal += parseFloat(book.abhiyan) || 0;
      soldCopiesTotal += parseFloat(book.sold_copies) || 0;
      totalSellTotal += parseFloat(book.total_sell) || 0;
      availableTotal += parseFloat(book.balance_stock) || 0;
      valueOfBookTotal += parseFloat(book.value_of_book) || 0;
      totalBillingTotal += parseFloat(book.total_biiling) || 0;
      receivedAmtTotal += parseFloat(book.received_amt) || 0;
      creditAmountTotal += parseFloat(book.credit_amount) || 0;
    });

    // Step 2: Table headers
    const tableHeader = `
    <tr>
      <th>Sr.No.</th>
      <th>Book Name</th>
      <th>Author Name</th>
      <th>Prakashan Name</th>
      <th>Publish Year</th>
      <th>Book Edition</th>
      <th>Opening Stock</th>
      <th>Opening Value</th>
      <th>Print Order</th>
      <th>Book Price</th>
      <th>Book Sale Price</th>
      <th>Agent Price</th>
      <th>Complementry</th>
      <th>Abhiyan</th>
      <th>Sold Copies</th>
      <th>Total Sell</th>
      <th>Available Stock</th>
      <th>Closing Value</th>
      <th>Total Amount</th>
      <th>Receipt Amount</th>
      <th>Credit Amount</th>
    </tr>`;

    // Step 3: Table body rows
    const tableBody = this.resultData.map((book: any, index: number) => `
    <tr>
      <td>${index + 1}</td>
      <td>${book.book_name}</td>
      <td>${book.author_name}</td>
      <td>${book.prakashan_name}</td>
      <td>${book.bookyear}</td>
      <td>${book.bookedition}</td>
      <td>${book.opening_stock}</td>
      <td>${book.opening_value_of_book}</td>
      <td>${book.print_order}</td>
      <td>${book.bookprice}</td>
      <td>${book.booksaleprice}</td>
      <td>${book.agentprice}</td>
      <td>${book.complementry}</td>
      <td>${book.abhiyan}</td>
      <td>${book.sold_copies}</td>
      <td>${book.total_sell}</td>
      <td>${book.balance_stock}</td>
      <td>${book.value_of_book}</td>
      <td>${book.total_biiling}</td>
      <td>${book.received_amt}</td>
      <td>${book.credit_amount}</td>
    </tr>
  `).join('');

    // Step 4: Table footer with totals
    const tableFooter = `
    <tfoot style="font-weight: bold; background-color: #f9f9f9;">
      <tr>
        <td colspan="6" style="text-align: right;">Total:</td>
        <td>${openingstockTotal}</td>
        <td>${openingValueTotal.toFixed(2)}</td>
        <td>${printorderTotal}</td>
        <td></td>
        <td></td>
        <td></td>
        <td>${complementryTotal}</td>
        <td>${abhiyanTotal}</td>
        <td>${soldCopiesTotal}</td>
        <td>${totalSellTotal}</td>
        <td>${availableTotal}</td>
        <td>${valueOfBookTotal.toFixed(2)}</td>
        <td>${totalBillingTotal.toFixed(2)}</td>
        <td>${receivedAmtTotal.toFixed(2)}</td>
        <td>${creditAmountTotal.toFixed(2)}</td>
      </tr>
    </tfoot>`;

    // Step 5: Full HTML content
    const printContent = `
    <html>
    <head>
      <title>Book Stock Report</title>
      <style>
        @page { size: A3 landscape; margin: 1cm; }
        body { font-family: Arial, sans-serif; font-size: 10pt; padding: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; table-layout: fixed; }
        th, td { border: 1px solid #000; padding: 4px; text-align: center; word-break: break-word; font-size: 9pt; }
        thead { background-color: #f2f2f2; }
        h2 { text-align: center; margin-bottom: 20px; }
        tfoot { font-weight: bold; }
      </style>
    </head>
    <body>
      <h2>Book Stock Report</h2>
      <table>
        <thead>${tableHeader}</thead>
        <tbody>${tableBody}</tbody>
        ${tableFooter}
      </table>
    </body>
    </html>
  `;

    const printWindow = window.open('', '', 'height=800,width=1200');
    if (printWindow) {
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);
    } else {
      alert("Popup blocked! Please allow pop-ups for this site.");
    }
  }




  printTableTillClosingValue() {

    const printContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>.</title>
    <meta charset="UTF-8">

    <style>

      @page {
        size: A4 landscape;
        margin: 10mm;
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 9pt;
        color: #000;
      }

      .header {
        text-align: center;
        margin-bottom: 15px;
      }

      .header h2 {
        margin: 5px 0;
        font-size: 16pt;
        font-weight: bold;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 8pt;
      }

      table, th, td {
        border: 1px solid #000;
      }

      th {
        background-color: #f0f0f0;
        padding: 4px 2px;
        font-weight: bold;
        text-align: center;
      }

      td {
        padding: 3px 2px;
        text-align: center;
      }

      .text-end {
        text-align: right;
        font-weight: bold;
      }

      /* TOTAL ROW STYLE */
      .total-row {
        background-color: #c8753f !important;
        font-weight: bold;
      }

      /* FORCE COLOR IN PRINT */
      @media print {

        .total-row {
          background-color: #c8753f !important;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

      }

    </style>
  </head>

  <body>

    <!-- HEADER -->
    <div class="header">
      <h2>Book Stock Report</h2>
    </div>

    <table>

      <thead>
        <tr>
          <th>Sr.No.</th>
          <th>Book Name</th>
          <th>Author</th>
          <th>Prakashan</th>
          <th>Publish Year</th>
          <th>Edition</th>
          <th>Opening Stock</th>
          <th>Opening Value</th>
          <th>Print Order</th>
          <th>Book Price</th>
          <th>Sale Price</th>
          <th>Agent Price</th>
          <th>Comp Copy</th>
          <th>Abhiyan Copy</th>
          <th>Sold Copy</th>
          <th>Total Sell</th>
          <th>Available Stock</th>
          <th>Closing Value</th>
        </tr>
      </thead>

      <tbody>
        ${this.generateTableRows()}
      </tbody>

      <!-- TOTAL ROW -->
    

        <tr class="total-row">

          <td colspan="6" class="text-end">Total:</td>

          <td>${this.openingstockTotal || 0}</td>
          <td>${this.formatNumber(this.openingValueTotal)}</td>
          <td>${this.printorderTotal || 0}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>${this.complementryTotal || 0}</td>
          <td>${this.abhiyanTotal || 0}</td>
          <td>${this.soldCopiesTotal || 0}</td>
          <td>${this.formatNumber(this.totalSellTotal)}</td>
          <td>${this.availableTotal || 0}</td>
          <td>${this.formatNumber(this.valueOfBookTotal)}</td>

        </tr>

    

    </table>

  </body>
  </html>
  `;


    const printWindow = window.open('', '_blank', 'width=1200,height=800');
    if (!printWindow) return;

    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };

  }
  applyFilters(): void {
    debugger
    const { adesh_from, adesh_to } = this.generateform1.value;

    this.printOrderData = this.originalPrintOrderData.filter((item: any) => {

      if (!item.adesh_date) {
        return false;
      }

      const adeshDate = new Date(item.adesh_date).toISOString().split('T')[0];

      if (adesh_from && adeshDate < adesh_from) {
        return false;
      }

      if (adesh_to && adeshDate > adesh_to) {
        return false;
      }

      return true;
    });
  }



  // Helper method to generate table rows
  private generateTableRows(): string {
    return this.resultData.map((book, index) => `
    <tr>
      <td>${index + 1}</td>
<td class="fw-700" style="text-align:left;font-weight: bold;">
  ${book['book_name'] || ''}
</td>

      <td   style="text-align: left;">${book['author_name'] || ''}</td>
      <td  style="text-align: left;">${book['prakashan_name'] || ''}</td>
 <td>${new Date(book.bookyear).toLocaleDateString('en-GB').replace(/\//g, '-')
      }</td>


      <td>${book['bookedition'] || ''}</td>
      <td>${book['opening_stock'] || 0}</td>
      <td>${book['opening_value_of_book'] || 0}</td>
      <td>${book['print_order'] || 0}</td>
      <td>${book['bookprice'] || 0}</td>
      <td>${book['booksaleprice'] || 0}</td>
      <td>${book['agentprice'] || 0}</td>
      <td>${book['complementry'] || 0}</td>
      <td>${book['abhiyan'] || 0}</td>
      <td>${book['sold_copies'] || 0}</td>
      <td>${book['total_sell'] || 0}</td>
      <td>${book['balance_stock'] || 0}</td>
      <td>${book['value_of_book'] || 0}</td>
    </tr>
  `).join('');
  }

  // Helper method to format date
  private formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    return d.getFullYear().toString();
  }

  // Helper method to format numbers with 2 decimal places
  private formatNumber(value: any): string {
    if (!value && value !== 0) return '0.00';
    return Number(value).toFixed(2);
  }

  // Helper method to get date range text
  private getDateRangeText(): string {
    const startDate = this.BookStockform.get('start_date')?.value;
    const endDate = this.BookStockform.get('end_date')?.value;

    if (startDate && endDate) {
      const start = new Date(startDate).toLocaleDateString('en-IN');
      const end = new Date(endDate).toLocaleDateString('en-IN');
      return `<div class="date-range"><strong>Period:</strong> ${start} to ${end}</div>`;
    }
    return '';
  }












  getSelectedbookname = '';
  getBookname(event, option) {
    if (event.isUserInput) {
      this.getSelectedbookname = option['bookname'];
    }
  }

  allSelectedtable = false;
  someComplete(): boolean {
    if (this.bookRcptRegisterdata == null) {
      return false;
    }
    return (
      this.bookRcptRegisterdata.filter((t) => t.is_selected).length > 0 &&
      !this.allSelectedtable
    );
  }


  //getBookRcptPymtData
  selectall(event) {
    // if(event.checked){
    //   debugger
    //   this.total =0;
    //   this.data_for_two_receipt.forEach(element => {
    //     element.is_selected = true;
    //     // this.total = this.total + element.remain_amt
    //   })
    //   }

    //   else{
    //     this.data_for_two_receipt.forEach(element => {
    //       element.is_selected = false;
    //     });;
    // }
  }



  copydata1(data1, event) {
    if (event.checked) {
      this.total = this.total + data1.remain_amt
      this.newList1.push(data1);
    }
    else {
      this.newList1 = this.newList1.filter((person: any) => person.rcpt_no !== data1.rcpt_no).slice();
      this.total = this.total - data1.remain_amt
    }
    console.log(this.newList1, "this.newList")
    console.log(this.total)
  }


  copydata2(data1, event) {
    if (event.checked) {
      this.total = this.total + (data1.remain_amt || 0);
      this.newList1.push(data1);
    } else {
      this.newList1 = this.newList1.filter(
        (person: any) => person.invoice_no !== data1.invoice_no
      );
      this.total = this.total - (data1.remain_amt || 0);
    }

    console.log(this.newList1, "Selected list");
    console.log(this.total, "Total");
  }

  copydata3(data1, event) {
    if (event.checked) {
      this.total = this.total + data1.remain_amt
      this.newList1.push(data1);
    }
    else {
      this.newList1 = this.newList1.filter((person: any) => person.order_no !== data1.order_no).slice();
      this.total = this.total - data1.remain_amt
    }
    console.log(this.newList1, "this.newList")
    console.log(this.total)
  }


  getSelectedrepname = '';
  getselectedpaymentmode = '';
  getRepname(event) {
    this.getSelectedrepname = event.value;
    if (
      this.getselectedpaymentmode == 'all' ||
      this.getselectedpaymentmode == ''
    ) {
      this.filterBookwiseReport = this.bookwisereportData.filter(
        (a) => a['rep_name'] == this.getSelectedrepname
      );
    } else {
      if (this.getSelectedrepname == 'all') {
        this.filterBookwiseReport = this.bookwisereportData.filter(
          (a) => a['paymentmode'] == this.getselectedpaymentmode
        );
      } else {
        this.filterBookwiseReport = this.bookwisereportData.filter(
          (a) =>
            a['rep_name'] == this.getSelectedrepname &&
            a['paymentmode'] == this.getselectedpaymentmode
        );
      }
    }
  }

  ClearFilter() {
    this.filterBookwiseReport = this.bookwisereportData;
  }

  paymodes = ['all', 'cash', 'complementry', 'sponsor', 'online', 'paylater', 'cheque'];
  getpaymentmode(event) {
    this.getselectedpaymentmode = event.value;
    if (this.getSelectedrepname == 'all' || this.getSelectedrepname == '') {
      this.filterBookwiseReport = this.bookwisereportData.filter(
        (a) => a['paymentmode'] == this.getselectedpaymentmode
      );
    } else {
      if (this.getselectedpaymentmode == 'all') {
        this.filterBookwiseReport = this.bookwisereportData.filter(
          (a) => a['rep_name'] == this.getSelectedrepname
        );
      } else {
        this.filterBookwiseReport = this.bookwisereportData.filter(
          (a) =>
            a['rep_name'] == this.getSelectedrepname &&
            a['paymentmode'] == this.getselectedpaymentmode
        );
      }
    }
  }

  getBookwiseReportonclick() {
    this.showbooks = true;
    this.getBookwiseReport(
      this.getSelectedbookname,
      this.getbookwiseStartDate,
      this.getbookwiseEndDate
    );
  }

  bookstatus_name = '';
  // FilterBook(event) {
  //   let status = event.value;
  //   if (this.rep_name_registration != '' && this.cust_name_registration != '' &&
  //     this.book_name_registration != '') {
  //     this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
  //       (item) => {
  //         return (

  //           item['booking_date'] >= this.startDate_registration &&
  //           item['booking_date'] <= this.enddate_registration &&
  //           item.name
  //             .toLowerCase()
  //             .indexOf(this.cust_name_registration.toLowerCase()) > -1 &&
  //           item.crep_name
  //             .toLowerCase()
  //             .indexOf(this.rep_name_registration.toLowerCase()) > -1 &&
  //           item.bookname.toLowerCase().indexOf(status.toLowerCase()) > -1
  //         );
  //       }
  //     );
  //   } else if (
  //     this.cust_name_registration == ''
  //     // this.paymentStatus == 'all' ||
  //     // status == 'all'
  //   ) {
  //     this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
  //       (item) => {
  //         return (
  //           item['booking_date'] >= this.startDate_registration &&
  //           item['booking_date'] <= this.enddate_registration &&
  //           // item.payment_status
  //           //   .toLowerCase()
  //           //   .indexOf(this.paymentStatus.toLowerCase()) > -1 &&
  //           item.crep_name
  //             .toLowerCase()
  //             .indexOf(this.rep_name_registration.toLowerCase()) > -1 &&
  //           item.bookname.toLowerCase().indexOf(status.toLowerCase()) > -1
  //         );
  //       }
  //     );
  //   } else if (
  //     this.rep_name_registration == ''
  //     // this.paymentStatus == 'all' ||
  //     // status == 'all'
  //   ) {
  //     this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
  //       (item) => {
  //         return (
  //           item['booking_date'] >= this.startDate_registration &&
  //           item['booking_date'] <= this.enddate_registration &&
  //           // item.payment_status
  //           //   .toLowerCase()
  //           //   .indexOf(this.paymentStatus.toLowerCase()) > -1 &&
  //           item.name
  //             .toLowerCase()
  //             .indexOf(this.cust_name_registration.toLowerCase()) > -1 &&
  //           item.bookname.toLowerCase().indexOf(status.toLowerCase()) > -1
  //         );
  //       }
  //     );
  //   } else {
  //     this.FilteredBookRegistration1 = this.bookregistrationdata.filter(
  //       (item) => {
  //         return (
  //           item['booking_date'] >= this.startDate_registration &&
  //           item['booking_date'] <= this.enddate_registration &&
  //           item.bookname.toLowerCase().indexOf(status.toLowerCase()) > -1
  //         );
  //       }
  //     );
  //   }
  // }


  FilterBook() {
    const bookName = this.book_name_registration?.toLowerCase() || '';
    const custName = this.cust_name_registration?.toLowerCase() || '';
    const repName = this.rep_name_registration?.toLowerCase() || '';

    this.FilteredBookRegistration1 = this.bookregistrationdata.filter(item => {
      const isDateInRange =
        item['booking_date'] >= this.startDate_registration &&
        item['booking_date'] <= this.enddate_registration;

      const matchesBookName = !bookName || item.bookname?.toLowerCase() === bookName;
      const matchesCustName = !custName || item.name?.toLowerCase() === custName;
      const matchesRepName = !repName || item.crep_name?.toLowerCase() === repName;

      return isDateInRange && matchesBookName && matchesCustName && matchesRepName;
    });
    this.bookCopiesTotal = 0;
    this.shippingCharges = 0;
    this.totalTotal = 0;
    this.recvTotal = 0;
    this.creditTotal = 0;
    this.remTotal = 0;

    for (let data of this.FilteredBookRegistration1) {
      this.bookCopiesTotal += parseInt(data.bookcopies) || 0;
      this.shippingCharges += parseInt(data.shipping_charges) || 0;
      this.totalTotal += parseInt(data.total) + parseInt(data.shipping_charges) || 0;
      this.recvTotal += parseInt(data.receivedamt) || 0;
      this.creditTotal += parseInt(data.crdtamt) || 0;
      this.remTotal += parseInt(data.remainingamt) || 0;

    }
  }


  GetUpdatedCommissionValue(id) {
    let commission = window.prompt('Please enter new Comission Percentage!');
    if (commission == '' || commission == null) {
      commission = '0';
    } else {
      this.service
        .updateRep_book_commision(parseInt(id), parseInt(commission))
        .subscribe((data) => {
          this.service.get_AllRepresentative_List().subscribe((data) => {
            this.getAllRepList = data;
          });
        });
    }
  }

  getinvoicestartDate;
  getinvoiceEndDate;
  getDateRange() {
    if (
      this.invoicegetBook.get('start').value != null &&
      this.invoicegetBook.get('end').value != null
    ) {
      this.getinvoicestartDate = formatDate(
        new Date(this.invoicegetBook.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getinvoiceEndDate = formatDate(
        new Date(this.invoicegetBook.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  nameid;
  name;
  selectedname(event, option) {
    if (event.isUserInput) {
      this.nameid = option['id'];
      this.name = option['name'];
    }
  }

  billid;
  invoice_nos;
  selectedBillno(event, option) {
    if (event.isUserInput) {
      this.billid = option['id'];
      this.invoice_nos = option['invoice_no'];
    }
  }



  nameeid;
  rep_name;
  selectedrepname(event, option) {
    if (event.isUserInput) {
      this.nameeid = option['id'];
      this.rep_name = option['rep_name'];
    }
  }


  getSelectedRepId;
  getSelectedRep;
  SelectRepresentative(event) {
    this.getSelectedRepId = event.value;
    this.getSelectedRep = this.getAllRepList.find(
      (a) => a['id'] == parseInt(this.getSelectedRepId)
    );
    this.service
      .Rep_invoiceBooks(
        parseInt(this.getSelectedRepId),
        this.getinvoicestartDate,
        this.getinvoiceEndDate
      )
      .subscribe((data) => {
        this.getRepSpecificBooks = data;
      });
  }

  getRepSelectedBookslist;
  getRepSelectedBooks(event) {
    this.getRepSelectedBookslist = event.value;
  }

  isGSTInvoice = 'N';
  displaygstNumberInput = false;
  getInvoiceType(event) {
    this.isGSTInvoice = event.value;
    if (this.isGSTInvoice == 'Y') {
      this.displaygstNumberInput = true;
    } else {
      this.displaygstNumberInput = false;
    }
  }

  getGstNumber(gst) {
    this.gstNumber = gst;
  }

  invoicedate = '';
  invoicedateChange(event) {
    console.log(event.value);

    this.invoicedate = formatDate(
      event.value,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    this.getInvoiceNo(this.invoicedate)
  }

  invoicedate1 = '';
  invoicedateChangep(event) {
    console.log(event.value);

    this.invoicedate1 = formatDate(
      event.value,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    this.getInvoiceNo(this.invoicedate1)
  }



  getInvoiceNo(date: any) {
    this.service.getBookCustInvoiceId(date).subscribe((data) => {
      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['invoice_no'].split('/')[2]);
      } else {
        value = 0;
      }

      let selectedDate = new Date(date);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      // Determine financial year
      let financialStartYear: number;
      let financialEndYear: number;

      if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar → Previous financial year
        financialStartYear = year - 1;
        financialEndYear = year;
      } else { // Apr to Dec → Current financial year
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      // Generate invoice number
      this.invoiceno = `VBD${month}/${startYearShort}-${endYearShort}/${value <= 8 ? '0' + (value + 1) : value + 1
        }`;

      this.invoicegetCustBook.get('billno').setValue(this.invoiceno)
      console.log('Generated Invoice No:', this.invoiceno);
      console.log('Generated Invoice Book:', this.invoicegetCustBook.value?.billno);

    });
  }
  getInvoiceNopkg(date: any) {
    this.service.getBookCustInvoiceId(date).subscribe((data) => {
      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['invoice_no'].split('/')[2]);
      } else {
        value = 0;
      }

      let selectedDate = new Date(date);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      // Determine financial year
      let financialStartYear: number;
      let financialEndYear: number;

      if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar → Previous financial year
        financialStartYear = year - 1;
        financialEndYear = year;
      } else { // Apr to Dec → Current financial year
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      // Generate invoice number
      this.invoiceno = `VBD${month}/${startYearShort}-${endYearShort}/${value <= 8 ? '0' + (value + 1) : value + 1
        }`;

      this.invoicegetCustBook.get('billno').setValue(this.invoiceno)
      console.log('Generated Invoice No:', this.invoiceno);
      console.log('Generated Invoice Book:', this.invoicegetCustBook.value?.billno);

    });
  }


  crdtNotedate = '';
  crdtNotedateChange(event) {
    console.log(event.value);

    this.crdtNotedate = formatDate(
      event.value,
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );
    this.getCrdtNoteNo(this.crdtNotedate)
  }
  getCrdtNoteNo(date: any) {
    this.service.getCrdtNoteNo(date).subscribe((data) => {
      let value: number;
      if (Object.keys(data).length > 0) {
        value = parseInt(data[0]['crdtnote_no'].split('/')[2]);
      } else {
        value = 0;
      }

      let selectedDate = new Date(date);
      let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
      let year = selectedDate.getFullYear();

      // Determine financial year
      let financialStartYear: number;
      let financialEndYear: number;

      if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar → Previous financial year
        financialStartYear = year - 1;
        financialEndYear = year;
      } else { // Apr to Dec → Current financial year
        financialStartYear = year;
        financialEndYear = year + 1;
      }

      let startYearShort = financialStartYear.toString().slice(-2);
      let endYearShort = financialEndYear.toString().slice(-2);

      // Generate invoice number
      this.crdtnoteno = `BDCN${month}/${startYearShort}-${endYearShort}/${value <= 8 ? '0' + (value + 1) : value + 1
        }`;

      this.bookcrdtnoteForm.get('crdtnoteno').setValue(this.crdtnoteno)
      console.log('Generated CrdtNote No:', this.crdtnoteno);
      console.log('Generated CrdtNote Book:', this.bookcrdtnoteForm.value?.crdtnoteno);

    });
  }

  invoiceDetails;
  viewmode = false;
  repInvoice = 'Y';
  generateBookInvoice() {


    if (this.invoicedate !== '') {
      if (this.getSelectedCust != undefined) {

        this.invoiceDetails = {
          rep: this.getSelectedRep,
          books: this.getRepSelectedBookslist,
          date: this.invoicedate,
          GST: this.isGSTInvoice,
          GST_no: this.gstNumber,
          id: this.getSelectedCust,
          invoiceBillNo: this.invoicegetCustBook.value?.billno ?? '',
        };
        console.log('Invoice Details:', this.invoiceDetails);  // Debugging step

        this.viewmode = false;
        this.repInvoice = 'Y';
        this.GenerateInvoice();
      }
    } else {
      alert('Please select a date');
    }







  }

  GenerateInvoice() {
    this.dialog.open(BookinvoiceComponent, {
      data: {
        book: this.invoiceDetails,
        view: this.viewmode,
        rep_invoice: this.repInvoice,


      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
    this.ngOnInit();
  }

  show(book) {
    this.dialog.open(ShowBookInvoiceComponent, {
      data: {
        book: book,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }


  show1(book) {
    debugger
    this.dialog.open(ShowGranthInvoiceComponent, {

      data: {
        book: book,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  viewReceiptPackage(book: any): void {
    debugger
    // Map the list row fields back to the shape ReceiptpackagebookComponent expects
    const formData = {
      orderno: book.orderno,
      recptno: book.recipt_no || book.recptno,
      bookdate: book.booking_date,
      crdtvno: book.voucher_no || book.crdtvno,
      seamt: book.receivedamt || book.seamt,
      receivedamt: book.receivedamt || book.received_amt || 0,
      recipt_amt: book.recipt_amt || 0,
      newordeleted: 'new',

      // Subscriber
      subscribersName: book.subscribers_name,
      subscribersNo: book.subscribers_no,
      mobileNumber: book.mob_no,

      // Personal
      title: book.title || '',
      nameRequired: book.subscribers_name,
      address: book.address || '',
      taluka: book.taluka || '',
      district: book.district || '',
      state: book.state || '',
      country: book.country || '',
      pincode: book.pincode || '',
      email: book.email || '',
      telephone: book.telephone || '',

      // Rep details
      crepname: book.crep_name || '',
      repmobno1: book.representative_mobile || '',
      officerep: book.office_rep_name || '',

      // GST
      bookSellerGstType: book.gstType || 'NO_GST',
      gstPercentage: book.gstPercentage || 0,
      gstAmount: book.gstAmount || 0,
      sgstAmount: book.sgstAmount || 0,
      cgstAmount: book.cgstAmount || 0,
      igstAmount: book.igstAmount || 0,
      totalAmount: book.total || 0,

      // Dispatch
      DeliveryMode: book.DeliveryMode || '',
      DistributiveRep: book.DistributiveRep || '',
      DistributionMode: book.DistributionMode || '',
      SubDistMode: book.SubDistMode || '',
    };

    // Build book_data array from the single row
    // (If your API returns one row per book, this is one item)
    const bookData = [{
      bookname: book.bookname,
      author: book.author_name || book.bookname,
      price: book.bookprice || 0,
      saleprice: book.prakashan_name || 0,
      discount: book.discount || 0,
      discountamt: book.totalafterdiscount || 0,
      totalad: book.totalafterdiscount || 0,
      bookcopies: book.bookcopies || 0,
      total: book.total || 0,
      shippingcharging: book.shipping_charges || 0,
      repcompercent: book.rep_com_percent || 0,
      commissionamt: book.repcommissionamt || 0,
    }];

    const dialogRef = this.dialog.open(ViewReceiptpackagebookComponent, {
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
      data: {
        formData: formData,
        bookData: bookData,
        inputValues: [],
        // total_amt:      ConvertToInt(book.total) + ConvertToInt(book.shipping_charges),
        shipping_total: book.shipping_charges || 0,
        booksellerid: book.id,        // passed as bse_id so it updates, not inserts
        iscomplementary: book.iscomplimentary === 'Y',
        isSponsor: book.isSponsor === 'Y',
        isViewOnly: true,          // ✅ flag to hide Save button in the dialog
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirm') {
        // refresh list if needed
      }
    });
  }

  // opentworeceipt() {
  //   if (!this.newList1 || !this.newList1.length) {
  //     console.warn('No books to show');
  //     return;
  //   }

  //   this.dialog.open(OpeninvoiceprintComponent, {
  //     data: { book: this.newList1 }, // array of books with invoice_no
  //     height: '1300px',
  //     width: '95%',
  //     maxWidth: '100%',
  //   });

  //   console.log(this.newList1, "open multiple receipts");
  // }

  onCheckboxChange(book: any, event: any) {
    if (event.checked) {
      this.newList1.push(book);
    } else {
      this.newList1 = this.newList1.filter(x => x.id !== book.id);
    }
  }

  selectAllRowsbillng4(event: any) {
    if (event.checked) {
      this.newList1 = [...this.Filteredbookbillingdata];
      this.Filteredbookbillingdata.forEach(x => x.is_selected = true);
    } else {
      this.newList1 = [];
      this.Filteredbookbillingdata.forEach(x => x.is_selected = false);
    }
  }

  opentworeceipt() {

    if (!this.newList1 || this.newList1.length === 0) {
      alert('Please select at least one receipt');
      return;
    }

    this.dialog.open(OpeninvoiceprintComponent, {
      data: {
        receiptdata: [...this.newList1]
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%'
    });

  }

  opentworeceipt2() {
    debugger

    const request = {
      startDate: this.fixDate(this.Managerange.value.start),
      endDate: this.fixDate(this.Managerange.value.end),
      rep: this.Managerange.value.repname,
      bookname: this.Managerange.value.book_name,
      custname: this.Managerange.value.custname
    };

    this.service.getBookDataforDelivery2(request)
      .subscribe((data: any) => {

        this.bookdeliverydata = data.data || [];

        const removedIds = this.getRemovedIds();

        this.FilteredDeliveryManageBooks = this.bookdeliverydata.filter(
          (item: any) => !removedIds.includes(Number(item.id))
        );

        this.Filter = this.FilteredDeliveryManageBooks;
      });
  }
  /**
  * UPDATED: Open dialog and handle delivered entries removal
  */
  // ✅ In your PARENT COMPONENT — replace opentworeceipt1() with this:

  opentworeceipt1() {

    // ✅ Get ONLY selected books
    const selectedBooks = this.FilteredDeliveryManageBooks
      .filter((book: any) => book.is_selected);

    if (!selectedBooks.length) {
      alert('Please select at least one record to print.');
      return;
    }

    const dialogRef = this.dialog.open(Bookstoresendmessage1Component, {
      data: { receiptdata: selectedBooks }, // ✅ pass only selected
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.deliveredIds?.length) {

        this.removeFromList(result.deliveredIds);

        const existing = this.getRemovedIds();
        const updated = [
          ...new Set([
            ...existing,
            ...result.deliveredIds.map((x: any) => Number(x))
          ])
        ];

        localStorage.setItem('removedBookIds', JSON.stringify(updated));
      }
    });
  }
  // toggleRow(book: any, event: any) {
  //   book.is_selected = event.checked;
  // }


  // ✅ Call this in ngOnInit() too — handles page refresh
  applyStoredRemovals() {

    const removedIds = JSON.parse(localStorage.getItem('removedBookIds') || '[]');

    if (!removedIds.length) return;

    this.FilteredDeliveryManageBooks =
      this.FilteredDeliveryManageBooks.filter(
        item => !removedIds.includes(item.id)
      );

    this.Filter = [...this.FilteredDeliveryManageBooks];
  }
  saveRemoved(ids: number[]) {

    const existing = this.getRemovedIds();

    const updated = [...new Set([
      ...existing,
      ...ids.map(x => Number(x))
    ])];

    localStorage.setItem('removedBookIds', JSON.stringify(updated));
  }
  // removeFromList(ids: number[]) {

  //   this.FilteredDeliveryManageBooks =
  //     this.FilteredDeliveryManageBooks.filter(
  //       item => !ids.includes(item.id)
  //     );

  //   this.Filter = [...this.FilteredDeliveryManageBooks];
  // }


  // removeFromList(ids: number[]) {
  //   this.FilteredDeliveryManageBooks = this.FilteredDeliveryManageBooks.filter(
  //     item => !ids.includes(item.id)
  //   );
  //   this.Filter = this.Filter.filter(
  //     item => !ids.includes(item.id)
  //   );
  //   this.FilteredDeliveryManageBooks = [...this.FilteredDeliveryManageBooks];
  // }

  /**
   * NEW METHOD: Remove delivered entries from the table
   */
  removeDeliveredEntries(deliveredIds: number[]): void {
    // Filter out delivered books
    this.FilteredDeliveryManageBooks = this.FilteredDeliveryManageBooks.filter(book => {
      return !deliveredIds.includes(book.id);
    });

    // Update checkbox states after removal
    this.updateSelectAllState();

    console.log(`Removed ${deliveredIds.length} entries from table. Remaining: ${this.FilteredDeliveryManageBooks.length}`);
  }

  /**
   * Update select all checkbox state
   */
  updateSelectAllState(): void {
    const selectedCount = this.FilteredDeliveryManageBooks.filter(b => b.is_selected).length;
    const totalCount = this.FilteredDeliveryManageBooks.length;

    this.allSelectedtable = totalCount > 0 && selectedCount === totalCount;
    this.someSelected = selectedCount > 0 && selectedCount < totalCount;
  }

  // Remove entry from receipts and table
  markDone(index: number) {
    const order = this.booksByOrder[index];

    // Remove from booksByOrder (printable view)
    this.booksByOrder.splice(index, 1);

    // Remove from FilteredDeliveryManageBooks (table view)
    const tabIndex = this.FilteredDeliveryManageBooks.findIndex(
      (b) => b.order_no === order.order_no
    );
    if (tabIndex > -1) {
      this.FilteredDeliveryManageBooks.splice(tabIndex, 1);
    }
  }

  // Optional: mark as delivered from tab table button
  markAsDelivered1(book: any) {
    const index = this.booksByOrder.findIndex(
      (b) => b.order_no === book.order_no
    );
    if (index > -1) this.booksByOrder.splice(index, 1);

    const tabIndex = this.FilteredDeliveryManageBooks.findIndex(
      (b) => b.order_no === book.order_no
    );
    if (tabIndex > -1) this.FilteredDeliveryManageBooks.splice(tabIndex, 1);
  }


  //    markDone(index: number) {
  //   if (confirm('Are you sure this entry is completed?')) {
  //     this.booksByOrder.splice(index, 1);
  //   }
  // }




  showOrder(book) {
    this.dialog.open(ShowBookOrderComponent, {
      data: {
        book: book,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  showgranth(book) {
    this.dialog.open(ShowgranthorderComponent, {
      data: {
        book: book,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }
  calculateTotals3() {
    this.totalInvoice = 0;
    this.totalReceipt = 0;
    this.totalCredit = 0;
    this.totalPending = 0;

    this.Filteredbookoutstandingdata.forEach(item => {
      this.totalInvoice += Number(item.invoice_total || 0);
      this.totalReceipt += Number(item.selecteamt_total || 0);
      this.totalCredit += Number(item.crdtnote_total || 0);
      this.totalPending += Number(item.remaining_amt || 0);
    });
  }



  showOrderEntry(book: any) {
    this.dialog.open(ShowOrderEntryBookSellerComponent, {
      data: { book },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%'
    });
  }
  showcrdtrcpt(item) {
    this.dialog.open(ShowBookCrdtNoteRcptComponent, {
      data: {
        data: item,
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  getCustinvoicestartDate;
  getCustinvoiceEndDate;
  getAllCustList = [];
  getCustlistWithoutFilter = [];
  getSpecificBooksCust = [];
  startDate_custReport: string = '';
  endDate_custReport: string = '';
  dateIsEnable: boolean = false;
  // dateIsEnableReport: boolean = false;


  getCustDateRange() {
    this.getAllCustList = [];

    const start = this.invoicegetCustBook.get('start')?.value;
    const end = this.invoicegetCustBook.get('end')?.value;

    if (start != null && end != null) {

      const startDateObj = new Date(start);
      const endDateObj = new Date(end);
      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ✅ FIXED HERE
      // if (startDateObj < min || startDateObj > max) {
      //   alert('Date is outside the allowed range.');
      //   this.invoicegetCustBook.get('start')?.setValue(null);
      //   this.invoicegetCustBook.get('end')?.setValue(null);
      // }

      this.startDate_custReport = formatDate(
        startDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.endDate_custReport = formatDate(
        endDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.dateIsEnable = true;

      // this.fetchCustData();

    } else {
      this.dateIsEnableReport = false;
      this.dateIsEnable = false;
    }
  }
  startDate_PrasiddhiPatrak = '';
  enddate_PrasiddhiPatrak = '';

  getChangedDatePrasiddhiPatrak() {

    const startValue = this.bookrcptregisterform.get('start')?.value;
    const endValue = this.bookrcptregisterform.get('end')?.value;

    if (!startValue || !endValue) return;

    // ✅ Convert input values (safe format)
    const startDate = new Date(startValue);
    const endDate = new Date(endValue);

    // ✅ Financial year range
    const financialYearStart = new Date(this.financialYearMin);
    const financialYearEnd = new Date(this.financialYearMax);

    // ❌ Validate financial year (same style as expenseledger3)
    if (startDate < financialYearStart || endDate > financialYearEnd) {
      alert("Selected dates are not in the current financial year!");

      this.bookrcptregisterform.reset();
      return;
    }

    // ❌ Extra safety: invalid range
    if (startDate > endDate) {
      alert("Start date cannot be greater than End date!");

      this.bookrcptregisterform.patchValue(
        { end: null },
        { emitEvent: false }
      );

      return;
    }

    // ✅ Assign formatted values (like your expenseledger method)
    this.startDate_PrasiddhiPatrak = formatDate(
      startDate,
      'yyyy-MM-dd',
      'en-IN'
    );

    this.enddate_PrasiddhiPatrak = formatDate(
      endDate,
      'yyyy-MM-dd',
      'en-IN'
    );
  }

  getCustinvoicestartDate1;
  getCustinvoiceEndDate1;
  getAllCustList1 = [];
  getCustlistWithoutFilter1 = [];
  getSpecificBooksCust1 = [];
  getCustDateRangePackage() {
    this.getAllCustList1 = [];
    if (
      this.invoicegetCustBook.get('start').value != null &&
      this.invoicegetCustBook.get('end').value != null
    ) {
      this.getCustinvoicestartDate = formatDate(
        new Date(this.invoicegetCustBook.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getCustinvoiceEndDate = formatDate(
        new Date(this.invoicegetCustBook.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.service
        .getCustInvoicesName(
          this.getCustinvoicestartDate,
          this.getCustinvoiceEndDate
        )
        .subscribe((data) => {
          this.uniquedata = data;
        });
    }
  }

  getbookcustInvoiceId() {
    this.service
      .getBookCustInvoiceId(
        this.invoicedate === ''
          ? formatDate(new Date(), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
          : this.invoicedate
      )
      .subscribe((data) => {
        // console.log('data', data);
        let value: number;
        if (Object.keys(data).length > 0) {
          // console.log('1', data[0]['invoice_no'].split('/'));
          value = parseInt(data[0]['invoice_no'].split('/')[2]);
        } else {
          value = 0;
        }
        // console.log('value', value);
        let month = ('0' + (new Date(this.invoicedate).getMonth() + 1)).slice(
          -2
        );
        let year = new Date(this.invoicedate)
          .getFullYear()
          .toString()
          .slice(-2);
        let nextyear = (new Date(this.invoicedate).getFullYear() + 1)
          .toString()
          .slice(-2);
        // console.log(
        //   formatDate(
        //     new Date(new Date().getFullYear(), new Date('4').getMonth(), 1),
        //     'yyyy-MM-dd',
        //     'en-IN',
        //     'GMT+0530'
        //   )
        // );
        if (
          this.invoicedate >=
          formatDate(
            new Date(new Date().getFullYear(), new Date('4').getMonth(), 1),
            'yyyy-MM-dd',
            'en-IN',
            'GMT+0530'
          )
        ) {
          this.invoiceno = `VBD${month}/${year}-${nextyear}/${value <= 9 ? '0' + (value + 1) : value + 1
            }`;
        } else {
          this.invoiceno = `VBD${month}/${parseInt(year) - 1}-${year}/${value <= 9 ? '0' + (value + 1) : value + 1
            }`;
        }
        // console.log('invoice no', this.invoiceno);
      });
  }

  insertdata() {
    debugger
    if (this.getSelectedCust == undefined) {
      for (
        let index = 0;
        index < Object.keys(this.uniquedata).length;
        index++
      ) {
        this.getbookcustInvoiceId();
        this.getDetailsData(this.uniquedata[index]['id']);
        this.service
          .getSingleBookSellerEntry(this.uniquedata[index]['id'])
          .subscribe((data) => {
            this.service
              .InsertCustInvoice(
                data[0]['crep_name'],
                data[0]['rep_mob_no'],
                data[0]['id'],
                data[0]['address'],
                this.invoiceno,
                this.invoicedate,
                '',
                '',
                this.gstNumber,
                this.totals,
                this.shipping_charges_total,
                0,
                0,
                0,
                0
              )
              .subscribe((custdata) => {
                for (
                  let index = 0;
                  index < Object.keys(this.book_data1).length;
                  index++
                ) {
                  this.service
                    .InsertCustInvoiceData(
                      parseInt(custdata['id']),
                      this.book_data1[index]['bookname'],
                      this.book_data1[index]['authorname'],
                      parseInt(this.book_data1[index]['bookcopies']),
                      parseInt(this.book_data1[index]['discount']),
                      parseInt(this.book_data1[index]['discountamt']),
                      parseInt(this.book_data1[index]['bookprice']),
                      parseInt(this.book_data1[index]['booksaleprice']),
                      parseInt(this.book_data1[index]['agentprice']),
                      parseInt(this.book_data1[index]['yearwisebook']),

                      parseInt(this.book_data1[index]['total']),
                      parseInt(this.book_data1[index]['shippingcharges']),
                      parseInt(this.book_data1[index]['total_amount']),
                      parseInt(this.book_data1[index]['received_amt']),
                      parseInt(this.book_data1[index]['remaining_amt']),
                      parseInt(
                        this.book_data1[index]['rep_commission_precent']
                      ),
                      parseInt(this.book_data1[index]['rep_commission_amt'])
                    )
                    .subscribe((invoice) => { });
                }
                setTimeout(() => {
                  window.alert(
                    'Invoice ' + parseInt(custdata['id']) + ' has been created.'
                  );
                }, (Object.keys(this.book_data1).length / 2) * 1000);
              });
          });
      }
    }

    if (this.getSelectedCust != undefined) {

      this.invoiceDetails = {
        id: this.getSelectedCust,
        date: this.invoicedate,
        GST: this.isGSTInvoice,
        GST_no: this.gstNumber,
        invoiceBillNo: this.invoicegetCustBook.value?.billno ?? '',

      };
      this.viewmode = false;
      this.repInvoice = 'N';
      this.GenerateInvoice();
    }
  }

  getDetailsData(id) {
    this.service.getBooks(id).subscribe((data) => {
      this.book_data1 = data;

      for (
        let index = 0;
        index < Object.keys(this.book_data1).length;
        index++
      ) {
        this.book_price_total =
          this.book_price_total + parseInt(this.book_data1[index]['bookprice']);
        this.book_sale_price_total =
          this.book_sale_price_total +
          parseInt(this.book_data1[index]['booksaleprice']);
        this.book_copies_total =
          this.book_copies_total +
          parseInt(this.book_data1[index]['bookcopies']);
        this.shipping_charges_total =
          this.shipping_charges_total +
          parseInt(this.book_data1[index]['shippingcharges']);
        this.total_total =
          this.total_total + parseInt(this.book_data1[index]['total']);
      }
      this.totals = this.total_total + this.shipping_charges_total;
    });
  }

  getSelectedCust;
  SelectCustomer(event) {
    this.getSelectedCust = event.value;

  }
  getbookname1(event) {
    this.book_name1 = event.target.value;
    console.log(this.book_name1)
  }

  generateCustInvoice() {
    debugger
    if (this.invoicedate !== '' && this.getSelectedCust != undefined) {
      this.insertdata();

    } else {
      alert('Please select a date and cust name...');
    }
  }

  selectAllOptions1(event: any) {
    event.stopPropagation();
    const custControl = this.invoicegetCustBook.get('cust_name');
    if (!custControl) return;

    if (this.allSelected) {
      custControl.setValue([]);
      this.allSelected = false;
    } else {
      custControl.setValue(this.uniquedata);
      this.allSelected = true;
    }
  }

  selectAllOptionsgranth(event: any) {
    event.stopPropagation();
    const custControl = this.invoicegetCustBook.get('cust_name');
    if (!custControl) return;

    if (this.allSelected) {
      custControl.setValue([]);
      this.allSelected = false;
    } else {
      custControl.setValue(this.granthunquiedata);
      this.allSelected = true;
    }
  }

  updateAllSelectedState1() {
    const custControl = this.invoicegetCustBook.get('cust_name');
    if (!custControl) return;

    const selected = custControl.value || [];
    this.allSelected = selected.length === this.uniquedata.length;
  }

  updateAllSelectedStategranth() {
    const custControl = this.invoicegetCustBook.get('cust_name');
    if (!custControl) return;

    const selected = custControl.value || [];
    this.allSelected = selected.length === this.granthunquiedata.length;
  }

  // 4️⃣ Optional: filter customers
  filterOption1(value: string) {
    const filterValue = (value || '').toLowerCase();
    // Keep original data somewhere if needed
    const filtered = this.uniquedata.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
    this.uniquedata = filtered;

    // If all were previously selected, update selection to match filtered list
    if (this.allSelected) {
      this.invoicegetCustBook.get('cust_name')?.setValue([...filtered]);
    }
  }


  allSelectedtable1 = false;

  selectAllRows(event: any) {
    this.allSelectedtable1 = event.checked;
    this.bookinvoicedata.forEach(book => book.selected = event.checked);
  }
  allSelectedtable2 = false;
  selectAllRowsbillng(event: any) {
    if (event.checked) {
      // Select all
      this.allSelectedtable2 = true;
      this.Filteredbookbillingdata.forEach((book: any) => {
        book.is_selected = true;
      });

      // Add all to list
      this.newList1 = [...this.Filteredbookbillingdata];
      this.total = this.Filteredbookbillingdata.reduce(
        (sum: number, b: any) => sum + (b.remain_amt || 0),
        0
      );
    } else {
      // Deselect all
      this.allSelectedtable2 = false;
      this.Filteredbookbillingdata.forEach((book: any) => {
        book.is_selected = false;
      });

      this.newList1 = [];
      this.total = 0;
    }

    console.log(this.newList1, "All selected list");
    console.log(this.total, "Total amount");
  }

  // Get selected rows for invoice generation
  getSelectedBooks() {
    return this.bookinvoicedata
      .filter(book => book.selected)  // only checked rows
      .map(book => book.name);        // return only names
  }


  getSelectedgranth() {
    return this.granthinvoicedata
      .filter(book => book.selected)  // only checked rows
      .map(book => book.name);        // return only names
  }
  isupdate = false;
  // 5️⃣ Open invoice dialog


  // 5️⃣ Open invoice dialog
  // openAdvtBill() {
  //   debugger;

  //   // Get selected customers from form
  //   const customersRaw = this.invoicegetCustBook.get('cust_name')?.value || [];
  //   const selectedCustomers: any[] = Array.isArray(customersRaw) ? customersRaw : [customersRaw];

  //   // Pass the names as an array, not a joined string
  //   const customerNames = selectedCustomers.map(c => c?.name || '');

  //   // Get date and bill number from form

  //   const date = this.invoicedate;
  //   const billno = this.invoicegetCustBook.get('billno')?.value || '';

  //   // Open dialog with correct data
  //   this.dialog.open(BookinvoiceComponent, {
  //     data: { customerNames, date, isupdate: this.isupdate, billno },
  //     width: '1200px',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   }).afterClosed().subscribe(() => {
  //     // Reset form and selections after closing dialog
  //     this.invoicegetCustBook.reset();
  //     this.allSelected = false;
  //     this.ngOnInit(); // reload data if needed
  //   });
  // }
  openAdvtBill() {
    debugger
    // Get selected customers from form
    const customersRaw = this.invoicegetCustBook.get('cust_name')?.value || [];
    const selectedCustomers: any[] = Array.isArray(customersRaw) ? customersRaw : [customersRaw];

    // Only selected books from table
    const selectedBooksellers = this.getSelectedBooks();

    // Combine customer names + selected bookseller names
    const customerNames = [
      ...selectedCustomers.map(c => c?.name || ''),
      ...selectedBooksellers
    ];

    const date = this.invoicedate;
    const billno = this.invoicegetCustBook.get('billno')?.value || '';

    this.dialog.open(BookinvoiceComponent, {
      data: { customerNames, date, isupdate: this.isupdate, billno, isGranth: 'N' },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    }).afterClosed().subscribe(() => {
      // Reset selections after closing dialog
      this.invoicegetCustBook.reset();
      this.allSelectedtable1 = false;
      this.bookinvoicedata.forEach(b => b.selected = false);
      this.ngOnInit();
    });
  }

  opengranthBill() {
    debugger
    const customersRaw = this.invoicegetCustBook.get('cust_name')?.value || [];
    const selectedCustomers: any[] = Array.isArray(customersRaw) ? customersRaw : [customersRaw];
    const selectedBooksellers = this.getSelectedgranth();
    const customerNames = [
      ...selectedCustomers.map(c => c?.name || ''),
      ...selectedBooksellers
    ];

    const date = this.invoicedate;
    const billno = this.invoicegetCustBook.get('billno')?.value || '';

    this.dialog.open(GranthInvoiceComponent, {
      data: { customerNames, date, isupdate: this.isupdate, billno, isGranth: 'Y' }, // ✅ pass isGranth: 'Y'
      width: '1200px',
      height: '1300px',
      maxWidth: '100%',
    }).afterClosed().subscribe(() => {
      this.invoicegetCustBook.reset();
      this.allSelectedtable1 = false;
      this.granthinvoicedata.forEach(b => b.selected = false);
      this.ngOnInit();
    });
  }


  repGeneratedInvoice = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  getGeneratedInvoiceStartDate;
  getGeneratedInvoiceEndDate;
  getRepInvoiceDateRange() {
    if (
      this.repGeneratedInvoice.get('start').value != null &&
      this.repGeneratedInvoice.get('end').value != null
    ) {
      this.getGeneratedInvoiceStartDate = formatDate(
        new Date(this.repGeneratedInvoice.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getGeneratedInvoiceEndDate = formatDate(
        new Date(this.repGeneratedInvoice.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  gstreportstartdate;
  gstreportenddate;
  getChangedDategstreport() {

    const start = this.gstreportForm.get('start')?.value;
    const end = this.gstreportForm.get('end')?.value;

    this.dateIsEnableReport = false;

    if (start != null && end != null) {

      const startDateObj = new Date(start);
      const endDateObj = new Date(end);

      const min = new Date(this.financialYearMin);
      const max = new Date(this.financialYearMax);

      // ❌ Validate financial year range
      if (
        (startDateObj < min || startDateObj > max)
      ) {
        alert('Date is outside the allowed range.');

        this.gstreportForm.get('start')?.setValue(null);
        this.gstreportForm.get('end')?.setValue(null);

        this.FilteredGSTdata = [];
        return;
      }

      // ❌ Validate start > end (kept as comment as in your code)
      // (not implemented since you said no logic change)

      // ✅ Format dates
      this.gstreportstartdate = formatDate(
        startDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.gstreportenddate = formatDate(
        endDateObj,
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      // ✅ Filter data
      this.FilteredGSTdata = this.bookRcptRegisterdata.filter((a) => {
        const receiptDate = new Date(a['receipt_date']);
        return (
          receiptDate >= startDateObj &&
          receiptDate <= endDateObj
        );
      });

      console.log("FilteredGSTdata", this.FilteredGSTdata);

      this.dateIsEnableReport = true;

    } else {
      this.FilteredGSTdata = [];
      this.dateIsEnableReport = false;
    }
  }

  // Add a property to your component
  showMobileOnly: boolean = true;

  // Existing method - filters ONLY valid mobile numbers
  // postingLabelBriefReport(showOnlyMobile: boolean = this.showMobileOnly): void {
  //   const filteredData = this.FilteredlabelsforDispatch.filter(item => {
  //     if (showOnlyMobile) {
  //       return item.mobileNumber && item.mobileNumber.trim() !== '' && item.mobileNumber !== '0';
  //     }
  //     return true;
  //   });

  //   this.dialog.open(BookSellerPostingLabelBriefComponent, {
  //     data: {
  //       delivery_mode: this.mode_names,
  //       rep_names: this.repnames,
  //       state_name: this.state_names,
  //       district_name: this.district_names,
  //       taluka_name: this.taluka_names,
  //       addresslabels: filteredData,
  //       country: this.country_names,
  //       office_rep_name: this.officerepnames,
  //       rep_name: this.repnames,
  //       name: this.sub_names,
  //       pincode: this.pincodes,
  //     },
  //     width: '1300px',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });
  // }

  // // NEW method - filters ONLY records with no/zero mobile number
  // postingLabelBriefReportNoMobile(): void {
  //   const filteredData = this.FilteredlabelsforDispatch.filter(item => {
  //     return !item.mobileNumber || item.mobileNumber.trim() === '' || item.mobileNumber === '0';
  //   });

  //   this.dialog.open(BookSellerPostingLabelBriefComponent, {
  //     data: {
  //       delivery_mode: this.mode_names,
  //       rep_names: this.repnames,
  //       state_name: this.state_names,
  //       district_name: this.district_names,
  //       taluka_name: this.taluka_names,
  //       addresslabels: filteredData,
  //       country: this.country_names,
  //       office_rep_name: this.officerepnames,
  //       rep_name: this.repnames,
  //       name: this.sub_names,
  //       pincode: this.pincodes,
  //     },
  //     width: '1300px',
  //     height: '1300px',
  //     maxWidth: '100%',
  //   });
  // }

  onSubmitDeliveryMode() {

    if (this.adddeliverymode.invalid) return;

    const payload = {
      delivery_mode: this.subform.get('DeliveryMode')?.value
    };

    console.log(payload);
  }
  get deliveryModeControl() {
    return this.adddeliverymode.get('subform')?.get('DeliveryMode');
  }





  getRepInvoice() {
    this.service
      .getRepInvoices(
        this.getGeneratedInvoiceStartDate,
        this.getGeneratedInvoiceEndDate
      )
      .subscribe((data) => {
        this.RepInvoiceData = data;
      });
  }

  getRepInvoiceData = [];
  ViewInvoice(book) {
    this.getSelectedRep = this.getAllRepList.find(
      (a) => a['id'] == parseInt(book['id'])
    );

    if (
      parseInt(book['cgst']) == 0 ||
      parseInt(book['sgst']) == 0 ||
      parseInt(book['igst']) == 0
    ) {
      this.isGSTInvoice = 'N';
    } else {
      this.isGSTInvoice = 'Y';
    }

    this.service
      .getRepInvoicesData(parseInt(book['invoice_id']))
      .subscribe((data) => {
        this.getRepInvoiceData = data;
        let getBookInvoiceDetails = {
          invoice_details: book,
          bookDetail: this.getRepInvoiceData,
        };
        this.invoiceDetails = {
          rep: this.getSelectedRep,
          books: getBookInvoiceDetails,
          GST: this.isGSTInvoice,
          GST_no: book['gst_no'],
        };
        this.viewmode = true;
        this.repInvoice = 'Y';
        setTimeout(() => {
          this.GenerateInvoice();
        }, 1000);
      });
  }

  getGeneratedInvoiceStartDateCust;
  getGeneratedInvoiceEndDateCust;
  getCustInvoiceDateRange() {
    if (
      this.CustGeneratedInvoice.get('start').value != null &&
      this.CustGeneratedInvoice.get('end').value != null
    ) {
      this.getGeneratedInvoiceStartDateCust = formatDate(
        new Date(this.CustGeneratedInvoice.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getGeneratedInvoiceEndDateCust = formatDate(
        new Date(this.CustGeneratedInvoice.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
    }
  }

  getCustInvoice() {
    this.service
      .getCustInvoices(
        this.getGeneratedInvoiceStartDateCust,
        this.getGeneratedInvoiceEndDateCust
      )
      .subscribe((data) => {
        this.CustInvoiceData = data;
      });
  }

  ViewCustInvoice(book) {
    this.getSelectedRep = this.getAllRepList.find(
      (a) => a['id'] == parseInt(book['id'])
    );

    if (
      parseInt(book['cgst']) == 0 ||
      parseInt(book['sgst']) == 0 ||
      parseInt(book['igst']) == 0
    ) {
      this.isGSTInvoice = 'N';
    } else {
      this.isGSTInvoice = 'Y';
    }

    this.service
      .getCustInvoicesData(parseInt(book['invoice_id']))
      .subscribe((data) => {
        this.getRepInvoiceData = data;
        let getBookInvoiceDetails = {
          invoice_details: book,
          bookDetail: this.getRepInvoiceData,
        };
        this.invoiceDetails = {
          rep: this.getSelectedRep,
          books: getBookInvoiceDetails,
          GST: this.isGSTInvoice,
          GST_no: book['gst_no'],
        };
        this.viewmode = true;
        this.repInvoice = 'N';
        setTimeout(() => {
          this.GenerateInvoice();
        }, 1000);
      });
  }

  complementry(event: boolean) {
    this.isSponsor = false;
    this.iscomplementary = event;

  }

  sponsor(event: boolean) {
    this.iscomplementary = false;
    this.isSponsor = event;

  }


  saveauthor() {
    if (
      window.confirm(
        'This operation is not reversable. Please confirm before proceed.'
      )
    ) {
      let data = {
        authorname: this.authorForm.get('authorname').value,
        address: this.authorForm.get('address').value,
        pincode: this.authorForm.get('pincode').value,
        country: this.authorForm.get('country').value,
        state: this.authorForm.get('state').value,
        district: this.authorForm.get('district').value,
        taluka: this.authorForm.get('taluka').value,
        mob_no: this.authorForm.get('mob_no').value,
        email: this.authorForm.get('email').value,
        pan_no: this.authorForm.get('pan_no').value,
        aadhar_no: this.authorForm.get('aadhar_no').value,
        bank_name: this.authorForm.get('bank_name').value,
        branch: this.authorForm.get('branch').value,
        acc_no: this.authorForm.get('acc_no').value,
        ifsc_code: this.authorForm.get('ifsc_code').value,
      };
      // console.log({ data });
      this.service.addAuthorAddress(data).subscribe((dataFromDB) => {
        alert('Author Data Added Successfully.');
        // console.log({ dataFromDB });
        setTimeout(() => {
          this.authorForm.reset();
          this.getAuthorData();
        }, 1500);
      });
    }
  }

  getAuthorData() {
    this.service.getAuthorData().subscribe((data) => {
      this.authorData = data;
      // console.log(data);

      for (
        let index = 0;
        index < Object.keys(this.authorData).length;
        index++
      ) {
        this.authornames.push({
          id: this.authorData[index]['id'],
          name: this.authorData[index]['author_name'],
        });
      }
      // console.log(this.authornames);
    });
  }

  isauthor: Boolean = false;
  authorId = 0;
  selected_authorname(event, option) {
    if (event.isUserInput) {
      for (
        let index = 0;
        index < Object.keys(this.authorData).length;
        index++
      ) {
        if (option['id'] == this.authorData[index]['id']) {
          this.isauthor = true;
          this.authorId = this.authorData[index]['id'];
          this.authorForm
            .get('authorname')
            .setValue(this.authorData[index]['author_name']);
          this.authorForm
            .get('address')
            .setValue(this.authorData[index]['author_address']);
          this.authorForm
            .get('pincode')
            .setValue(this.authorData[index]['pincode']);
          this.authorForm
            .get('country')
            .setValue(this.authorData[index]['country']);
          this.authorForm
            .get('state')
            .setValue(this.authorData[index]['state']);
          this.authorForm
            .get('district')
            .setValue(this.authorData[index]['district']);
          this.authorForm
            .get('taluka')
            .setValue(this.authorData[index]['taluka']);
          this.authorForm
            .get('mob_no')
            .setValue(this.authorData[index]['mob_no']);
          this.authorForm
            .get('email')
            .setValue(this.authorData[index]['email']);
          this.authorForm
            .get('pan_no')
            .setValue(this.authorData[index]['pan_no']);
          this.authorForm
            .get('aadhar_no')
            .setValue(
              this.authorData[index]['aadhar_no'] > 0
                ? this.authorData[index]['aadhar_no']
                : ''
            );
          this.authorForm
            .get('bank_name')
            .setValue(this.authorData[index]['bank_name']);
          this.authorForm
            .get('branch')
            .setValue(this.authorData[index]['branch']);
          this.authorForm
            .get('acc_no')
            .setValue(
              this.authorData[index]['account_no'] > 0
                ? this.authorData[index]['account_no']
                : ''
            );
          this.authorForm
            .get('ifsc_code')
            .setValue(this.authorData[index]['ifsc_code']);
        }
      }
    }
  }

  updateAuthor() {
    if (this.authorId != 0) {
      let data = {
        id: this.authorId,
        authorname: this.authorForm.get('authorname').value,
        address: this.authorForm.get('address').value,
        pincode: this.authorForm.get('pincode').value,
        country: this.authorForm.get('country').value,
        state: this.authorForm.get('state').value,
        district: this.authorForm.get('district').value,
        taluka: this.authorForm.get('taluka').value,
        mob_no: this.authorForm.get('mob_no').value,
        email: this.authorForm.get('email').value,
        pan_no: this.authorForm.get('pan_no').value,
        aadhar_no: this.authorForm.get('aadhar_no').value,
        bank_name: this.authorForm.get('bank_name').value,
        branch: this.authorForm.get('branch').value,
        acc_no: this.authorForm.get('acc_no').value,
        ifsc_code: this.authorForm.get('ifsc_code').value,
      };
      // console.log({ data });

      this.service.updateAuthorAddress(data).subscribe((data) => {
        alert('Author Address Updated Successfully..');

        setTimeout(() => {
          this.authorForm.reset();
          this.authorId = 0;
          this.getAuthorData();
        }, 1500);
      });
    }
  }

  deleteAuthorData() {
    if (this.authorId != 0) {
      this.service.deleteAuthorAddress(this.authorId).subscribe((data) => {
        alert('Author Address Deleted Successfully.');

        setTimeout(() => {
          this.authorForm.reset();
          this.authorId = 0;
          this.getAuthorData();
        }, 1500);
      });
    }
  }

  deleteBookPymtreceipt(id: any) {
    debugger
    const req: any = {
      "id": id
    }
    debugger;
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deleteBookPymtreceipt(req).subscribe((res) => {
        console.log(res)
        location.reload();
      });
    }
    this.ngOnInit();
  }
  deleteBookregiledger(id: any) {
    const req: any = {
      "id": id
    }
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete Complimentry Copies?')) {
      this.service.deleteBookledgerreg(req).subscribe((res) => {
        console.log(res)
        location.reload();
      });
    }
    this.ngOnInit();
  }
  deletepackagegranthId(id: any) {
    if (!id) {
      window.alert('Invalid ID');
      return;
    }

    if (!confirm('Are you sure you want to delete this record?')) {
      return;
    }

    this.service.deletepackagegranthIds(id).subscribe({
      next: (_data) => {
        window.alert('Record Deleted Successfully...');
        this.ngOnInit();
      },
      error: (err) => {
        console.error(err);
        window.alert('Something went wrong while deleting the record.');
      }
    });
  }
  deleteBookregiledgerpackage(id: any) {
    const req: any = {
      "id": id
    }
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete  ?')) {
      this.service.deleteBookledgerreg(req).subscribe((res) => {
        console.log(res)
        location.reload();
      });
    }
    this.ngOnInit();
  }

  getAuthorAddress() {
    this.dialog.open(AuthorAddressComponent, {
      data: {},
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }

  booksname = '';
  selected_book_name(event, option) {
    if (event.isUserInput) {
      this.booksname = option['name'];
      if (this.booksname != '') {
        // console.log(this.bookSellerAddressData);
        this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
          (item) => {
            return (
              item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) > -1
            );
          }
        );
      }
    }
    // console.log(this.bookSellerAddressData);
  }

  getauthorStartDate;
  getauthorEndDate;
  getAuthorDate() {
    if (
      this.bookselleraddressForm.get('start').value != null &&
      this.bookselleraddressForm.get('end').value != null
    ) {
      this.getauthorStartDate = formatDate(
        new Date(this.bookselleraddressForm.get('start').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );
      this.getauthorEndDate = formatDate(
        new Date(this.bookselleraddressForm.get('end').value),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      if (
        this.booksname == '' &&
        this.getauthorStartDate != null &&
        this.getauthorEndDate != null
      ) {
        // console.log(this.bookSellerAddressData);
        this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
          (item) => {
            return (
              item['date'] >= this.getauthorStartDate &&
              item['date'] <= this.getauthorEndDate
            );
          }
        );
      } else if (
        this.booksname != '' &&
        this.getauthorStartDate != null &&
        this.getauthorEndDate != null
      ) {
        // console.log(this.bookSellerAddressData);
        this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
          (item) => {
            return (
              item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
              -1 &&
              item['date'] >= this.getauthorStartDate &&
              item['date'] <= this.getauthorEndDate
            );
          }
        );
      } else {
        this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
          (item) => {
            return (
              item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) > -1
            );
          }
        );
      }
    }
    // console.log(this.FilteredBookSellerAddress);
  }

  countryname = '';
  country(event) {
    this.countryname = event.target.value;
    console.log(this.countryname);
    if (
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1
          );
        }
      );
    } else if (
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1
          );
        }
      );
    } else if (
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1
          );
        }
      );
    } else if (
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1
          );
        }
      );
    }
  }

  statename = '';
  state(event) {
    this.statename = event.target.value;
    if (
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) > -1
          );
        }
      );
    }
  }

  districtname = '';
  district(event) {
    this.districtname = event.target.value;
    if (
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname == '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname == '' &&
      this.booksname != '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname != '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    } else if (
      this.districtname != '' &&
      this.statename == '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1
          );
        }
      );
    }
  }

  talukaname = '';
  taluka(event) {
    this.talukaname = event.target.value;
    if (
      this.talukaname != '' &&
      this.districtname != '' &&
      this.statename != '' &&
      this.countryname != '' &&
      this.booksname != '' &&
      this.getauthorStartDate != null &&
      this.getauthorEndDate != null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
            -1 &&
            item['date'] >= this.getauthorStartDate &&
            item['date'] <= this.getauthorEndDate &&
            item.country.toLowerCase().indexOf(this.countryname.toLowerCase()) >
            -1 &&
            item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
            -1 &&
            item.district
              .toLowerCase()
              .indexOf(this.districtname.toLowerCase()) > -1 &&
            item.taluka.toLowerCase().indexOf(this.talukaname.toLowerCase()) >
            -1
          );
        }
      );
    } else if (
      this.talukaname != '' &&
      this.districtname == '' &&
      this.statename == '' &&
      this.countryname == '' &&
      this.booksname == '' &&
      this.getauthorStartDate == null &&
      this.getauthorEndDate == null
    ) {
      this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
        (item) => {
          return (
            item.taluka.toLowerCase().indexOf(this.talukaname.toLowerCase()) >
            -1
          );
        }
      );
    }
  }

  // authorrepname = '';
  // selected_authorrepname(event, option){
  //   if(event.isUserInput){
  //     this.authorrepname = option['name'];
  //     if (
  //       this.authorrepname != '' &&
  //       this.talukaname != '' &&
  //       this.districtname != '' &&
  //       this.statename != '' &&
  //       this.countryname != '' &&
  //       this.booksname != '' &&
  //       this.getauthorStartDate != null &&
  //       this.getauthorEndDate != null
  //     ) {
  //       this.FilteredBookSellerAddress = this.bookSellerAddressData.filter(
  //         (item) => {
  //           return (
  //             item.name.toLowerCase().indexOf(this.booksname.toLowerCase()) >
  //               -1 &&
  //             item['date'] >= this.getauthorStartDate &&
  //             item['date'] <= this.getauthorEndDate &&
  //             item.country
  //               .toLowerCase()
  //               .indexOf(this.countryname.toLowerCase()) > -1 &&
  //             item.state.toLowerCase().indexOf(this.statename.toLowerCase()) >
  //               -1 &&
  //             item.district
  //               .toLowerCase()
  //               .indexOf(this.districtname.toLowerCase()) > -1 &&
  //             item.taluka.toLowerCase().indexOf(this.talukaname.toLowerCase()) >
  //               -1 &&
  //             item.taluka
  //               .toLowerCase()
  //               .indexOf(this.authorrepname.toLowerCase()) > -1
  //           );
  //         }
  //       );
  //     }
  //   }
  // }

  isComplimntry = '';
  isComplementaryAddress(event) {
    // console.log('event', event.value);
    this.isComplimntry = event.value;
  }

  printPage() {
    window.print();
  }


  showfulladdress() {
    if (this.isComplimntry != '') {
      this.dialog.open(BookSellerAddressComponent, {
        data: {
          bookselleraddress: this.FilteredBookSellerAddress.filter((a) => {
            return a['complimentary'] == this.isComplimntry;
          }),
        },
        height: '1300px',
        width: '1200px',
        maxWidth: '100%',
      });
    } else {
      this.dialog.open(BookSellerAddressComponent, {
        data: {
          bookselleraddress: this.FilteredBookSellerAddress,
        },
        height: '1300px',
        width: '1200px',
        maxWidth: '100%',
      });
    }
  }

  showlistaddress() {
    if (this.isComplimntry != '') {
      this.showFilteredBookSellerAddress =
        this.FilteredBookSellerAddress.filter((a) => {
          return a['complimentary'] == this.isComplimntry;
        });
    } else {
      this.showFilteredBookSellerAddress = this.FilteredBookSellerAddress;
    }
  }

  toInt(val) {
    // console.log(parseInt(val));
    return parseInt(val);
  }
  onTabClick(event: any) {
    console.log(event)
    localStorage.setItem("tab", event.index)
  }


  startDate_contract;
  enddate_contract;
  BookLedgerform = new FormGroup({
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    book_seller_name: new FormControl(''),
  });

      startDate_contract1;
  enddate_contract1;
  GranthLedgerform = new FormGroup({
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    book_seller_name: new FormControl(''),
  });

  // startDate_contract: any = '';
  // enddate_contract: any = '';

  getChangedDateContractM7() {

    debugger;

    if (
      this.BookLedgerform.get('start_date')?.value &&
      this.BookLedgerform.get('end_date')?.value
    ) {

      this.startDate_contract = formatDate(
        new Date(this.BookLedgerform.get('start_date')?.value as string),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.enddate_contract = formatDate(
        new Date(this.BookLedgerform.get('end_date')?.value as string),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      const payload = {
        start_date: this.startDate_contract,
        end_date: this.enddate_contract,
        book_seller_name: this.BookLedgerform.get('book_seller_name')?.value
      };

      console.log('Payload => ', payload);

      // API CALL
      // this.service.getBookSellerLedgerData(payload).subscribe((res:any)=>{
      //   console.log(res);
      // });

    } else {
      console.log('Dates are missing');
    }
  }
 getChangedDateContractgranth() {

    debugger;

    if (
      this.GranthLedgerform.get('start_date')?.value &&
      this.GranthLedgerform.get('end_date')?.value
    ) {

      this.startDate_contract1 = formatDate(
        new Date(this.GranthLedgerform.get('start_date')?.value as string),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      this.enddate_contract1 = formatDate(
        new Date(this.GranthLedgerform.get('end_date')?.value as string),
        'yyyy-MM-dd',
        'en-IN',
        'GMT+0530'
      );

      const payload = {
        start_date: this.startDate_contract1,
        end_date: this.enddate_contract1,
        book_seller_name: this.GranthLedgerform.get('book_seller_name')?.value
      };

      console.log('Payload => ', payload);

      // API CALL
      // this.service.getBookSellerLedgerData(payload).subscribe((res:any)=>{
      //   console.log(res);
      // });

    } else {
      console.log('Dates are missing');
    }
  }

  searchBookStockStartDate: any = null;
  searchBookStockEndDate: any = null;
  getBookStcokDateChanged() {

    const start = this.BookStockform.get('start_date')?.value;
    const end = this.BookStockform.get('end_date')?.value;

    if (!start || !end) return;

    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    // ❌ Financial year validation
    if (startDateObj < min || endDateObj > max) {
      alert('Selected date is outside financial year');

      this.BookStockform.patchValue({
        start_date: null,
        end_date: null
      });

      return;
    }

    // ❌ Start > End validation
    if (startDateObj > endDateObj) {
      alert('Start date cannot be greater than End date');

      this.BookStockform.patchValue({
        end_date: null
      });

      return;
    }

    // ✅ Format for API
    this.searchBookStockStartDate = formatDate(startDateObj, 'yyyy-MM-dd', 'en-IN');
    this.searchBookStockEndDate = formatDate(endDateObj, 'yyyy-MM-dd', 'en-IN');

    console.log("Validated Dates:", this.searchBookStockStartDate, this.searchBookStockEndDate);
  }
  //  searchBookStockStartDate: any = null;
  // searchBookStockEndDate: any = null;
  getBookStcokDateChanged1() {

    const start = this.BookStockform.get('start_date')?.value;
    const end = this.BookStockform.get('end_date')?.value;

    if (!start || !end) return;

    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    const min = new Date(this.financialYearMin);
    const max = new Date(this.financialYearMax);

    // ❌ Financial year validation
    if (startDateObj < min || endDateObj > max) {
      alert('Selected date is outside financial year');

      this.BookStockform.patchValue({
        start_date: null,
        end_date: null
      });

      return;
    }

    // ❌ Start > End validation
    if (startDateObj > endDateObj) {
      alert('Start date cannot be greater than End date');

      this.BookStockform.patchValue({
        end_date: null
      });

      return;
    }

    // ✅ Format for API
    this.searchBookStockStartDate = formatDate(startDateObj, 'yyyy-MM-dd', 'en-IN');
    this.searchBookStockEndDate = formatDate(endDateObj, 'yyyy-MM-dd', 'en-IN');

    console.log("Validated Dates:", this.searchBookStockStartDate, this.searchBookStockEndDate);
  }





  bool_seller_names = []
  getBookSellerNames(event) {
    // if (event.target.value.length > 2) {
    this.service.getBookSeNames(event.target.value).subscribe((res) => {
      this.bool_seller_names = res;
      // console.log(res);
    });
    // }
  }
  granth_seller_names = []
  getGranthSellerNames(event) {
    // if (event.target.value.length > 2) {
    this.service.getgranthSeNames(event.target.value).subscribe((res) => {
      this.granth_seller_names = res;
      // console.log(res);
    });
    // }
  } 
  bill_nos_list = []
  getBillNos(event) {
    // if (event.target.value.length > 2) {
    this.service.getInvoicenos(event.target.value).subscribe((res) => {
      this.bill_nos_list = res;
      // console.log(res);
    });
    // }
  }





  book_rep_names = []
  getBookRepNames(event) {
    // if (event.target.value.length > 2) {
    this.service.getBookReppNames(event.target.value).subscribe((res) => {
      this.book_rep_names = res;
      // console.log(res);
    });
    // }
  }


  getBookGSTReportData() {

    this.service.getBookGSTReportData(
      this.gstreportstartdate,
      this.gstreportenddate
    ).subscribe({
      next: (res: any) => {

        console.log('RAW RESPONSE:', res);

        // ✅ IMPORTANT FIX: use res.data
        const dataList = res?.data || [];

        if (!Array.isArray(dataList)) {
          console.error('Invalid data format:', dataList);
          return;
        }

        this.showGSTReceiptData = [];
        this.gstreporttotalamt = 0;

        dataList.forEach((item: any) => {

          const amt = Number(item.select_entry_amt) || 0;

          this.showGSTReceiptData.push({
            id: item.id,
            receipt_date: item.receipt_date,
            book_seller_name: item.book_seller_name,
            book_seller_name_eng: item.book_seller_name_eng,
            district: item.district,
            edistrict: item.edistrict,
            receipt_no: item.receipt_no,

            gst_no: '27AAATH0433Q1ZI',
            hsn_code: '4902',

            select_entry_amt: amt
          });

          this.gstreporttotalamt += amt;
        });

        console.log('FINAL DATA:', this.showGSTReceiptData);
        console.log('TOTAL AMT:', this.gstreporttotalamt);

        // ✅ OPEN REPORT ONLY AFTER DATA READY
        this.GSTReportPrint();
      },

      error: (err) => {
        console.error('API ERROR:', err);
      }
    });
  }

  // calculateGSTReportData() {
  //   this.gstreporttotalamt = 0;
  //   for (
  //     let index = 0;
  //     index < Object.keys(this.showGSTReceiptData).length;
  //     index++
  //   ) {
  //     this.gstreporttotalamt =
  //       this.gstreporttotalamt +
  //       parseInt(this.showGSTReceiptData[index]['select_entry_amt']);
  //   }
  //   console.log(this.gstreporttotalamt);

  //   this.exportGSTReceiptData.push({
  //     SR_NO: 'Total',
  //     Receipt_Date: '',
  //     Book_Seller_Name: '',
  //     Address: '',
  //     Receipt_No: '',
  //     GST_No: '',
  //     HSN_Code: '',
  //     Total_Amount: this.gstreporttotalamt,
  //   });
  // }



  showFields = true;

  toggleFields() {
    this.showFields = !this.showFields;
  }
  onSellerSelected(event: any) {
    const selectedName = event.option.value;
    this.subform.patchValue({ subname2: selectedName });
  }
  GSTReportPrint() {

    this.dialog.open(GSTReportComponent, {
      data: {
        val: this.showGSTReceiptData,
        totalamt: this.gstreporttotalamt,
        startdate: this.gstreportstartdate,
        enddate: this.gstreportenddate
      },
      width: '1200px',
      height: '1300px',
      maxWidth: '100%'
    });

  }
  showBoookLedgerReport() {
    // console.log(this.contractData);
    // if (this.contractReportType !== '') {
    debugger
    this.dialog.open(BookSellerLedgerBriefReportComponentComponent, {
      data: {
        contractData: this.contractData,
        startDate: this.startDate_contract,
        endDate: this.enddate_contract,
        repName: this.contractReportRepName,
        offRepName: this.contractReportOffRepName,
        name: this.BookLedgerform.value.book_seller_name,
        reportType: this.contractReportType,
      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });
    // }
    // else {
    //   alert('Please select report type');
    // }
  }

  showGranthLedgerReport() {
  const startDateVal = this.GranthLedgerform.value.start_date;
  const endDateVal = this.GranthLedgerform.value.end_date;

  const formattedStart = startDateVal
    ? formatDate(new Date(startDateVal), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
    : '';

  const formattedEnd = endDateVal
    ? formatDate(new Date(endDateVal), 'yyyy-MM-dd', 'en-IN', 'GMT+0530')
    : '';

  this.dialog.open(GranthSellerLedgerBriefReportIndetailComponent, {
    data: {
      contractData: this.contractData,
      startDate: formattedStart,
      endDate: formattedEnd,
      repName: this.contractReportRepName,
      offRepName: this.contractReportOffRepName,
      name: this.GranthLedgerform.value.book_seller_name,
      reportType: this.contractReportType,
    },
    height: '1300px',
    width: '95%',
    maxWidth: '100%',
  });
}
  newdelInvoice(e) {
    debugger;
    if (e.value == 'deleted') {

      this.deleteInc = true;
      const data: any = {
        value: 'book_invoice',
        startDate: sessionStorage.getItem('startDate'),
        endDate: sessionStorage.getItem('endDate')
      };

      this.service.getBookdeleterecipt(data).subscribe((data) => {
        this.getdeletereciptinvoice = data;
      });

    }
    else {


      this.deleteInc = false
    }
  }

  newdelCommision(e) {
    debugger;
    if (e.value == 'deleted') {

      this.deleteComm = true;
      const data: any = {
        "value": 'book_comm_pymt_rcpt',
      }
      this.service.getBookdeleterecipt(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeletereciptComm = data;
      });
    }
    else {


      this.deleteInc = false
    }
  }

  newdelOrder(e) {
    debugger;
    if (e.value == 'deleted') {

      this.deleteOrd = true;
      const data: any = {
        "value": 'book_order',
        "startDate": sessionStorage.getItem('startDate'),
        "endDate": sessionStorage.getItem('endDate')
      };

      this.service.getBookdeleteOrder(data).subscribe((data) => {
        this.getdeleteOrder = data;
      });
    }
    else {
      this.subform.get('orderno').setValue('');

      const dateValue = this.subform.get('date')?.value; // Get date value

      // Ensure the value is a valid Date object before formatting
      if (dateValue) {
        const formattedDate = formatDate(dateValue, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.getBookSellerOrderNo(formattedDate);
      } else {
        const formattedDate = formatDate(new Date, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.getBookSellerOrderNo(formattedDate);
      }
      this.deleteOrd = false
    }
  }

  newdelOrderPackage(e) {
    debugger;
    if (e.value == 'deleted') {

      this.deleteOrdpack = true;
      const data: any = {
        "value": 'book_order',
      }
      this.service.getBookdeleteOrderPackage(data).subscribe((data) => {
        // console.log('Database data', data);
        this.getdeleteOrder1 = data;
      });
    }
    else {
      this.subform.get('orderno').setValue('');

      const dateValue = this.subform.get('date')?.value; // Get date value

      // Ensure the value is a valid Date object before formatting
      if (dateValue) {
        const formattedDate = formatDate(dateValue, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.getBookSellerOrderNoPackage(formattedDate);
      } else {
        const formattedDate = formatDate(new Date, 'yyyy-MM-dd', 'en-IN', 'GMT+0530');
        this.getBookSellerOrderNoPackage(formattedDate);
      }
      this.deleteOrdpack = false
    }
  }

  newdelcrdtnote(e) {
    debugger;
    if (e.value == 'deleted') {
      this.deletecn = true;
      const data: any = {
        value: 'crdt_note',
        startDate: sessionStorage.getItem('startDate'),
        endDate: sessionStorage.getItem('endDate')
      };

      this.service.newdelcrdtnote(data).subscribe((data) => {
        this.getdeletecn = data;
      });

    }
    else {
      this.deletecn = false
    }

  }

  newdelRcpt(e) {
    debugger;

    // Use dateString from pendingbookdata instead of current system date
    const dateString = this.pendingbookdata.voucher_date;
    const selectedDate = new Date(dateString);

    let date = ('0' + selectedDate.getDate()).slice(-2);
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    let year = selectedDate.getFullYear();
    let financialStartYear, financialEndYear;

    // Determine financial year based on dateString
    if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar
      financialStartYear = year - 1;
      financialEndYear = year;
    } else { // Apr to Dec
      financialStartYear = year;
      financialEndYear = year + 1;
    }

    let shortStartYear = financialStartYear.toString().slice(-2);
    let shortEndYear = financialEndYear.toString().slice(-2);

    if (e.value === 'deleted') {
      const delVal = this.val1; // Use existing val1
      this.recptno = `BDR${month}/${shortStartYear}-${shortEndYear}/${delVal}`;
      this.bookpymtrecptform.get('recptno').setValue(this.recptno);
      this.deleterec = true;

      const requestData: any = {
        value: 'book_pymt_rcpt',
        startDate: sessionStorage.getItem('startDate'),
        endDate: sessionStorage.getItem('endDate')
      };

      this.service.getBookdeleterecipt(requestData).subscribe((data) => {
        this.getBookdeleterecipt = data;
      });


    } else {
      const newVal = this.val1 + 1; // Increment receipt number
      this.recptno = `BDR${month}/${shortStartYear}-${shortEndYear}/${newVal}`;
      this.bookpymtrecptform.get('recptno').setValue(this.recptno);
      this.deleterec = false;
    }
  }

  newdelCommRcpt(e) {
    debugger;

    // Use dateString from pendingbookdata instead of current system date
    const dateString = this.pendingbookcommdata.voucher_date;
    const selectedDate = new Date(dateString);

    let date = ('0' + selectedDate.getDate()).slice(-2);
    let month = ('0' + (selectedDate.getMonth() + 1)).slice(-2);
    let year = selectedDate.getFullYear();
    let financialStartYear, financialEndYear;

    // Determine financial year based on dateString
    if (selectedDate.getMonth() + 1 < 4) { // Jan, Feb, Mar
      financialStartYear = year - 1;
      financialEndYear = year;
    } else { // Apr to Dec
      financialStartYear = year;
      financialEndYear = year + 1;
    }

    let shortStartYear = financialStartYear.toString().slice(-2);
    let shortEndYear = financialEndYear.toString().slice(-2);

    if (e.value === 'deleted') {
      const delVal = this.val1; // Use existing val1
      this.commino = `BCN${month}/${shortStartYear}-${shortEndYear}/${delVal}`;
      this.bookcommrecptform.get('commino').setValue(this.commino);
      this.deleteComm = true;

      const requestData: any = {
        value: 'book_comm_pymt_rcpt',
        startDate: sessionStorage.getItem('startDate'),
        endDate: sessionStorage.getItem('endDate')
      };

      this.service.getBookdeleterecipt(requestData).subscribe((data) => {
        this.getBookdeleterecipt = data;
      });


    } else {
      const newVal = this.val1 + 1; // Increment receipt number
      this.commino = `BCN${month}/${shortStartYear}-${shortEndYear}/${newVal}`;
      this.bookcommrecptform.get('commino').setValue(this.commino);
      this.deleteComm = false;
    }
  }

  dateFilter = (d: Date | null): boolean => {
    if (!d) return false;

    const selectedDate = this.invoicegetCustBook.get('date')?.value;
    if (!selectedDate) return true;

    const selectedMonth = new Date(selectedDate).getMonth();
    const selectedYear = new Date(selectedDate).getFullYear();

    return d.getMonth() === selectedMonth && d.getFullYear() === selectedYear;
  };

  // cancelBookInvoice(id: number) {
  //   if (
  //     window.confirm(
  //       'This operation is not reversable, Do you want to cancel invoice?'
  //     )
  //   ) {
  //     // console.log(id);
  //     this.service.cancelBookInvoice(id).subscribe((res) => {
  //       if (res['status'] === 'Success') {
  //         // console.log(res);
  //         alert(res['message']);
  //         this.ngOnInit();
  //       } else {
  //         alert('Something went wrong, Please try again.');
  //       }
  //     });
  //   }
  // }

  cancelBookInvoice(id: number, invoice_no: string) {
    if (
      window.confirm(
        `This operation is not reversible. Do you want to cancel invoice ${invoice_no}?`
      )
    ) {
      this.service.cancelBookInvoice(id, invoice_no).subscribe((res) => {
        if (res['status'] === 'Success') {
          alert(res['message']);
          this.ngOnInit();
        } else {
          alert('Something went wrong, Please try again.');
        }
      }, (error) => {

        if (error.error?.status == 'Failure') {
          alert(error.error?.message);
        }
      });
    }
  }


  //CREDIT CODE
  // selectedItem(book) {
  //   debugger;
  //   this.calculateRcptAmt(book);
  // }


  dialog1data;
  bookcreditdata = [];
  UpdatedBillingData = []
  calculateCrdtAmt(book) {
    this.debugger
    console.log(book);
    debugger;

    const previouslyFocusedElement = document.activeElement as HTMLElement;
    this.bookpymtcrdtdata.push(book);

    const dialogdata = this.dialog.open(AddBookCreditPriceComponent, {
      data: {
        book: book,
        seAmt: parseFloat(this.bookcrdtnoteForm.get('crditnoteamt').value),
        seCopies: parseFloat(this.bookcrdtnoteForm.get('returncopies').value),
        bsname: this.bookcrdtnoteForm.get('bsname').value,
      },
      height: '85vh',
      width: '95vw',
      maxWidth: '100%',
    });

    dialogdata.afterClosed().subscribe((res) => {
      debugger;
      if (!res || !res.data) {
        console.warn("No data returned from dialog.");
        return;
      }

      this.bookcreditdata.push(res.data);

      console.log(res.data);
      console.log("bookcreditdata", this.bookcreditdata);

      let bookIndex = this.BookBillingData.findIndex(b => b.id === res.id);
      if (bookIndex !== -1) {
        this.BookBillingData[bookIndex]['remaining_amt'] = res.remaining_amt;
        this.BookBillingData[bookIndex]['total_remaining_amt'] = res.remaining_amt;
        this.BookBillingData[bookIndex]['credit_amount'] = res.value;
        this.BookBillingData[bookIndex]['credit_note_amount'] = parseInt(res.selecetdAmt) || 0;
        this.BookBillingData[bookIndex]['return_copies'] = res.retCopies;
        this.BookBillingData[bookIndex]['remarks'] = res.newRemark;

        // ✅ Also set remark into form so it’s accessible later
        if (res.newRemark) {
          this.bookcrdtnoteForm.get('remark').setValue(res.newRemark);
        }

        console.log(`Updated remaining_amt for book ID ${res.id}:`, res.remainingamt);

        if (!this.UpdatedBillingData) {
          this.UpdatedBillingData = [];
        }
        this.UpdatedBillingData.push(this.BookBillingData[bookIndex]);
      } else {
        console.warn(`Book ID ${res.id} not found in BookBillingData`);
      }

      // Calculate total received amount
      let rcvd_amt = 0;
      for (let index = 0; index < Object.keys(this.bookcreditdata).length; index++) {
        for (let index1 = 0; index1 < Object.keys(this.bookcreditdata[index]).length; index1++) {
          rcvd_amt += parseInt(this.bookcreditdata[index][index1]['rcvd_amt']) || 0;
        }
      }

      // Update form values
      this.bookcrdtnoteForm.get('crditnoteamt').setValue(parseInt(res.selecetdAmt) || 0);
      this.bookcrdtnoteForm.get('returncopies').setValue(parseInt(res.returnCopies) || 0);

      this.invoice_total = rcvd_amt;
    });
  }

  addbookpymtcrdt() {
    let actualVal = this.deleterec ? this.val1 : this.val1 + 1;

    let remarkVal = this.bookcrdtnoteForm.get('remark').value;

    // Update each selected book with remark
    this.UpdatedBillingData = this.UpdatedBillingData.map(b => ({
      ...b,
      credit_remark: remarkVal
    }));

    let data = {
      date: this.bookcrdtnoteForm.get('date').value,
      todaydate: this.bookcrdtnoteForm.get('todaydate').value,
      repname: this.bookcrdtnoteForm.get('repname').value,
      crdtnoteno: this.bookcrdtnoteForm.get('crdtnoteno').value,
      offrepname: this.bookcrdtnoteForm.get('offrepname').value,
      bsname: this.bookcrdtnoteForm.get('bsname').value,
      crditnoteamt: this.bookcrdtnoteForm.get('crditnoteamt').value,
      returncopies: this.bookcrdtnoteForm.get('returncopies').value,
      remark: remarkVal,
      receiver_address: this.bookcrdtnoteForm.get('receiver_address').value,
      value: actualVal,
    };

    this.dialog.open(BookCrdtnoteRcptComponent, {
      data: {
        data,
        bookpymtcrdtdata: this.bookpymtcrdtdata,
        book: "",
        bookcreditdata: this.bookcreditdata,
        BookBillingData: this.UpdatedBillingData,
        booksellername: this.bookcrdtnoteForm.get('bsname').value,
        billno: this.bookcreditdata['invoice_no'],
      },
      height: '1300px',
      width: '1200px',
      maxWidth: '100%',
    });
  }







  deleteBookPymtCrdt(id: any) {
    debugger
    const req: any = {
      "id": id
    }
    debugger;
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deleteBookPymtCrdt(req).subscribe((res: any) => {
        console.log(res);
        alert(res.message || 'Credit Payment successfully cancelled.');
        location.reload();
      });
    }
    this.ngOnInit();
  }

  deleteBookCommPymtCrdt(id: any) {
    debugger
    const req: any = {
      "id": id
    }
    debugger;
    console.log(req, "this delete id")
    if (window.confirm('Are you sure want to delete?')) {
      this.service.deleteBookCommPymtCrdt(req).subscribe((res: any) => {
        console.log(res);
        alert(res.message || 'Commission Payment successfully cancelled.');
        location.reload();
      });
    }
    this.ngOnInit();
  }

  openBookCreditReceipt() {
    this.dialog.open(BookCreditNoteRegisterComponent, {
      data: {
        receiptdata: this.newList1,

      },
      height: '1300px',
      width: '95%',
      maxWidth: '100%',
    });

  }




  filterByRepName() {
    const searchTerm = this.repNameSearch.toLowerCase().trim();

    if (searchTerm === '') {
      // No search term — reset to full data
      this.FilteredCommbookRcptRegisterdata = this.bookRcptCommisionRegisterdata;
    } else {
      // Filter by rep_name (case-insensitive)
      this.FilteredCommbookRcptRegisterdata = this.bookRcptCommisionRegisterdata.filter(item =>
        item.rep_name && item.rep_name.toLowerCase().includes(searchTerm)
      );
    }

    // Recalculate the receivedCommAmount after filtering
    this.receivedCommAmount = 0;
    for (let item of this.FilteredCommbookRcptRegisterdata) {
      this.receivedCommAmount += parseInt(item.select_entry_amt) || 0;
    }
  }


  filterByBookName() {
    const searchTerm = this.bookNameSearch.toLowerCase().trim();

    if (!this.bookStockData || this.bookStockData.length === 0) {
      console.warn('No bookData available to filter');
      this.Filteredbookdata = [];
      return;
    }

    if (searchTerm === '') {
      this.Filteredbookdata = this.bookStockData;
    } else {
      this.Filteredbookdata = this.bookStockData.filter(item =>
        item.bookname?.toLowerCase().includes(searchTerm)
      );
    }

    console.log('Filtered Data:', this.Filteredbookdata);
  }



  filterByBookName1() {
    const searchTerm = this.bookNameSearch1.toLowerCase().trim();

    if (!this.bookdata || this.bookdata.length === 0) {
      console.warn('No bookData available to filter');
      this.booknames = [];
      return;
    }

    if (searchTerm === '') {
      this.booknames = [...this.bookdata];
    } else {
      this.booknames = this.bookdata.filter(item =>
        item.bookname?.toLowerCase().includes(searchTerm)
      );
    }

    console.log('Filtered Data:', this.booknames);
  }

  representativeName: any;
  representativeNameArray: string[] = [];

  getContractRepNames(event: any) {
    this.representativeName = event.source.value

    if (event.source.selected) {
      // Add if not already present
      if (!this.representativeNameArray.includes(event.source.value)) {
        this.representativeNameArray.push(event.source.value);
      }
    } else {
      // Remove on uncheck
      this.representativeNameArray = this.representativeNameArray.filter(rep => rep !== event.source.value);
    }

    // Update string: wrap each name in double quotes and join with commas
    this.representativeName = this.representativeNameArray
      .map(rep => `"${rep}"`)
      .join(',');

    console.log("representativeNameArray", this.representativeNameArray);
    console.log("representativeName", this.representativeName);

  }


  officecrepName: any;
  offRepNameArray: string[] = [];

  getContractOfcRepNames(event: any) {
    this.officecrepName = event.source.value
    if (event.source.selected) {
      if (!this.offRepNameArray.includes(event.source.value)) {
        this.offRepNameArray.push(event.source.value);
      }
    } else {
      this.offRepNameArray = this.offRepNameArray.filter(rep => rep !== event.source.value);
    }
    this.officecrepName = this.offRepNameArray
      .map(rep => `"${rep}"`)
      .join(',');
    console.log("offRepNameArray", this.offRepNameArray);
    console.log("officecrepName", this.officecrepName);
  }

  bookSellerName: any;
  bookSellerNameArray: string[] = [];
  getBookSellerName(event: any) {
    this.bookSellerName = event.source.value
    this.bookSellerName = event.source.value
    if (event.source.selected) {
      if (!this.bookSellerNameArray.includes(event.source.value)) {
        this.bookSellerNameArray.push(event.source.value);
      }
    } else {
      this.bookSellerNameArray = this.bookSellerNameArray.filter(rep => rep !== event.source.value);
    }
    this.bookSellerName = this.bookSellerNameArray
      .map(rep => `"${rep}"`)
      .join(',');
    console.log("bookSellerNameArray", this.bookSellerNameArray);
    console.log("bookSellerName", this.bookSellerName);
  }


  addSellerTypees() {

    console.log(this.addSellerType.value)
    this.dev_mode = this.addSellerType.value.sellertype

    this.service.addBookSellerType(this.dev_mode).subscribe((_data) => {
      this.getSellerTypes();
      this.addSellerType.reset();
      window.alert('Book Seller Type Added Successfully...');

    });
  }

  addbookdeliveryMode() {

    console.log(this.addDeliveryModeType.value)
    this.dev_mode = this.addDeliveryModeType.value.deliverytype

    this.service.addbookdeliveryMode(this.dev_mode).subscribe((_data) => {
      this.getbookdeliverymode();
      this.addDeliveryModeType.reset();
      window.alert('Book Seller Type Added Successfully...');

    });
  }

  update_Seller() {
    this.id = this.delivery_update_data.id
    this.dev_mode = this.addSellerType.value.sellertype;
    this.service.updateBookSellerType(this.id, this.dev_mode).subscribe((_data) => {
      this.getSellerTypes();
      this.addSellerType.reset();
      this.seller_type_update_btn = false;
      window.alert('Book Seller Type Updated Successfully...');

    });
  }


  update_bookdeliveryMode() {
    this.id = this.delivery_update_data.id
    this.dev_mode = this.addDeliveryModeType.value.deliverytype;
    this.service.updateBookSellerType(this.id, this.dev_mode).subscribe((_data) => {
      this.getbookdeliverymode();
      this.addDeliveryModeType.reset();
      this.seller_type_update_btn = false;
      window.alert('Book Seller Type Updated Successfully...');

    });
  }
  delete_seller_type(id) {
    // this.id = id;
    this.service.deletedBookSellerType(id).subscribe((_data) => {
      this.getSellerTypes();

      window.alert('Book Seller Type Delete Successfully...');

    });
  }

  delete_bookDeliveryMode(id) {
    // this.id = id;
    this.service.deletedDeliveryModeType(id).subscribe((_data) => {
      this.getbookdeliverymode();

      window.alert('Book Delivery Mode Delete Successfully...');

    });
  }
  update_seller_type(item) {
    this.delivery_update_data = item
    this.seller_type_update_btn = true


    this.addSellerType.patchValue({
      sellertype: item.sellertype,
    })
  }
  // =========================
  addComplTypees() {

    console.log(this.addComplType.value)
    this.dev_mode = this.addComplType.value.comptype

    this.service.addComplimentryType(this.dev_mode).subscribe((_data) => {
      this.getComplTypes();
      this.addComplType.reset();
      window.alert('Complimentry Type Added Successfully...');

    });
  }

  update_Compl() {
    this.id = this.compl_update_data.id
    this.dev_mode = this.addComplType.value.comptype;
    this.service.updateComplType(this.id, this.dev_mode).subscribe((_data) => {
      this.getComplTypes();
      this.addComplType.reset();
      this.compl_type_update_btn = false;
      window.alert('Complimentry Type Updated Successfully...');

    });
  }

  delete_compl_type(id) {
    // this.id = id;
    this.service.deletedComplType(id).subscribe((_data) => {
      this.getComplTypes();

      this.addComplType.reset();
      window.alert('Complimentry Type Delete Successfully...');

    });
  }

  update_compl_type(item) {
    this.compl_update_data = item
    this.compl_type_update_btn = true


    this.addComplType.patchValue({
      comptype: item.comptype,
    })
  }


  // =========================

  // abhiyanType
  addAbhiyanTypees() {

    console.log(this.addAbhiyanType.value)
    this.dev_mode = this.addAbhiyanType.value.abhiyantype

    this.service.addAbhiyanType(this.dev_mode).subscribe((_data) => {
      this.getAbhiyanTypes();
      this.addAbhiyanType.reset();
      window.alert('Abhiyan Type Added Successfully...');

    });
  }

  update_Abhiyan() {
    this.id = this.abhiyan_update_data.id
    this.dev_mode = this.addAbhiyanType.value.abhiyantype;
    this.service.updateAbhiyanType(this.id, this.dev_mode).subscribe((_data) => {
      this.getAbhiyanTypes();
      this.addAbhiyanType.reset();
      this.abhiyan_type_update_btn = false;
      window.alert('Abhiyan Type Updated Successfully...');

    });
  }

  delete_abhiyan_type(id) {
    // this.id = id;
    this.service.deletedAbhiyanType(id).subscribe((_data) => {
      this.getAbhiyanTypes();

      this.addAbhiyanType.reset();
      window.alert('Complimentry Type Delete Successfully...');

    });
  }

  update_abhiyan_type(item) {
    this.abhiyan_update_data = item
    this.abhiyan_type_update_btn = true


    this.addAbhiyanType.patchValue({
      abhiyantype: item.abhiyantype,
    })
  }

  expenseledgerStartDate = '';
  expenseledgerEndDate = '';
  expenseledgerDateRange() {

    if (
      this.expense.get('start').value != null &&
      this.expense.get('end').value != null
    ) {
      this.expenseledgerStartDate = formatDate(
        this.expense.get('start').value,
        'yyyy-MM-dd',
        'en-IN'
      );
      this.expenseledgerEndDate = formatDate(
        this.expense.get('end').value,
        'yyyy-MM-dd',
        'en-IN'
      );
    }
  }

  expense_report_new() {

    debugger

    const subCtrl = this.expense.get('subexpnameother');

    // Case: sub expense is required and not selected
    if (!subCtrl?.value || subCtrl.value === '') {
      alert('Please select sub expense');
      return;
    }

    const dialogdata = this.dialog.open(ExpenseLedgerReportComponent, {
      data: {
        startDate: this.expenseledgerStartDate,
        endDate: this.expenseledgerEndDate,
        mainexp: this.expense.value.expnameother,
        subexp: this.expense.value.subexpnameother,
      },
      width: '1300px',
      height: '1300px',
      maxWidth: '100%',
    });
    dialogdata.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  getSubExpByMainExp(event: any) {
    debugger;

    // find selected main-expense (keeps your existing loop logic)
    for (let index = 0; index < Object.keys(this.mainExpData).length; index++) {
      if (this.mainExpData[index]['id'] === event.value.id) {
        this.mainexpId = this.mainExpData[index]['id'];
        this.mainexpName = this.mainExpData[index]['exp_name'];
        break;
      }
    }

    // fetch sub-expenses for selected main
    this.service.getSubExpenseLedgerWithId(event.value.id).subscribe((res: any[]) => {
      this.subExpData = res || [];

      const subCtrl = this.expense.get('subexpnameother');

      if (this.subExpData && this.subExpData.length > 0) {
        this.subexpense = true;

        if (subCtrl?.disabled) {
          subCtrl.enable({ emitEvent: false });
        }
        subCtrl?.reset();


      } else {
        this.subexpense = false;

        // clear value and state so old ids/names don't persist
        subCtrl?.reset();                  // clears value and marks pristine/touched = false
        subCtrl?.setErrors(null);         // clear any leftover errors
        subCtrl?.clearValidators();       // optional: remove validators if you don't want them
        subCtrl?.updateValueAndValidity();

        // disable so it won't be submitted if you're reading rawValue or form.value
        if (subCtrl?.enabled) {
          subCtrl.disable({ emitEvent: false });
        }
      }
    });
  }

  //   this.bookcommForm.patchValue({
  //   rep_name: selectedRepName
  // });


}

